var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C18.03925562 -0.99900941 33.00851772 0.92056569 50 7 C51.50906341 7.51837817 53.01817389 8.03661932 54.52734375 8.5546875 C67.01828316 12.95856328 78.88888514 18.80115165 90.609375 24.93359375 C93.02034648 26.2036921 93.02034648 26.2036921 96 26 C97.34886024 27.31762347 98.67995673 28.65350777 100 30 C101.73418447 31.06228758 103.50856186 32.06103361 105.3125 33 C106.77042969 33.7734375 106.77042969 33.7734375 108.2578125 34.5625 C109.16273438 35.036875 110.06765625 35.51125 111 36 C119.36346813 40.46051633 126.56997024 46.38632214 133.875 52.375 C135.18455066 53.4457348 136.49445189 54.51604097 137.8046875 55.5859375 C138.81571533 56.41472412 138.81571533 56.41472412 139.84716797 57.26025391 C141.33316859 58.46112036 142.8332153 59.64473961 144.34423828 60.81396484 C151.0801576 66.0547899 157.1193026 71.81869279 163.125 77.875 C164.09081316 78.83366861 165.05695753 79.79200365 166.0234375 80.75 C166.92578125 81.65492187 167.828125 82.55984375 168.7578125 83.4921875 C169.5739502 84.31058105 170.39008789 85.12897461 171.23095703 85.97216797 C173 88 173 88 173 90 C173.99 90.33 174.98 90.66 176 91 C177.82421875 92.99609375 177.82421875 92.99609375 179.6875 95.4375 C180.62142578 96.64212891 180.62142578 96.64212891 181.57421875 97.87109375 C183 100 183 100 183 102 C183.66 102 184.32 102 185 102 C186.5993954 104.11304738 188.06064049 106.21791407 189.5 108.4375 C189.94069824 109.10982666 190.38139648 109.78215332 190.83544922 110.47485352 C207.81047055 136.62434058 220.6472734 164.15872541 228.35180664 194.42675781 C228.8438466 196.3005134 229.41479721 198.15321874 230 200 C230.66 200.33 231.32 200.66 232 201 C231.98259766 201.58555664 231.96519531 202.17111328 231.94726562 202.77441406 C231.85344368 208.47298008 232.29407033 213.90635751 233.06787109 219.54785156 C236.51937148 245.12405443 236.62141559 271.62118888 232.26953125 297.07861328 C231.92945679 299.0942822 231.92945679 299.0942822 232.09375 301.52734375 C231.97067572 304.77342782 230.93673867 307.42924045 229.86035156 310.47900391 C228.97116815 313.08448289 228.21886778 315.70029081 227.4921875 318.35546875 C217.7999359 353.51322293 201.23695981 388.04515804 175 414 C174.31421875 414.7321875 173.6284375 415.464375 172.921875 416.21875 C165.37645564 424.14415451 156.76910216 430.50218988 148 437 C147.32807617 437.5153833 146.65615234 438.0307666 145.96386719 438.56176758 C143.18368102 440.59782883 140.16928255 442.1531212 137.125 443.75 C136.14611816 444.26735718 136.14611816 444.26735718 135.14746094 444.79516602 C100.34908831 463.10239067 63.08269276 468.94223694 24.94140625 457.56640625 C9.95966614 452.89783538 -4.01786609 445.22923656 -16 435 C-16 434.34 -16 433.68 -16 433 C-16.56074219 432.78085937 -17.12148438 432.56171875 -17.69921875 432.3359375 C-31.45417959 424.34918605 -38.90633867 404.5027986 -43 390 C-47.90014385 371.34551298 -47.02986586 350.72735277 -37.66796875 333.47265625 C-31.65528328 324.55923727 -23.42137389 315.4737913 -13 312 C-12.67 310.35 -12.34 308.7 -12 307 C-10.68 307 -9.36 307 -8 307 C-8 307.99 -8 308.98 -8 310 C-5.36 309.34 -2.72 308.68 0 308 C-13.20028223 304.69992944 -23.70190025 309.36290338 -35 316 C-35 316.99 -35 317.98 -35 319 C-36.12921875 319.37125 -36.12921875 319.37125 -37.28125 319.75 C-45.43699667 323.49976858 -49.68316092 334.32324278 -52.90234375 342.2109375 C-61.24405265 365.20251326 -58.01812629 391.20035274 -48 413 C-44.95813009 419.36647772 -41.01424415 424.89508376 -36.76953125 430.51953125 C-35 433 -35 433 -33.875 435.265625 C-32.69679047 437.60100461 -31.33205079 437.86728962 -29 439 C-27.85219859 440.14780141 -26.70661549 441.29793544 -25.57421875 442.4609375 C-7.38521704 460.24373322 17.71427521 468.62613749 42 474 C42 474.66 42 475.32 42 476 C42.66 476.33 43.32 476.66 44 477 C38.48022939 479.47590997 34.56375145 478.80811075 28.875 477.5625 C28.00190186 477.3771167 27.12880371 477.1917334 26.22924805 477.00073242 C2.18351437 471.61774501 -17.98395125 461.55105017 -35.92895508 444.73095703 C-38.21097776 442.59490191 -40.39037951 440.739747 -43 439 C-43.70179832 437.68481889 -44.36502221 436.34871251 -45 435 C-46.02467438 433.57099465 -47.06838062 432.1555495 -48.125 430.75 C-63.90460835 408.32980646 -70.42480302 380.60980019 -66.17724609 353.48583984 C-62.63166048 334.18209595 -53.51132399 318.10639921 -38 306 C-37.34 305.34 -36.68 304.68 -36 304 C-21.56811794 296.4196175 -6.8252383 294.73935892 9 299 C9 299.66 9 300.32 9 301 C10.32 300.67 11.64 300.34 13 300 C12.34 299.34 11.68 298.68 11 298 C10.29875 297.21625 9.5975 296.4325 8.875 295.625 C-0.2006953 287.3384956 -10.85091096 287.24272704 -22.53759766 287.7734375 C-39.37512776 289.32263718 -55.60798403 300.1810264 -66.27880859 312.81396484 C-83.6701115 334.4008819 -90.10851402 361.45324942 -87.5390625 388.84765625 C-84.85004067 411.67168163 -76.46983969 432.10772866 -62 450 C-61.35160156 450.80308594 -60.70320313 451.60617187 -60.03515625 452.43359375 C-54.9708048 458.40932133 -49.1924231 463.23004548 -43 468 C-42.13503906 468.680625 -41.27007812 469.36125 -40.37890625 470.0625 C-9.61683628 493.46544179 31.79261708 500.90068276 69.60668945 496.05029297 C103.48126633 491.07003069 134.5963441 476.64714329 161 455 C161.62277832 454.49082031 162.24555664 453.98164063 162.88720703 453.45703125 C164.83055036 451.85782667 166.76145221 450.24498003 168.6875 448.625 C169.28836426 448.12500488 169.88922852 447.62500977 170.50830078 447.10986328 C173.4393387 444.6037116 175.45365192 442.52689242 177 439 C178.62428502 437.61258988 180.25154039 436.22848809 181.89453125 434.86328125 C197.11966993 421.38945723 208.02916648 403.4721882 218 386 C218.4031543 385.30890137 218.80630859 384.61780273 219.22167969 383.90576172 C234.49262213 357.61448443 249.55768047 321.2650632 247.91015625 290.2578125 C248 288 248 288 250 286 C251.50772529 278.81708491 251.13307143 271.16768895 251.09765625 263.8671875 C251.0962413 262.74933868 251.09482635 261.63148987 251.09336853 260.47976685 C251.08781622 256.94481617 251.07527279 253.40993121 251.0625 249.875 C251.05747883 247.46354259 251.05291701 245.05208417 251.04882812 242.640625 C251.03786246 236.76039463 251.02117253 230.88020201 251 225 C250.34 224.67 249.68 224.34 249 224 C249.33 221.36 249.66 218.72 250 216 C249.34 215.67 248.68 215.34 248 215 C247.65625 212.63671875 247.65625 212.63671875 247.5 209.6875 C247.29800449 205.90513408 246.91409596 203.28441466 245 200 C244.67 199.34 244.34 198.68 244 198 C244.66 198 245.32 198 246 198 C239.37006993 167.72359458 227.63590855 125.63590855 205 103 C204.10618612 101.67920497 203.2340045 100.34369418 202.375 99 C197.92901875 92.25512113 192.83106725 86.06031701 187.5 80 C185 77 185 77 185 75 C184.34 75 183.68 75 183 75 C181.62689293 73.70766393 180.28965176 72.37562854 179 71 C177.515 71.495 177.515 71.495 176 72 C176 71.34 176 70.68 176 70 C176.66 70 177.32 70 178 70 C170.05320497 60.66251584 161.61009204 52.61969178 152 45 C151.41814941 44.5359375 150.83629883 44.071875 150.23681641 43.59375 C148.38992577 42.12132831 146.53952291 40.65345982 144.6875 39.1875 C144.11306152 38.73141357 143.53862305 38.27532715 142.94677734 37.80541992 C139.40246236 35.01854692 135.78235434 32.45481091 132 30 C131.34 30.66 130.68 31.32 130 32 C129.7834375 30.94232422 129.7834375 30.94232422 129.5625 29.86328125 C127.15141373 25.44496566 123.272671 23.66445865 119 21.1875 C118.16726563 20.68541016 117.33453125 20.18332031 116.4765625 19.66601562 C112.49518239 17.00634658 112.49518239 17.00634658 108 16 C107.41798828 15.38705078 107.41798828 15.38705078 106.82421875 14.76171875 C104.17356023 12.20187508 101.01189686 10.58709024 97.8125 8.8125 C97.15830078 8.44447266 96.50410156 8.07644531 95.83007812 7.69726562 C94.22253039 6.7937534 92.61159349 5.8962759 91 5 C91 4.01 91 3.02 91 2 C91.66 1.67 92.32 1.34 93 1 C93 1.66 93 2.32 93 3 C93.99 3 94.98 3 96 3 C96 3.66 96 4.32 96 5 C96.54962402 5.16363037 97.09924805 5.32726074 97.66552734 5.49584961 C103.37657286 7.28472741 108.43348726 9.60317615 113.625 12.5625 C114.40133789 13.00013672 115.17767578 13.43777344 115.97753906 13.88867188 C123.57389307 18.22855864 130.8250105 23.00180278 138 28 C138.59264648 28.40718262 139.18529297 28.81436523 139.79589844 29.23388672 C148.65521897 35.32617997 156.91586951 41.91585961 165 49 C166.2065625 50.03833984 166.2065625 50.03833984 167.4375 51.09765625 C173.05547535 56.02287451 178.37840144 61.2467507 183.6875 66.5 C184.40067383 67.20012207 185.11384766 67.90024414 185.84863281 68.62158203 C190.6848861 73.44996601 194.90351564 78.53678901 199 84 C199.97225751 85.25002266 200.94613529 86.49878732 201.921875 87.74609375 C220.84552637 112.29471471 249 153.02034023 249 185 C249.66 185.33 250.32 185.66 251 186 C251.27393012 187.88353499 251.53487095 189.76995106 251.72705078 191.66357422 C252.00043944 194.00376157 252.41886828 196.26101215 252.90234375 198.56640625 C264.64135565 254.8639026 257.99800194 314.44187627 235 367 C234.59910156 367.92151855 234.19820312 368.84303711 233.78515625 369.79248047 C225.7053963 388.12757508 215.50433516 405.32757992 203 421 C202.35933594 421.83144531 201.71867187 422.66289062 201.05859375 423.51953125 C196.8735134 428.88827069 192.41600145 433.9180639 187.68017578 438.80273438 C185.53729644 441.0648763 184.05246378 442.86309634 182.9296875 445.79296875 C182.62289063 446.52128906 182.31609375 447.24960937 182 448 C180.0859375 448.6015625 180.0859375 448.6015625 178 449 C176.27593036 450.47329538 176.27593036 450.47329538 174.625 452.375 C142.95730426 485.1548699 94.86575866 504.49358215 49.81054688 505.29711914 C38.44122712 505.35425596 27.26498172 504.48782777 16 503 C16 503.33 16 503.66 16 504 C14.35 504 12.7 504 11 504 C11.33 503.01 11.66 502.02 12 501 C10.6903125 500.88785156 9.380625 500.77570313 8.03125 500.66015625 C3.28625284 500.12727083 -0.99642795 498.99061283 -5.5 497.4375 C-6.27480713 497.17138916 -7.04961426 496.90527832 -7.84790039 496.63110352 C-27.79489812 489.58539077 -45.86698714 478.90923448 -61 464 C-62.09248047 463.01580078 -62.09248047 463.01580078 -63.20703125 462.01171875 C-72.29622386 453.55924717 -78.99118538 442.78505189 -85 432 C-85.66 432 -86.32 432 -87 432 C-87.26941406 430.87078125 -87.53882813 429.7415625 -87.81640625 428.578125 C-88.57742562 425.52869296 -89.43691029 422.53769791 -90.40234375 419.546875 C-100.69380101 387.60809911 -101.29955219 355.59558033 -86.75 324.8125 C-83.19050105 317.96433355 -78.85985584 311.97666292 -74 306 C-73.15501953 304.90751953 -73.15501953 304.90751953 -72.29296875 303.79296875 C-60.7745477 289.58411358 -42.07715415 279.44825789 -24 277 C-10.7215294 275.64954487 2.00366394 277.30919287 13.0625 285.359375 C17.597943 289.19987109 21.24755398 293.21692815 23 299 C24.95484971 298.95129001 24.95484971 298.95129001 27 298 C31.30293262 289.43397672 32.61503646 279.29534621 30.234375 270.015625 C26.59192248 259.31953428 20.96766419 252.3932872 10.9375 247.25 C-8.11089262 238.28605053 -29.48965327 241.62329037 -48.84033203 248.19775391 C-68.01482527 255.32045171 -85.46985875 267.68598984 -100.29296875 281.6015625 C-102 283 -102 283 -104 283 C-104 283.66 -104 284.32 -104 285 C-104.66 285 -105.32 285 -106 285 C-105.08216786 277.6743398 -96.09681839 271.59499728 -90.56640625 267.22265625 C-69.41210274 251.08390462 -44.25456868 236.29270682 -17 235 C-16.34773438 234.9484375 -15.69546875 234.896875 -15.0234375 234.84375 C-4.72797156 234.38103243 6.12464961 237.32542594 16 240 C16 240.66 16 241.32 16 242 C16.66 242.185625 17.32 242.37125 18 242.5625 C27.74896495 247.23387904 34.54686904 256.63008357 38.4375 266.5 C43.114009 282.2098311 39.58565485 296.91235528 32 311 C41.2463228 311.60631625 49.18893314 309.72842025 56.375 303.625 C57.6032195 302.43688563 58.81353166 301.22980965 60 300 C60.9075 299.0925 61.815 298.185 62.75 297.25 C70.36125489 286.25596516 71.03909791 273.0995617 69.0625 260.1875 C66.42683806 246.80619317 60.32867734 232.83087133 50.30078125 223.40234375 C49 222 49 222 49 220 C48.4121875 219.73574219 47.824375 219.47148437 47.21875 219.19921875 C44.92225788 217.95798093 43.37931647 216.61351162 41.5 214.8125 C31.91036895 206.33343284 21.17858488 202.14810507 9 199 C7.22109375 198.51853516 7.22109375 198.51853516 5.40625 198.02734375 C-3.43155847 195.99729159 -12.13195597 195.69457569 -21.1875 195.625 C-22.35120117 195.61106201 -23.51490234 195.59712402 -24.71386719 195.58276367 C-32.83691991 195.6269731 -40.16960801 196.88991835 -48 199 C-50.47152927 199.65098938 -52.70477228 200.09042042 -55.2578125 200.41796875 C-75.44392414 203.55756231 -95.98627873 214.51177541 -112.83984375 225.671875 C-115 227 -115 227 -117 227 C-117 226.01 -117 225.02 -117 224 C-115.6015625 222.77661133 -115.6015625 222.77661133 -113.625 221.58203125 C-112.89514893 221.13625732 -112.16529785 220.6904834 -111.41333008 220.23120117 C-110.61693115 219.76302979 -109.82053223 219.2948584 -109 218.8125 C-108.18490967 218.32563721 -107.36981934 217.83877441 -106.5300293 217.3371582 C-90.76122738 208.03486449 -74.48611521 200.63424668 -56.8125 195.75 C-55.92224121 195.50362793 -55.03198242 195.25725586 -54.11474609 195.00341797 C-42.18181706 191.83109603 -30.72339519 190.58898506 -18.375 190.625 C-17.67101074 190.62554382 -16.96702148 190.62608765 -16.24169922 190.62664795 C-5.08124014 190.66621731 5.3531838 191.46785574 16 195 C16.69464355 195.22494141 17.38928711 195.44988281 18.10498047 195.68164062 C41.16522391 203.31755248 59.16363379 216.72992584 70.3359375 238.6171875 C78.37926228 255.4350484 81.7654023 272.97361048 76.03125 291.0546875 C72.19244055 301.24828288 65.71165685 310.65779139 56 316 C47.23663342 319.88881162 38.50256166 321.94240593 29 323 C29.69950185 326.79499854 31.11829495 328.37518645 34.1875 330.765625 C43.5442026 337.13786211 52.91296585 337.77377108 64 337 C76.76821698 334.46164788 87.73305164 326.92033804 96 317 C96.33 316.01 96.66 315.02 97 314 C97.45503906 313.56042969 97.91007813 313.12085938 98.37890625 312.66796875 C108.84321011 301.90108261 110.34294708 282.78192071 110.4375 268.6875 C110.44765137 267.5830957 110.45780273 266.47869141 110.46826172 265.34082031 C110.45110107 263.78572754 110.45110107 263.78572754 110.43359375 262.19921875 C110.42384521 261.26940186 110.41409668 260.33958496 110.40405273 259.3815918 C109.92626874 256.56540878 109.0954939 255.84518008 107 254 C106.26953125 251.40625 106.26953125 251.40625 105.8125 248.5 C105.65394531 247.5409375 105.49539063 246.581875 105.33203125 245.59375 C104.6942446 240.61151079 104.6942446 240.61151079 106 238 C105.53040945 235.3446323 105.53040945 235.3446323 104.6875 232.4375 C104.42324219 231.44621094 104.15898438 230.45492187 103.88671875 229.43359375 C103.25852446 226.84289689 103.25852446 226.84289689 101 226 C100.31875294 224.00491933 99.65572791 222.00361307 99 220 C95.49207399 211.74026849 95.49207399 211.74026849 89 206 C88.90332031 205.29101562 88.80664062 204.58203125 88.70703125 203.8515625 C87.72174003 199.87773605 85.34430475 197.36628266 82.6875 194.375 C82.14915527 193.76180908 81.61081055 193.14861816 81.05615234 192.5168457 C68.35586028 178.28031743 53.6256465 167.47827566 36 160 C35.01 160 34.02 160 33 160 C33 159.34 33 158.68 33 158 C26.30177855 156.05249949 19.54762659 154.37142236 12.75 152.8125 C11.99412598 152.63364258 11.23825195 152.45478516 10.45947266 152.27050781 C4.84569856 151.00657711 -0.41280703 150.13760234 -6 152 C-6.33 151.34 -6.66 150.68 -7 150 C-11.86306756 148.80873694 -16.71391476 148.84925236 -21.6875 148.875 C-22.44611328 148.87113281 -23.20472656 148.86726562 -23.98632812 148.86328125 C-27.2477639 148.86903842 -29.88513748 148.96171249 -33 150 C-33 149.34 -33 148.68 -33 148 C-33.99 148.66 -34.98 149.32 -36 150 C-36.99 149.67 -37.98 149.34 -39 149 C-46.81639502 148.49696468 -54.50985293 149.36963817 -62.25 150.375 C-63.33595459 150.51075439 -64.42190918 150.64650879 -65.54077148 150.78637695 C-68.69493124 151.18296288 -71.84765374 151.58927252 -75 152 C-75.86061035 152.11166504 -76.7212207 152.22333008 -77.60791016 152.33837891 C-81.74075198 152.87699704 -85.87143256 153.42938499 -90 154 C-90 153.01 -90 152.02 -90 151 C-85.64195356 150.11743951 -81.28205723 149.24489785 -76.92016602 148.3815918 C-75.43654357 148.08648964 -73.95346193 147.78865496 -72.47094727 147.48803711 C-70.340068 147.05643953 -68.20743801 146.63470176 -66.07421875 146.21484375 C-64.79119873 145.95823975 -63.50817871 145.70163574 -62.1862793 145.43725586 C-59 145 -59 145 -56 146 C-56 145.34 -56 144.68 -56 144 C-50.73877289 143.97489873 -45.47758219 143.95695448 -40.21630859 143.94506836 C-38.43407584 143.94010258 -36.65184701 143.93332772 -34.86962891 143.92456055 C-19.33808604 143.85018414 -4.02636054 143.95550038 11.25 147.125 C12.31428223 147.34454346 13.37856445 147.56408691 14.47509766 147.7902832 C36.25476405 152.49548538 57.37623673 160.83045958 74 176 C74.69996094 176.58265625 75.39992188 177.1653125 76.12109375 177.765625 C100.29831193 197.93687136 115.75957657 229.07651794 118.75 260.2890625 C118.8325 261.51367188 118.915 262.73828125 119 264 C119.0825 265.12148438 119.165 266.24296875 119.25 267.3984375 C120.02431862 288.15985554 113.33520113 309.45110722 99.6875 325.1875 C88.27021151 337.32548112 73.72795838 345.63483963 56.91015625 346.9765625 C52.13018318 347.01505893 47.64634209 346.03252046 43 345 C41.00092329 344.66117344 39.00144274 344.32455828 37 344 C37 343.34 37 342.68 37 342 C36.01 341.6596875 36.01 341.6596875 35 341.3125 C31.07265467 339.59428642 27.58739822 337.33225393 24 335 C25.95066761 344.80467139 28.63980921 354.85752331 36.6875 361.4375 C48.12193786 368.91635728 61.68241474 370.44950782 74.93359375 367.78515625 C95.73223679 362.45964383 113.7224427 349.68111776 125.125 331.25 C126.10061176 329.50957348 127.0578144 327.75874645 128 326 C128.57621094 324.97390625 129.15242187 323.9478125 129.74609375 322.890625 C134.7280046 313.59105809 137.48996718 304.20206888 140 294 C139.01 294 138.02 294 137 294 C137.33 293.34 137.66 292.68 138 292 C138.99 292.33 139.98 292.66 141 293 C141 292.01 141 291.02 141 290 C141.99 290 142.98 290 144 290 C140.989744 309.97393395 135.23057187 327.67698056 123 344 C122.33613281 344.92039062 121.67226563 345.84078125 120.98828125 346.7890625 C109.73880117 361.55270549 92.65885183 373.1024868 74.27734375 376.6015625 C58.62953317 378.50391849 43.93631642 376.35340658 30.72265625 367.46875 C29.86994141 366.74171875 29.86994141 366.74171875 29 366 C29 365.34 29 364.68 29 364 C28.34 364 27.68 364 27 364 C22.07222263 357.61573671 18.64731384 350.58019677 16 343 C14.74807672 349.27469982 15.06032058 354.95000616 16.1875 361.1875 C16.3572937 362.18426758 16.3572937 362.18426758 16.53051758 363.20117188 C17.66609186 368.96562455 19.80906833 373.80906833 24 378 C24.45375 378.825 24.9075 379.65 25.375 380.5 C27.13647591 383.20996294 28.12510255 383.74223237 31 385 C31.4021875 385.45890625 31.804375 385.9178125 32.21875 386.390625 C34.7112856 388.64265278 37.35817818 389.47158343 40.5 390.625 C41.6446875 391.05039062 42.789375 391.47578125 43.96875 391.9140625 C48.35381958 393.48500238 51.53942679 394.11953321 56.19921875 394.09765625 C58.01196289 394.09282227 58.01196289 394.09282227 59.86132812 394.08789062 C61.12396484 394.07951172 62.38660156 394.07113281 63.6875 394.0625 C64.96173828 394.05798828 66.23597656 394.05347656 67.54882812 394.04882812 C70.69926564 394.03702873 73.84960949 394.02056597 77 394 C77.33 393.34 77.66 392.68 78 392 C78.78375 391.87625 79.5675 391.7525 80.375 391.625 C95.06105331 389.09292184 108.12794514 380.86824298 119 371 C119.48855469 370.56059082 119.97710938 370.12118164 120.48046875 369.66845703 C134.52652725 356.8816692 146.22368289 339.5321104 151 321 C151.66 321 152.32 321 153 321 C154.37578376 314.83796118 155.73820643 308.67332288 157.0625 302.5 C157.23587891 301.70980469 157.40925781 300.91960937 157.58789062 300.10546875 C159.93850054 289.09993113 160.3088202 278.22154039 160.375 267 C160.38333862 265.81361938 160.38333862 265.81361938 160.3918457 264.60327148 C160.4399831 250.98313886 158.93289746 238.39998203 155.45898438 225.17773438 C155 223 155 223 155 219 C154.01 218.67 153.02 218.34 152 218 C152.66 218 153.32 218 154 218 C150.535 208.595 150.535 208.595 147 199 C146.34 199 145.68 199 145 199 C144.88978516 197.7934375 144.88978516 197.7934375 144.77734375 196.5625 C143.76401053 191.91848042 141.7994493 188.1687648 139.5625 184 C139.11511475 183.16130371 138.66772949 182.32260742 138.20678711 181.45849609 C134.05486486 173.83512773 129.37288382 166.80988938 124 160 C123.57638184 159.46213867 123.15276367 158.92427734 122.71630859 158.37011719 C112.64895366 145.74711555 101.50460373 133.9478356 88 125 C87.13890625 124.401875 86.2778125 123.80375 85.390625 123.1875 C81.52418841 120.1611262 81.52418841 120.1611262 77 119 C76.14293457 118.11006348 76.14293457 118.11006348 75.26855469 117.20214844 C72.6067507 114.61826209 70.05490594 113.34665375 66.703125 111.765625 C66.10949158 111.48273621 65.51585815 111.19984741 64.90423584 110.90838623 C63.02317425 110.01422072 61.13679924 109.13198351 59.25 108.25 C57.9670775 107.64270899 56.68452118 107.03464376 55.40234375 106.42578125 C52.27241488 104.94154153 49.13761211 103.46794064 46 102 C45.67 102.66 45.34 103.32 45 104 C45 103.01 45 102.02 45 101 C44.67 101.66 44.34 102.32 44 103 C43.484375 102.731875 42.96875 102.46375 42.4375 102.1875 C34.50827858 98.32454598 26.9626294 95.54037798 18 96 C18 95.34 18 94.68 18 94 C16.453125 94.309375 16.453125 94.309375 14.875 94.625 C10.8765784 95.01194403 8.66306243 94.51883076 5 93 C5 92.34 5 91.68 5 91 C-0.94 90.01 -0.94 90.01 -7 89 C-7 88.34 -7 87.68 -7 87 C-2.67324694 86.08064534 0.61097912 86.06764758 4.9375 86.9375 C9.42699572 87.77301409 13.45361599 88.09673157 18 88 C18.99 88.33 19.98 88.66 21 89 C21 89.66 21 90.32 21 91 C22.15757812 91.12117188 23.31515625 91.24234375 24.5078125 91.3671875 C28.74744416 91.90156356 32.78785655 92.89226086 36.875 94.125 C37.60114502 94.34309326 38.32729004 94.56118652 39.07543945 94.78588867 C52.97356382 99.06738603 65.55000116 104.50354261 78 112 C79.46118467 112.78971541 80.92350086 113.57733947 82.38671875 114.36328125 C86.97844913 116.90270947 91.11042969 119.84786721 95.25 123.0625 C95.98307373 123.62904297 96.71614746 124.19558594 97.47143555 124.77929688 C104.34111618 130.15602373 110.81566334 135.84939248 117 142 C117.76304443 142.75700195 117.76304443 142.75700195 118.54150391 143.52929688 C145.13018719 170.26124723 159.51493448 205.32908574 166.50683594 241.80786133 C166.91432069 244.02863851 166.91432069 244.02863851 168 246 C168.11028863 248.17370543 168.15448279 250.35088401 168.16796875 252.52734375 C168.17438889 253.51139946 168.17438889 253.51139946 168.18093872 254.51533508 C168.1909896 256.65612498 168.19097939 258.7966908 168.1875 260.9375 C168.18656342 261.66618286 168.18562683 262.39486572 168.18466187 263.14562988 C168.06755646 305.01052554 156.38045904 344.06395408 126.578125 374.5703125 C121.46370666 379.60350514 115.83798737 383.84188934 110 388 C109.28070312 388.56203125 108.56140625 389.1240625 107.8203125 389.703125 C106 391 106 391 103 392 C101.21744817 392.80555645 99.435269 393.61196423 97.65625 394.42529297 C90.23725929 397.79048349 83.04499915 400.48550468 75 402 C74.3090625 402.13019531 73.618125 402.26039063 72.90625 402.39453125 C70.93176082 402.69798758 68.99397536 402.87723659 67 403 C66.1440625 403.05285156 65.288125 403.10570312 64.40625 403.16015625 C48.87208529 403.64037908 34.23276571 400.30080847 22.125 390.1875 C14.84464617 383.23627609 10.9040535 375.56383003 8 366 C7.773125 365.27167969 7.54625 364.54335938 7.3125 363.79296875 C5.48648515 356.95809373 5.82018775 350.02266745 6 343 C1.18702071 358.31677687 0.08095168 372.02805124 7.75 386.8125 C16.07614963 400.87308112 28.25322776 408.67274167 43.84765625 413.08984375 C61.07154299 417.20425777 80.24441363 415.32560218 96.703125 409.21875 C100 408 100 408 103.859375 406.96875 C105.41398437 406.48921875 105.41398437 406.48921875 107 406 C107.33 405.34 107.66 404.68 108 404 C110.04029629 402.97537097 112.10854292 402.00622192 114.1875 401.0625 C142.81340909 387.34922449 161.36617904 359.23765918 173.22998047 330.84277344 C173.87615869 329.29637103 174.54658906 327.76013344 175.22265625 326.2265625 C176.21974169 323.7636485 176.21974169 323.7636485 176 320 C176.66 320 177.32 320 178 320 C178.16435547 319.05253906 178.16435547 319.05253906 178.33203125 318.0859375 C179.29985217 312.62522437 180.39406649 307.22044012 181.625 301.8125 C182.74807249 296.69690481 183.20047155 292.21226027 183 287 C183.33 286.34 183.66 285.68 184 285 C184.073596 283.02339534 184.0835023 281.04426905 184.0625 279.06640625 C184.05476563 277.85919922 184.04703125 276.65199219 184.0390625 275.40820312 C184.01337789 272.87955364 183.98734629 270.35090765 183.9609375 267.82226562 C183.91435128 260.48105382 184.15755916 253.29519916 185 246 C184.34 245.67 183.68 245.34 183 245 C182.65625 242.62890625 182.65625 242.62890625 182.5 239.5625 C182.12717345 233.90231516 181.25898624 228.52487167 180 223 C179.34 223 178.68 223 178 223 C178 222.34 178 221.68 178 221 C178.66 221 179.32 221 180 221 C180 220.01 180 219.02 180 218 C179.01 218 178.02 218 177 218 C177.33 217.01 177.66 216.02 178 215 C177.34 215 176.68 215 176 215 C176.12375 213.845 176.2475 212.69 176.375 211.5 C176.43749512 204.99009119 173.71241897 199.31096977 171.3125 193.37890625 C170 190 170 190 170 188 C169.34 187.67 168.68 187.34 168 187 C167.33145039 185.00062863 166.6653314 183.00044459 166 181 C164.53940781 177.88344054 162.93060504 174.84972078 161.3125 171.8125 C160.63876343 170.54394165 160.63876343 170.54394165 159.95141602 169.24975586 C154.16901305 158.46551746 147.50192292 148.66544677 140 139 C139.34773438 138.14019531 138.69546875 137.28039062 138.0234375 136.39453125 C133.2173137 130.26162038 127.92092644 124.71535783 122.4375 119.1875 C121.37499023 118.11109253 121.37499023 118.11109253 120.29101562 117.01293945 C115.80415206 112.55258539 111.14751083 108.67041722 106 105 C105.11054687 104.33355469 104.22109375 103.66710937 103.3046875 102.98046875 C98.18189958 99.20014776 92.97992548 95.53833641 87.6875 92 C87.11306152 91.60192139 86.53862305 91.20384277 85.94677734 90.79370117 C82.14924994 88.30071411 79.52018493 87.56234216 75 88 C74.91105469 87.38640625 74.82210937 86.7728125 74.73046875 86.140625 C74.18684896 83.90424818 74.18684896 83.90424818 72.36328125 82.734375 C67.94274808 80.61251908 64.9668588 79.88449166 60 80 C58.375 78.6875 58.375 78.6875 57 77 C52.66475536 73.41221133 48.70874251 71 43 71 C43 70.01 43 69.02 43 68 C48.45778354 67.58790216 52.30853296 69.74634131 57.16015625 72.00390625 C60.07383275 73.02589732 61.18902918 73.12573651 64 72 C64.33 72.99 64.66 73.98 65 75 C66.81405715 76.16624759 66.81405715 76.16624759 69.09375 77.09375 C69.95097656 77.47853516 70.80820312 77.86332031 71.69140625 78.25976562 C72.61824219 78.66904297 73.54507813 79.07832031 74.5 79.5 C92.78893586 87.89798075 108.98653458 99.31293634 123.765625 112.95703125 C125.83742629 114.85135306 127.96108951 116.65010994 130.125 118.4375 C131.07375 119.283125 132.0225 120.12875 133 121 C133 121.66 133 122.32 133 123 C133.66 123 134.32 123 135 123 C137.58256945 125.42445295 139.7519194 128.26846121 142 131 C142.40959961 131.49338867 142.81919922 131.98677734 143.24121094 132.49511719 C159.95683091 152.74028071 173.94961629 176.94810664 182 202 C182.66 202 183.32 202 184 202 C183.95101563 202.93070313 183.90203125 203.86140625 183.8515625 204.8203125 C183.85417112 209.99841419 185.15151069 214.87106621 186.375 219.875 C186.59671875 220.83664063 186.8184375 221.79828125 187.046875 222.7890625 C187.26601563 223.70171875 187.48515625 224.614375 187.7109375 225.5546875 C187.90993652 226.38468262 188.10893555 227.21467773 188.31396484 228.06982422 C188.81944278 230.19847319 188.81944278 230.19847319 191 231 C190.98259766 232.01320312 190.98259766 232.01320312 190.96484375 233.046875 C190.95582031 233.93890625 190.94679688 234.8309375 190.9375 235.75 C190.92009766 237.07257813 190.92009766 237.07257813 190.90234375 238.421875 C190.90091993 240.90587541 190.90091993 240.90587541 191.49900818 242.86309814 C192.05531397 245.23593306 192.12007479 247.33217744 192.11352539 249.76855469 C192.11344986 250.70922791 192.11337433 251.64990112 192.11329651 252.61907959 C192.10813522 253.62650208 192.10297394 254.63392456 192.09765625 255.671875 C192.09553383 257.22820648 192.09553383 257.22820648 192.09336853 258.815979 C192.08777447 262.12734876 192.07522303 265.43865071 192.0625 268.75 C192.05748423 270.99609277 192.05292146 273.24218661 192.04882812 275.48828125 C192.03780699 280.9922106 192.02107474 286.49610046 192 292 C191.67 292 191.34 292 191 292 C190.87995605 292.63276855 190.75991211 293.26553711 190.63623047 293.91748047 C187.06307862 312.502576 182.68357928 330.07964753 174 347 C173.64953613 347.68562012 173.29907227 348.37124023 172.93798828 349.07763672 C167.30497553 359.97862582 160.99302224 369.69557829 153 379 C152.56075195 379.52287598 152.12150391 380.04575195 151.66894531 380.58447266 C132.92279888 402.78385658 104.26317667 419.98223491 75 423 C52.55251008 424.18243293 30.75402431 422.18257307 12.97192383 407.02050781 C3.34733216 398.26725945 -2.73852159 388.68519713 -6 376 C-6.12890625 372.578125 -6.12890625 372.578125 -6 370 C-6.66 369.67 -7.32 369.34 -8 369 C-6.98627242 355.92745328 -5.35962843 342.71820424 1 331 C-7.7217755 337.86180032 -12.75002334 344.93156641 -15 356 C-16.81467448 373.74850178 -12.64604732 391.28665956 -1.41796875 405.40625 C10.37189974 419.21303118 26.95611084 429.13805383 45 432 C46.66666501 432.00234742 48.3333359 432.00292397 50 432 C50.33 432.33 50.66 432.66 51 433 C81.27017433 437.95330125 112.79093464 427.45104218 138 411 C145.43793289 405.63228225 152.00689826 399.24130073 158.29296875 392.58203125 C160 391 160 391 162 391 C162.2475 390.43796875 162.495 389.8759375 162.75 389.296875 C164.2122385 386.61001175 165.99219075 384.55898064 168 382.25 C171.84189695 377.60978681 175.258123 372.82721288 178.5 367.75 C178.933125 367.0890332 179.36625 366.42806641 179.8125 365.74707031 C182.50641948 361.43636742 183.63163483 358.07817702 184 353 C184.66 353.66 185.32 354.32 186 355 C186.309375 354.05125 186.61875 353.1025 186.9375 352.125 C187.78177371 349.64184202 188.65041384 347.60816436 189.9453125 345.35546875 C195.93899465 334.34058931 203.77566155 316.79841563 203 304 C203.66 304 204.32 304 205 304 C205.04898437 303.36578125 205.09796875 302.7315625 205.1484375 302.078125 C205.55560936 296.99549696 206.0000267 291.92497571 206.546875 286.85546875 C206.64178223 285.9624707 206.73668945 285.06947266 206.83447266 284.14941406 C207.02668573 282.35520996 207.22419575 280.56156466 207.42724609 278.76855469 C207.51570801 277.93614258 207.60416992 277.10373047 207.6953125 276.24609375 C207.77797363 275.50029053 207.86063477 274.7544873 207.94580078 273.98608398 C208.11909226 271.78729422 208.11909226 271.78729422 207 269 C207.66 269 208.32 269 209 269 C208.58527135 257.93329328 208.06084875 246.94338678 206.66064453 235.95166016 C206.11499252 231.58128669 205.91399054 227.39221618 206 223 C205.01 223.33 204.02 223.66 203 224 C202.67 222.35 202.34 220.7 202 219 C202.66 219.33 203.32 219.66 204 220 C203.04876919 212.07854343 201.18698705 204.49018544 199.0625 196.8125 C198.80968262 195.86737549 198.55686523 194.92225098 198.29638672 193.94848633 C197.91957764 192.62240356 197.91957764 192.62240356 197.53515625 191.26953125 C197.312229 190.47135986 197.08930176 189.67318848 196.85961914 188.85083008 C196.57594482 188.24005615 196.29227051 187.62928223 196 187 C195.01 186.67 194.02 186.34 193 186 C193 185.34 193 184.68 193 184 C193.66 184 194.32 184 195 184 C193.74699312 180.84677011 192.46968518 177.70396598 191.1875 174.5625 C190.83107422 173.66466797 190.47464844 172.76683594 190.10742188 171.84179688 C189.75615234 170.98779297 189.40488281 170.13378906 189.04296875 169.25390625 C188.56380005 168.06776733 188.56380005 168.06776733 188.07495117 166.85766602 C187.07538387 164.65694081 187.07538387 164.65694081 184 164 C184.33 163.01 184.66 162.02 185 161 C183.62507196 157.8331162 183.62507196 157.8331162 182 155 C181.34 155 180.68 155 180 155 C179.9175 154.319375 179.835 153.63875 179.75 152.9375 C178.77667472 149.1253093 177.04192545 146.35929671 175 143 C173.68 143 172.36 143 171 143 C171 142.34 171 141.68 171 141 C171.66 140.67 172.32 140.34 173 140 C172.4946875 139.30132812 171.989375 138.60265625 171.46875 137.8828125 C170.8190625 136.97273437 170.169375 136.06265625 169.5 135.125 C168.8503125 134.22007812 168.200625 133.31515625 167.53125 132.3828125 C166 130 166 130 166 128 C165.34 127.67 164.68 127.34 164 127 C162.67578125 125.51171875 162.67578125 125.51171875 161.3125 123.6875 C160.85488281 123.09324219 160.39726563 122.49898438 159.92578125 121.88671875 C159 120 159 120 159.35546875 117.76953125 C159.56816406 117.18558594 159.78085937 116.60164063 160 116 C198 160.97584541 198 160.97584541 198 180 C198.66 180.33 199.32 180.66 200 181 C200.8515625 182.9609375 200.8515625 182.9609375 201.625 185.375 C202.01558594 186.56222656 202.01558594 186.56222656 202.4140625 187.7734375 C203 190 203 190 203 193 C203.66 193.33 204.32 193.66 205 194 C207.69199108 201.36046807 209.00114059 209.33604027 210.5625 217 C210.87477539 218.50433594 210.87477539 218.50433594 211.19335938 220.0390625 C212.56099716 226.67574996 213.81713171 233.32799898 215 240 C215.33 240 215.66 240 216 240 C216.09765625 246.15234375 216.09765625 246.15234375 216 248 C215.67 248.33 215.34 248.66 215 249 C214.9487568 250.6228912 214.96481755 252.24796309 215.0078125 253.87109375 C215.61856611 286.86718583 210.03762444 316.36249978 197.73095703 346.95068359 C196.88801583 348.95133051 196.88801583 348.95133051 197 351 C196.34 351 195.68 351 195 351 C194.7421875 351.8559375 194.484375 352.711875 194.21875 353.59375 C188.1155082 370.65152837 174.94135631 385.71727348 163 399 C162.07960938 400.03060547 162.07960938 400.03060547 161.140625 401.08203125 C138.11536682 425.41813333 103.19916369 440.74504605 69.98046875 442.28515625 C42.62989734 443.02929941 17.23196128 435.36989856 -3 416.375 C-14.25930755 404.75611377 -24.13562064 388.38795499 -24.1875 371.8125 C-24.0946875 369.9253125 -24.0946875 369.9253125 -24 368 C-24.66 367.67 -25.32 367.34 -26 367 C-25.67 366.67 -25.34 366.34 -25 366 C-24.83900898 364.19034171 -24.72206604 362.37671042 -24.625 360.5625 C-23.42664164 345.43099001 -16.82276079 333.54727233 -6 323 C-4.68806268 321.97209035 -3.36161311 320.96113866 -2 320 C-12.51686909 321.6432608 -20.45287981 326.19719496 -26.75 334.75 C-36.60599285 349.74727386 -38.15919934 367.74373316 -34.9375 385.125 C-29.42755967 407.29289947 -16.28998973 425.69693568 3 438 C3.76699219 438.51175781 4.53398437 439.02351563 5.32421875 439.55078125 C31.17846163 456.08894984 64.59966363 458.34221243 94.0625 452.1875 C125.64980516 445.05612351 155.74263392 427.52757514 176 402 C176.67160156 401.20464844 177.34320312 400.40929687 178.03515625 399.58984375 C203.89062103 368.76729139 219.61888641 331.64585871 226 292 C226.18691406 290.89446777 226.37382813 289.78893555 226.56640625 288.64990234 C228.47615568 275.8011216 228.22277873 262.96213945 228.125 250 C228.1149453 247.66406636 228.10582388 245.3281285 228.09765625 242.9921875 C228.0758513 237.32803149 228.04257295 231.66403604 228 226 C227.01 226 226.02 226 225 226 C225.18820312 225.00355469 225.37640625 224.00710937 225.5703125 222.98046875 C226.13762027 218.95379494 225.65321777 215.27885443 224.875 211.3125 C224.73739258 210.58264893 224.59978516 209.85279785 224.45800781 209.10083008 C218.13676616 176.64104852 206.46730018 145.56943652 188 118 C187.59072266 117.3827002 187.18144531 116.76540039 186.75976562 116.12939453 C179.45017283 105.20326005 171.05970668 94.83870043 161.609375 85.6875 C159 83 159 83 159 81 C158.45085937 80.78214844 157.90171875 80.56429687 157.3359375 80.33984375 C154.24546755 78.56721634 152.04816259 76.1262584 149.625 73.5625 C143.2520165 67.00992597 136.31039773 61.46329406 129 56 C128.4529541 55.58637207 127.9059082 55.17274414 127.34228516 54.74658203 C122.15560601 50.13505814 122.15560601 50.13505814 116 48 C116 47.34 116 46.68 116 46 C115.25363281 45.72285156 114.50726562 45.44570313 113.73828125 45.16015625 C111.25382114 44.10753906 109.36960421 42.99741563 107.1875 41.4375 C75.20579164 19.80281493 37.80195991 7.44848484 0 1 C0 0.67 0 0.34 0 0 Z M76 85 C76 85.66 76 86.32 76 87 C76.99 86.67 77.98 86.34 79 86 C78.01 85.67 77.02 85.34 76 85 Z M230 203 C231 206 231 206 231 206 Z M177 210 C178 213 178 213 178 213 Z M107 242 C108 245 108 245 108 245 Z M108 246 C108.33 248.97 108.66 251.94 109 255 C109.33 255 109.66 255 110 255 C109.67 252.03 109.34 249.06 109 246 C108.67 246 108.34 246 108 246 Z M-10 308 C-10.33 308.99 -10.66 309.98 -11 311 C-10.01 310.67 -9.02 310.34 -8 310 C-8.66 309.34 -9.32 308.68 -10 308 Z ",
    fill: "#E23881",
    transform: "translate(472,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C15.67058772 13.58897233 23.13952678 31.47701724 25.09649658 51.8578186 C25.5009997 57.63654463 25.46768025 63.42042688 25.47265625 69.2109375 C25.47588129 70.59081555 25.47924622 71.97069329 25.48274231 73.35057068 C25.48869542 76.23250112 25.49058633 79.11440175 25.48999023 81.99633789 C25.48990921 84.91599758 25.49681857 87.83549959 25.51049805 90.75512695 C25.74070278 140.69673839 25.74070278 140.69673839 13.3046875 159.83203125 C12.85738281 160.52425781 12.41007813 161.21648437 11.94921875 161.9296875 C10.80661811 163.61510721 9.5642085 165.23209917 8.3046875 166.83203125 C7.6446875 166.83203125 6.9846875 166.83203125 6.3046875 166.83203125 C6.07523438 167.41210938 5.84578125 167.9921875 5.609375 168.58984375 C0.60381281 177.19221709 -12.43237115 182.38930046 -21.359375 185.87109375 C-23.90077709 186.82712993 -23.90077709 186.82712993 -26.6953125 188.83203125 C-19.20211509 194.6430823 -12.22065673 196.95504769 -2.6953125 195.83203125 C3.89193311 194.12640516 10.0798123 191.53748759 16.3046875 188.83203125 C17.33045889 192.76206304 18.34538258 196.69472016 19.3503418 200.63012695 C19.69372406 201.96845809 20.04005944 203.30603515 20.3894043 204.64282227 C20.89106799 206.56455815 21.3812397 208.48928244 21.87109375 210.4140625 C22.16959229 211.57139893 22.46809082 212.72873535 22.77563477 213.92114258 C23.3046875 216.83203125 23.3046875 216.83203125 22.3046875 219.83203125 C6.12298964 228.46080636 -11.93241082 231.2611317 -29.74609375 226.45214844 C-38.04403028 223.81227384 -45.11744369 219.46620013 -51.6953125 213.83203125 C-53.91118598 212.55350838 -53.91118598 212.55350838 -55.6953125 211.83203125 C-55.0353125 211.50203125 -54.3753125 211.17203125 -53.6953125 210.83203125 C-54.27539062 210.12240234 -54.27539062 210.12240234 -54.8671875 209.3984375 C-63.6953125 198.18846689 -63.6953125 198.18846689 -63.6953125 191.83203125 C-64.58089844 191.81785156 -65.46648437 191.80367187 -66.37890625 191.7890625 C-84.96541933 191.07345274 -104.0889497 185.15712557 -117.6953125 171.83203125 C-117.6953125 171.17203125 -117.6953125 170.51203125 -117.6953125 169.83203125 C-118.3553125 169.83203125 -119.0153125 169.83203125 -119.6953125 169.83203125 C-132.91914921 154.94547244 -138.6449504 136.44865626 -138.9765625 116.72265625 C-138.99497192 115.87403015 -139.01338135 115.02540405 -139.03234863 114.15106201 C-139.11052713 110.54630281 -139.17896 106.94137822 -139.24755859 103.33642578 C-139.29927309 100.6942421 -139.35648807 98.05221769 -139.4140625 95.41015625 C-139.42763794 94.59452209 -139.44121338 93.77888794 -139.4552002 92.9385376 C-139.52736097 89.66669862 -139.65384723 86.95642705 -140.6953125 83.83203125 C-140.2003125 82.84203125 -140.2003125 82.84203125 -139.6953125 81.83203125 C-139.64755314 80.02016059 -139.6583775 78.20665488 -139.6953125 76.39453125 C-139.84257478 49.74005772 -136.71418616 25.49165184 -117.953125 4.96484375 C-114.58711518 1.78518742 -110.86661457 -0.78536278 -107.015625 -3.34375 C-104.68203277 -5.17840921 -103.74614255 -6.43218708 -102.6953125 -9.16796875 C-101.7053125 -8.83796875 -100.7153125 -8.50796875 -99.6953125 -8.16796875 C-97.09152754 -9.05478052 -97.09152754 -9.05478052 -94.2578125 -10.41796875 C-64.84425303 -23.20647287 -25.23074339 -20.29429359 0 0 Z M-92.9453125 28.45703125 C-106.11726124 42.36367036 -104.00230125 64.82653049 -103.90112305 82.57739258 C-103.88282554 85.8921683 -103.88061447 89.20666324 -103.88085938 92.52148438 C-104.62086723 121.13065148 -104.62086723 121.13065148 -93.6953125 146.83203125 C-93.0353125 146.83203125 -92.3753125 146.83203125 -91.6953125 146.83203125 C-91.3653125 147.82203125 -91.0353125 148.81203125 -90.6953125 149.83203125 C-83.01000539 156.46934193 -72.81289927 160.33444502 -62.6953125 160.83203125 C-61.54675781 160.89003906 -61.54675781 160.89003906 -60.375 160.94921875 C-47.27316213 161.31886308 -33.86203968 158.30737987 -23.6953125 149.73828125 C-13.39149475 139.91745495 -10.79517879 127.67290616 -10.1484375 113.91015625 C-10.10680481 113.0412677 -10.06517212 112.17237915 -10.02227783 111.27716064 C-9.59760613 101.7032273 -9.47407841 92.13130568 -9.45507812 82.54882812 C-9.44527302 79.57003861 -9.41404324 76.59191345 -9.3828125 73.61328125 C-9.29352458 57.44656548 -9.38402876 39.83948697 -20.7578125 27.08203125 C-40.43812191 8.90567562 -73.93032177 11.36131061 -92.9453125 28.45703125 Z ",
    fill: "#EB2573",
    transform: "translate(247.6953125,585.16796875)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.99 3 1.98 3 3 C10.86550419 2.88220331 18.7308744 2.75737601 26.59619141 2.62768555 C29.27129929 2.58389779 31.94641119 2.54272323 34.62158203 2.50268555 C38.46915654 2.44482191 42.31659877 2.38117356 46.1640625 2.31640625 C47.95500839 2.29133751 47.95500839 2.29133751 49.78213501 2.26576233 C50.90284393 2.24581711 52.02355286 2.22587189 53.17822266 2.20532227 C54.65048813 2.18200584 54.65048813 2.18200584 56.15249634 2.15821838 C59.160219 1.99109761 62.03972965 1.54706794 65 1 C65 1.33 65 1.66 65 2 C66.79630859 2.05607422 66.79630859 2.05607422 68.62890625 2.11328125 C91.1175716 2.95849283 112.97302867 6.69769387 129.12109375 23.7265625 C139.719598 36.5505323 142.26943317 51.94671557 144 68 C144.33 68 144.66 68 145 68 C145 88.79 145 109.58 145 131 C144.67 131 144.34 131 144 131 C143.93006836 131.68924561 143.86013672 132.37849121 143.78808594 133.08862305 C141.58158015 154.32535444 139.18112036 172.56481782 123 188 C117.40565423 192.50754611 111.50158607 195.98140647 105 199 C104.34 199.33 103.68 199.66 103 200 C101.09100343 200.37477233 99.1721591 200.69995565 97.25 201 C96.22390625 201.165 95.1978125 201.33 94.140625 201.5 C82.19950063 203.07759584 70.24399706 203.13802469 58.2265625 203.09765625 C56.56505374 203.09578574 54.90354442 203.09436484 53.24203491 203.09336853 C48.91852228 203.08959313 44.5950445 203.07980681 40.27154541 203.06866455 C35.83988923 203.05834197 31.40822729 203.05384793 26.9765625 203.04882812 C18.31769253 203.03817886 9.65885063 203.0211641 1 203 C-0.91145757 196.49005943 -2.22179396 190.66538188 0 184 C-0.66 183.67 -1.32 183.34 -2 183 C-1.34 183 -0.68 183 0 183 C-0.23396484 181.93458984 -0.23396484 181.93458984 -0.47265625 180.84765625 C-0.76462891 179.46900391 -0.76462891 179.46900391 -1.0625 178.0625 C-1.25972656 177.14597656 -1.45695313 176.22945312 -1.66015625 175.28515625 C-1.77230469 174.53105469 -1.88445313 173.77695312 -2 173 C-1.67 172.67 -1.34 172.34 -1 172 C-0.91159597 170.27702445 -0.89310145 168.55041258 -0.90234375 166.82519531 C-0.90729858 165.16777313 -0.90729858 165.16777313 -0.91235352 163.47686768 C-0.92065186 162.27278259 -0.9289502 161.06869751 -0.9375 159.828125 C-0.94128662 158.5984198 -0.94507324 157.3687146 -0.94897461 156.10174561 C-0.96332082 151.48263047 -0.98647792 146.86357927 -1.01037598 142.24450684 C-1.03328299 137.73072073 -1.04864375 133.21694654 -1.0625 128.703125 C-1.07079834 127.50713684 -1.07909668 126.31114868 -1.08764648 125.07891846 C-1.09094971 123.96136169 -1.09425293 122.84380493 -1.09765625 121.69238281 C-1.10289307 120.71166809 -1.10812988 119.73095337 -1.11352539 118.72052002 C-1.00187298 116.04488406 -0.60020462 113.60575736 0 111 C-0.66 111 -1.32 111 -2 111 C-1.9278125 110.45214844 -1.855625 109.90429688 -1.78125 109.33984375 C0.15325845 96.39714526 0.15325845 96.39714526 -2 84 C-1.34 84 -0.68 84 0 84 C-0.165 83.175 -0.33 82.35 -0.5 81.5 C-0.88736085 78.78847404 -1.0395601 76.45986694 -1 73.75 C-0.7204915 70.186339 -0.7204915 70.186339 -2 68 C-1.34 68 -0.68 68 0 68 C0 66.35 0 64.7 0 63 C-0.66 63 -1.32 63 -2 63 C-1.34 60.36 -0.68 57.72 0 55 C-0.66 55 -1.32 55 -2 55 C-1.89171875 54.1646875 -1.89171875 54.1646875 -1.78125 53.3125 C-0.33659663 44.45832269 -0.33659663 44.45832269 -2 36 C-1.34 36 -0.68 36 0 36 C-0.08378906 35.07703125 -0.16757812 34.1540625 -0.25390625 33.203125 C-1.12497911 22.04457142 -0.74319422 11.15934713 0 0 Z M37 37 C37 37.54868398 37 38.09736795 37 38.66267872 C37 82.44178581 37 126.22089291 37 170 C38.98 169.01 38.98 169.01 41 168 C41.99 168.66 42.98 169.32 44 170 C46.62531524 170.16713569 46.62531524 170.16713569 49 170 C49 169.34 49 168.68 49 168 C49.58918213 168.06856201 50.17836426 168.13712402 50.78540039 168.20776367 C74.20955344 171.02420592 74.20955344 171.02420592 95.50390625 163.1875 C102.36254398 157.19857717 105.26677002 149.91758454 106.22123337 140.91279602 C106.58399705 135.31513051 106.53595503 129.71586409 106.49609375 124.109375 C106.49624912 122.31105491 106.49774436 120.51273449 106.50050354 118.7144165 C106.5018788 114.96928877 106.48947222 111.22454809 106.46655273 107.47949219 C106.43808813 102.69947859 106.44093953 97.92010278 106.45364285 93.14004135 C106.46062182 89.43551255 106.45278684 85.73112918 106.44038582 82.02661896 C106.43589866 80.26451425 106.43551035 78.50239379 106.43945122 76.74028778 C106.47179704 60.35634232 106.47179704 60.35634232 99 46 C97.03327085 44.8499169 97.03327085 44.8499169 95 44 C94.071875 43.01 94.071875 43.01 93.125 42 C89.46654086 38.55674434 85.9215371 38 81 38 C81 38.66 81 39.32 81 40 C79.68 39.67 78.36 39.34 77 39 C77.33 38.34 77.66 37.68 78 37 C76.92878906 37 75.85757813 37 74.75390625 37 C70.50260417 37 66.25130208 37 62 37 C61.01 37.495 61.01 37.495 60 38 C59.67 37.67 59.34 37.34 59 37 C55.27775401 36.70613847 54.22213757 36.85190829 51 39 C51 38.34 51 37.68 51 37 C49.865625 37 48.73125 37 47.5625 37 C44.04166667 37 40.52083333 37 37 37 Z M143 92 C143 95.3 143 98.6 143 102 C143.33 102 143.66 102 144 102 C144 98.7 144 95.4 144 92 C143.67 92 143.34 92 143 92 Z ",
    fill: "#737EBB",
    transform: "translate(517,568)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.53641869 0.68537139 2.53641869 0.68537139 4.625 -0.0625 C7.41460108 -0.67272524 9.05752286 0.38939722 11.625 1.5 C11.57170532 3.07467041 11.57170532 3.07467041 11.51733398 4.68115234 C11.38716101 8.5685228 11.26393206 12.45608749 11.14282227 16.34375 C11.08938576 18.0277307 11.03405512 19.71165239 10.97680664 21.39550781 C10.89494148 23.81302158 10.81984528 26.23066432 10.74609375 28.6484375 C10.71905869 29.4036972 10.69202362 30.15895691 10.66416931 30.93710327 C10.46211274 34.84429703 10.46211274 34.84429703 11.625 38.5 C10.366875 38.37625 9.10875 38.2525 7.8125 38.125 C6.75095703 38.02058594 6.75095703 38.02058594 5.66796875 37.9140625 C3.625 37.5 3.625 37.5 0.625 35.5 C0.625 36.16 0.625 36.82 0.625 37.5 C-0.21998047 37.25636719 -0.21998047 37.25636719 -1.08203125 37.0078125 C-3.47946869 36.47686383 -5.61022125 36.36689329 -8.0625 36.375 C-8.85011719 36.37242187 -9.63773437 36.36984375 -10.44921875 36.3671875 C-12.38264914 36.28872222 -12.38264914 36.28872222 -13.375 37.5 C-15.88717358 37.63579317 -18.00344462 37.60133329 -20.4375 36.9375 C-22.73105372 36.41960077 -24.14020863 36.88350583 -26.375 37.5 C-26.705 37.17 -27.035 36.84 -27.375 36.5 C-29.39094582 36.26572222 -31.413474 36.08663876 -33.4375 35.9375 C-34.54222656 35.85371094 -35.64695312 35.76992188 -36.78515625 35.68359375 C-37.63980469 35.62300781 -38.49445313 35.56242188 -39.375 35.5 C-39.87 36.49 -39.87 36.49 -40.375 37.5 C-42.685 36.84 -44.995 36.18 -47.375 35.5 C-47.375 36.16 -47.375 36.82 -47.375 37.5 C-50.015 36.84 -52.655 36.18 -55.375 35.5 C-55.375 36.16 -55.375 36.82 -55.375 37.5 C-56.035 37.5 -56.695 37.5 -57.375 37.5 C-57.375 36.84 -57.375 36.18 -57.375 35.5 C-59.685 35.5 -61.995 35.5 -64.375 35.5 C-64.87 36.49 -64.87 36.49 -65.375 37.5 C-66.365 37.005 -66.365 37.005 -67.375 36.5 C-71.665 36.17 -75.955 35.84 -80.375 35.5 C-80.375 51.67 -80.375 67.84 -80.375 84.5 C-54.305 84.5 -28.235 84.5 -1.375 84.5 C-1.375 95.06 -1.375 105.62 -1.375 116.5 C-3.8045903 118.9295903 -5.06888913 118.73446257 -8.38343811 118.74884033 C-9.07755295 118.74164978 -9.77166779 118.73445923 -10.48681641 118.72705078 C-11.58453117 118.72748886 -11.58453117 118.72748886 -12.704422 118.72793579 C-15.12858854 118.72654001 -17.55244951 118.7109674 -19.9765625 118.6953125 C-21.65522087 118.69158325 -23.33388141 118.68873586 -25.01254272 118.68673706 C-29.43491607 118.67909369 -33.85715845 118.65943922 -38.27947998 118.6373291 C-42.79046863 118.61688579 -47.3014784 118.60773859 -51.8125 118.59765625 C-60.66672427 118.57619394 -69.52085125 118.54204955 -78.375 118.5 C-78.705 120.15 -79.035 121.8 -79.375 123.5 C-79.045 123.5 -78.715 123.5 -78.375 123.5 C-78.375 127.13 -78.375 130.76 -78.375 134.5 C-78.705 134.5 -79.035 134.5 -79.375 134.5 C-79.705 138.46 -80.035 142.42 -80.375 146.5 C-79.715 146.5 -79.055 146.5 -78.375 146.5 C-78.705 147.49 -79.035 148.48 -79.375 149.5 C-79.47152378 152.36448509 -79.51425903 155.19881075 -79.5 158.0625 C-79.50386719 158.84302734 -79.50773437 159.62355469 -79.51171875 160.42773438 C-79.60983265 164.59669875 -79.60983265 164.59669875 -78.375 168.5 C-53.955 168.5 -29.535 168.5 -4.375 168.5 C-4.375 167.84 -4.375 167.18 -4.375 166.5 C-3.715 166.83 -3.055 167.16 -2.375 167.5 C-0.83831135 167.72467831 0.70468054 167.90796805 2.25 168.0625 C3.06726563 168.14628906 3.88453125 168.23007812 4.7265625 168.31640625 C5.35304688 168.37699219 5.97953125 168.43757812 6.625 168.5 C6.955 167.84 7.285 167.18 7.625 166.5 C8.285 166.5 8.945 166.5 9.625 166.5 C9.625 167.82 9.625 169.14 9.625 170.5 C10.285 170.83 10.945 171.16 11.625 171.5 C10.965 171.5 10.305 171.5 9.625 171.5 C9.625 181.4 9.625 191.3 9.625 201.5 C-32.285 201.5 -74.195 201.5 -117.375 201.5 C-118.14052538 198.43789846 -118.50033652 196.45851706 -118.50198364 193.42155457 C-118.50480347 192.61841324 -118.50762329 191.81527191 -118.51052856 190.98779297 C-118.50749222 189.67935425 -118.50749222 189.67935425 -118.50439453 188.34448242 C-118.50614685 187.41879959 -118.50789917 186.49311676 -118.50970459 185.53938293 C-118.514107 182.47805915 -118.51119003 179.41679313 -118.5078125 176.35546875 C-118.50848617 174.22561126 -118.50945673 172.09575384 -118.51071167 169.96589661 C-118.5121866 165.49963652 -118.51004126 161.03339643 -118.50537109 156.56713867 C-118.49968432 150.85081222 -118.50294744 145.13453283 -118.50894356 139.41820812 C-118.51256352 135.01808826 -118.5114038 130.61797947 -118.50881577 126.21785927 C-118.50814993 124.1107921 -118.5089629 122.00372392 -118.51129532 119.89665794 C-118.51384422 116.94564541 -118.50994925 113.99470813 -118.50439453 111.04370117 C-118.50641876 110.17748138 -118.50844299 109.3112616 -118.51052856 108.41879272 C-118.49404257 103.67379959 -118.16789236 99.18005219 -117.375 94.5 C-118.035 94.17 -118.695 93.84 -119.375 93.5 C-118.715 93.5 -118.055 93.5 -117.375 93.5 C-117.53726074 92.4076001 -117.69952148 91.3152002 -117.86669922 90.18969727 C-118.51854321 84.94626991 -118.51863939 79.74230721 -118.5078125 74.46484375 C-118.50876923 73.42735489 -118.50972595 72.38986603 -118.51071167 71.32093811 C-118.51138908 69.13835591 -118.50956557 66.95577164 -118.50537109 64.77319336 C-118.50001119 61.44445246 -118.50533386 58.11584615 -118.51171875 54.78710938 C-118.511058 52.65885387 -118.50977689 50.53059845 -118.5078125 48.40234375 C-118.50983673 47.41362778 -118.51186096 46.4249118 -118.51394653 45.40623474 C-118.49682261 40.32882594 -118.24795975 35.50413123 -117.375 30.5 C-118.035 30.17 -118.695 29.84 -119.375 29.5 C-118.715 29.5 -118.055 29.5 -117.375 29.5 C-117.45878906 28.49582031 -117.54257812 27.49164062 -117.62890625 26.45703125 C-117.73228173 25.07555897 -117.83511643 23.69404615 -117.9375 22.3125 C-117.99357422 21.65830078 -118.04964844 21.00410156 -118.10742188 20.33007812 C-118.43425953 15.73256183 -118.25867623 11.29751188 -117.88256836 6.7019043 C-117.78866318 5.53837936 -117.694758 4.37485443 -117.5980072 3.17607117 C-117.52441483 2.29296768 -117.45082245 1.4098642 -117.375 0.5 C-116.79447184 0.50092179 -116.21394367 0.50184359 -115.61582375 0.50279331 C-101.50339048 0.52485834 -87.39095979 0.54141635 -73.27851295 0.55181217 C-66.45389818 0.55697288 -59.6292949 0.56401129 -52.8046875 0.57543945 C-46.22356567 0.58645465 -39.64245269 0.59227777 -33.06132126 0.59487724 C-30.54541205 0.5967307 -28.02950353 0.60034981 -25.5135994 0.60573006 C-22.00075087 0.61294622 -18.48795235 0.61399069 -14.97509766 0.61352539 C-13.4009333 0.6189183 -13.4009333 0.6189183 -11.79496765 0.62442017 C-10.84141891 0.6230455 -9.88787018 0.62167084 -8.90542603 0.62025452 C-8.07396875 0.62117631 -7.24251148 0.6220981 -6.38585854 0.62304783 C-3.67245429 0.45701004 -2.77743419 -0.58472299 0 0 Z ",
    fill: "#F12576",
    transform: "translate(484.375,569.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.93742341 -0.02703381 3.87495479 -0.04641125 5.8125 -0.0625 C6.89144531 -0.07410156 7.97039063 -0.08570313 9.08203125 -0.09765625 C12 0 12 0 15 1 C15.99 0.67 16.98 0.34 18 0 C20.03992808 -0.09398043 22.08291414 -0.12992069 24.125 -0.125 C25.20007813 -0.12757813 26.27515625 -0.13015625 27.3828125 -0.1328125 C30 0 30 0 31 1 C32.671549 0.69208308 34.33805547 0.35613097 36 0 C36.99 0 37.98 0 39 0 C40.19625 -0.020625 41.3925 -0.04125 42.625 -0.0625 C46 0 46 0 47 1 C48.99958364 1.04080783 51.00045254 1.04254356 53 1 C53 1.66 53 2.32 53 3 C57.06275446 2.86076952 61.12512857 2.71246082 65.1875 2.5625 C66.33798828 2.52318359 67.48847656 2.48386719 68.67382812 2.44335938 C69.78564453 2.40146484 70.89746094 2.35957031 72.04296875 2.31640625 C73.06414795 2.27974854 74.08532715 2.24309082 75.13745117 2.20532227 C77.98924835 2.06862168 77.98924835 2.06862168 80.68481445 1.41772461 C83 1 83 1 86 2 C88 4 88 4 88.22705078 6.79736328 C88.21657715 7.95993652 88.20610352 9.12250977 88.1953125 10.3203125 C88.18886719 11.57714844 88.18242188 12.83398438 88.17578125 14.12890625 C88.15064453 16.10697266 88.15064453 16.10697266 88.125 18.125 C88.11496983 19.46483721 88.10584404 20.80468152 88.09765625 22.14453125 C88.07402075 25.42986573 88.04107234 28.71484465 88 32 C88.66 32 89.32 32 90 32 C90.495 33.98 90.495 33.98 91 36 C86.92845714 38.10144148 83.59731561 38.11805803 79.140625 38 C76.88171056 37.92850447 76.88171056 37.92850447 74.25 38.5625 C71.56195268 39.08517587 69.66706254 38.53341251 67 38 C64.36195411 38.39397335 64.36195411 38.39397335 62 39 C54 39 46 39 38 39 C38 38.34 38 37.68 38 37 C36.52031676 37.14049518 35.04125484 37.28754826 33.5625 37.4375 C32.73878906 37.51871094 31.91507813 37.59992187 31.06640625 37.68359375 C29.01337975 37.78930815 29.01337975 37.78930815 28 39 C26.33391013 39.04384447 24.66619446 39.0396713 23 39 C20.06406867 39 17.23443584 39.22499427 14.3125 39.5 C13.31863281 39.5928125 12.32476563 39.685625 11.30078125 39.78125 C10.16189453 39.88953125 10.16189453 39.88953125 9 40 C9.09364965 45.05403538 9.19976907 50.10759821 9.31738281 55.16113281 C9.35563327 56.87981011 9.39049303 58.59856638 9.421875 60.31738281 C9.46761128 62.7900004 9.52559084 65.26207613 9.5859375 67.734375 C9.59748871 68.50118591 9.60903992 69.26799683 9.62094116 70.05804443 C9.72788554 73.93568618 10.15112486 76.61122083 12 80 C11.505 81.485 11.505 81.485 11 83 C11.66 83 12.32 83 13 83 C13 83.99 13 84.98 13 86 C35.44 86 57.88 86 81 86 C81.495 84.515 81.495 84.515 82 83 C82 83.99 82 84.98 82 86 C83.485 86.495 83.485 86.495 85 87 C84.01 87.495 84.01 87.495 83 88 C83 96.91 83 105.82 83 115 C83.66 115.33 84.32 115.66 85 116 C84.34 116 83.68 116 83 116 C83 116.66 83 117.32 83 118 C83.66 118.33 84.32 118.66 85 119 C81.49717623 120.16760792 78.83768417 120.08060028 75.1418457 120.02172852 C74.44890411 120.01212097 73.75596252 120.00251343 73.04202271 119.99261475 C70.75317131 119.95965169 68.4645124 119.91930925 66.17578125 119.87890625 C64.58823829 119.85460249 63.00068823 119.83075906 61.41313171 119.80735779 C57.23570658 119.74454228 53.05840738 119.67546846 48.88110352 119.60510254 C44.61805962 119.53439622 40.35492647 119.46959301 36.09179688 119.40429688 C27.72776382 119.27531715 19.36386951 119.13918216 11 119 C11 124.61 11 130.22 11 136 C10.67 136 10.34 136 10 136 C9.94195719 140.41661151 9.90638896 144.83312496 9.875 149.25 C9.85824219 150.50425781 9.84148438 151.75851562 9.82421875 153.05078125 C9.81777344 154.25605469 9.81132813 155.46132813 9.8046875 156.703125 C9.79421387 157.81333008 9.78374023 158.92353516 9.77294922 160.06738281 C9.99946231 162.99305509 10.62819358 164.47194885 12 167 C19.44827085 167.14525351 26.8965987 167.28727669 34.3449707 167.42724609 C36.86907282 167.47503709 39.39316198 167.52351818 41.91723633 167.57275391 C57.28152319 167.87191944 72.63264547 168.05520379 88 168 C88.33 179.55 88.66 191.1 89 203 C50.39 203 11.78 203 -28 203 C-28 136.34 -28 69.68 -28 1 C-27.67 1.66 -27.34 2.32 -27 3 C-18.42 2.67 -9.84 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z M8 2 C12 3 12 3 12 3 Z M15 2 C15 2.33 15 2.66 15 3 C16.65 3 18.3 3 20 3 C20 2.67 20 2.34 20 2 C18.35 2 16.7 2 15 2 Z M21 2 C21 2.33 21 2.66 21 3 C23.64 3 26.28 3 29 3 C29 2.67 29 2.34 29 2 C26.36 2 23.72 2 21 2 Z M32 2 C36 3 36 3 36 3 Z M40 2 C40 2.33 40 2.66 40 3 C41.98 3 43.96 3 46 3 C46 2.67 46 2.34 46 2 C44.02 2 42.04 2 40 2 Z M48 2 C52 3 52 3 52 3 Z M88 33 C89 36 89 36 89 36 Z M48 37 C52 38 52 38 52 38 Z M9 84 C9 84.66 9 85.32 9 86 C9.66 85.67 10.32 85.34 11 85 C10.34 84.67 9.68 84.34 9 84 Z ",
    fill: "#7480BD",
    transform: "translate(715,568)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C2.051875 1.649375 3.10375 1.29875 4.1875 0.9375 C7.88859572 0.02739449 9.43467379 0.10866845 13 1 C13.99 0.67 14.98 0.34 16 0 C19.94767545 1.22833737 21.15832235 3.53342409 23.0625 7.0625 C25.06283026 11.12366149 25.06283026 11.12366149 29 13 C29.41701656 15.05467533 29.82993796 17.11023637 30.2265625 19.16894531 C31.84986238 25.11079676 35.1063302 30.4661854 38 35.875 C38.67748406 37.1598892 39.35399053 38.44529431 40.02954102 39.73120117 C41.37604212 42.29022468 42.72830827 44.8460486 44.08642578 47.39892578 C45.80721843 50.63374959 47.5138473 53.87580724 49.21484375 57.12109375 C51.46769231 61.41879967 53.73012173 65.71126529 56 70 C59.10726428 66.22547063 61.24285163 61.99694004 63.5 57.6875 C63.89058594 56.95337891 64.28117188 56.21925781 64.68359375 55.46289062 C67.01015309 51.04869471 69.08478604 46.60702383 71 42 C72.61370882 38.77258236 74.45267373 35.66226879 76.35253906 32.5949707 C78.85962585 28.42982092 80.60824415 24.38361883 82.15625 19.76953125 C87.08746667 6.5578328 87.08746667 6.5578328 93 2 C104.89174685 -2.3299563 121.87770236 -0.74876345 134 2 C132.38055656 8.0179318 129.2545552 13.04650073 126.125 18.375 C122.54822393 24.50164319 119.0982655 30.61613201 116 37 C115 39 115 39 113.12255859 41.30541992 C111.13019411 43.83471908 109.58492701 46.29575106 108.0390625 49.11328125 C107.49161377 50.10295898 106.94416504 51.09263672 106.38012695 52.11230469 C105.80093506 53.16836914 105.22174316 54.22443359 104.625 55.3125 C99.61862679 64.35154446 94.53127041 73.3315605 89.3125 82.25 C88.72484863 83.25458252 88.13719727 84.25916504 87.53173828 85.29418945 C83.16511448 92.74377489 83.16511448 92.74377489 81.28686523 95.65844727 C79.70634038 97.91527679 79.70634038 97.91527679 80.546875 100.32421875 C81.02640625 101.20722656 81.5059375 102.09023438 82 103 C82.29326172 103.55896973 82.58652344 104.11793945 82.88867188 104.69384766 C83.98005749 106.75056704 85.11075395 108.78190568 86.25 110.8125 C86.68618652 111.59383301 87.12237305 112.37516602 87.57177734 113.18017578 C91.75866787 120.64148538 96.07695273 128.02493167 100.40112305 135.40722656 C105.00081 143.26633517 109.54702919 151.15483276 114.0625 159.0625 C114.39601471 159.64626404 114.72952942 160.23002808 115.07315063 160.83148193 C118.66763064 167.12517429 122.24569526 173.42784513 125.796875 179.74609375 C126.68814087 181.33055298 126.68814087 181.33055298 127.59741211 182.94702148 C128.71032184 184.92808002 129.82066616 186.91058277 130.92797852 188.89477539 C131.42225342 189.77512451 131.91652832 190.65547363 132.42578125 191.5625 C132.85286377 192.32691406 133.27994629 193.09132813 133.7199707 193.87890625 C134.98186504 196.06105345 134.98186504 196.06105345 136.66088867 198.15234375 C138 200 138 200 138 202 C132.55566741 202.02479204 127.11136797 202.04290359 121.66699219 202.05493164 C119.81640042 202.05994811 117.9658126 202.06676282 116.11523438 202.07543945 C113.44920883 202.0876229 110.78323588 202.09325528 108.1171875 202.09765625 C107.29507782 202.10281754 106.47296814 202.10797882 105.62594604 202.11329651 C96.34811304 202.11419451 96.34811304 202.11419451 93 201 C91.02124023 198.30371094 91.02124023 198.30371094 89.30859375 194.734375 C88.99600113 194.10396301 88.68340851 193.47355103 88.36134338 192.82403564 C87.3656125 190.80889452 86.40009361 188.78115198 85.4375 186.75 C84.46740961 184.73547539 83.49101032 182.72458296 82.50294495 180.71881104 C81.6046192 178.89054562 80.72642736 177.05242793 79.84936523 175.21386719 C77.93189278 171.8816418 75.7365372 169.66818865 73 167 C72.375 164.0625 72.375 164.0625 72 161 C70.58906754 157.81006573 69.46722167 155.46722167 67 153 C66.30251417 151.68252676 65.63040043 150.35085807 65 149 C64.34 149 63.68 149 63 149 C62.90203125 148.443125 62.8040625 147.88625 62.703125 147.3125 C61.71748334 142.28232877 60.28854305 138.11616353 57.8046875 133.62890625 C57 132 57 132 57 130 C56.01 129.67 55.02 129.34 54 129 C54 128.34 54 127.68 54 127 C53.65855957 127.71841064 53.31711914 128.43682129 52.96533203 129.17700195 C46.35631349 143.05815498 39.63494035 156.83989986 32.38330078 170.39941406 C29.53717573 175.75008898 26.73899849 181.1258686 23.9375 186.5 C23.36451172 187.59393066 22.79152344 188.68786133 22.20117188 189.81494141 C21.66943359 190.83507324 21.13769531 191.85520508 20.58984375 192.90625 C20.11409912 193.81697266 19.63835449 194.72769531 19.14819336 195.66601562 C17.90444104 198.06164494 17.90444104 198.06164494 17 201 C11.76100772 201.87266212 6.74677147 202.13410177 1.44140625 202.09765625 C0.65225327 202.0962413 -0.13689972 202.09482635 -0.94996643 202.09336853 C-3.44585115 202.08781555 -5.94164285 202.07527208 -8.4375 202.0625 C-10.13997265 202.05747891 -11.84244673 202.05291707 -13.54492188 202.04882812 C-17.69664988 202.03786158 -21.84830922 202.02062991 -26 202 C-14 178 -14 178 -12.60717773 176.18139648 C-10.92695389 173.90085569 -9.61493868 171.59789342 -8.28515625 169.09765625 C-7.77033691 168.13625732 -7.25551758 167.1748584 -6.72509766 166.18432617 C-6.17644043 165.15412354 -5.6277832 164.1239209 -5.0625 163.0625 C-0.84751001 155.21221357 3.4275233 147.40851937 7.875 139.6875 C9.35930174 137.09954484 10.84260439 134.51101921 12.32568359 131.92236328 C13.53848072 129.80553891 14.75250601 127.68941804 15.96728516 125.57373047 C17.71094625 122.53242942 19.44116947 119.48375371 21.16436768 116.43081665 C21.8391418 115.23984816 22.51789407 114.05112363 23.2008667 112.86483765 C24.15874486 111.1997485 25.10112442 109.52577326 26.04296875 107.8515625 C26.58977295 106.89072754 27.13657715 105.92989258 27.69995117 104.93994141 C29.17193437 101.61118617 29.63725271 98.60724218 30 95 C29.0409375 94.814375 29.0409375 94.814375 28.0625 94.625 C27.381875 94.41875 26.70125 94.2125 26 94 C25.67 93.34 25.34 92.68 25 92 C25.66 92 26.32 92 27 92 C23.7 85.73 20.4 79.46 17 73 C16.01 73 15.02 73 14 73 C14.495 71.515 14.495 71.515 15 70 C14.08525612 67.62905555 14.08525612 67.62905555 12.60546875 65.08984375 C12.06672119 64.10830322 11.52797363 63.1267627 10.97290039 62.11547852 C10.38371826 61.06674561 9.79453613 60.0180127 9.1875 58.9375 C8.59380615 57.86363037 8.0001123 56.78976074 7.38842773 55.68334961 C6.17626817 53.4932587 4.95987306 51.30550672 3.73925781 49.12011719 C2.18392115 46.32994278 0.64582983 43.53142075 -0.8828125 40.7265625 C-6.70772631 29.37237468 -6.70772631 29.37237468 -14 19 C-14.66 19 -15.32 19 -16 19 C-16.061875 18.05125 -16.12375 17.1025 -16.1875 16.125 C-16.89171763 10.92872751 -19.52049381 6.54728625 -22 2 C-17.57576535 0.88523221 -13.27758596 0.9185686 -8.75 1 C-6.16031188 1.0455931 -3.59104894 1.04732509 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z M64 146 C65 148 65 148 65 148 Z ",
    fill: "#727EB8",
    transform: "translate(834,569)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.55750977 0.00676758 1.55750977 0.00676758 3.14648438 0.01367188 C5.66022175 0.02525592 8.17382623 0.04156077 10.6875 0.0625 C11.90782574 3.72347722 11.8257131 7.0841917 11.81448364 10.89541626 C11.81604363 11.70173378 11.81760362 12.50805131 11.81921089 13.3388027 C11.82321016 16.04961734 11.82003539 18.76037631 11.81689453 21.47119141 C11.81824902 23.41087375 11.82002923 25.35055583 11.82220459 27.29023743 C11.82677258 32.56475849 11.82499211 37.83926004 11.8218255 43.11378145 C11.81929937 48.62398107 11.82164008 54.13417898 11.82321167 59.64437866 C11.82503231 68.89671123 11.82262948 78.14903583 11.81787109 87.40136719 C11.81242547 98.11403054 11.81419374 108.82667486 11.8196975 119.53933775 C11.82422779 128.72320361 11.82487969 137.90706373 11.82225883 147.09093034 C11.820696 152.58224638 11.82050251 158.07355346 11.82379532 163.56486893 C11.82667292 168.72431776 11.82470041 173.88374194 11.81890106 179.0431881 C11.817573 180.94236269 11.81796835 182.84153933 11.82016373 184.74071312 C11.82287335 187.32168761 11.81949647 189.90258174 11.81448364 192.48355103 C11.81671436 193.24510864 11.81894509 194.00666625 11.82124341 194.79130137 C11.80165006 199.94834994 11.80165006 199.94834994 10.6875 201.0625 C-1.1925 201.0625 -13.0725 201.0625 -25.3125 201.0625 C-25.3125 135.0625 -25.3125 69.0625 -25.3125 1.0625 C-16.7766355 0.40589504 -8.52085323 -0.07225772 0 0 Z ",
    fill: "#F22576",
    transform: "translate(324.3125,569.9375)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C18.03925562 -0.99900941 33.00851772 0.92056569 50 7 C51.50906341 7.51837817 53.01817389 8.03661932 54.52734375 8.5546875 C67.01828316 12.95856328 78.88888514 18.80115165 90.609375 24.93359375 C93.02034648 26.2036921 93.02034648 26.2036921 96 26 C97.34886024 27.31762347 98.67995673 28.65350777 100 30 C101.73418447 31.06228758 103.50856186 32.06103361 105.3125 33 C106.77042969 33.7734375 106.77042969 33.7734375 108.2578125 34.5625 C109.16273438 35.036875 110.06765625 35.51125 111 36 C119.36346813 40.46051633 126.56997024 46.38632214 133.875 52.375 C135.18455066 53.4457348 136.49445189 54.51604097 137.8046875 55.5859375 C138.81571533 56.41472412 138.81571533 56.41472412 139.84716797 57.26025391 C141.33316859 58.46112036 142.8332153 59.64473961 144.34423828 60.81396484 C151.0801576 66.0547899 157.1193026 71.81869279 163.125 77.875 C164.09081316 78.83366861 165.05695753 79.79200365 166.0234375 80.75 C166.92578125 81.65492187 167.828125 82.55984375 168.7578125 83.4921875 C169.5739502 84.31058105 170.39008789 85.12897461 171.23095703 85.97216797 C173 88 173 88 173 90 C173.99 90.33 174.98 90.66 176 91 C177.82421875 92.99609375 177.82421875 92.99609375 179.6875 95.4375 C180.62142578 96.64212891 180.62142578 96.64212891 181.57421875 97.87109375 C183 100 183 100 183 102 C183.66 102 184.32 102 185 102 C186.5993954 104.11304738 188.06064049 106.21791407 189.5 108.4375 C190.16104736 109.44598999 190.16104736 109.44598999 190.83544922 110.47485352 C207.81047055 136.62434058 220.6472734 164.15872541 228.35180664 194.42675781 C228.8438466 196.3005134 229.41479721 198.15321874 230 200 C230.66 200.33 231.32 200.66 232 201 C231.98259766 201.58555664 231.96519531 202.17111328 231.94726562 202.77441406 C231.85344368 208.47298008 232.29407033 213.90635751 233.06787109 219.54785156 C236.51937148 245.12405443 236.62141559 271.62118888 232.26953125 297.07861328 C231.92945679 299.0942822 231.92945679 299.0942822 232.09375 301.52734375 C231.97067572 304.77342782 230.93673867 307.42924045 229.86035156 310.47900391 C228.97116815 313.08448289 228.21886778 315.70029081 227.4921875 318.35546875 C217.7999359 353.51322293 201.23695981 388.04515804 175 414 C174.31421875 414.7321875 173.6284375 415.464375 172.921875 416.21875 C165.37645564 424.14415451 156.76910216 430.50218988 148 437 C147.32807617 437.5153833 146.65615234 438.0307666 145.96386719 438.56176758 C143.18368102 440.59782883 140.16928255 442.1531212 137.125 443.75 C136.14611816 444.26735718 136.14611816 444.26735718 135.14746094 444.79516602 C110.14248474 457.95014087 78.76591654 468.26764395 50 463 C48.64857956 462.37080606 47.31154609 461.70856833 46 461 C44.34259285 460.62331656 42.67654729 460.27942455 41 460 C41.66 459.67 42.32 459.34 43 459 C43.33 458.01 43.66 457.02 44 456 C53.57 456 63.14 456 73 456 C73 455.67 73 455.34 73 455 C74.0415625 454.90203125 75.083125 454.8040625 76.15625 454.703125 C113.44735029 450.92881098 148.42375212 433.92663692 173.25 405.4375 C174.17169072 404.29570404 175.08786227 403.14944185 176 402 C176.67160156 401.20464844 177.34320312 400.40929687 178.03515625 399.58984375 C203.89062103 368.76729139 219.61888641 331.64585871 226 292 C226.18691406 290.89446777 226.37382813 289.78893555 226.56640625 288.64990234 C228.47615568 275.8011216 228.22277873 262.96213945 228.125 250 C228.1149453 247.66406636 228.10582388 245.3281285 228.09765625 242.9921875 C228.0758513 237.32803149 228.04257295 231.66403604 228 226 C227.01 226 226.02 226 225 226 C225.18820312 225.00355469 225.37640625 224.00710937 225.5703125 222.98046875 C226.13762027 218.95379494 225.65321777 215.27885443 224.875 211.3125 C224.73739258 210.58264893 224.59978516 209.85279785 224.45800781 209.10083008 C218.13676616 176.64104852 206.46730018 145.56943652 188 118 C187.38608398 117.07405029 187.38608398 117.07405029 186.75976562 116.12939453 C179.45017283 105.20326005 171.05970668 94.83870043 161.609375 85.6875 C159 83 159 83 159 81 C158.45085937 80.78214844 157.90171875 80.56429687 157.3359375 80.33984375 C154.24546755 78.56721634 152.04816259 76.1262584 149.625 73.5625 C143.2520165 67.00992597 136.31039773 61.46329406 129 56 C128.4529541 55.58637207 127.9059082 55.17274414 127.34228516 54.74658203 C122.15560601 50.13505814 122.15560601 50.13505814 116 48 C116 47.34 116 46.68 116 46 C115.25363281 45.72285156 114.50726562 45.44570313 113.73828125 45.16015625 C111.25382114 44.10753906 109.36960421 42.99741563 107.1875 41.4375 C75.20579164 19.80281493 37.80195991 7.44848484 0 1 C0 0.67 0 0.34 0 0 Z M230 203 C231 206 231 206 231 206 Z ",
    fill: "#70739D",
    transform: "translate(472,0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.99 2 3.98 2 5 2 C5 2.66 5 3.32 5 4 C5.54962402 4.16363037 6.09924805 4.32726074 6.66552734 4.49584961 C12.37657286 6.28472741 17.43348726 8.60317615 22.625 11.5625 C23.40133789 12.00013672 24.17767578 12.43777344 24.97753906 12.88867188 C32.57389307 17.22855864 39.8250105 22.00180278 47 27 C47.59264648 27.40718262 48.18529297 27.81436523 48.79589844 28.23388672 C57.65521897 34.32617997 65.91586951 40.91585961 74 48 C75.2065625 49.03833984 75.2065625 49.03833984 76.4375 50.09765625 C82.05547535 55.02287451 87.37840144 60.2467507 92.6875 65.5 C93.40067383 66.20012207 94.11384766 66.90024414 94.84863281 67.62158203 C99.6848861 72.44996601 103.90351564 77.53678901 108 83 C108.97225751 84.25002266 109.94613529 85.49878732 110.921875 86.74609375 C129.84552637 111.29471471 158 152.02034023 158 184 C158.66 184.33 159.32 184.66 160 185 C160.27393012 186.88353499 160.53487095 188.76995106 160.72705078 190.66357422 C161.00043944 193.00376157 161.41886828 195.26101215 161.90234375 197.56640625 C173.64135565 253.8639026 166.99800194 313.44187627 144 366 C143.59910156 366.92151855 143.19820312 367.84303711 142.78515625 368.79248047 C134.7053963 387.12757508 124.50433516 404.32757992 112 420 C111.35933594 420.83144531 110.71867188 421.66289062 110.05859375 422.51953125 C105.8735134 427.88827069 101.41600145 432.9180639 96.68017578 437.80273438 C94.53729644 440.0648763 93.05246378 441.86309634 91.9296875 444.79296875 C91.46949219 445.88544922 91.46949219 445.88544922 91 447 C89.0859375 447.6015625 89.0859375 447.6015625 87 448 C85.27593036 449.47329538 85.27593036 449.47329538 83.625 451.375 C51.95730426 484.1548699 3.86575866 503.49358215 -41.18945312 504.29711914 C-52.55877288 504.35425596 -63.73501828 503.48782777 -75 502 C-75 502.33 -75 502.66 -75 503 C-76.65 503 -78.3 503 -80 503 C-79.67 502.01 -79.34 501.02 -79 500 C-80.175625 499.938125 -81.35125 499.87625 -82.5625 499.8125 C-89.66707832 499.06105422 -96.31133204 496.38818052 -103 494 C-99.33054929 492.65940442 -97.27423908 493.3807884 -93.6875 494.75 C-74.99630705 501.28065778 -54.6680671 502.50074287 -35 502 C-36.65 501.67 -38.3 501.34 -40 501 C-40 500.67 -40 500.34 -40 500 C-38.35 499.67 -36.7 499.34 -35 499 C-35.90202148 498.98598145 -35.90202148 498.98598145 -36.82226562 498.97167969 C-61.37961545 498.49835208 -85.63051253 495.7852886 -108 485 C-103.96358347 483.65452782 -101.61437682 485.1372671 -97.875 486.6875 C-57.45556738 502.54584198 -12.2399673 497.81476456 27 481 C42.59523842 474.17944096 56.86807997 464.76625736 70 454 C70.62277832 453.49082031 71.24555664 452.98164063 71.88720703 452.45703125 C73.83055036 450.85782667 75.76145221 449.24498003 77.6875 447.625 C78.58879639 446.87500732 78.58879639 446.87500732 79.50830078 446.10986328 C82.4393387 443.6037116 84.45365192 441.52689242 86 438 C87.62428502 436.61258988 89.25154039 435.22848809 90.89453125 433.86328125 C106.11966993 420.38945723 117.02916648 402.4721882 127 385 C127.4031543 384.30890137 127.80630859 383.61780273 128.22167969 382.90576172 C143.49262213 356.61448443 158.55768047 320.2650632 156.91015625 289.2578125 C157 287 157 287 159 285 C160.50772529 277.81708491 160.13307143 270.16768895 160.09765625 262.8671875 C160.0962413 261.74933868 160.09482635 260.63148987 160.09336853 259.47976685 C160.08781622 255.94481617 160.07527279 252.40993121 160.0625 248.875 C160.05747883 246.46354259 160.05291701 244.05208417 160.04882812 241.640625 C160.03786246 235.76039463 160.02117253 229.88020201 160 224 C159.34 223.67 158.68 223.34 158 223 C158.33 220.36 158.66 217.72 159 215 C158.34 214.67 157.68 214.34 157 214 C156.65625 211.63671875 156.65625 211.63671875 156.5 208.6875 C156.29800449 204.90513408 155.91409596 202.28441466 154 199 C153.67 198.34 153.34 197.68 153 197 C153.66 197 154.32 197 155 197 C148.37006993 166.72359458 136.63590855 124.63590855 114 102 C113.10618612 100.67920497 112.2340045 99.34369418 111.375 98 C106.92901875 91.25512113 101.83106725 85.06031701 96.5 79 C94 76 94 76 94 74 C93.34 74 92.68 74 92 74 C90.62689293 72.70766393 89.28965176 71.37562854 88 70 C87.01 70.33 86.02 70.66 85 71 C85 70.34 85 69.68 85 69 C85.66 69 86.32 69 87 69 C79.05320497 59.66251584 70.61009204 51.61969178 61 44 C60.41814941 43.5359375 59.83629883 43.071875 59.23681641 42.59375 C57.38992577 41.12132831 55.53952291 39.65345982 53.6875 38.1875 C53.11306152 37.73141357 52.53862305 37.27532715 51.94677734 36.80541992 C48.40246236 34.01854692 44.78235434 31.45481091 41 29 C40.34 29.66 39.68 30.32 39 31 C38.7834375 29.94232422 38.7834375 29.94232422 38.5625 28.86328125 C36.15141373 24.44496566 32.272671 22.66445865 28 20.1875 C27.16726563 19.68541016 26.33453125 19.18332031 25.4765625 18.66601562 C21.49518239 16.00634658 21.49518239 16.00634658 17 15 C16.61199219 14.59136719 16.22398437 14.18273438 15.82421875 13.76171875 C13.17356023 11.20187508 10.01189686 9.58709024 6.8125 7.8125 C6.15830078 7.44447266 5.50410156 7.07644531 4.83007812 6.69726562 C3.22253039 5.7937534 1.61159349 4.8962759 0 4 C0 2.66666667 0 1.33333333 0 0 Z ",
    fill: "#68698C",
    transform: "translate(563,1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.26122711 -0.02510127 10.52241781 -0.04304552 15.78369141 -0.05493164 C17.56592416 -0.05989742 19.34815299 -0.06667228 21.13037109 -0.07543945 C36.66191396 -0.14981586 51.97363946 -0.04449962 67.25 3.125 C68.31428223 3.34454346 69.37856445 3.56408691 70.47509766 3.7902832 C92.25476405 8.49548538 113.37623673 16.83045958 130 32 C130.69996094 32.58265625 131.39992188 33.1653125 132.12109375 33.765625 C156.29831193 53.93687136 171.75957657 85.07651794 174.75 116.2890625 C174.8325 117.51367188 174.915 118.73828125 175 120 C175.0825 121.12148438 175.165 122.24296875 175.25 123.3984375 C176.02431862 144.15985554 169.33520113 165.45110722 155.6875 181.1875 C144.27021151 193.32548112 129.72795838 201.63483963 112.91015625 202.9765625 C108.13018318 203.01505893 103.64634209 202.03252046 99 201 C97.00092329 200.66117344 95.00144274 200.32455828 93 200 C93 199.34 93 198.68 93 198 C92.01 197.6596875 92.01 197.6596875 91 197.3125 C87.07265467 195.59428642 83.58739822 193.33225393 80 191 C81.95066761 200.80467139 84.63980921 210.85752331 92.6875 217.4375 C104.12193786 224.91635728 117.68241474 226.44950782 130.93359375 223.78515625 C151.73223679 218.45964383 169.7224427 205.68111776 181.125 187.25 C182.10061176 185.50957348 183.0578144 183.75874645 184 182 C184.57621094 180.97390625 185.15242187 179.9478125 185.74609375 178.890625 C190.7280046 169.59105809 193.48996718 160.20206888 196 150 C195.01 150 194.02 150 193 150 C193.33 149.34 193.66 148.68 194 148 C194.99 148.33 195.98 148.66 197 149 C197 148.01 197 147.02 197 146 C197.99 146 198.98 146 200 146 C196.989744 165.97393395 191.23057187 183.67698056 179 200 C178.33613281 200.92039062 177.67226563 201.84078125 176.98828125 202.7890625 C165.73880117 217.55270549 148.65885183 229.1024868 130.27734375 232.6015625 C114.62953317 234.50391849 99.93631642 232.35340658 86.72265625 223.46875 C86.15417969 222.9840625 85.58570313 222.499375 85 222 C85 221.34 85 220.68 85 220 C84.34 220 83.68 220 83 220 C78.49686457 214.16588858 75.2422722 207.83529671 72.82421875 200.8984375 C72.16010703 198.81241165 72.16010703 198.81241165 70 198 C70 195.36 70 192.72 70 190 C70.99 190.33 71.98 190.66 73 191 C73.66015625 192.890625 73.66015625 192.890625 74.0625 195.25 C74.7180254 198.72042861 75.65289953 201.72847028 77 205 C77 205.99 77 206.98 77 208 C77.99 208 78.98 208 80 208 C82.09153804 203.81692392 79.81813409 199.42238304 78.65625 195.140625 C77.99954495 191.99782227 77.88502643 189.20009776 78 186 C79.485 186.99 79.485 186.99 81 188 C81 188.66 81 189.32 81 190 C81.78375 190.309375 82.5675 190.61875 83.375 190.9375 C86 192 86 192 88 193 C88.80787812 191.18936967 88.80787812 191.18936967 89 189 C87.61679734 187.12303933 87.61679734 187.12303933 85.625 185.5 C82.88445235 183.09792637 81.56050562 181.65129377 81 178 C84.81488023 176.3060793 88.37576566 175.48207188 92.5 174.875 C93.6034375 174.70742188 94.706875 174.53984375 95.84375 174.3671875 C98.60418631 174.04604763 101.22585627 173.92754102 104 174 C101.7766119 176.2233881 101.07694479 176.3605016 98.0859375 176.8515625 C97.32539062 176.98046875 96.56484375 177.109375 95.78125 177.2421875 C94.9871875 177.36851562 94.193125 177.49484375 93.375 177.625 C92.57320313 177.7590625 91.77140625 177.893125 90.9453125 178.03125 C88.96472516 178.36134789 86.98250325 178.68161083 85 179 C85.69950185 182.79499854 87.11829495 184.37518645 90.1875 186.765625 C99.5442026 193.13786211 108.91296585 193.77377108 120 193 C132.76821698 190.46164788 143.73305164 182.92033804 152 173 C152.33 172.01 152.66 171.02 153 170 C153.45503906 169.56042969 153.91007813 169.12085938 154.37890625 168.66796875 C164.84321011 157.90108261 166.34294708 138.78192071 166.4375 124.6875 C166.44765137 123.5830957 166.45780273 122.47869141 166.46826172 121.34082031 C166.45110107 119.78572754 166.45110107 119.78572754 166.43359375 118.19921875 C166.42384521 117.26940186 166.41409668 116.33958496 166.40405273 115.3815918 C165.92626874 112.56540878 165.0954939 111.84518008 163 110 C162.26953125 107.40625 162.26953125 107.40625 161.8125 104.5 C161.65394531 103.5409375 161.49539063 102.581875 161.33203125 101.59375 C160.6942446 96.61151079 160.6942446 96.61151079 162 94 C161.53040945 91.3446323 161.53040945 91.3446323 160.6875 88.4375 C160.42324219 87.44621094 160.15898438 86.45492187 159.88671875 85.43359375 C159.25852446 82.84289689 159.25852446 82.84289689 157 82 C156.31875294 80.00491933 155.65572791 78.00361307 155 76 C151.49207399 67.74026849 151.49207399 67.74026849 145 62 C144.90332031 61.29101562 144.80664062 60.58203125 144.70703125 59.8515625 C143.72174003 55.87773605 141.34430475 53.36628266 138.6875 50.375 C138.14915527 49.76180908 137.61081055 49.14861816 137.05615234 48.5168457 C124.35586028 34.28031743 109.6256465 23.47827566 92 16 C91.01 16 90.02 16 89 16 C89 15.34 89 14.68 89 14 C82.30177855 12.05249949 75.54762659 10.37142236 68.75 8.8125 C67.99412598 8.63364258 67.23825195 8.45478516 66.45947266 8.27050781 C60.84569856 7.00657711 55.58719297 6.13760234 50 8 C49.505 7.01 49.505 7.01 49 6 C44.13693244 4.80873694 39.28608524 4.84925236 34.3125 4.875 C33.55388672 4.87113281 32.79527344 4.86726562 32.01367188 4.86328125 C28.7522361 4.86903842 26.11486252 4.96171249 23 6 C23 5.34 23 4.68 23 4 C22.01 4.66 21.02 5.32 20 6 C19.01 5.67 18.02 5.34 17 5 C9.18360498 4.49696468 1.49014707 5.36963817 -6.25 6.375 C-7.87893188 6.57863159 -7.87893188 6.57863159 -9.54077148 6.78637695 C-12.69493124 7.18296288 -15.84765374 7.58927252 -19 8 C-20.29091553 8.16749756 -20.29091553 8.16749756 -21.60791016 8.33837891 C-25.74075198 8.87699704 -29.87143256 9.42938499 -34 10 C-34 9.01 -34 8.02 -34 7 C-29.64195356 6.11743951 -25.28205723 5.24489785 -20.92016602 4.3815918 C-19.43654357 4.08648964 -17.95346193 3.78865496 -16.47094727 3.48803711 C-14.340068 3.05643953 -12.20743801 2.63470176 -10.07421875 2.21484375 C-8.79119873 1.95823975 -7.50817871 1.70163574 -6.1862793 1.43725586 C-3 1 -3 1 0 2 C0 1.34 0 0.68 0 0 Z M163 98 C164 101 164 101 164 101 Z M164 102 C164.33 104.97 164.66 107.94 165 111 C165.33 111 165.66 111 166 111 C165.67 108.03 165.34 105.06 165 102 C164.67 102 164.34 102 164 102 Z ",
    fill: "#8C5689",
    transform: "translate(416,144)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.66310435 0.79125074 8.91546187 1.16488126 13.625 1.0625 C14.615 1.3925 15.605 1.7225 16.625 2.0625 C16.625 2.7225 16.625 3.3825 16.625 4.0625 C18.36136719 4.24425781 18.36136719 4.24425781 20.1328125 4.4296875 C24.37244416 4.96406356 28.41285655 5.95476086 32.5 7.1875 C33.22614502 7.40559326 33.95229004 7.62368652 34.70043945 7.84838867 C48.59856382 12.12988603 61.17500116 17.56604261 73.625 25.0625 C75.08618467 25.85221541 76.54850086 26.63983947 78.01171875 27.42578125 C82.60344913 29.96520947 86.73542969 32.91036721 90.875 36.125 C91.60807373 36.69154297 92.34114746 37.25808594 93.09643555 37.84179688 C99.96611618 43.21852373 106.44066334 48.91189248 112.625 55.0625 C113.38804443 55.81950195 113.38804443 55.81950195 114.16650391 56.59179688 C140.75518719 83.32374723 155.13993448 118.39158574 162.13183594 154.87036133 C162.53932069 157.09113851 162.53932069 157.09113851 163.625 159.0625 C163.73528863 161.23620543 163.77948279 163.41338401 163.79296875 165.58984375 C163.79938889 166.57389946 163.79938889 166.57389946 163.80593872 167.57783508 C163.8159896 169.71862498 163.81597939 171.8591908 163.8125 174 C163.81156342 174.72868286 163.81062683 175.45736572 163.80966187 176.20812988 C163.69255646 218.07302554 152.00545904 257.12645408 122.203125 287.6328125 C117.08870666 292.66600514 111.46298737 296.90438934 105.625 301.0625 C104.90570312 301.62453125 104.18640625 302.1865625 103.4453125 302.765625 C101.3344336 304.26951297 99.19439747 304.87625958 96.75 305.67578125 C91.69962261 307.33757822 86.73416591 309.143163 81.7890625 311.09765625 C73.1261744 313.73930237 64.57889969 314.40384325 55.5625 314.375 C54.0455957 314.39916992 54.0455957 314.39916992 52.49804688 314.42382812 C45.72340062 314.42819042 39.98832409 313.38514405 33.625 311.0625 C33.625 310.4025 33.625 309.7425 33.625 309.0625 C31.645 308.4025 29.665 307.7425 27.625 307.0625 C27.625 305.4125 27.625 303.7625 27.625 302.0625 C28.74007935 302.59846802 28.74007935 302.59846802 29.87768555 303.14526367 C39.35726973 307.29027394 47.25426145 307.68002523 57.4375 307.375 C58.91988352 307.34984184 60.40230901 307.32704215 61.88476562 307.30664062 C65.46573696 307.25234051 69.04508582 307.16650215 72.625 307.0625 C72.955 306.4025 73.285 305.7425 73.625 305.0625 C74.40875 304.93875 75.1925 304.815 76 304.6875 C90.68605331 302.15542184 103.75294514 293.93074298 114.625 284.0625 C115.11355469 283.62309082 115.60210938 283.18368164 116.10546875 282.73095703 C130.15152725 269.9441692 141.84868289 252.5946104 146.625 234.0625 C147.285 234.0625 147.945 234.0625 148.625 234.0625 C150.00078376 227.90046118 151.36320643 221.73582288 152.6875 215.5625 C152.86087891 214.77230469 153.03425781 213.98210937 153.21289062 213.16796875 C155.56350054 202.16243113 155.9338202 191.28404039 156 180.0625 C156.00833862 178.87611938 156.00833862 178.87611938 156.0168457 177.66577148 C156.0649831 164.04563886 154.55789746 151.46248203 151.08398438 138.24023438 C150.625 136.0625 150.625 136.0625 150.625 132.0625 C149.635 131.7325 148.645 131.4025 147.625 131.0625 C148.285 131.0625 148.945 131.0625 149.625 131.0625 C147.315 124.7925 145.005 118.5225 142.625 112.0625 C141.965 112.0625 141.305 112.0625 140.625 112.0625 C140.55152344 111.258125 140.47804688 110.45375 140.40234375 109.625 C139.38901053 104.98098042 137.4244493 101.2312648 135.1875 97.0625 C134.51642212 95.80445557 134.51642212 95.80445557 133.83178711 94.52099609 C129.67986486 86.89762773 124.99788382 79.87238938 119.625 73.0625 C118.98957275 72.25570801 118.98957275 72.25570801 118.34130859 71.43261719 C108.27395366 58.80961555 97.12960373 47.0103356 83.625 38.0625 C82.76390625 37.464375 81.9028125 36.86625 81.015625 36.25 C77.14918841 33.2236262 77.14918841 33.2236262 72.625 32.0625 C71.76793457 31.17256348 71.76793457 31.17256348 70.89355469 30.26464844 C68.2317507 27.68076209 65.67990594 26.40915375 62.328125 24.828125 C61.73449158 24.54523621 61.14085815 24.26234741 60.52923584 23.97088623 C58.64817425 23.07672072 56.76179924 22.19448351 54.875 21.3125 C53.5920775 20.70520899 52.30952118 20.09714376 51.02734375 19.48828125 C47.89741488 18.00404153 44.76261211 16.53044064 41.625 15.0625 C41.295 15.7225 40.965 16.3825 40.625 17.0625 C40.625 16.0725 40.625 15.0825 40.625 14.0625 C40.295 14.7225 39.965 15.3825 39.625 16.0625 C39.109375 15.794375 38.59375 15.52625 38.0625 15.25 C30.13327858 11.38704598 22.5876294 8.60287798 13.625 9.0625 C13.625 8.4025 13.625 7.7425 13.625 7.0625 C12.59375 7.26875 11.5625 7.475 10.5 7.6875 C6.5015784 8.07444403 4.28806243 7.58133076 0.625 6.0625 C0.625 5.4025 0.625 4.7425 0.625 4.0625 C-5.315 3.0725 -5.315 3.0725 -11.375 2.0625 C-11.375 1.4025 -11.375 0.7425 -11.375 0.0625 C-7.26837755 -1.02903719 -4.16051701 -0.75600844 0 0 Z ",
    fill: "#7A75A5",
    transform: "translate(476.375,86.9375)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.45778354 -0.41209784 9.30853296 1.74634131 14.16015625 4.00390625 C17.07383275 5.02589732 18.18902918 5.12573651 21 4 C21.33 4.99 21.66 5.98 22 7 C23.81405715 8.16624759 23.81405715 8.16624759 26.09375 9.09375 C27.37958984 9.67092773 27.37958984 9.67092773 28.69140625 10.25976562 C29.61824219 10.66904297 30.54507813 11.07832031 31.5 11.5 C49.78893586 19.89798075 65.98653458 31.31293634 80.765625 44.95703125 C82.83742629 46.85135306 84.96108951 48.65010994 87.125 50.4375 C88.07375 51.283125 89.0225 52.12875 90 53 C90 53.66 90 54.32 90 55 C90.66 55 91.32 55 92 55 C94.58256945 57.42445295 96.7519194 60.26846121 99 63 C99.40959961 63.49338867 99.81919922 63.98677734 100.24121094 64.49511719 C116.95683091 84.74028071 130.94961629 108.94810664 139 134 C139.66 134 140.32 134 141 134 C140.92652344 135.39605469 140.92652344 135.39605469 140.8515625 136.8203125 C140.85417112 141.99841419 142.15151069 146.87106621 143.375 151.875 C143.59671875 152.83664063 143.8184375 153.79828125 144.046875 154.7890625 C144.37558594 156.15804687 144.37558594 156.15804687 144.7109375 157.5546875 C144.90993652 158.38468262 145.10893555 159.21467773 145.31396484 160.06982422 C145.81944278 162.19847319 145.81944278 162.19847319 148 163 C147.98259766 164.01320312 147.98259766 164.01320312 147.96484375 165.046875 C147.95582031 165.93890625 147.94679688 166.8309375 147.9375 167.75 C147.92009766 169.07257813 147.92009766 169.07257813 147.90234375 170.421875 C147.90091993 172.90587541 147.90091993 172.90587541 148.49900818 174.86309814 C149.05531397 177.23593306 149.12007479 179.33217744 149.11352539 181.76855469 C149.11344986 182.70922791 149.11337433 183.64990112 149.11329651 184.61907959 C149.10813522 185.62650208 149.10297394 186.63392456 149.09765625 187.671875 C149.09553383 189.22820648 149.09553383 189.22820648 149.09336853 190.815979 C149.08777447 194.12734876 149.07522303 197.43865071 149.0625 200.75 C149.05748423 202.99609277 149.05292146 205.24218661 149.04882812 207.48828125 C149.03780699 212.9922106 149.02107474 218.49610046 149 224 C148.67 224 148.34 224 148 224 C147.87995605 224.63276855 147.75991211 225.26553711 147.63623047 225.91748047 C144.06307862 244.502576 139.68357928 262.07964753 131 279 C130.64953613 279.68562012 130.29907227 280.37124023 129.93798828 281.07763672 C124.30497553 291.97862582 117.99302224 301.69557829 110 311 C109.34112793 311.78431396 109.34112793 311.78431396 108.66894531 312.58447266 C98.30539158 324.85710207 85.91210152 334.05560644 72 342 C70.92685547 342.63035156 70.92685547 342.63035156 69.83203125 343.2734375 C65.16248802 345.83446533 60.35344943 347.08407885 55.17578125 348.26171875 C52.99233659 348.76930921 50.82252698 349.33819565 48.66796875 349.95703125 C47.60191406 350.25996094 46.53585937 350.56289063 45.4375 350.875 C44.46683594 351.16117187 43.49617187 351.44734375 42.49609375 351.7421875 C40 352 40 352 38.16015625 350.5703125 C37.58587891 349.79300781 37.58587891 349.79300781 37 349 C37.33 348.34 37.66 347.68 38 347 C39.32 347 40.64 347 42 347 C42 346.34 42 345.68 42 345 C44.3535311 344.20640264 46.70778883 343.41508217 49.0625 342.625 C49.71927734 342.40328125 50.37605469 342.1815625 51.05273438 341.953125 C54.32910759 340.85562067 57.58989957 339.83424582 60.93359375 338.9609375 C61.94550781 338.64382813 62.95742188 338.32671875 64 338 C64.33 337.34 64.66 336.68 65 336 C67.04029629 334.97537097 69.10854292 334.00622192 71.1875 333.0625 C99.81340909 319.34922449 118.36617904 291.23765918 130.22998047 262.84277344 C130.87615869 261.29637103 131.54658906 259.76013344 132.22265625 258.2265625 C133.21974169 255.7636485 133.21974169 255.7636485 133 252 C133.66 252 134.32 252 135 252 C135.10957031 251.36835938 135.21914063 250.73671875 135.33203125 250.0859375 C136.29985217 244.62522437 137.39406649 239.22044012 138.625 233.8125 C139.74807249 228.69690481 140.20047155 224.21226027 140 219 C140.33 218.34 140.66 217.68 141 217 C141.073596 215.02339534 141.0835023 213.04426905 141.0625 211.06640625 C141.05476562 209.85919922 141.04703125 208.65199219 141.0390625 207.40820312 C141.01337789 204.87955364 140.98734629 202.35090765 140.9609375 199.82226562 C140.91435128 192.48105382 141.15755916 185.29519916 142 178 C141.34 177.67 140.68 177.34 140 177 C139.65625 174.62890625 139.65625 174.62890625 139.5 171.5625 C139.12717345 165.90231516 138.25898624 160.52487167 137 155 C136.34 155 135.68 155 135 155 C135 154.34 135 153.68 135 153 C135.66 153 136.32 153 137 153 C137 152.01 137 151.02 137 150 C136.01 150 135.02 150 134 150 C134.33 149.01 134.66 148.02 135 147 C134.34 147 133.68 147 133 147 C133.185625 145.2675 133.185625 145.2675 133.375 143.5 C133.43749512 136.99009119 130.71241897 131.31096977 128.3125 125.37890625 C127 122 127 122 127 120 C126.34 119.67 125.68 119.34 125 119 C124.33145039 117.00062863 123.6653314 115.00044459 123 113 C121.53940781 109.88344054 119.93060504 106.84972078 118.3125 103.8125 C117.63876343 102.54394165 117.63876343 102.54394165 116.95141602 101.24975586 C111.16901305 90.46551746 104.50192292 80.66544677 97 71 C96.02160156 69.71029297 96.02160156 69.71029297 95.0234375 68.39453125 C90.2173137 62.26162038 84.92092644 56.71535783 79.4375 51.1875 C78.37499023 50.11109253 78.37499023 50.11109253 77.29101562 49.01293945 C72.80415206 44.55258539 68.14751083 40.67041722 63 37 C61.66582031 36.00033203 61.66582031 36.00033203 60.3046875 34.98046875 C55.18189958 31.20014776 49.97992548 27.53833641 44.6875 24 C43.82584229 23.40288208 43.82584229 23.40288208 42.94677734 22.79370117 C39.14924994 20.30071411 36.52018493 19.56234216 32 20 C31.91105469 19.38640625 31.82210937 18.7728125 31.73046875 18.140625 C31.18684896 15.90424818 31.18684896 15.90424818 29.36328125 14.734375 C24.94274808 12.61251908 21.9668588 11.88449166 17 12 C15.375 10.6875 15.375 10.6875 14 9 C9.66475536 5.41221133 5.70874251 3 0 3 C0 2.01 0 1.02 0 0 Z M33 17 C33 17.66 33 18.32 33 19 C33.99 18.67 34.98 18.34 36 18 C35.01 17.67 34.02 17.34 33 17 Z M134 142 C135 145 135 145 135 145 Z ",
    fill: "#706E98",
    transform: "translate(515,68)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.90867026 16.64401281 30.39752737 38.90291376 39 61 C39 61.99 39 62.98 39 64 C39.66 64.33 40.32 64.66 41 65 C41.8515625 66.9609375 41.8515625 66.9609375 42.625 69.375 C42.88539063 70.16648437 43.14578125 70.95796875 43.4140625 71.7734375 C44 74 44 74 44 77 C44.66 77.33 45.32 77.66 46 78 C48.69199108 85.36046807 50.00114059 93.33604027 51.5625 101 C51.77068359 102.00289063 51.97886719 103.00578125 52.19335938 104.0390625 C53.56099716 110.67574996 54.81713171 117.32799898 56 124 C56.33 124 56.66 124 57 124 C57.09765625 130.15234375 57.09765625 130.15234375 57 132 C56.67 132.33 56.34 132.66 56 133 C55.9487568 134.6228912 55.96481755 136.24796309 56.0078125 137.87109375 C56.61856611 170.86718583 51.03762444 200.36249978 38.73095703 230.95068359 C37.88801583 232.95133051 37.88801583 232.95133051 38 235 C37.34 235 36.68 235 36 235 C35.7421875 235.8559375 35.484375 236.711875 35.21875 237.59375 C29.1155082 254.65152837 15.94135631 269.71727348 4 283 C3.38640625 283.68707031 2.7728125 284.37414062 2.140625 285.08203125 C-11.76319458 299.77740491 -30.58425499 310.19353793 -49 318 C-49.67788574 318.28955566 -50.35577148 318.57911133 -51.05419922 318.87744141 C-62.88195145 323.73999481 -74.39745593 323.56634774 -87 323 C-87 322.34 -87 321.68 -87 321 C-88.15757812 320.93941406 -89.31515625 320.87882812 -90.5078125 320.81640625 C-92.04688457 320.73194498 -93.58594655 320.64729982 -95.125 320.5625 C-96.26582031 320.50352539 -96.26582031 320.50352539 -97.4296875 320.44335938 C-101.68509203 320.20490998 -105.80370826 319.79769763 -110 319 C-110 318.67 -110 318.34 -110 318 C-109.42258057 318.01047363 -108.84516113 318.02094727 -108.25024414 318.03173828 C-71.17673947 318.61187235 -35.6558639 310.1404741 -8 284 C-5.53111335 281.55941005 -3.09001373 279.1064895 -0.70703125 276.58203125 C1 275 1 275 3 275 C3.2475 274.43796875 3.495 273.8759375 3.75 273.296875 C5.2122385 270.61001175 6.99219075 268.55898064 9 266.25 C12.84189695 261.60978681 16.258123 256.82721288 19.5 251.75 C19.933125 251.0890332 20.36625 250.42806641 20.8125 249.74707031 C23.50641948 245.43636742 24.63163483 242.07817702 25 237 C25.66 237.66 26.32 238.32 27 239 C27.309375 238.05125 27.61875 237.1025 27.9375 236.125 C28.78177371 233.64184202 29.65041384 231.60816436 30.9453125 229.35546875 C36.93899465 218.34058931 44.77566155 200.79841563 44 188 C44.66 188 45.32 188 46 188 C46.07347656 187.04867187 46.07347656 187.04867187 46.1484375 186.078125 C46.55560936 180.99549696 47.0000267 175.92497571 47.546875 170.85546875 C47.64178223 169.9624707 47.73668945 169.06947266 47.83447266 168.14941406 C48.02668573 166.35520996 48.22419575 164.56156466 48.42724609 162.76855469 C48.51570801 161.93614258 48.60416992 161.10373047 48.6953125 160.24609375 C48.77797363 159.50029053 48.86063477 158.7544873 48.94580078 157.98608398 C49.11909226 155.78729422 49.11909226 155.78729422 48 153 C48.66 153 49.32 153 50 153 C49.58527135 141.93329328 49.06084875 130.94338678 47.66064453 119.95166016 C47.11499252 115.58128669 46.91399054 111.39221618 47 107 C46.01 107.33 45.02 107.66 44 108 C43.67 106.35 43.34 104.7 43 103 C43.66 103.33 44.32 103.66 45 104 C44.04876919 96.07854343 42.18698705 88.49018544 40.0625 80.8125 C39.80968262 79.86737549 39.55686523 78.92225098 39.29638672 77.94848633 C39.04518066 77.06443115 38.79397461 76.18037598 38.53515625 75.26953125 C38.20076538 74.07227417 38.20076538 74.07227417 37.85961914 72.85083008 C37.57594482 72.24005615 37.29227051 71.62928223 37 71 C36.01 70.67 35.02 70.34 34 70 C34 69.34 34 68.68 34 68 C34.66 68 35.32 68 36 68 C34.74699312 64.84677011 33.46968518 61.70396598 32.1875 58.5625 C31.83107422 57.66466797 31.47464844 56.76683594 31.10742188 55.84179688 C30.75615234 54.98779297 30.40488281 54.13378906 30.04296875 53.25390625 C29.72352295 52.46314697 29.40407715 51.6723877 29.07495117 50.85766602 C28.07538387 48.65694081 28.07538387 48.65694081 25 48 C25.33 47.01 25.66 46.02 26 45 C24.62507196 41.8331162 24.62507196 41.8331162 23 39 C22.34 39 21.68 39 21 39 C20.9175 38.319375 20.835 37.63875 20.75 36.9375 C19.77667472 33.1253093 18.04192545 30.35929671 16 27 C14.68 27 13.36 27 12 27 C12 26.34 12 25.68 12 25 C12.99 24.505 12.99 24.505 14 24 C13.4946875 23.30132812 12.989375 22.60265625 12.46875 21.8828125 C11.8190625 20.97273438 11.169375 20.06265625 10.5 19.125 C9.8503125 18.22007812 9.200625 17.31515625 8.53125 16.3828125 C7 14 7 14 7 12 C6.01 11.505 6.01 11.505 5 11 C3.7109375 9.51171875 3.7109375 9.51171875 2.375 7.6875 C1.70597656 6.79611328 1.70597656 6.79611328 1.0234375 5.88671875 C0 4 0 4 0 0 Z ",
    fill: "#736C98",
    transform: "translate(631,116)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.8096551 27.78736287 -9.03799977 56.94816436 -20 82 C-20.40089844 82.92151855 -20.80179688 83.84303711 -21.21484375 84.79248047 C-29.2946037 103.12757508 -39.49566484 120.32757992 -52 136 C-52.64066406 136.83144531 -53.28132812 137.66289062 -53.94140625 138.51953125 C-58.1264866 143.88827069 -62.58399855 148.9180639 -67.31982422 153.80273438 C-69.46270356 156.0648763 -70.94753622 157.86309634 -72.0703125 160.79296875 C-72.37710938 161.52128906 -72.68390625 162.24960937 -73 163 C-74.9140625 163.6015625 -74.9140625 163.6015625 -77 164 C-78.72406964 165.47329538 -78.72406964 165.47329538 -80.375 167.375 C-112.04269574 200.1548699 -160.13424134 219.49358215 -205.18945312 220.29711914 C-216.55877288 220.35425596 -227.73501828 219.48782777 -239 218 C-239 218.33 -239 218.66 -239 219 C-240.65 219 -242.3 219 -244 219 C-243.67 218.01 -243.34 217.02 -243 216 C-244.175625 215.938125 -245.35125 215.87625 -246.5625 215.8125 C-253.66707832 215.06105422 -260.31133204 212.38818052 -267 210 C-263.33054929 208.65940442 -261.27423908 209.3807884 -257.6875 210.75 C-238.99630705 217.28065778 -218.6680671 218.50074287 -199 218 C-200.65 217.67 -202.3 217.34 -204 217 C-204 216.67 -204 216.34 -204 216 C-202.35 215.67 -200.7 215.34 -199 215 C-199.90202148 214.98598145 -199.90202148 214.98598145 -200.82226562 214.97167969 C-225.37961545 214.49835208 -249.63051253 211.7852886 -272 201 C-267.96358347 199.65452782 -265.61437682 201.1372671 -261.875 202.6875 C-221.45556738 218.54584198 -176.2399673 213.81476456 -137 197 C-121.40476158 190.17944096 -107.13192003 180.76625736 -94 170 C-93.06583252 169.23623047 -93.06583252 169.23623047 -92.11279297 168.45703125 C-90.16944964 166.85782667 -88.23854779 165.24498003 -86.3125 163.625 C-85.41120361 162.87500732 -85.41120361 162.87500732 -84.49169922 162.10986328 C-81.5606613 159.6037116 -79.54634808 157.52689242 -78 154 C-76.37571498 152.61258988 -74.74845961 151.22848809 -73.10546875 149.86328125 C-57.88033007 136.38945723 -46.97083352 118.4721882 -37 101 C-36.5968457 100.30890137 -36.19369141 99.61780273 -35.77832031 98.90576172 C-23.5499927 77.85281406 -15.93025014 54.50519161 -10 31 C-9.79391113 30.18337891 -9.58782227 29.36675781 -9.37548828 28.52539062 C-8.91363533 26.68443266 -8.45622444 24.84236089 -8 23 C-7.67 23 -7.34 23 -7 23 C-7.57156863 29.24997873 -8.6000419 35.07557493 -10.25 41.125 C-10.46744873 41.93815674 -10.68489746 42.75131348 -10.90893555 43.58911133 C-12.97161788 51.16460618 -15.39829502 58.59344411 -18 66 C-17.67 65.34 -17.34 64.68 -17 64 C-16.01 64 -15.02 64 -14 64 C-13.88825439 63.45835205 -13.77650879 62.9167041 -13.66137695 62.35864258 C-12.63463506 57.54498338 -11.39290034 52.86450683 -9.9440918 48.16235352 C-5.71706546 34.33551714 -3.33048041 20.24871217 -1 6 C-0.66720658 3.99991009 -0.3340266 1.99988433 0 0 Z ",
    fill: "#7473A4",
    transform: "translate(727,285)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C18.03925562 -0.99900941 33.00851772 0.92056569 50 7 C51.50906341 7.51837817 53.01817389 8.03661932 54.52734375 8.5546875 C67.01828316 12.95856328 78.88888514 18.80115165 90.609375 24.93359375 C93.02034648 26.2036921 93.02034648 26.2036921 96 26 C97.34886024 27.31762347 98.67995673 28.65350777 100 30 C101.73418447 31.06228758 103.50856186 32.06103361 105.3125 33 C106.77042969 33.7734375 106.77042969 33.7734375 108.2578125 34.5625 C109.16273438 35.036875 110.06765625 35.51125 111 36 C119.36346813 40.46051633 126.56997024 46.38632214 133.875 52.375 C135.18455066 53.4457348 136.49445189 54.51604097 137.8046875 55.5859375 C138.81571533 56.41472412 138.81571533 56.41472412 139.84716797 57.26025391 C141.33316859 58.46112036 142.8332153 59.64473961 144.34423828 60.81396484 C151.0801576 66.0547899 157.1193026 71.81869279 163.125 77.875 C164.09081316 78.83366861 165.05695753 79.79200365 166.0234375 80.75 C166.92578125 81.65492187 167.828125 82.55984375 168.7578125 83.4921875 C169.5739502 84.31058105 170.39008789 85.12897461 171.23095703 85.97216797 C173 88 173 88 173 90 C173.99 90.33 174.98 90.66 176 91 C177.82421875 92.99609375 177.82421875 92.99609375 179.6875 95.4375 C180.62142578 96.64212891 180.62142578 96.64212891 181.57421875 97.87109375 C183 100 183 100 183 102 C183.66 102 184.32 102 185 102 C186.59941976 104.11307957 188.0609363 106.21767062 189.5 108.4375 C189.93997314 109.11055176 190.37994629 109.78360352 190.83325195 110.47705078 C192.23622983 112.64272802 193.62141067 114.81872449 195 117 C195.44005371 117.69464355 195.88010742 118.38928711 196.33349609 119.10498047 C202.31130259 128.63945865 207.09897185 138.24456851 211.12158203 148.74609375 C212.0455429 151.11685716 213.01520382 153.46475005 213.99609375 155.8125 C230.0361383 194.4149078 238.57053554 238.22098345 233 280 C232.01 280 231.02 280 230 280 C230.01571045 278.75017334 230.01571045 278.75017334 230.03173828 277.47509766 C230.39237647 244.18225863 227.83493832 213.17390039 219 181 C218.437251 178.9362658 217.87474421 176.87246553 217.3125 174.80859375 C216.8750814 173.20570695 216.43761263 171.60283384 216 170 C215.34 170 214.68 170 214 170 C213.5153125 168.8140625 213.030625 167.628125 212.53125 166.40625 C208.11555501 155.69974759 203.42680826 145.23325574 198 135 C197.38640625 133.84242188 196.7728125 132.68484375 196.140625 131.4921875 C186.91211631 114.75121513 175.36771254 99.01878123 161.6171875 85.69921875 C159 83 159 83 159 81 C158.45085937 80.78214844 157.90171875 80.56429687 157.3359375 80.33984375 C154.24546755 78.56721634 152.04816259 76.1262584 149.625 73.5625 C143.2520165 67.00992597 136.31039773 61.46329406 129 56 C128.4529541 55.58637207 127.9059082 55.17274414 127.34228516 54.74658203 C122.15560601 50.13505814 122.15560601 50.13505814 116 48 C116 47.34 116 46.68 116 46 C115.25363281 45.72285156 114.50726562 45.44570313 113.73828125 45.16015625 C111.25382114 44.10753906 109.36960421 42.99741563 107.1875 41.4375 C75.20579164 19.80281493 37.80195991 7.44848484 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7676A3",
    transform: "translate(472,0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.93742341 -0.02703381 3.87495479 -0.04641125 5.8125 -0.0625 C6.89144531 -0.07410156 7.97039063 -0.08570313 9.08203125 -0.09765625 C12 0 12 0 15 1 C15.99 0.67 16.98 0.34 18 0 C20.03992808 -0.09398043 22.08291414 -0.12992069 24.125 -0.125 C25.20007813 -0.12757813 26.27515625 -0.13015625 27.3828125 -0.1328125 C30 0 30 0 31 1 C32.671549 0.69208308 34.33805547 0.35613097 36 0 C36.99 0 37.98 0 39 0 C40.19625 -0.020625 41.3925 -0.04125 42.625 -0.0625 C46 0 46 0 47 1 C48.99958364 1.04080783 51.00045254 1.04254356 53 1 C53 1.66 53 2.32 53 3 C57.06275446 2.86076952 61.12512857 2.71246082 65.1875 2.5625 C66.33798828 2.52318359 67.48847656 2.48386719 68.67382812 2.44335938 C69.78564453 2.40146484 70.89746094 2.35957031 72.04296875 2.31640625 C73.06414795 2.27974854 74.08532715 2.24309082 75.13745117 2.20532227 C77.98924835 2.06862168 77.98924835 2.06862168 80.68481445 1.41772461 C83 1 83 1 86 2 C88 4 88 4 88.22705078 6.79736328 C88.21657715 7.95993652 88.20610352 9.12250977 88.1953125 10.3203125 C88.18886719 11.57714844 88.18242188 12.83398438 88.17578125 14.12890625 C88.15064453 16.10697266 88.15064453 16.10697266 88.125 18.125 C88.11496983 19.46483721 88.10584404 20.80468152 88.09765625 22.14453125 C88.07402075 25.42986573 88.04107234 28.71484465 88 32 C88.66 32 89.32 32 90 32 C90.495 33.98 90.495 33.98 91 36 C86.92845714 38.10144148 83.59731561 38.11805803 79.140625 38 C76.88171056 37.92850447 76.88171056 37.92850447 74.25 38.5625 C71.56195268 39.08517587 69.66706254 38.53341251 67 38 C64.36195411 38.39397335 64.36195411 38.39397335 62 39 C54 39 46 39 38 39 C38 38.34 38 37.68 38 37 C36.52031676 37.14049518 35.04125484 37.28754826 33.5625 37.4375 C32.73878906 37.51871094 31.91507813 37.59992187 31.06640625 37.68359375 C29.01337975 37.78930815 29.01337975 37.78930815 28 39 C26.33391013 39.04384447 24.66619446 39.0396713 23 39 C20.06406867 39 17.23443584 39.22499427 14.3125 39.5 C13.31863281 39.5928125 12.32476563 39.685625 11.30078125 39.78125 C10.16189453 39.88953125 10.16189453 39.88953125 9 40 C9.09364965 45.05403538 9.19976907 50.10759821 9.31738281 55.16113281 C9.35563327 56.87981011 9.39049303 58.59856638 9.421875 60.31738281 C9.46761128 62.7900004 9.52559084 65.26207613 9.5859375 67.734375 C9.59748871 68.50118591 9.60903992 69.26799683 9.62094116 70.05804443 C9.72788554 73.93568618 10.15112486 76.61122083 12 80 C11.505 81.485 11.505 81.485 11 83 C11.66 83 12.32 83 13 83 C13 83.99 13 84.98 13 86 C34.12 86 55.24 86 77 86 C77 86.33 77 86.66 77 87 C54.23 87 31.46 87 8 87 C8 69.84 8 52.68 8 35 C33.74 35 59.48 35 86 35 C86 24.77 86 14.54 86 4 C49.04 4 12.08 4 -26 4 C-26 69.01 -26 134.02 -26 201 C10.96 200.67 47.92 200.34 86 200 C86 190.43 86 180.86 86 171 C60.26 171 34.52 171 8 171 C8 153.18 8 135.36 8 117 C32.09 117 56.18 117 81 117 C81 109.08 81 101.16 81 93 C81.33 93 81.66 93 82 93 C82 101.25 82 109.5 82 118 C46.36 118.495 46.36 118.495 10 119 C9.95875 126.1775 9.9175 133.355 9.875 140.75 C9.85679199 143.01069336 9.83858398 145.27138672 9.81982422 147.60058594 C9.81398224 149.39517988 9.80888598 151.18977646 9.8046875 152.984375 C9.7893396 154.37873779 9.7893396 154.37873779 9.77368164 155.80126953 C9.77343994 156.69410645 9.77319824 157.58694336 9.77294922 158.50683594 C9.76628738 159.66599518 9.76628738 159.66599518 9.75949097 160.84857178 C10.03038648 163.27181653 10.79451907 164.89773202 12 167 C19.44827085 167.14525351 26.8965987 167.28727669 34.3449707 167.42724609 C36.86907282 167.47503709 39.39316198 167.52351818 41.91723633 167.57275391 C57.28152319 167.87191944 72.63264547 168.05520379 88 168 C88.33 179.55 88.66 191.1 89 203 C50.39 203 11.78 203 -28 203 C-28 136.34 -28 69.68 -28 1 C-27.67 1.66 -27.34 2.32 -27 3 C-18.42 2.67 -9.84 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z M8 2 C12 3 12 3 12 3 Z M15 2 C15 2.33 15 2.66 15 3 C16.65 3 18.3 3 20 3 C20 2.67 20 2.34 20 2 C18.35 2 16.7 2 15 2 Z M21 2 C21 2.33 21 2.66 21 3 C23.64 3 26.28 3 29 3 C29 2.67 29 2.34 29 2 C26.36 2 23.72 2 21 2 Z M32 2 C36 3 36 3 36 3 Z M40 2 C40 2.33 40 2.66 40 3 C41.98 3 43.96 3 46 3 C46 2.67 46 2.34 46 2 C44.02 2 42.04 2 40 2 Z M48 2 C52 3 52 3 52 3 Z M88 33 C89 36 89 36 89 36 Z M48 37 C52 38 52 38 52 38 Z M9 84 C9 84.66 9 85.32 9 86 C9.66 85.67 10.32 85.34 11 85 C10.34 84.67 9.68 84.34 9 84 Z ",
    fill: "#565E7A",
    transform: "translate(715,568)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.70398926 0.00054382 1.40797852 0.00108765 2.13330078 0.00164795 C13.29375986 0.04121731 23.7281838 0.84285574 34.375 4.375 C35.06964355 4.59994141 35.76428711 4.82488281 36.47998047 5.05664062 C59.54022391 12.69255248 77.53863379 26.10492584 88.7109375 47.9921875 C96.75426228 64.8100484 100.1404023 82.34861048 94.40625 100.4296875 C90.05193544 111.99215792 82.62446065 121.158609 71.5625 126.8125 C69.375 127.375 69.375 127.375 66.375 126.375 C70.005 124.395 73.635 122.415 77.375 120.375 C76.385 120.375 75.395 120.375 74.375 120.375 C74.375 119.715 74.375 119.055 74.375 118.375 C71.70168786 118.83328208 69.37881336 119.37337932 66.875 120.4375 C64.19726817 121.44164944 62.20921974 121.53695541 59.375 121.375 C61.44132183 120.32056117 63.50502656 119.31908184 65.63671875 118.40234375 C74.8276042 114.27310536 81.35615859 108.62345819 85.375 99.25 C91.40668033 81.21778902 87.47456539 63.9853668 79.50390625 47.40625 C76.67828667 41.85523746 73.21678307 37.04692937 68.67578125 32.77734375 C67.375 31.375 67.375 31.375 67.375 29.375 C66.7871875 29.11074219 66.199375 28.84648437 65.59375 28.57421875 C63.29725788 27.33298093 61.75431647 25.98851162 59.875 24.1875 C50.28536895 15.70843284 39.55358488 11.52310507 27.375 8.375 C26.1890625 8.05402344 25.003125 7.73304688 23.78125 7.40234375 C14.94344153 5.37229159 6.24304403 5.06957569 -2.8125 5 C-4.55805176 4.97909302 -4.55805176 4.97909302 -6.33886719 4.95776367 C-14.46191991 5.0019731 -21.79460801 6.26491835 -29.625 8.375 C-32.09652927 9.02598938 -34.32977228 9.46542042 -36.8828125 9.79296875 C-57.06892414 12.93256231 -77.61127873 23.88677541 -94.46484375 35.046875 C-96.625 36.375 -96.625 36.375 -98.625 36.375 C-98.625 35.385 -98.625 34.395 -98.625 33.375 C-97.2265625 32.15161133 -97.2265625 32.15161133 -95.25 30.95703125 C-94.52014893 30.51125732 -93.79029785 30.0654834 -93.03833008 29.60620117 C-92.24193115 29.13802979 -91.44553223 28.6698584 -90.625 28.1875 C-89.80990967 27.70063721 -88.99481934 27.21377441 -88.1550293 26.7121582 C-72.38622738 17.40986449 -56.11111521 10.00924668 -38.4375 5.125 C-37.54724121 4.87862793 -36.65698242 4.63225586 -35.73974609 4.37841797 C-23.80681706 1.20609603 -12.34839519 -0.03601494 0 0 Z ",
    fill: "#B34D8D",
    transform: "translate(453.625,190.625)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.53641869 0.68537139 2.53641869 0.68537139 4.625 -0.0625 C7.41460108 -0.67272524 9.05752286 0.38939722 11.625 1.5 C11.57170532 3.07467041 11.57170532 3.07467041 11.51733398 4.68115234 C11.38716101 8.5685228 11.26393206 12.45608749 11.14282227 16.34375 C11.08938576 18.0277307 11.03405512 19.71165239 10.97680664 21.39550781 C10.89494148 23.81302158 10.81984528 26.23066432 10.74609375 28.6484375 C10.71905869 29.4036972 10.69202362 30.15895691 10.66416931 30.93710327 C10.46211274 34.84429703 10.46211274 34.84429703 11.625 38.5 C10.366875 38.37625 9.10875 38.2525 7.8125 38.125 C6.75095703 38.02058594 6.75095703 38.02058594 5.66796875 37.9140625 C3.625 37.5 3.625 37.5 0.625 35.5 C0.625 36.16 0.625 36.82 0.625 37.5 C-0.21998047 37.25636719 -0.21998047 37.25636719 -1.08203125 37.0078125 C-3.47946869 36.47686383 -5.61022125 36.36689329 -8.0625 36.375 C-8.85011719 36.37242187 -9.63773437 36.36984375 -10.44921875 36.3671875 C-12.38264914 36.28872222 -12.38264914 36.28872222 -13.375 37.5 C-15.88717358 37.63579317 -18.00344462 37.60133329 -20.4375 36.9375 C-22.73105372 36.41960077 -24.14020863 36.88350583 -26.375 37.5 C-26.705 37.17 -27.035 36.84 -27.375 36.5 C-29.39094582 36.26572222 -31.413474 36.08663876 -33.4375 35.9375 C-34.54222656 35.85371094 -35.64695312 35.76992188 -36.78515625 35.68359375 C-37.63980469 35.62300781 -38.49445313 35.56242188 -39.375 35.5 C-39.87 36.49 -39.87 36.49 -40.375 37.5 C-42.685 36.84 -44.995 36.18 -47.375 35.5 C-47.375 36.16 -47.375 36.82 -47.375 37.5 C-50.015 36.84 -52.655 36.18 -55.375 35.5 C-55.375 36.16 -55.375 36.82 -55.375 37.5 C-56.035 37.5 -56.695 37.5 -57.375 37.5 C-57.375 36.84 -57.375 36.18 -57.375 35.5 C-59.685 35.5 -61.995 35.5 -64.375 35.5 C-64.87 36.49 -64.87 36.49 -65.375 37.5 C-66.365 37.005 -66.365 37.005 -67.375 36.5 C-71.665 36.17 -75.955 35.84 -80.375 35.5 C-80.375 51.67 -80.375 67.84 -80.375 84.5 C-54.305 84.5 -28.235 84.5 -1.375 84.5 C-1.375 95.06 -1.375 105.62 -1.375 116.5 C-27.775 116.5 -54.175 116.5 -81.375 116.5 C-81.375 116.17 -81.375 115.84 -81.375 115.5 C-55.635 115.5 -29.895 115.5 -3.375 115.5 C-3.375 105.6 -3.375 95.7 -3.375 85.5 C-29.445 85.5 -55.515 85.5 -82.375 85.5 C-82.375 68.34 -82.375 51.18 -82.375 33.5 C-52.345 33.5 -22.315 33.5 8.625 33.5 C8.625 23.27 8.625 13.04 8.625 2.5 C-32.625 2.5 -73.875 2.5 -116.375 2.5 C-116.375 67.51 -116.375 132.52 -116.375 199.5 C-75.455 199.5 -34.535 199.5 7.625 199.5 C7.625 189.6 7.625 179.7 7.625 169.5 C-22.075 169.5 -51.775 169.5 -82.375 169.5 C-82.375 152.34 -82.375 135.18 -82.375 117.5 C-82.045 117.5 -81.715 117.5 -81.375 117.5 C-81.375 134.33 -81.375 151.16 -81.375 168.5 C-80.715 168.5 -80.055 168.5 -79.375 168.5 C-79.045 167.84 -78.715 167.18 -78.375 166.5 C-78.375 167.16 -78.375 167.82 -78.375 168.5 C-53.955 168.5 -29.535 168.5 -4.375 168.5 C-4.375 167.84 -4.375 167.18 -4.375 166.5 C-3.715 166.83 -3.055 167.16 -2.375 167.5 C-0.83831135 167.72467831 0.70468054 167.90796805 2.25 168.0625 C3.06726563 168.14628906 3.88453125 168.23007812 4.7265625 168.31640625 C5.35304688 168.37699219 5.97953125 168.43757812 6.625 168.5 C6.955 167.84 7.285 167.18 7.625 166.5 C8.285 166.5 8.945 166.5 9.625 166.5 C9.625 167.82 9.625 169.14 9.625 170.5 C10.285 170.83 10.945 171.16 11.625 171.5 C10.965 171.5 10.305 171.5 9.625 171.5 C9.625 181.4 9.625 191.3 9.625 201.5 C-32.285 201.5 -74.195 201.5 -117.375 201.5 C-118.14052538 198.43789846 -118.50033652 196.45851706 -118.50198364 193.42155457 C-118.50480347 192.61841324 -118.50762329 191.81527191 -118.51052856 190.98779297 C-118.50749222 189.67935425 -118.50749222 189.67935425 -118.50439453 188.34448242 C-118.50614685 187.41879959 -118.50789917 186.49311676 -118.50970459 185.53938293 C-118.514107 182.47805915 -118.51119003 179.41679313 -118.5078125 176.35546875 C-118.50848617 174.22561126 -118.50945673 172.09575384 -118.51071167 169.96589661 C-118.5121866 165.49963652 -118.51004126 161.03339643 -118.50537109 156.56713867 C-118.49968432 150.85081222 -118.50294744 145.13453283 -118.50894356 139.41820812 C-118.51256352 135.01808826 -118.5114038 130.61797947 -118.50881577 126.21785927 C-118.50814993 124.1107921 -118.5089629 122.00372392 -118.51129532 119.89665794 C-118.51384422 116.94564541 -118.50994925 113.99470813 -118.50439453 111.04370117 C-118.50641876 110.17748138 -118.50844299 109.3112616 -118.51052856 108.41879272 C-118.49404257 103.67379959 -118.16789236 99.18005219 -117.375 94.5 C-118.035 94.17 -118.695 93.84 -119.375 93.5 C-118.715 93.5 -118.055 93.5 -117.375 93.5 C-117.53726074 92.4076001 -117.69952148 91.3152002 -117.86669922 90.18969727 C-118.51854321 84.94626991 -118.51863939 79.74230721 -118.5078125 74.46484375 C-118.50876923 73.42735489 -118.50972595 72.38986603 -118.51071167 71.32093811 C-118.51138908 69.13835591 -118.50956557 66.95577164 -118.50537109 64.77319336 C-118.50001119 61.44445246 -118.50533386 58.11584615 -118.51171875 54.78710938 C-118.511058 52.65885387 -118.50977689 50.53059845 -118.5078125 48.40234375 C-118.50983673 47.41362778 -118.51186096 46.4249118 -118.51394653 45.40623474 C-118.49682261 40.32882594 -118.24795975 35.50413123 -117.375 30.5 C-118.035 30.17 -118.695 29.84 -119.375 29.5 C-118.715 29.5 -118.055 29.5 -117.375 29.5 C-117.45878906 28.49582031 -117.54257812 27.49164062 -117.62890625 26.45703125 C-117.73228173 25.07555897 -117.83511643 23.69404615 -117.9375 22.3125 C-117.99357422 21.65830078 -118.04964844 21.00410156 -118.10742188 20.33007812 C-118.43425953 15.73256183 -118.25867623 11.29751188 -117.88256836 6.7019043 C-117.78866318 5.53837936 -117.694758 4.37485443 -117.5980072 3.17607117 C-117.52441483 2.29296768 -117.45082245 1.4098642 -117.375 0.5 C-116.79447184 0.50092179 -116.21394367 0.50184359 -115.61582375 0.50279331 C-101.50339048 0.52485834 -87.39095979 0.54141635 -73.27851295 0.55181217 C-66.45389818 0.55697288 -59.6292949 0.56401129 -52.8046875 0.57543945 C-46.22356567 0.58645465 -39.64245269 0.59227777 -33.06132126 0.59487724 C-30.54541205 0.5967307 -28.02950353 0.60034981 -25.5135994 0.60573006 C-22.00075087 0.61294622 -18.48795235 0.61399069 -14.97509766 0.61352539 C-13.4009333 0.6189183 -13.4009333 0.6189183 -11.79496765 0.62442017 C-10.84141891 0.6230455 -9.88787018 0.62167084 -8.90542603 0.62025452 C-8.07396875 0.62117631 -7.24251148 0.6220981 -6.38585854 0.62304783 C-3.67245429 0.45701004 -2.77743419 -0.58472299 0 0 Z ",
    fill: "#8F2B55",
    transform: "translate(484.375,569.5)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.49901431 5.61278508 10.24778016 10.35280156 11.125 19.125 C10.9325663 25.03384645 9.01437194 30.82167109 5.06640625 35.2734375 C-1.07286573 40.68655903 -5.78354223 41.90756858 -13.98828125 41.7421875 C-19.91298497 41.07521487 -23.31983304 38.75384612 -27.03125 34.1796875 C-31.19994979 28.22159298 -32.84373101 23.73726456 -32.25 16.375 C-30.32197945 8.73660013 -26.86927132 3.67940328 -20.25 -0.625 C-13.58135105 -3.58884398 -6.48864069 -3.24432035 0 0 Z ",
    fill: "#E32B75",
    transform: "translate(354.25,140.625)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.17604565 3.31431047 -2.6919487 6.27355828 -4.4375 9.3125 C-9.76768082 18.77789484 -11.17237375 27.2691817 -11.125 38.0625 C-11.12886719 38.94744141 -11.13273437 39.83238281 -11.13671875 40.74414062 C-11.13040231 44.95404523 -11.0746695 48.89749181 -10 53 C-9.34 51.68 -8.68 50.36 -8 49 C-7.34 49.66 -6.68 50.32 -6 51 C-6.15855469 50.16597656 -6.31710937 49.33195312 -6.48046875 48.47265625 C-8.68850589 33.71367115 -6.71327767 20.34381003 2 8 C3 11 3 11 2 14 C1.91733514 15.91906917 1.89259337 17.84089474 1.90234375 19.76171875 C1.90717773 21.43911133 1.90717773 21.43911133 1.91210938 23.15039062 C1.92048828 24.31763672 1.92886719 25.48488281 1.9375 26.6875 C1.94201172 27.86634766 1.94652344 29.04519531 1.95117188 30.25976562 C1.96296727 33.17322789 1.9794273 36.08658863 2 39 C2.66 39 3.32 39 4 39 C4.66 39.99 5.32 40.98 6 42 C6 34.08 6 26.16 6 18 C6.33 18 6.66 18 7 18 C7.06993164 18.58378418 7.13986328 19.16756836 7.21191406 19.76904297 C8.57525615 37.30861164 8.57525615 37.30861164 17 52 C17.474375 52.845625 17.94875 53.69125 18.4375 54.5625 C20.15307848 57.23880242 21.16613463 57.7601839 24 59 C24.4021875 59.46019531 24.804375 59.92039062 25.21875 60.39453125 C27.71078697 62.64064352 30.3546958 63.43259905 33.5 64.5625 C37.02340635 65.83616378 39.87625216 66.91750144 43 69 C36.59859065 68.53444296 31.73230171 66.85288164 26 64 C25.505 65.98 25.505 65.98 25 68 C27.97 68.99 27.97 68.99 31 70 C31 70.66 31 71.32 31 72 C38.3048236 73.75585124 45.24740312 74.35396741 52.75 74.3125 C53.80477539 74.30758545 54.85955078 74.3026709 55.94628906 74.29760742 C67.80123209 74.12005643 77.77644316 71.97536912 88.57421875 66.890625 C91 66 91 66 94 67 C83.06855693 71.9967691 72.13386364 76.25295242 60 77 C59.1440625 77.05285156 58.288125 77.10570312 57.40625 77.16015625 C41.87208529 77.64037908 27.23276571 74.30080847 15.125 64.1875 C7.84464617 57.23627609 3.9040535 49.56383003 1 40 C0.773125 39.27167969 0.54625 38.54335938 0.3125 37.79296875 C-1.51351485 30.95809373 -1.17981225 24.02266745 -1 17 C-5.81297929 32.31677687 -6.91904832 46.02805124 0.75 60.8125 C9.00446254 74.75202129 21.27960139 82.88745654 36.84765625 87.09375 C40.99503801 88.0854512 45.06019456 88.48143483 49.3125 88.6875 C50.07288574 88.7280249 50.83327148 88.7685498 51.61669922 88.81030273 C60.43717267 89.19243334 69.20337333 88.63390325 78 88 C76.68 88.33 75.36 88.66 74 89 C74 89.99 74 90.98 74 92 C77.24244991 93.08081664 77.82091097 92.97566845 80.90625 91.96875 C82.02193359 91.61876953 82.02193359 91.61876953 83.16015625 91.26171875 C83.93230469 91.01035156 84.70445312 90.75898438 85.5 90.5 C87.0286504 90.00235922 88.55983716 89.51242543 90.09375 89.03125 C90.77115234 88.81017578 91.44855469 88.58910156 92.14648438 88.36132812 C94 88 94 88 97 89 C94.23229617 89.96823963 91.46133261 90.92460317 88.6875 91.875 C87.92115234 92.14441406 87.15480469 92.41382813 86.36523438 92.69140625 C64.34476296 100.18384881 39.78234121 99.41144611 18.75 89.4375 C3.46633275 81.65113121 -6.48645473 69.40184573 -12.15234375 53.296875 C-12.98842727 50.04501099 -13.16699883 47.33997669 -13 44 C-13.66 43.67 -14.32 43.34 -15 43 C-13.98627242 29.92745328 -12.35962843 16.71820424 -6 5 C-6.66 4.67 -7.32 4.34 -8 4 C-3.375 0 -3.375 0 0 0 Z ",
    fill: "#D43F86",
    transform: "translate(479,326)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.99 2 3.98 2 5 2 C5 2.66 5 3.32 5 4 C5.54962402 4.16363037 6.09924805 4.32726074 6.66552734 4.49584961 C12.37657286 6.28472741 17.43348726 8.60317615 22.625 11.5625 C23.40133789 12.00013672 24.17767578 12.43777344 24.97753906 12.88867188 C32.57389307 17.22855864 39.8250105 22.00180278 47 27 C47.88896973 27.61077393 47.88896973 27.61077393 48.79589844 28.23388672 C57.65521897 34.32617997 65.91586951 40.91585961 74 48 C74.804375 48.69222656 75.60875 49.38445313 76.4375 50.09765625 C82.05547535 55.02287451 87.37840144 60.2467507 92.6875 65.5 C93.40067383 66.20012207 94.11384766 66.90024414 94.84863281 67.62158203 C99.6848861 72.44996601 103.90351564 77.53678901 108 83 C108.97225751 84.25002266 109.94613529 85.49878732 110.921875 86.74609375 C121.2920392 100.19874225 129.78401313 114.44979057 137.75 129.4375 C138.28818359 130.43918213 138.82636719 131.44086426 139.38085938 132.47290039 C139.86876953 133.4086792 140.35667969 134.34445801 140.859375 135.30859375 C141.29733398 136.14189209 141.73529297 136.97519043 142.18652344 137.83374023 C143.56614952 141.50763645 141.21132186 145.36603442 140 149 C139.4423999 147.80793945 139.4423999 147.80793945 138.87353516 146.59179688 C128.80109107 122.76528411 128.80109107 122.76528411 114 102 C113.10618612 100.67920497 112.2340045 99.34369418 111.375 98 C106.92901875 91.25512113 101.83106725 85.06031701 96.5 79 C94 76 94 76 94 74 C93.34 74 92.68 74 92 74 C90.62689293 72.70766393 89.28965176 71.37562854 88 70 C86.515 70.495 86.515 70.495 85 71 C85 70.34 85 69.68 85 69 C85.66 69 86.32 69 87 69 C79.05320497 59.66251584 70.61009204 51.61969178 61 44 C60.41814941 43.5359375 59.83629883 43.071875 59.23681641 42.59375 C57.38992577 41.12132831 55.53952291 39.65345982 53.6875 38.1875 C52.82584229 37.50337036 52.82584229 37.50337036 51.94677734 36.80541992 C48.40246236 34.01854692 44.78235434 31.45481091 41 29 C40.34 29.66 39.68 30.32 39 31 C38.855625 30.29488281 38.71125 29.58976562 38.5625 28.86328125 C36.15141373 24.44496566 32.272671 22.66445865 28 20.1875 C27.16726563 19.68541016 26.33453125 19.18332031 25.4765625 18.66601562 C21.49518239 16.00634658 21.49518239 16.00634658 17 15 C16.61199219 14.59136719 16.22398437 14.18273438 15.82421875 13.76171875 C13.17356023 11.20187508 10.01189686 9.58709024 6.8125 7.8125 C6.15830078 7.44447266 5.50410156 7.07644531 4.83007812 6.69726562 C3.22253039 5.7937534 1.61159349 4.8962759 0 4 C0 2.66666667 0 1.33333333 0 0 Z ",
    fill: "#797AA9",
    transform: "translate(563,1)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.29546594 -0.46271757 21.14808711 2.48167594 31.0234375 5.15625 C31.0234375 5.81625 31.0234375 6.47625 31.0234375 7.15625 C32.0134375 7.4346875 32.0134375 7.4346875 33.0234375 7.71875 C42.77240245 12.39012904 49.57030654 21.78633357 53.4609375 31.65625 C57.00928331 43.57623419 56.32609131 56.89476113 51.0234375 68.15625 C50.04886463 69.83791153 49.0554302 71.50920148 48.0234375 73.15625 C47.6934375 72.49625 47.3634375 71.83625 47.0234375 71.15625 C47.74006633 69.21028229 48.54706169 67.29715096 49.3984375 65.40625 C52.38333261 58.76944411 53.16387515 53.16194773 53.1484375 45.90625 C53.15101563 44.68421875 53.15359375 43.4621875 53.15625 42.203125 C53.23452428 39.23855817 53.23452428 39.23855817 52.0234375 37.15625 C49.99880495 36.50411708 49.99880495 36.50411708 48.0234375 36.15625 C48.3534375 38.13625 48.6834375 40.11625 49.0234375 42.15625 C49.3534375 42.15625 49.6834375 42.15625 50.0234375 42.15625 C50.24921152 47.5748266 49.49013863 51.93112721 48.0234375 57.15625 C47.3634375 57.15625 46.7034375 57.15625 46.0234375 57.15625 C45.3634375 58.47625 44.7034375 59.79625 44.0234375 61.15625 C44.24 60.17398438 44.24 60.17398438 44.4609375 59.171875 C47.13217246 46.03830311 46.71985343 35.73935497 40.2109375 23.84375 C32.61309692 14.50926015 21.40525913 8.57105549 9.40625 7.31640625 C-23.88609015 5.07872437 -52.76189997 19.5290293 -77.9765625 40.15625 C-80.44200383 42.32359387 -82.87631982 44.51112422 -85.26953125 46.7578125 C-86.9765625 48.15625 -86.9765625 48.15625 -88.9765625 48.15625 C-88.9765625 48.81625 -88.9765625 49.47625 -88.9765625 50.15625 C-89.6365625 50.15625 -90.2965625 50.15625 -90.9765625 50.15625 C-90.05873036 42.8305898 -81.07338089 36.75124728 -75.54296875 32.37890625 C-53.10368697 15.2598366 -28.48029116 2.25140642 0 0 Z ",
    fill: "#A94078",
    transform: "translate(456.9765625,234.84375)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.78198477 3.30710686 2.96157065 6.68214999 4.125 10.25 C4.47820312 11.32765625 4.83140625 12.4053125 5.1953125 13.515625 C5.46085937 14.33546875 5.72640625 15.1553125 6 16 C7.32 15.67 8.64 15.34 10 15 C9.67 13.783125 9.34 12.56625 9 11.3125 C8.19677787 8.12789396 7.79358027 5.3027157 8 2 C9.58946436 4.99060355 10.83608315 8.0698264 12.05419922 11.22753906 C15.96967387 21.3477678 20.66762253 29.8234463 27.23046875 38.51953125 C29 41 29 41 30.125 43.265625 C31.30320953 45.60100461 32.66794921 45.86728962 35 47 C36.14780141 48.14780141 37.29338451 49.29793544 38.42578125 50.4609375 C56.61478296 68.24373322 81.71427521 76.62613749 106 82 C106 82.66 106 83.32 106 84 C106.66 84.33 107.32 84.66 108 85 C102.48022939 87.47590997 98.56375145 86.80811075 92.875 85.5625 C92.00190186 85.3771167 91.12880371 85.1917334 90.22924805 85.00073242 C66.18351437 79.61774501 46.01604875 69.55105017 28.07104492 52.73095703 C25.78902224 50.59490191 23.60962049 48.739747 21 47 C20.29820168 45.68481889 19.63497779 44.34871251 19 43 C17.97532562 41.57099465 16.93161938 40.1555495 15.875 38.75 C8.46405243 28.26018277 -0.56856295 13.14801814 0 0 Z ",
    fill: "#C43A7B",
    transform: "translate(408,392)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0789673 3.22251568 0.94905076 4.89030281 -0.375 8 C-5.90521066 21.23115821 -3.48051963 36.77102049 1 50 C1.66 50.99 2.32 51.98 3 53 C3.99 52.34 4.98 51.68 6 51 C6.33 51.33 6.66 51.66 7 52 C6.72285156 51.26394531 6.44570313 50.52789062 6.16015625 49.76953125 C5.79792969 48.79371094 5.43570312 47.81789063 5.0625 46.8125 C4.70285156 45.84957031 4.34320313 44.88664062 3.97265625 43.89453125 C1.89057241 37.69845042 1.75260318 31.79243628 1.6875 25.3125 C1.65849609 24.36955078 1.62949219 23.42660156 1.59960938 22.45507812 C1.53761578 15.51656405 2.98896885 10.23731827 6 4 C7 7 7 7 5.5625 10.5625 C0.54877334 24.70259548 4.30482763 40.94156347 10.5 54 C19.12738329 71.10081468 34.33183515 82.28131838 52 89 C57.69541513 90.8189208 62.99799151 92.18417716 69 92 C69.33 92.66 69.66 93.32 70 94 C73.09503056 95.08676781 76.16365221 95.18969759 79.421875 95.31640625 C80.44667969 95.35830078 81.47148438 95.40019531 82.52734375 95.44335938 C83.59082031 95.48267578 84.65429688 95.52199219 85.75 95.5625 C86.82894531 95.60568359 87.90789062 95.64886719 89.01953125 95.69335938 C91.67956428 95.79928989 94.33968812 95.90136421 97 96 C97 96.33 97 96.66 97 97 C95.02 97 93.04 97 91 97 C91 97.66 91 98.32 91 99 C100.9 98.505 100.9 98.505 111 98 C98.6050295 106.26331367 74.2600737 102.82983043 60.32421875 100.04296875 C37.34988586 94.84854703 17.99290568 81.97243314 5.04296875 62.30078125 C-1.51415856 51.70656981 -5.61656884 40.5368997 -5 28 C-5.66 27.67 -6.32 27.34 -7 27 C-6.67 26.67 -6.34 26.34 -6 26 C-5.83900898 24.19034171 -5.72206604 22.37671042 -5.625 20.5625 C-5.07138498 13.18975394 -3.44336052 6.55878195 0 0 Z ",
    fill: "#AC4F8E",
    transform: "translate(453,340)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.05381611 2.10008536 11.98153833 3.648238 16 10 C18.18457865 14.05707463 18.46528933 17.42465491 18 22 C16.08281902 27.81690137 13.5051258 31.07174159 8 34 C3.01920617 35.66026461 -1.30273629 35.59903425 -6.1875 33.875 C-11.46789693 30.35473538 -14.58147618 26.18992211 -16 20 C-16.77215598 14.92583215 -15.2756605 11.94038074 -12.4921875 7.8359375 C-10.30652568 5.14677244 -8.08918039 3.54459019 -5 2 C-2.125 1.75 -2.125 1.75 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#767BB2",
    transform: "translate(351,293)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C18.03925562 -0.99900941 33.00851772 0.92056569 50 7 C51.50906341 7.51837817 53.01817389 8.03661932 54.52734375 8.5546875 C67.01828316 12.95856328 78.88888514 18.80115165 90.609375 24.93359375 C93.02034648 26.2036921 93.02034648 26.2036921 96 26 C97.34886024 27.31762347 98.67995673 28.65350777 100 30 C101.73418447 31.06228758 103.50856186 32.06103361 105.3125 33 C106.77042969 33.7734375 106.77042969 33.7734375 108.2578125 34.5625 C109.16273438 35.036875 110.06765625 35.51125 111 36 C119.36340253 40.46048135 126.57010446 46.38629378 133.875 52.375 C138.36251444 56.04561128 142.86442207 59.68600499 147.4375 63.25 C152.32872037 67.1364026 156.68177524 71.49402634 161 76 C157.41087588 76 156.89142971 75.33563446 154.3125 73 C153.68988281 72.443125 153.06726563 71.88625 152.42578125 71.3125 C151.95527344 70.879375 151.48476563 70.44625 151 70 C150.77706675 72.18829043 150.77706675 72.18829043 152.75 73.9453125 C153.4925 74.66460937 154.235 75.38390625 155 76.125 C155.7425 76.84945312 156.485 77.57390625 157.25 78.3203125 C157.8275 78.87460938 158.405 79.42890625 159 80 C156 80 156 80 153.35546875 77.54296875 C152.29476836 76.42894557 151.23911142 75.31010695 150.1875 74.1875 C143.61972688 67.39931308 136.56286805 61.63360993 129 56 C128.4544043 55.58782227 127.90880859 55.17564453 127.34667969 54.75097656 C122.15821817 50.13673455 122.15821817 50.13673455 116 48 C116 47.34 116 46.68 116 46 C115.25363281 45.72285156 114.50726562 45.44570313 113.73828125 45.16015625 C111.25382114 44.10753906 109.36960421 42.99741563 107.1875 41.4375 C75.20579164 19.80281493 37.80195991 7.44848484 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7E7CB1",
    transform: "translate(472,0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.93742341 -0.02703381 3.87495479 -0.04641125 5.8125 -0.0625 C6.89144531 -0.07410156 7.97039063 -0.08570313 9.08203125 -0.09765625 C12 0 12 0 15 1 C15.99 0.67 16.98 0.34 18 0 C20.03992808 -0.09398043 22.08291414 -0.12992069 24.125 -0.125 C25.20007813 -0.12757813 26.27515625 -0.13015625 27.3828125 -0.1328125 C30 0 30 0 31 1 C32.671549 0.69208308 34.33805547 0.35613097 36 0 C36.99 0 37.98 0 39 0 C40.19625 -0.020625 41.3925 -0.04125 42.625 -0.0625 C46 0 46 0 47 1 C48.99958364 1.04080783 51.00045254 1.04254356 53 1 C53 1.66 53 2.32 53 3 C57.06275446 2.86076952 61.12512857 2.71246082 65.1875 2.5625 C66.33798828 2.52318359 67.48847656 2.48386719 68.67382812 2.44335938 C69.78564453 2.40146484 70.89746094 2.35957031 72.04296875 2.31640625 C73.06414795 2.27974854 74.08532715 2.24309082 75.13745117 2.20532227 C77.98924835 2.06862168 77.98924835 2.06862168 80.68481445 1.41772461 C83 1 83 1 86 2 C88 4 88 4 88.22705078 6.79736328 C88.21657715 7.95993652 88.20610352 9.12250977 88.1953125 10.3203125 C88.18886719 11.57714844 88.18242188 12.83398438 88.17578125 14.12890625 C88.15064453 16.10697266 88.15064453 16.10697266 88.125 18.125 C88.11496983 19.46483721 88.10584404 20.80468152 88.09765625 22.14453125 C88.07402075 25.42986573 88.04107234 28.71484465 88 32 C88.66 32 89.32 32 90 32 C90.495 33.98 90.495 33.98 91 36 C86.92845714 38.10144148 83.59731561 38.11805803 79.140625 38 C76.88171056 37.92850447 76.88171056 37.92850447 74.25 38.5625 C71.56195268 39.08517587 69.66706254 38.53341251 67 38 C64.36195411 38.39397335 64.36195411 38.39397335 62 39 C54 39 46 39 38 39 C38 38.34 38 37.68 38 37 C36.52031676 37.14049518 35.04125484 37.28754826 33.5625 37.4375 C32.73878906 37.51871094 31.91507813 37.59992187 31.06640625 37.68359375 C29.01337975 37.78930815 29.01337975 37.78930815 28 39 C26.33391013 39.04384447 24.66619446 39.0396713 23 39 C20.06406867 39 17.23443584 39.22499427 14.3125 39.5 C13.31863281 39.5928125 12.32476563 39.685625 11.30078125 39.78125 C10.16189453 39.88953125 10.16189453 39.88953125 9 40 C9.09364965 45.05403538 9.19976907 50.10759821 9.31738281 55.16113281 C9.35563327 56.87981011 9.39049303 58.59856638 9.421875 60.31738281 C9.46761128 62.7900004 9.52559084 65.26207613 9.5859375 67.734375 C9.59748871 68.50118591 9.60903992 69.26799683 9.62094116 70.05804443 C9.72788554 73.93568618 10.15112486 76.61122083 12 80 C11.505 81.485 11.505 81.485 11 83 C11.66 83 12.32 83 13 83 C13 83.99 13 84.98 13 86 C34.12 86 55.24 86 77 86 C77 86.33 77 86.66 77 87 C54.23 87 31.46 87 8 87 C8 69.84 8 52.68 8 35 C33.74 35 59.48 35 86 35 C86 24.77 86 14.54 86 4 C49.04 4 12.08 4 -26 4 C-26 69.34 -26 134.68 -26 202 C-26.33 202 -26.66 202 -27 202 C-27 136.33 -27 70.66 -27 3 C-18.42 2.67 -9.84 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z M8 2 C12 3 12 3 12 3 Z M15 2 C15 2.33 15 2.66 15 3 C16.65 3 18.3 3 20 3 C20 2.67 20 2.34 20 2 C18.35 2 16.7 2 15 2 Z M21 2 C21 2.33 21 2.66 21 3 C23.64 3 26.28 3 29 3 C29 2.67 29 2.34 29 2 C26.36 2 23.72 2 21 2 Z M32 2 C36 3 36 3 36 3 Z M40 2 C40 2.33 40 2.66 40 3 C41.98 3 43.96 3 46 3 C46 2.67 46 2.34 46 2 C44.02 2 42.04 2 40 2 Z M48 2 C52 3 52 3 52 3 Z M88 33 C89 36 89 36 89 36 Z M48 37 C52 38 52 38 52 38 Z M9 84 C9 84.66 9 85.32 9 86 C9.66 85.67 10.32 85.34 11 85 C10.34 84.67 9.68 84.34 9 84 Z ",
    fill: "#464B64",
    transform: "translate(715,568)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.99 3 1.98 3 3 C10.86550419 2.88220331 18.7308744 2.75737601 26.59619141 2.62768555 C29.27129929 2.58389779 31.94641119 2.54272323 34.62158203 2.50268555 C38.46915654 2.44482191 42.31659877 2.38117356 46.1640625 2.31640625 C47.95500839 2.29133751 47.95500839 2.29133751 49.78213501 2.26576233 C50.90284393 2.24581711 52.02355286 2.22587189 53.17822266 2.20532227 C54.65048813 2.18200584 54.65048813 2.18200584 56.15249634 2.15821838 C59.160219 1.99109761 62.03972965 1.54706794 65 1 C65 1.33 65 1.66 65 2 C66.79630859 2.05607422 66.79630859 2.05607422 68.62890625 2.11328125 C84.00527115 2.6911849 98.82305011 4.62668276 113 11 C113.495 11.99 113.495 11.99 114 13 C109.11182372 12.16816885 104.50449245 10.57134852 99.84960938 8.90429688 C71.8353379 -0.37804382 21.71830517 4.26291074 2 4 C2 69.01 2 134.02 2 201 C54.17775174 205.02652973 54.17775174 205.02652973 111.8125 192.25 C117.74579832 189 117.74579832 189 121 189 C114.44663127 194.87543403 105.94743387 199.64235179 97.25 201 C96.22390625 201.165 95.1978125 201.33 94.140625 201.5 C82.19950063 203.07759584 70.24399706 203.13802469 58.2265625 203.09765625 C56.56505374 203.09578574 54.90354442 203.09436484 53.24203491 203.09336853 C48.91852228 203.08959313 44.5950445 203.07980681 40.27154541 203.06866455 C35.83988923 203.05834197 31.40822729 203.05384793 26.9765625 203.04882812 C18.31769253 203.03817886 9.65885063 203.0211641 1 203 C-0.91145757 196.49005943 -2.22179396 190.66538188 0 184 C-0.66 183.67 -1.32 183.34 -2 183 C-1.34 183 -0.68 183 0 183 C-0.23396484 181.93458984 -0.23396484 181.93458984 -0.47265625 180.84765625 C-0.76462891 179.46900391 -0.76462891 179.46900391 -1.0625 178.0625 C-1.25972656 177.14597656 -1.45695313 176.22945312 -1.66015625 175.28515625 C-1.77230469 174.53105469 -1.88445313 173.77695312 -2 173 C-1.67 172.67 -1.34 172.34 -1 172 C-0.91159597 170.27702445 -0.89310145 168.55041258 -0.90234375 166.82519531 C-0.90729858 165.16777313 -0.90729858 165.16777313 -0.91235352 163.47686768 C-0.92065186 162.27278259 -0.9289502 161.06869751 -0.9375 159.828125 C-0.94128662 158.5984198 -0.94507324 157.3687146 -0.94897461 156.10174561 C-0.96332082 151.48263047 -0.98647792 146.86357927 -1.01037598 142.24450684 C-1.03328299 137.73072073 -1.04864375 133.21694654 -1.0625 128.703125 C-1.07079834 127.50713684 -1.07909668 126.31114868 -1.08764648 125.07891846 C-1.09094971 123.96136169 -1.09425293 122.84380493 -1.09765625 121.69238281 C-1.10289307 120.71166809 -1.10812988 119.73095337 -1.11352539 118.72052002 C-1.00187298 116.04488406 -0.60020462 113.60575736 0 111 C-0.66 111 -1.32 111 -2 111 C-1.9278125 110.45214844 -1.855625 109.90429688 -1.78125 109.33984375 C0.15325845 96.39714526 0.15325845 96.39714526 -2 84 C-1.34 84 -0.68 84 0 84 C-0.165 83.175 -0.33 82.35 -0.5 81.5 C-0.88736085 78.78847404 -1.0395601 76.45986694 -1 73.75 C-0.7204915 70.186339 -0.7204915 70.186339 -2 68 C-1.34 68 -0.68 68 0 68 C0 66.35 0 64.7 0 63 C-0.66 63 -1.32 63 -2 63 C-1.34 60.36 -0.68 57.72 0 55 C-0.66 55 -1.32 55 -2 55 C-1.89171875 54.1646875 -1.89171875 54.1646875 -1.78125 53.3125 C-0.33659663 44.45832269 -0.33659663 44.45832269 -2 36 C-1.34 36 -0.68 36 0 36 C-0.08378906 35.07703125 -0.16757812 34.1540625 -0.25390625 33.203125 C-1.12497911 22.04457142 -0.74319422 11.15934713 0 0 Z ",
    fill: "#4A4A63",
    transform: "translate(517,568)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C-0.010256 19.97393395 -5.76942813 37.67698056 -18 54 C-18.99580078 55.38058594 -18.99580078 55.38058594 -20.01171875 56.7890625 C-25.96552887 64.60275045 -33.05612717 70.34725034 -41 76 C-41.74765625 76.54785156 -42.4953125 77.09570312 -43.265625 77.66015625 C-55.98485847 85.84753685 -76.51550407 87.44622733 -91.09326172 84.58984375 C-94.52701891 83.69461734 -97.78344588 82.49173524 -101 81 C-101 79.35 -101 77.7 -101 76 C-96.9591263 76.41093631 -92.96363192 76.82637263 -88.96484375 77.546875 C-71.95571592 80.6056246 -56.56700829 77.15235372 -41.91015625 68.078125 C-30.05409749 59.61178505 -19.93867704 48.81125527 -13 36 C-12.4225 34.97261719 -11.845 33.94523437 -11.25 32.88671875 C-6.27288727 23.586812 -3.50964773 14.20050369 -1 4 C-1.99 4 -2.98 4 -4 4 C-3.67 3.34 -3.34 2.68 -3 2 C-2.01 2.33 -1.02 2.66 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#8C5B92",
    transform: "translate(613,290)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.50165911 -0.93970523 5.38079164 -2.375 8.5625 C-9.70547249 25.98535104 -8.70398286 45.56089237 -1.74316406 63.00878906 C5.36555058 79.8250173 16.58600592 93.1690274 32 103 C32.76699219 103.51175781 33.53398437 104.02351563 34.32421875 104.55078125 C55.93286149 118.37316925 80.13373195 119.78989081 105 121 C105 121.33 105 121.66 105 122 C94.44 122 83.88 122 73 122 C72.67 122.66 72.34 123.32 72 124 C74.64 124.66 77.28 125.32 80 126 C80 126.33 80 126.66 80 127 C72.89725037 127.3119696 66.99846333 126.27473007 60.1875 124.3125 C59.21627197 124.03776855 58.24504395 123.76303711 57.24438477 123.47998047 C40.94019709 118.76548367 25.99180661 111.09120163 13 100 C13 99.34 13 98.68 13 98 C12.38125 97.7525 11.7625 97.505 11.125 97.25 C8.60474173 95.76749514 7.98768341 94.71612936 7 92 C7 91.01 7 90.02 7 89 C6.34 88.34 5.68 87.68 5 87 C5.375 84.875 5.375 84.875 6 83 C6.33 83 6.66 83 7 83 C6.55269531 82.33355469 6.10539062 81.66710937 5.64453125 80.98046875 C-6.93214119 61.80707686 -12.73568802 40.52543954 -8.26953125 17.62890625 C-6.52165993 11.00126357 -3.99929609 5.5545779 0 0 Z ",
    fill: "#B63F7B",
    transform: "translate(443,335)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.36720809 0.48792801 8.21436615 2.95713547 11.75 6.875 C14.67958799 11.1066271 15.08349146 15.29222348 14.4375 20.3125 C13.04400212 24.4762045 10.86532792 27.35141658 7.1875 29.75 C3.27064294 31.68332047 -0.27411709 32.13978647 -4.5625 31.3125 C-8.56335889 29.86503479 -11.11361903 27.79591027 -14 24.6875 C-16.58285339 19.10853668 -16.50189832 14.32605654 -14.6796875 8.48046875 C-13.52203764 5.80100766 -12.38432262 3.59322 -10.5625 1.3125 C-6.88950698 0.08816899 -3.83127811 0.33607703 0 0 Z ",
    fill: "#727BB1",
    transform: "translate(706.5625,419.6875)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.5028038 4.35763296 -3.05301137 6.91905734 -6 10 C-7.65438613 10.69658363 -9.32429732 11.35638306 -11 12 C-13.80161102 13.40043909 -16.5546542 14.89056585 -19.3125 16.375 C-42.97670671 29.06358269 -73.8527382 37.97123425 -101 33 C-102.35142044 32.37080606 -103.68845391 31.70856833 -105 31 C-106.65740715 30.62331656 -108.32345271 30.27942455 -110 30 C-109.34 29.67 -108.68 29.34 -108 29 C-107.67 28.01 -107.34 27.02 -107 26 C-97.43 26 -87.86 26 -78 26 C-78 25.67 -78 25.34 -78 25 C-76.9584375 24.90203125 -75.916875 24.8040625 -74.84375 24.703125 C-51.66284438 22.35693472 -26.48912702 15.58670029 -7.65625 1.2109375 C-5.17732052 -0.60148736 -2.97182931 -0.20262473 0 0 Z ",
    fill: "#7A71A2",
    transform: "translate(623,430)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.69035498 3.36905542 5.2474258 7.37049285 7.25 11.875 C7.64477539 12.75978027 8.03955078 13.64456055 8.44628906 14.55615234 C14.36899421 28.1248356 18.7679671 42.24044998 22.40332031 56.58056641 C22.87869364 58.40283082 23.43197833 60.20445586 24 62 C24.66 62.33 25.32 62.66 26 63 C25.98259766 63.58555664 25.96519531 64.17111328 25.94726562 64.77441406 C25.85344368 70.47298008 26.29407033 75.90635751 27.06787109 81.54785156 C30.51937148 107.12405443 30.62141559 133.62118888 26.26953125 159.07861328 C25.92945679 161.0942822 25.92945679 161.0942822 26.09375 163.52734375 C25.97144094 166.75324533 24.95614491 169.38178995 23.88671875 172.41308594 C22.92634955 175.21486789 22.09465564 178.03497263 21.28125 180.8828125 C20.98863281 181.90503906 20.69601562 182.92726563 20.39453125 183.98046875 C19.79612074 186.08405153 19.1997801 188.18822419 18.60546875 190.29296875 C15.32883496 201.71066621 15.32883496 201.71066621 13 206 C10.8125 206.9375 10.8125 206.9375 9 207 C9.29264706 201.43970584 10.31437312 196.80965671 12.1875 191.5625 C14.72260922 184.38823585 16.56752101 177.09023579 18.3125 169.6875 C18.57893311 168.59058838 18.84536621 167.49367676 19.11987305 166.36352539 C20.4284637 160.68351139 21.29179443 155.45543004 20.99682617 149.62036133 C20.99961316 147.31938087 21.19886424 145.21739183 21.48730469 142.94042969 C22.14608346 137.35096257 22.12536373 131.80550868 22.09765625 126.18359375 C22.0962413 125.08652603 22.09482635 123.98945831 22.09336853 122.85914612 C22.08781012 119.38523531 22.07526546 115.91139104 22.0625 112.4375 C22.05747962 110.06966239 22.05291766 107.70182377 22.04882812 105.33398438 C22.03785435 99.55596722 22.02115811 93.77798836 22 88 C21.01 88 20.02 88 19 88 C19.18820312 87.00355469 19.37640625 86.00710937 19.5703125 84.98046875 C20.13764823 80.95359644 19.65239901 77.27913103 18.875 73.3125 C18.74029297 72.590625 18.60558594 71.86875 18.46679688 71.125 C16.23311426 59.57282649 13.59862747 47.95874184 9.47070312 36.92773438 C9 35 9 35 10 32 C17.2951097 52.24100442 22.28321327 72.52988571 24 94 C24.16628906 95.85818359 24.16628906 95.85818359 24.3359375 97.75390625 C25.318041 110.4814368 25.09491139 123.24390882 25 136 C28.31539022 131.02691467 27.3374803 125.3450274 27.3125 119.5 C27.31067719 118.83306122 27.30885437 118.16612244 27.30697632 117.47897339 C27.12515674 77.74221632 17.76267427 39.99235159 0.8828125 4.109375 C0 2 0 2 0 0 Z M24 65 C25 68 25 68 25 68 Z ",
    fill: "#7477A5",
    transform: "translate(678,138)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.70398926 0.00054382 1.40797852 0.00108765 2.13330078 0.00164795 C13.29375986 0.04121731 23.7281838 0.84285574 34.375 4.375 C35.06964355 4.59994141 35.76428711 4.82488281 36.47998047 5.05664062 C47.67996746 8.76527942 58.59681716 13.30856172 67.375 21.375 C63.53226281 21.375 62.10054364 20.07051586 58.9375 17.9375 C54.47293858 14.9079144 54.47293858 14.9079144 49.375 13.375 C49.375 14.035 49.375 14.695 49.375 15.375 C51.355 15.705 53.335 16.035 55.375 16.375 C55.375 17.365 55.375 18.355 55.375 19.375 C51.82326714 18.03436381 48.62311022 16.41039583 45.3125 14.5625 C30.68076305 7.13743946 13.92515175 5.19346625 -2.25 5.125 C-3.44496094 5.104375 -4.63992188 5.08375 -5.87109375 5.0625 C-14.19007799 5.02644806 -21.61133826 6.18697928 -29.625 8.375 C-32.0962683 9.02714025 -34.32976295 9.46541923 -36.8828125 9.79296875 C-57.06892414 12.93256231 -77.61127873 23.88677541 -94.46484375 35.046875 C-96.625 36.375 -96.625 36.375 -98.625 36.375 C-98.625 35.385 -98.625 34.395 -98.625 33.375 C-97.2265625 32.15161133 -97.2265625 32.15161133 -95.25 30.95703125 C-94.52014893 30.51125732 -93.79029785 30.0654834 -93.03833008 29.60620117 C-92.24193115 29.13802979 -91.44553223 28.6698584 -90.625 28.1875 C-89.80990967 27.70063721 -88.99481934 27.21377441 -88.1550293 26.7121582 C-72.38622738 17.40986449 -56.11111521 10.00924668 -38.4375 5.125 C-37.54724121 4.87862793 -36.65698242 4.63225586 -35.73974609 4.37841797 C-23.80681706 1.20609603 -12.34839519 -0.03601494 0 0 Z ",
    fill: "#B1417B",
    transform: "translate(453.625,190.625)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.1875 0.875 3.1875 0.875 6 2 C5.96447021 3.04978027 5.92894043 4.09956055 5.89233398 5.18115234 C5.76216101 9.0685228 5.63893206 12.95608749 5.51782227 16.84375 C5.46438576 18.5277307 5.40905512 20.21165239 5.35180664 21.89550781 C5.26994148 24.31302158 5.19484528 26.73066432 5.12109375 29.1484375 C5.09405869 29.9036972 5.06702362 30.65895691 5.03916931 31.43710327 C4.83711274 35.34429703 4.83711274 35.34429703 6 39 C4.741875 38.87625 3.48375 38.7525 2.1875 38.625 C1.12595703 38.52058594 1.12595703 38.52058594 0.04296875 38.4140625 C-2 38 -2 38 -5 36 C-5 36.66 -5 37.32 -5 38 C-5.84498047 37.75636719 -5.84498047 37.75636719 -6.70703125 37.5078125 C-9.10446869 36.97686383 -11.23522125 36.86689329 -13.6875 36.875 C-14.47511719 36.87242187 -15.26273437 36.86984375 -16.07421875 36.8671875 C-18.00764914 36.78872222 -18.00764914 36.78872222 -19 38 C-21.51217358 38.13579317 -23.62844462 38.10133329 -26.0625 37.4375 C-28.35605372 36.91960077 -29.76520863 37.38350583 -32 38 C-32.33 37.67 -32.66 37.34 -33 37 C-35.01594582 36.76572222 -37.038474 36.58663876 -39.0625 36.4375 C-40.16722656 36.35371094 -41.27195312 36.26992188 -42.41015625 36.18359375 C-43.26480469 36.12300781 -44.11945313 36.06242188 -45 36 C-45.495 36.99 -45.495 36.99 -46 38 C-48.31 37.34 -50.62 36.68 -53 36 C-53 36.66 -53 37.32 -53 38 C-55.64 37.34 -58.28 36.68 -61 36 C-61 36.66 -61 37.32 -61 38 C-61.66 38 -62.32 38 -63 38 C-63 37.34 -63 36.68 -63 36 C-65.31 36 -67.62 36 -70 36 C-70.33 36.66 -70.66 37.32 -71 38 C-71.66 37.67 -72.32 37.34 -73 37 C-77.29 36.67 -81.58 36.34 -86 36 C-86 52.17 -86 68.34 -86 85 C-59.93 85 -33.86 85 -7 85 C-7 95.56 -7 106.12 -7 117 C-33.4 117 -59.8 117 -87 117 C-87 116.67 -87 116.34 -87 116 C-61.26 116 -35.52 116 -9 116 C-9 106.1 -9 96.2 -9 86 C-35.07 86 -61.14 86 -88 86 C-88 68.84 -88 51.68 -88 34 C-57.97 34 -27.94 34 3 34 C3 23.77 3 13.54 3 3 C1.02 2.67 -0.96 2.34 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#A52E5F",
    transform: "translate(490,569)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.98520054 11.7976061 24.60490964 27.64922343 29.93359375 43.8359375 C31.0378614 47.11233602 32.42866542 50.1014454 33.91918945 53.21459961 C43.31378166 73.02087952 50.00723354 94.26207942 53 116 C53.1023999 116.70334473 53.2047998 117.40668945 53.31030273 118.13134766 C54.41734481 127.07856808 54.10793477 136.12720049 54.0625 145.125 C54.05747515 146.86197788 54.05291398 148.59895716 54.04882812 150.3359375 C54.03790014 154.55732688 54.02068978 158.77864764 54 163 C53.01 162.67 52.02 162.34 51 162 C50.970271 160.44104004 50.970271 160.44104004 50.93994141 158.85058594 C50.86377876 154.98885164 50.775078 151.1274889 50.68261719 147.26611328 C50.64437143 145.59594059 50.60951085 143.92568677 50.578125 142.25537109 C50.53237839 139.85224443 50.47440075 137.44967416 50.4140625 135.046875 C50.40251129 134.30193787 50.39096008 133.55700073 50.37905884 132.78948975 C50.27100477 128.98048814 49.8960238 126.29952579 48 123 C47.7047806 120.22605167 47.49287769 117.5299489 47.375 114.75 C47.33632813 114.00492187 47.29765625 113.25984375 47.2578125 112.4921875 C47.16394892 110.6618476 47.08090282 108.83095857 47 107 C46.01 107.33 45.02 107.66 44 108 C43.67 106.35 43.34 104.7 43 103 C43.99 103.495 43.99 103.495 45 104 C44.04876919 96.07854343 42.18698705 88.49018544 40.0625 80.8125 C39.80968262 79.86737549 39.55686523 78.92225098 39.29638672 77.94848633 C39.04518066 77.06443115 38.79397461 76.18037598 38.53515625 75.26953125 C38.312229 74.47135986 38.08930176 73.67318848 37.85961914 72.85083008 C37.57594482 72.24005615 37.29227051 71.62928223 37 71 C36.01 70.67 35.02 70.34 34 70 C34 69.34 34 68.68 34 68 C34.66 68 35.32 68 36 68 C34.74699312 64.84677011 33.46968518 61.70396598 32.1875 58.5625 C31.83107422 57.66466797 31.47464844 56.76683594 31.10742188 55.84179688 C30.75615234 54.98779297 30.40488281 54.13378906 30.04296875 53.25390625 C29.72352295 52.46314697 29.40407715 51.6723877 29.07495117 50.85766602 C28.07538387 48.65694081 28.07538387 48.65694081 25 48 C25.33 47.01 25.66 46.02 26 45 C24.62507196 41.8331162 24.62507196 41.8331162 23 39 C22.34 39 21.68 39 21 39 C20.9175 38.319375 20.835 37.63875 20.75 36.9375 C19.77667472 33.1253093 18.04192545 30.35929671 16 27 C14.68 27 13.36 27 12 27 C12 26.34 12 25.68 12 25 C12.66 24.67 13.32 24.34 14 24 C13.4946875 23.30132812 12.989375 22.60265625 12.46875 21.8828125 C11.8190625 20.97273438 11.169375 20.06265625 10.5 19.125 C9.8503125 18.22007812 9.200625 17.31515625 8.53125 16.3828125 C7 14 7 14 7 12 C6.34 11.67 5.68 11.34 5 11 C3.7109375 9.51171875 3.7109375 9.51171875 2.375 7.6875 C1.70597656 6.79611328 1.70597656 6.79611328 1.0234375 5.88671875 C0 4 0 4 0 0 Z ",
    fill: "#6C668A",
    transform: "translate(631,116)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.45778354 -0.41209784 9.30853296 1.74634131 14.16015625 4.00390625 C17.07383275 5.02589732 18.18902918 5.12573651 21 4 C21.33 4.99 21.66 5.98 22 7 C23.81405715 8.16624759 23.81405715 8.16624759 26.09375 9.09375 C27.37958984 9.67092773 27.37958984 9.67092773 28.69140625 10.25976562 C29.61824219 10.66904297 30.54507813 11.07832031 31.5 11.5 C49.78893586 19.89798075 65.98653458 31.31293634 80.765625 44.95703125 C82.83742629 46.85135306 84.96108951 48.65010994 87.125 50.4375 C88.07375 51.283125 89.0225 52.12875 90 53 C90 53.66 90 54.32 90 55 C90.66 55 91.32 55 92 55 C93.41015625 56.36328125 93.41015625 56.36328125 95.0625 58.3125 C95.67351562 59.03050781 96.28453125 59.74851563 96.9140625 60.48828125 C100.6363573 64.9703703 104.33105871 69.47414044 108 74 C107.67 74.66 107.34 75.32 107 76 C105.82739389 74.71372289 104.6620717 73.42080217 103.5 72.125 C102.8503125 71.40570313 102.200625 70.68640625 101.53125 69.9453125 C100 68 100 68 100 66 C99.34 66 98.68 66 98 66 C99.57313172 70.72843614 102.20641235 74.3433843 105.125 78.3125 C105.59292969 78.95767578 106.06085938 79.60285156 106.54296875 80.26757812 C107.6905929 81.84848894 108.84465477 83.42472301 110 85 C109.67 85.66 109.34 86.32 109 87 C107.85724609 85.45892578 107.85724609 85.45892578 106.69140625 83.88671875 C103.48391733 79.5736676 100.24782544 75.28273278 97 71 C96.27296875 70.03835937 95.5459375 69.07671875 94.796875 68.0859375 C90.06221504 62.06509039 84.82541171 56.62416584 79.4375 51.1875 C78.72891846 50.46957275 78.02033691 49.75164551 77.2902832 49.01196289 C72.80346423 44.55218234 68.14716971 40.67017399 63 37 C61.66582031 36.00033203 61.66582031 36.00033203 60.3046875 34.98046875 C55.18189958 31.20014776 49.97992548 27.53833641 44.6875 24 C43.82584229 23.40288208 43.82584229 23.40288208 42.94677734 22.79370117 C39.14924994 20.30071411 36.52018493 19.56234216 32 20 C31.91105469 19.38640625 31.82210937 18.7728125 31.73046875 18.140625 C31.18684896 15.90424818 31.18684896 15.90424818 29.36328125 14.734375 C24.94274808 12.61251908 21.9668588 11.88449166 17 12 C15.375 10.6875 15.375 10.6875 14 9 C9.66475536 5.41221133 5.70874251 3 0 3 C0 2.01 0 1.02 0 0 Z M33 17 C33 17.66 33 18.32 33 19 C33.99 18.67 34.98 18.34 36 18 C35.01 17.67 34.02 17.34 33 17 Z ",
    fill: "#6E6288",
    transform: "translate(515,68)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.66310435 0.79125074 8.91546187 1.16488126 13.625 1.0625 C14.615 1.3925 15.605 1.7225 16.625 2.0625 C16.625 2.7225 16.625 3.3825 16.625 4.0625 C18.36136719 4.24425781 18.36136719 4.24425781 20.1328125 4.4296875 C24.37244416 4.96406356 28.41285655 5.95476086 32.5 7.1875 C33.22614502 7.40559326 33.95229004 7.62368652 34.70043945 7.84838867 C48.59856382 12.12988603 61.17500116 17.56604261 73.625 25.0625 C75.07340618 25.84135674 76.52268598 26.6185902 77.97265625 27.39453125 C82.81164804 30.06818765 87.13833744 33.24081717 91.5 36.625 C92.24507812 37.18896484 92.99015625 37.75292969 93.7578125 38.33398438 C97.25486146 41.02281249 100.07365977 43.42593213 102.625 47.0625 C101.305 47.0625 99.985 47.0625 98.625 47.0625 C106.05 54.4875 106.05 54.4875 113.625 62.0625 C113.295 62.7225 112.965 63.3825 112.625 64.0625 C112.13733154 63.55912109 111.64966309 63.05574219 111.1472168 62.53710938 C98.30381109 49.21903453 98.30381109 49.21903453 83.625 38.0625 C82.34109375 37.17304687 82.34109375 37.17304687 81.03125 36.265625 C77.15898862 33.22806808 77.15898862 33.22806808 72.625 32.0625 C71.76793457 31.17256348 71.76793457 31.17256348 70.89355469 30.26464844 C68.2317507 27.68076209 65.67990594 26.40915375 62.328125 24.828125 C61.73449158 24.54523621 61.14085815 24.26234741 60.52923584 23.97088623 C58.64817425 23.07672072 56.76179924 22.19448351 54.875 21.3125 C53.5920775 20.70520899 52.30952118 20.09714376 51.02734375 19.48828125 C47.89741488 18.00404153 44.76261211 16.53044064 41.625 15.0625 C41.295 15.7225 40.965 16.3825 40.625 17.0625 C40.625 16.0725 40.625 15.0825 40.625 14.0625 C40.295 14.7225 39.965 15.3825 39.625 16.0625 C39.109375 15.794375 38.59375 15.52625 38.0625 15.25 C30.13327858 11.38704598 22.5876294 8.60287798 13.625 9.0625 C13.625 8.4025 13.625 7.7425 13.625 7.0625 C12.59375 7.26875 11.5625 7.475 10.5 7.6875 C6.5015784 8.07444403 4.28806243 7.58133076 0.625 6.0625 C0.625 5.4025 0.625 4.7425 0.625 4.0625 C-5.315 3.0725 -5.315 3.0725 -11.375 2.0625 C-11.375 1.4025 -11.375 0.7425 -11.375 0.0625 C-7.26837755 -1.02903719 -4.16051701 -0.75600844 0 0 Z ",
    fill: "#926398",
    transform: "translate(476.375,86.9375)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31796021 2.12125731 3.70550303 4.07008057 5.04296875 6.90625 C5.56987305 8.02193359 5.56987305 8.02193359 6.10742188 9.16015625 C6.46384766 9.93230469 6.82027344 10.70445312 7.1875 11.5 C7.55552734 12.27214844 7.92355469 13.04429687 8.30273438 13.83984375 C11 19.61469446 11 19.61469446 11 23 C11.66 23.33 12.32 23.66 13 24 C13.8515625 25.9609375 13.8515625 25.9609375 14.625 28.375 C14.88539063 29.16648438 15.14578125 29.95796875 15.4140625 30.7734375 C16 33 16 33 16 36 C16.66 36.33 17.32 36.66 18 37 C20.69199108 44.36046807 22.00114059 52.33604027 23.5625 60 C23.77068359 61.00289062 23.97886719 62.00578125 24.19335938 63.0390625 C25.56099716 69.67574996 26.81713171 76.32799898 28 83 C28.33 83 28.66 83 29 83 C29.09765625 89.15234375 29.09765625 89.15234375 29 91 C28.67 91.33 28.34 91.66 28 92 C27.9487568 93.6228912 27.96481755 95.24796309 28.0078125 96.87109375 C28.61856611 129.86718583 23.03762444 159.36249978 10.73095703 189.95068359 C9.88801583 191.95133051 9.88801583 191.95133051 10 194 C9.34 194 8.68 194 8 194 C7.5978125 195.3303125 7.5978125 195.3303125 7.1875 196.6875 C6.08289181 199.76877548 4.77150856 202.26221405 3 205 C2.67 204.34 2.34 203.68 2 203 C3.11764377 200.40125106 4.29839761 197.90153784 5.5625 195.375 C11.50045111 183.07144088 15.93013673 170.83940479 19.4375 157.625 C19.70900879 156.60712402 19.98051758 155.58924805 20.26025391 154.54052734 C20.50308105 153.59129395 20.7459082 152.64206055 20.99609375 151.6640625 C21.32371704 150.38716553 21.32371704 150.38716553 21.65795898 149.08447266 C22.21779089 146.94713058 22.21779089 146.94713058 21 145 C20.67 144.67 20.34 144.34 20 144 C19.78085937 145.01835937 19.56171875 146.03671875 19.3359375 147.0859375 C17.5750343 155.03372098 15.55959034 162.83165849 13 170.5625 C12.7632959 171.28679199 12.5265918 172.01108398 12.28271484 172.75732422 C10.58863031 177.74769527 8.43850279 182.32795478 6 187 C5 185 5 185 5.57324219 182.92797852 C5.89454102 182.08678467 6.21583984 181.24559082 6.546875 180.37890625 C6.8975 179.44240234 7.248125 178.50589844 7.609375 177.54101562 C7.98578125 176.55810547 8.3621875 175.57519531 8.75 174.5625 C14.21700419 161.16486759 14.21700419 161.16486759 16 147 C16.66 147 17.32 147 18 147 C18.04898438 146.36578125 18.09796875 145.7315625 18.1484375 145.078125 C18.55560936 139.99549696 19.0000267 134.92497571 19.546875 129.85546875 C19.64178223 128.9624707 19.73668945 128.06947266 19.83447266 127.14941406 C20.02668573 125.35520996 20.22419575 123.56156466 20.42724609 121.76855469 C20.51570801 120.93614258 20.60416992 120.10373047 20.6953125 119.24609375 C20.77797363 118.50029053 20.86063477 117.7544873 20.94580078 116.98608398 C21.11909226 114.78729422 21.11909226 114.78729422 20 112 C20.66 112 21.32 112 22 112 C21.95456055 111.14003418 21.95456055 111.14003418 21.90820312 110.26269531 C20.80991939 89.20099264 20.80991939 89.20099264 21 79 C21.33 79 21.66 79 22 79 C22.87510383 84.47859123 23.29024034 89.89857799 23.5625 95.4375 C23.60568359 96.26443359 23.64886719 97.09136719 23.69335938 97.94335938 C23.79838033 99.96209549 23.89958559 101.98102951 24 104 C24.33 104 24.66 104 25 104 C26.07995441 69.36146238 17.09659299 36.44275627 1.6875 5.54296875 C0 2 0 2 0 0 Z ",
    fill: "#6A6A8F",
    transform: "translate(659,157)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.66 2.64 1.32 4 2 C3.09311745 16.64518838 3.09311745 16.64518838 2.4375 21.375 C-0.04643109 42.68873129 3.08633318 66.86994782 13.1796875 85.96875 C14 88 14 88 13 91 C12.01 91.495 12.01 91.495 11 92 C11.33 93.32 11.66 94.64 12 96 C8.47026484 92.75790987 6.96527092 89.08053731 5.0625 84.75 C4.70913574 83.94804199 4.35577148 83.14608398 3.99169922 82.31982422 C0.87133297 75.04088957 -1.39524772 67.7695432 -3 60 C-3.17660156 59.14704346 -3.35320312 58.29408691 -3.53515625 57.4152832 C-5.07987771 49.22812251 -5.30022186 41.25340295 -5.25 32.9375 C-5.25773437 31.65294922 -5.26546875 30.36839844 -5.2734375 29.04492188 C-5.25800236 21.47784336 -4.68271508 14.38343946 -3 7 C-2.34 7 -1.68 7 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#F03482",
    transform: "translate(381,342)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.94875 0.04125 1.8975 0.0825 2.875 0.125 C3.37 1.61 3.37 1.61 3.875 3.125 C1.03355795 7.74234333 -2.44632083 9.69568581 -7.125 12.125 C-7.125 12.785 -7.125 13.445 -7.125 14.125 C-7.69605469 14.21136719 -8.26710938 14.29773438 -8.85546875 14.38671875 C-15.14028404 15.47582029 -20.69795012 17.40000344 -26.55859375 19.90625 C-35.29359231 22.89126594 -44.01524146 23.46684184 -53.1875 23.4375 C-54.19876953 23.45361328 -55.21003906 23.46972656 -56.25195312 23.48632812 C-63.02659938 23.49069042 -68.76167591 22.44764405 -75.125 20.125 C-75.125 19.465 -75.125 18.805 -75.125 18.125 C-77.105 17.465 -79.085 16.805 -81.125 16.125 C-81.125 14.475 -81.125 12.825 -81.125 11.125 C-80.38161377 11.48231201 -79.63822754 11.83962402 -78.87231445 12.20776367 C-69.39273027 16.35277394 -61.49573855 16.74252523 -51.3125 16.4375 C-49.83011648 16.41234184 -48.34769099 16.38954215 -46.86523438 16.36914062 C-43.28426304 16.31484051 -39.70491418 16.22900215 -36.125 16.125 C-35.795 15.465 -35.465 14.805 -35.125 14.125 C-34.34125 14.00125 -33.5575 13.8775 -32.75 13.75 C-21.49080781 11.80875997 -10.00236663 0.40009467 0 0 Z ",
    fill: "#816194",
    transform: "translate(585.125,377.875)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.86100976 11.79151463 6.40977091 29.96989067 6.4375 43.625 C6.44340149 44.43972778 6.44930298 45.25445557 6.4553833 46.09387207 C6.51165805 57.58604164 5.37765975 68.5021507 3.35131836 79.80601501 C2.98026251 82.12326072 2.72548965 84.43453844 2.49047852 86.76928711 C2.16652373 89.85388283 1.69665819 92.61782464 0.6171875 95.54296875 C0.34052246 96.30013184 0.06385742 97.05729492 -0.22119141 97.83740234 C-0.51944824 98.61293457 -0.81770508 99.3884668 -1.125 100.1875 C-1.4348584 101.00686035 -1.7447168 101.8262207 -2.06396484 102.67041016 C-9.55971195 122.08518975 -9.55971195 122.08518975 -17 129 C-17.763125 129.763125 -18.52625 130.52625 -19.3125 131.3125 C-19.869375 131.869375 -20.42625 132.42625 -21 133 C-21.71875 130.86328125 -21.71875 130.86328125 -22 128 C-20.59375 125.23046875 -20.59375 125.23046875 -18.5 122.1875 C-3.81186973 99.73966382 2.20464567 71.91221213 2.1875 45.375 C2.18814453 44.32973145 2.18878906 43.28446289 2.18945312 42.20751953 C2.13913778 34.76885356 1.57494854 27.5882093 0.4375 20.2421875 C-0.15520846 15.84979442 -0.40917636 12.22752907 1 8 C0.90731495 5.93381251 0.90731495 5.93381251 0.5625 3.8125 C0.376875 2.554375 0.19125 1.29625 0 0 Z ",
    fill: "#74709D",
    transform: "translate(632,223)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.55750977 0.00676758 1.55750977 0.00676758 3.14648438 0.01367188 C5.66022175 0.02525592 8.17382623 0.04156077 10.6875 0.0625 C11.90782574 3.72347722 11.8257131 7.0841917 11.81448364 10.89541626 C11.81604363 11.70173378 11.81760362 12.50805131 11.81921089 13.3388027 C11.82321016 16.04961734 11.82003539 18.76037631 11.81689453 21.47119141 C11.81824902 23.41087375 11.82002923 25.35055583 11.82220459 27.29023743 C11.82677258 32.56475849 11.82499211 37.83926004 11.8218255 43.11378145 C11.81929937 48.62398107 11.82164008 54.13417898 11.82321167 59.64437866 C11.82503231 68.89671123 11.82262948 78.14903583 11.81787109 87.40136719 C11.81242547 98.11403054 11.81419374 108.82667486 11.8196975 119.53933775 C11.82422779 128.72320361 11.82487969 137.90706373 11.82225883 147.09093034 C11.820696 152.58224638 11.82050251 158.07355346 11.82379532 163.56486893 C11.82667292 168.72431776 11.82470041 173.88374194 11.81890106 179.0431881 C11.817573 180.94236269 11.81796835 182.84153933 11.82016373 184.74071312 C11.82287335 187.32168761 11.81949647 189.90258174 11.81448364 192.48355103 C11.81671436 193.24510864 11.81894509 194.00666625 11.82124341 194.79130137 C11.80165006 199.94834994 11.80165006 199.94834994 10.6875 201.0625 C-1.1925 201.0625 -13.0725 201.0625 -25.3125 201.0625 C-25.3125 135.0625 -25.3125 69.0625 -25.3125 1.0625 C-16.7766355 0.40589504 -8.52085323 -0.07225772 0 0 Z M-24.3125 2.0625 C-24.3125 67.0725 -24.3125 132.0825 -24.3125 199.0625 C-13.0925 199.0625 -1.8725 199.0625 9.6875 199.0625 C9.6875 134.0525 9.6875 69.0425 9.6875 2.0625 C-1.5325 2.0625 -12.7525 2.0625 -24.3125 2.0625 Z ",
    fill: "#712342",
    transform: "translate(324.3125,569.9375)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C2.03726245 35.59884714 -14.44271201 86.15997477 -37 114 C-38.6313208 115.37635315 -40.2914565 116.72076794 -42 118 C-42.33 117.01 -42.66 116.02 -43 115 C-45.97 119.455 -45.97 119.455 -49 124 C-49 120.63610867 -48.43239708 119.72018501 -46.69140625 116.9296875 C-46.19632568 116.1253125 -45.70124512 115.3209375 -45.19116211 114.4921875 C-44.65370361 113.62851562 -44.11624512 112.76484375 -43.5625 111.875 C-28.06387551 86.37410471 -17.31570534 59.99659401 -10 31 C-9.79391113 30.18337891 -9.58782227 29.36675781 -9.37548828 28.52539062 C-8.91363533 26.68443266 -8.45622444 24.84236089 -8 23 C-7.67 23 -7.34 23 -7 23 C-7.57156863 29.24997873 -8.6000419 35.07557493 -10.25 41.125 C-10.46744873 41.93815674 -10.68489746 42.75131348 -10.90893555 43.58911133 C-12.97161788 51.16460618 -15.39829502 58.59344411 -18 66 C-17.67 65.34 -17.34 64.68 -17 64 C-16.01 64 -15.02 64 -14 64 C-13.88825439 63.45835205 -13.77650879 62.9167041 -13.66137695 62.35864258 C-12.63463506 57.54498338 -11.39290034 52.86450683 -9.9440918 48.16235352 C-5.71706546 34.33551714 -3.33048041 20.24871217 -1 6 C-0.66720658 3.99991009 -0.3340266 1.99988433 0 0 Z ",
    fill: "#6A6C93",
    transform: "translate(727,285)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.26122711 -0.02510127 10.52241781 -0.04304552 15.78369141 -0.05493164 C17.56592416 -0.05989742 19.34815299 -0.06667228 21.13037109 -0.07543945 C36.66235763 -0.14981798 51.97301783 -0.0431593 67.25 3.125 C68.31138184 3.34309326 69.37276367 3.56118652 70.46630859 3.78588867 C86.43483537 7.22616511 100.90577374 12.77836801 115 21 C114.34 21.33 113.68 21.66 113 22 C110.44704576 20.87852367 107.98526929 19.69464979 105.5 18.4375 C89.74606788 10.76190253 73.40369908 6.0574872 56 4 C56.62753174 4.10957031 57.25506348 4.21914062 57.90161133 4.33203125 C72.48337695 6.94583166 85.68749606 10.4630357 99 17 C99.73734375 17.3609375 100.4746875 17.721875 101.234375 18.09375 C103.3548982 19.14649201 105.46203363 20.22033905 107.5625 21.3125 C108.50138062 21.80036987 108.50138062 21.80036987 109.45922852 22.2980957 C112.53849512 23.96944957 114.01346809 25.02020213 116 28 C112.68939078 26.72870856 109.5750972 25.31162726 106.4609375 23.6171875 C105.21957031 22.95009766 105.21957031 22.95009766 103.953125 22.26953125 C102.22505936 21.33480484 100.4985086 20.39727271 98.7734375 19.45703125 C97.9484375 19.01488281 97.1234375 18.57273438 96.2734375 18.1171875 C95.52497559 17.71097168 94.77651367 17.30475586 94.00537109 16.88623047 C91.90807959 15.79789208 91.90807959 15.79789208 89 16 C89 15.34 89 14.68 89 14 C82.30177855 12.05249949 75.54762659 10.37142236 68.75 8.8125 C67.99412598 8.63364258 67.23825195 8.45478516 66.45947266 8.27050781 C60.84569856 7.00657711 55.58719297 6.13760234 50 8 C49.505 7.01 49.505 7.01 49 6 C44.13693244 4.80873694 39.28608524 4.84925236 34.3125 4.875 C33.55388672 4.87113281 32.79527344 4.86726562 32.01367188 4.86328125 C28.7522361 4.86903842 26.11486252 4.96171249 23 6 C23 5.34 23 4.68 23 4 C22.01 4.66 21.02 5.32 20 6 C19.01 5.67 18.02 5.34 17 5 C9.18360498 4.49696468 1.49014707 5.36963817 -6.25 6.375 C-7.87893188 6.57863159 -7.87893188 6.57863159 -9.54077148 6.78637695 C-12.69493124 7.18296288 -15.84765374 7.58927252 -19 8 C-20.29091553 8.16749756 -20.29091553 8.16749756 -21.60791016 8.33837891 C-25.74075198 8.87699704 -29.87143256 9.42938499 -34 10 C-34 9.01 -34 8.02 -34 7 C-29.64195356 6.11743951 -25.28205723 5.24489785 -20.92016602 4.3815918 C-19.43654357 4.08648964 -17.95346193 3.78865496 -16.47094727 3.48803711 C-14.340068 3.05643953 -12.20743801 2.63470176 -10.07421875 2.21484375 C-8.79119873 1.95823975 -7.50817871 1.70163574 -6.1862793 1.43725586 C-3 1 -3 1 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#844470",
    transform: "translate(416,144)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.98 0.99 -3.96 1.98 -6 3 C-5.16666667 5.16666667 -5.16666667 5.16666667 -3 6 C-4.6274068 8.31263072 -6.28002516 10.27245691 -8.3125 12.25 C-11.12151526 15.12434119 -13.36747528 18.1419634 -15.66796875 21.42578125 C-16.10753906 21.94527344 -16.54710937 22.46476562 -17 23 C-17.66 23 -18.32 23 -19 23 C-21.48666993 30.02140858 -22.51782253 36.31292403 -22.4375 43.75 C-22.43282715 44.70648438 -22.4281543 45.66296875 -22.42333984 46.6484375 C-22.25735318 54.65898092 -20.80288425 61.47108463 -18 69 C-17.32917101 70.99860774 -16.66130236 72.99821988 -16 75 C-17.32 73.68 -18.64 72.36 -20 71 C-21.485 71.99 -21.485 71.99 -23 73 C-29.3188481 58.58321066 -32.03650875 41.74988817 -26.96484375 26.44140625 C-26.64644531 25.63574219 -26.32804687 24.83007812 -26 24 C-25.67128906 23.16339844 -25.34257812 22.32679688 -25.00390625 21.46484375 C-20.92320427 12.32915453 -14.28473914 4.94787632 -5.82421875 -0.35546875 C-3.5301685 -1.16600042 -2.26268836 -0.78419883 0 0 Z ",
    fill: "#ED3886",
    transform: "translate(478,321)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C-10.4326269 7.69258089 -24.44113628 12.55959578 -39.13793945 15.61962891 C-41.23362497 16.05652918 -41.23362497 16.05652918 -44 17 C-44.495 18.485 -44.495 18.485 -45 20 C-32.57779592 17.342495 -20.74118745 14.08452619 -8.90625 9.453125 C-5.9615948 8.31172056 -3.1368993 7.4730245 0 7 C-3.71305163 10.25879531 -7.92532596 11.71261972 -12.5 13.375 C-13.33587646 13.67881592 -14.17175293 13.98263184 -15.03295898 14.2956543 C-44.14325967 24.59780843 -73.50375152 26.0278064 -104 22 C-104 22.33 -104 22.66 -104 23 C-105.65 23 -107.3 23 -109 23 C-108.67 22.01 -108.34 21.02 -108 20 C-109.7634375 19.9071875 -109.7634375 19.9071875 -111.5625 19.8125 C-118.66707832 19.06105422 -125.31133204 16.38818052 -132 14 C-128.33054929 12.65940442 -126.27423908 13.3807884 -122.6875 14.75 C-103.99630705 21.28065778 -83.6680671 22.50074287 -64 22 C-65.65 21.67 -67.3 21.34 -69 21 C-69 20.67 -69 20.34 -69 20 C-67.35 19.67 -65.7 19.34 -64 19 C-64.60134766 18.9906543 -65.20269531 18.98130859 -65.82226562 18.97167969 C-90.37961545 18.49835208 -114.63051253 15.7852886 -137 5 C-132.96358347 3.65452782 -130.61437682 5.1372671 -126.875 6.6875 C-86.30071582 22.60659714 -41.419221 17.63204768 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#855283",
    transform: "translate(592,481)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.24491652 2.16327768 -6.03906671 3.0801711 -9.7578125 4.2421875 C-10.42029999 4.45183136 -11.08278748 4.66147522 -11.76535034 4.87747192 C-14.58837734 5.77078453 -17.41474858 6.65327176 -20.24121094 7.53564453 C-30.87824327 10.83919055 -30.87824327 10.83919055 -41.13769531 15.15258789 C-43.90220488 16.41053397 -46.76529497 17.29734193 -49.6640625 18.19140625 C-52.84960799 19.29409507 -55.90406587 20.66748874 -59 22 C-61.24947551 22.85554697 -63.49949981 23.70965208 -65.75 24.5625 C-80.17420518 30.21049903 -93.65080202 38.20389417 -107 46 C-107 46.66 -107 47.32 -107 48 C-107.54269531 48.17015625 -108.08539063 48.3403125 -108.64453125 48.515625 C-113.14473554 50.04001852 -115.18171009 51.10807584 -118 55 C-120.6875 55.25 -120.6875 55.25 -123 55 C-123 54.01 -123 53.02 -123 52 C-121.576875 51.2265625 -121.576875 51.2265625 -120.125 50.4375 C-117.0823309 48.70631965 -114.25666871 46.78932409 -111.41796875 44.7421875 C-84.11993677 25.53107251 -52.33708612 13.28706254 -20.875 2.8125 C-20.0301001 2.52093018 -19.1852002 2.22936035 -18.31469727 1.92895508 C-12.12995986 -0.05324555 -6.46897124 -0.31063948 0 0 Z ",
    fill: "#9B3869",
    transform: "translate(346,0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.76937712 2.3532598 13.4789155 4.7245961 20.0625 7.5625 C44.13393235 17.63159589 69.26897383 18.71497335 95 19 C95 19.33 95 19.66 95 20 C91.04 20.495 91.04 20.495 87 21 C89.64 21.33 92.28 21.66 95 22 C95 22.33 95 22.66 95 23 C63.54514662 28.24247556 26.14718666 20.78330343 -1 4 C-1 1 -1 1 0 0 Z ",
    fill: "#DF408C",
    transform: "translate(441,480)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0789673 3.22251568 0.94905076 4.89030281 -0.375 8 C-5.90521066 21.23115821 -3.48051963 36.77102049 1 50 C1.66 50.99 2.32 51.98 3 53 C3.99 52.34 4.98 51.68 6 51 C6.33 51.33 6.66 51.66 7 52 C6.72285156 51.26394531 6.44570313 50.52789062 6.16015625 49.76953125 C5.79792969 48.79371094 5.43570312 47.81789063 5.0625 46.8125 C4.70285156 45.84957031 4.34320313 44.88664062 3.97265625 43.89453125 C1.89057241 37.69845042 1.75260318 31.79243628 1.6875 25.3125 C1.65849609 24.36955078 1.62949219 23.42660156 1.59960938 22.45507812 C1.53761578 15.51656405 2.98896885 10.23731827 6 4 C7 7 7 7 5.5625 10.5625 C0.54763956 24.70579304 4.30851186 40.93776933 10.5 54 C15.04352562 63.07303468 21.34218139 70.29999931 29.2734375 76.64453125 C32 79 32 79 33 82 C30.03 81.01 30.03 81.01 27 80 C26.505 81.485 26.505 81.485 26 83 C25.278125 82.401875 24.55625 81.80375 23.8125 81.1875 C21.1724154 79.00195733 21.1724154 79.00195733 18.625 77.75 C6.74557406 69.83038271 -0.51272147 54.11172486 -4.3125 40.8125 C-5.09568681 36.46937314 -5.18315517 32.39572403 -5 28 C-5.66 27.67 -6.32 27.34 -7 27 C-6.67 26.67 -6.34 26.34 -6 26 C-5.83900898 24.19034171 -5.72206604 22.37671042 -5.625 20.5625 C-5.07138498 13.18975394 -3.44336052 6.55878195 0 0 Z ",
    fill: "#AE4079",
    transform: "translate(453,340)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.05914466 0.05162664 6.56640989 0.54877203 9.75 3.25 C12.47503759 6.75361976 12.25747788 11.00410176 11.75 15.25 C10.68896512 18.43310463 9.70992253 19.73239471 6.7578125 21.32421875 C2.80037265 22.90319728 0.58711985 23.50271543 -3.5625 22.25 C-9.78975082 17.61576683 -9.78975082 17.61576683 -10.66796875 13.1015625 C-10.9429532 8.62749115 -10.71859214 6.82672878 -7.8125 3.25 C-6.966875 2.59 -6.12125 1.93 -5.25 1.25 C-3.68966377 -0.31033623 -2.16052864 0.04292441 0 0 Z ",
    fill: "#7678AD",
    transform: "translate(439.25,73.75)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.72403665 3.72403665 4.68758888 9.39109296 6.3125 14.3125 C6.71549316 15.53275879 7.11848633 16.75301758 7.53369141 18.01025391 C16.03357461 44.20139624 20.20758532 70.64529645 20.125 98.1875 C20.13080078 100.13946289 20.13080078 100.13946289 20.13671875 102.13085938 C20.12991146 108.83944813 19.9154122 115.35236381 19 122 C18.01 122 17.02 122 16 122 C16.01047363 121.16678223 16.02094727 120.33356445 16.03173828 119.47509766 C16.44502592 81.32184752 13.63426932 45.13806721 0.09667969 9.11767578 C-0.65310499 7.09660815 -1.33366585 5.05009517 -2 3 C-1 1 -1 1 0 0 Z ",
    fill: "#868BC7",
    transform: "translate(686,158)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.52207031 0.18175781 1.04414063 0.36351562 1.58203125 0.55078125 C4.04683645 1.39252733 6.52227829 2.19710191 9 3 C9.79664063 3.27457031 10.59328125 3.54914063 11.4140625 3.83203125 C26.06910577 8.43725382 41.90056239 7.08809695 57 6 C55.68 6.33 54.36 6.66 53 7 C53 7.99 53 8.98 53 10 C56.24244991 11.08081664 56.82091097 10.97566845 59.90625 9.96875 C60.65003906 9.73542969 61.39382813 9.50210937 62.16015625 9.26171875 C63.31837891 8.88466797 63.31837891 8.88466797 64.5 8.5 C66.0286504 8.00235922 67.55983716 7.51242543 69.09375 7.03125 C70.10985352 6.69963867 70.10985352 6.69963867 71.14648438 6.36132812 C73 6 73 6 76 7 C73.23229617 7.96823963 70.46133261 8.92460317 67.6875 9.875 C66.92115234 10.14441406 66.15480469 10.41382813 65.36523438 10.69140625 C55.25982703 14.12976062 45.46688961 15.38990704 34.8125 15.375 C33.72767334 15.37483887 32.64284668 15.37467773 31.52514648 15.37451172 C10.07210969 15.07210969 10.07210969 15.07210969 4 9 C5.11375 9.061875 6.2275 9.12375 7.375 9.1875 C8.57125 9.125625 9.7675 9.06375 11 9 C11.66 8.01 12.32 7.02 13 6 C12.31292969 5.81824219 11.62585938 5.63648438 10.91796875 5.44921875 C10.01691406 5.19785156 9.11585938 4.94648438 8.1875 4.6875 C7.29417969 4.44386719 6.40085937 4.20023437 5.48046875 3.94921875 C2.94752262 2.9799181 1.7283504 2.04990396 0 0 Z ",
    fill: "#985A94",
    transform: "translate(500,408)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.08667969 0.29197266 1.08667969 0.29197266 2.1953125 0.58984375 C2.74960937 0.74582031 3.30390625 0.90179687 3.875 1.0625 C3.875 1.3925 3.875 1.7225 3.875 2.0625 C-36.385 2.0625 -76.645 2.0625 -118.125 2.0625 C-118.125 58.4925 -118.125 114.9225 -118.125 173.0625 C-118.455 173.0625 -118.785 173.0625 -119.125 173.0625 C-120.1290008 156.71162989 -120.23656598 140.37607147 -120.25 124 C-120.25249756 122.92435791 -120.25499512 121.84871582 -120.25756836 120.74047852 C-120.26349198 117.6277347 -120.26195194 114.51508882 -120.2578125 111.40234375 C-120.25979645 110.46454575 -120.2617804 109.52674774 -120.26382446 108.56053162 C-120.24642778 103.62012718 -119.96419287 98.93306877 -119.125 94.0625 C-119.785 93.7325 -120.445 93.4025 -121.125 93.0625 C-120.465 93.0625 -119.805 93.0625 -119.125 93.0625 C-119.28726074 91.9701001 -119.44952148 90.8777002 -119.61669922 89.75219727 C-120.26854321 84.50876991 -120.26863939 79.30480721 -120.2578125 74.02734375 C-120.25876923 72.98985489 -120.25972595 71.95236603 -120.26071167 70.88343811 C-120.26138908 68.70085591 -120.25956557 66.51827164 -120.25537109 64.33569336 C-120.25001119 61.00695246 -120.25533386 57.67834615 -120.26171875 54.34960938 C-120.261058 52.22135387 -120.25977689 50.09309845 -120.2578125 47.96484375 C-120.25983673 46.97612778 -120.26186096 45.9874118 -120.26394653 44.96873474 C-120.24682261 39.89132594 -119.99795975 35.06663123 -119.125 30.0625 C-119.785 29.7325 -120.445 29.4025 -121.125 29.0625 C-120.465 29.0625 -119.805 29.0625 -119.125 29.0625 C-119.20878906 28.05832031 -119.29257812 27.05414062 -119.37890625 26.01953125 C-119.48228173 24.63805897 -119.58511643 23.25654615 -119.6875 21.875 C-119.74357422 21.22080078 -119.79964844 20.56660156 -119.85742188 19.89257812 C-120.18425953 15.29506183 -120.00867623 10.86001188 -119.63256836 6.2644043 C-119.53866318 5.10087936 -119.444758 3.93735443 -119.3480072 2.73857117 C-119.27441483 1.85546768 -119.20082245 0.9723642 -119.125 0.0625 C-118.54447184 0.06342179 -117.96394367 0.06434359 -117.36582375 0.06529331 C-103.25339048 0.08735834 -89.14095979 0.10391635 -75.02851295 0.11431217 C-68.20389818 0.11947288 -61.3792949 0.12651129 -54.5546875 0.13793945 C-47.97356567 0.14895465 -41.39245269 0.15477777 -34.81132126 0.15737724 C-32.29541205 0.1592307 -29.77950353 0.16284981 -27.2635994 0.16823006 C-23.75075087 0.17544622 -20.23795235 0.17649069 -16.72509766 0.17602539 C-15.1509333 0.1814183 -15.1509333 0.1814183 -13.54496765 0.18692017 C-12.59141891 0.1855455 -11.63787018 0.18417084 -10.65542603 0.18275452 C-9.82396875 0.18367631 -8.99251148 0.1845981 -8.13585854 0.18554783 C-0.93116529 -0.25531951 -0.93116529 -0.25531951 0 0 Z ",
    fill: "#7F2B51",
    transform: "translate(486.125,569.9375)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.75618605 7.76635633 12.09532078 23.92101604 12.875 35.0625 C13.60878347 49.99162595 9.90073307 63.3228661 0.1171875 74.8046875 C-4.10023504 79.17773448 -8.99479939 83.45580556 -15 85 C-15.99 84.67 -16.98 84.34 -18 84 C-14.37 82.02 -10.74 80.04 -7 78 C-7.99 78 -8.98 78 -10 78 C-10 77.34 -10 76.68 -10 76 C-12.67331214 76.45828208 -14.99618664 76.99837932 -17.5 78.0625 C-20.17773183 79.06664944 -22.16578026 79.16195541 -25 79 C-22.93367817 77.94556117 -20.86997344 76.94408184 -18.73828125 76.02734375 C-9.15562399 71.72209194 -2.8419122 66.04871974 0.9375 56.125 C1.29714844 55.03445313 1.65679688 53.94390625 2.02734375 52.8203125 C3 50 3 50 5 47 C6 48 6 48 6.0625 51.0625 C6.041875 52.031875 6.02125 53.00125 6 54 C7.98 53.505 7.98 53.505 10 53 C10.64263376 35.12489483 9.28674524 20.66613035 1.171875 4.4765625 C0 2 0 2 0 0 Z ",
    fill: "#9A4980",
    transform: "translate(538,233)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.21155366 7.11787776 -5.13692717 10.87957478 -10 16 C-11.15207453 17.32794431 -12.29821159 18.66106993 -13.4375 20 C-21.48170012 29.14441583 -30.33948777 36.64811658 -40 44 C-40.66 43.67 -41.32 43.34 -42 43 C-42 42.01 -42 41.02 -42 40 C-42.66 39.34 -43.32 38.68 -44 38 C-43.01773438 37.21689453 -43.01773438 37.21689453 -42.015625 36.41796875 C-32.36457791 28.63442653 -22.80659095 20.68554121 -15 11 C-13.79940067 9.57677298 -12.5907683 8.16029122 -11.375 6.75 C-10.82585938 6.10546875 -10.27671875 5.4609375 -9.7109375 4.796875 C-6.38790786 1.30693519 -4.97590129 0 0 0 Z ",
    fill: "#7678A9",
    transform: "translate(663,391)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.96 1.65 -7.92 3.3 -12 5 C-10.6696875 4.5978125 -10.6696875 4.5978125 -9.3125 4.1875 C10.08492496 -1.33209247 32.8969878 -5.42127897 51.63671875 4.37890625 C53.47612811 5.50566486 55.24945219 6.73960558 57 8 C56.34 8.33 55.68 8.66 55 9 C52.828125 8.07421875 52.828125 8.07421875 50.25 6.6875 C32.07091823 -2.71457524 11.20697665 0.47961896 -7.66015625 6.45703125 C-27.71062393 13.26925062 -45.97020041 26.21692283 -61.29296875 40.6015625 C-63 42 -63 42 -65 42 C-65 42.66 -65 43.32 -65 44 C-65.66 44 -66.32 44 -67 44 C-66.08216786 36.6743398 -57.09681839 30.59499728 -51.56640625 26.22265625 C-39.14992626 16.75004532 -25.94136766 8.38588096 -11.5625 2.25 C-10.75135742 1.90235596 -9.94021484 1.55471191 -9.10449219 1.1965332 C-3.38785059 -1.12928353 -3.38785059 -1.12928353 0 0 Z ",
    fill: "#A04174",
    transform: "translate(433,241)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.66 1.98 1.32 3 2 C3 2.66 3 3.32 3 4 C3.78375 4.268125 4.5675 4.53625 5.375 4.8125 C8 6 8 6 10 9 C7.0280615 7.87548273 4.66559313 6.77706209 2 5 C4.00450352 15.07526769 6.68794661 25.14484474 15.25 31.5625 C16.49822846 32.37771897 17.74794234 33.19067444 19 34 C19.66 34.66 20.32 35.32 21 36 C20.67 36.66 20.34 37.32 20 38 C19.34 38 18.68 38 18 38 C18 38.99 18 39.98 18 41 C31.3895296 45.65722769 47.34246422 45.95354428 60.8203125 41.55859375 C63 41 63 41 66 42 C50.37106946 48.25157222 33.97416671 49.41759123 18.109375 42.79296875 C14.13518128 40.86978436 10.37436793 38.87701211 7 36 C7 35.34 7 34.68 7 34 C6.34 34 5.68 34 5 34 C0.49686457 28.16588858 -2.7577278 21.83529671 -5.17578125 14.8984375 C-5.83989297 12.81241165 -5.83989297 12.81241165 -8 12 C-8 9.36 -8 6.72 -8 4 C-7.01 4.33 -6.02 4.66 -5 5 C-4.33984375 6.890625 -4.33984375 6.890625 -3.9375 9.25 C-3.2819746 12.72042861 -2.34710047 15.72847028 -1 19 C-1 19.99 -1 20.98 -1 22 C-0.01 22 0.98 22 2 22 C4.09153804 17.81692392 1.81813409 13.42238304 0.65625 9.140625 C-0.00045505 5.99782227 -0.11497357 3.20009776 0 0 Z ",
    fill: "#9D4B82",
    transform: "translate(494,330)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.74242075 2.49494717 3.73182791 3.75668655 5 8 C5.52940385 9.42079903 6.07066892 10.83721168 6.62109375 12.25 C11.4964047 24.94261989 15.26762983 37.31383254 16 51 C16.04125 51.75023437 16.0825 52.50046875 16.125 53.2734375 C16.54291023 68.99730989 13.27636415 84.04126062 6 98 C6.99 97.01 7.98 96.02 9 95 C9.66 95.33 10.32 95.66 11 96 C15.75261439 84.88651805 15.75261439 84.88651805 17 73 C17.66 73 18.32 73 19 73 C19.33 72.34 19.66 71.68 20 71 C19.26306592 87.65471023 11.70898884 103.21782998 0 115 C0 111.89448334 0.5393715 110.64738916 2 108 C1.34 107.34 0.68 106.68 0 106 C-4.455 110.455 -4.455 110.455 -9 115 C-9.66 114.67 -10.32 114.34 -11 114 C-9.93458984 112.96939453 -9.93458984 112.96939453 -8.84765625 111.91796875 C-7.92855469 111.01691406 -7.00945313 110.11585938 -6.0625 109.1875 C-5.14597656 108.29417969 -4.22945312 107.40085937 -3.28515625 106.48046875 C-0.82064892 104.14563407 -0.82064892 104.14563407 0 101 C0.45503906 100.56042969 0.91007813 100.12085938 1.37890625 99.66796875 C11.84321011 88.90108261 13.34294708 69.78192071 13.4375 55.6875 C13.44765137 54.5830957 13.45780273 53.47869141 13.46826172 52.34082031 C13.45682129 51.3040918 13.44538086 50.26736328 13.43359375 49.19921875 C13.42384521 48.26940186 13.41409668 47.33958496 13.40405273 46.3815918 C12.92626874 43.56540878 12.0954939 42.84518008 10 41 C9.26953125 38.40625 9.26953125 38.40625 8.8125 35.5 C8.65394531 34.5409375 8.49539063 33.581875 8.33203125 32.59375 C7.6942446 27.61151079 7.6942446 27.61151079 9 25 C8.53040945 22.3446323 8.53040945 22.3446323 7.6875 19.4375 C7.42324219 18.44621094 7.15898438 17.45492187 6.88671875 16.43359375 C6.25852446 13.84289689 6.25852446 13.84289689 4 13 C3.27954236 11.0187415 2.61998741 9.01495907 2 7 C1.62875 6.0925 1.2575 5.185 0.875 4.25 C0 2 0 2 0 0 Z M10 29 C11 32 11 32 11 32 Z M11 33 C11.33 35.97 11.66 38.94 12 42 C12.33 42 12.66 42 13 42 C12.67 39.03 12.34 36.06 12 33 C11.67 33 11.34 33 11 33 Z ",
    fill: "#785985",
    transform: "translate(569,213)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.23 0 20.46 0 31 0 C31 0.33 31 0.66 31 1 C21.1 1 11.2 1 1 1 C1.33 2.65 1.66 4.3 2 6 C2.08846464 7.89059416 2.12785439 9.78385155 2.12939453 11.67651367 C2.13254669 12.79084274 2.13569885 13.90517181 2.13894653 15.05326843 C2.1369223 16.24611954 2.13489807 17.43897064 2.1328125 18.66796875 C2.13376923 19.89912918 2.13472595 21.13028961 2.13571167 22.39875793 C2.13639141 24.99687756 2.13455149 27.59499889 2.13037109 30.19311523 C2.12678304 32.86148408 2.12581857 35.52965151 2.13037109 38.19799805 C2.1365267 42.04217578 2.13580677 45.88628838 2.1328125 49.73046875 C2.13483673 50.92939255 2.13686096 52.12831635 2.13894653 53.36357117 C2.13579437 54.46844376 2.13264221 55.57331635 2.12939453 56.71166992 C2.12820114 58.17463753 2.12820114 58.17463753 2.12698364 59.66716003 C2 62 2 62 1 64 C1.66 64.33 2.32 64.66 3 65 C2.34 65 1.68 65 1 65 C1.33 65.99 1.66 66.98 2 68 C2.08557696 69.35003335 2.11774051 70.70390425 2.11352539 72.05664062 C2.11344986 72.86758179 2.11337433 73.67852295 2.11329651 74.51403809 C2.10813522 75.38596802 2.10297394 76.25789795 2.09765625 77.15625 C2.0962413 78.05492798 2.09482635 78.95360596 2.09336853 79.8795166 C2.08777055 82.75304488 2.07522737 85.62649531 2.0625 88.5 C2.05748395 90.43619678 2.05292122 92.3723948 2.04882812 94.30859375 C2.03899235 98.57338668 2.02477923 102.83813951 2.00672913 107.10290527 C2.00093905 108.73526145 2 110.36763355 2 112 C2 119 2 126 2 133 C2.99 132.01 2.99 132.01 4 131 C4.66 131.33 5.32 131.66 6 132 C9.47564102 132.7116505 9.47564102 132.7116505 13 133 C13.97952637 133.02094727 14.95905273 133.04189453 15.96826172 133.06347656 C19.50238074 133.13230324 23.03577547 133.18202886 26.5703125 133.21972656 C28.08898234 133.23967519 29.60757705 133.2668445 31.12597656 133.30175781 C41.53867495 133.53477564 51.16885891 133.41973073 59.82421875 126.859375 C60.43910156 126.16328125 61.05398438 125.4671875 61.6875 124.75 C62.33074219 124.04359375 62.97398437 123.3371875 63.63671875 122.609375 C64.08660156 122.07828125 64.53648437 121.5471875 65 121 C65 124.57740957 64.48655634 124.96946985 62.0625 127.4375 C46.22776839 142.62984899 18.17431019 136 0 136 C0 91.12 0 46.24 0 0 Z ",
    fill: "#575B78",
    transform: "translate(553,603)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.51748915 8.548591 1.05907765 15.54412702 -1 22.8125 C-1.30760254 23.89909912 -1.61520508 24.98569824 -1.93212891 26.10522461 C-6.75628846 42.5531858 -13.86240749 65.1614054 -27 77 C-28.61051271 72.16846187 -27.14973655 69.45871285 -25 65 C-23.75130035 62.01699529 -22.7018524 59.15833581 -22 56 C-21.67 56.66 -21.34 57.32 -21 58 C-20.690625 57.05125 -20.38125 56.1025 -20.0625 55.125 C-18.87050719 51.61913878 -18.18677624 50.20236691 -15.66015625 47.46484375 C-12.39710801 43.58975412 -10.99480377 39.32711339 -9.4375 34.5625 C-9.14012939 33.68231201 -8.84275879 32.80212402 -8.53637695 31.89526367 C-5.05242313 21.42441091 -2.27326636 10.79801519 0 0 Z ",
    fill: "#7677A5",
    transform: "translate(679,297)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C27.38207408 -1.24463973 54.73130302 5.22907805 78.98828125 18.0078125 C81.18130441 19.12458035 81.18130441 19.12458035 84.296875 20.29296875 C88.33302504 22.00997834 91.54716647 24.43726296 94.9375 27.1875 C95.54215088 27.6729126 96.14680176 28.1583252 96.76977539 28.65844727 C107.7250979 37.56083824 107.7250979 37.56083824 110 41 C109.69140625 43.22265625 109.69140625 43.22265625 109 45 C108.566875 44.505 108.13375 44.01 107.6875 43.5 C106.00259517 41.66781808 106.00259517 41.66781808 103 42 C101.5703125 40.7578125 101.5703125 40.7578125 100.125 39.125 C98.23421012 37.12762147 97.21382293 36.08440379 94.625 35.0625 C89.74314375 33.08651056 85.76387843 28.99043162 82.296875 25.078125 C61.12106544 5.91905921 26.92889649 2.71530516 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#A2508A",
    transform: "translate(448,146)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.40711848 3.60753721 -6.86983492 6.27584857 -11 9 C-11.5775 9.639375 -12.155 10.27875 -12.75 10.9375 C-18.6529774 16.34856261 -26.22613666 18.5905828 -33.89453125 20.296875 C-36.0530887 20.78560499 -38.19674676 21.34313303 -40.32421875 21.953125 C-41.92716797 22.40945313 -41.92716797 22.40945313 -43.5625 22.875 C-44.53316406 23.16117187 -45.50382813 23.44734375 -46.50390625 23.7421875 C-49 24 -49 24 -50.83984375 22.5703125 C-51.22269531 22.05210937 -51.60554687 21.53390625 -52 21 C-51.67 20.34 -51.34 19.68 -51 19 C-49.68 19 -48.36 19 -47 19 C-47 18.34 -47 17.68 -47 17 C-44.6464689 16.20640264 -42.29221117 15.41508217 -39.9375 14.625 C-39.28072266 14.40328125 -38.62394531 14.1815625 -37.94726562 13.953125 C-34.67089241 12.85562067 -31.41010043 11.83424582 -28.06640625 10.9609375 C-27.05449219 10.64382813 -26.04257812 10.32671875 -25 10 C-24.67 9.34 -24.34 8.68 -24 8 C-22.11732556 6.93738621 -20.19300583 5.94780772 -18.25 5 C-17.20328125 4.484375 -16.1565625 3.96875 -15.078125 3.4375 C-9.65674514 0.90568809 -6.06920747 -0.23800814 0 0 Z ",
    fill: "#7A6998",
    transform: "translate(604,396)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.66 12.54 2.32 25.08 3 38 C2.67 38 2.34 38 2 38 C1.86013672 38.85827393 1.72027344 39.71654785 1.57617188 40.60083008 C-1.85148149 61.30314004 -6.35199489 81.05598468 -13 101 C-13.99 101 -14.98 101 -16 101 C-16.66 102.32 -17.32 103.64 -18 105 C-17.24602337 100.38529969 -15.72248768 96.14667703 -14.1875 91.75 C-12.05816186 85.49627394 -10.16151521 79.23883723 -8.625 72.8125 C-8.45766357 72.1309082 -8.29032715 71.44931641 -8.11791992 70.74707031 C-7.36080754 67.4481944 -7.00284153 64.53162153 -7.0234375 61.13671875 C-7 58 -7 58 -5 56 C-4.47581673 54.01333114 -4.47581673 54.01333114 -4.21875 51.6796875 C-4.09991455 50.76638672 -3.9810791 49.85308594 -3.85864258 48.91210938 C-3.74029053 47.90986328 -3.62193848 46.90761719 -3.5 45.875 C-3.37326904 44.83923828 -3.24653809 43.80347656 -3.1159668 42.73632812 C-1.47660518 28.54167832 -0.75868215 14.26376925 0 0 Z ",
    fill: "#8388C1",
    transform: "translate(726,248)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C-0.72936444 24.74542992 -9.45062814 46.59295208 -27 65 C-29.265625 66.3046875 -29.265625 66.3046875 -31 67 C-30.566875 66.45730469 -30.13375 65.91460937 -29.6875 65.35546875 C-29.130625 64.64003906 -28.57375 63.92460937 -28 63.1875 C-27.443125 62.47980469 -26.88625 61.77210938 -26.3125 61.04296875 C-24.72974317 58.98404001 -24.72974317 58.98404001 -25 56 C-25.81791016 56.87011719 -25.81791016 56.87011719 -26.65234375 57.7578125 C-31.70356225 62.9903568 -36.77071593 67.24475783 -43 71 C-43.66 70.67 -44.32 70.34 -45 70 C-44.24976563 69.46632813 -43.49953125 68.93265625 -42.7265625 68.3828125 C-20.29085674 52.05052292 -7.20791026 30.90094448 -1 4 C-1.99 4 -2.98 4 -4 4 C-3.67 3.34 -3.34 2.68 -3 2 C-2.01 2.33 -1.02 2.66 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#77608E",
    transform: "translate(613,290)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.69035498 3.36905542 5.2474258 7.37049285 7.25 11.875 C7.64477539 12.75978027 8.03955078 13.64456055 8.44628906 14.55615234 C14.36899421 28.1248356 18.7679671 42.24044998 22.40332031 56.58056641 C22.87869364 58.40283082 23.43197833 60.20445586 24 62 C24.66 62.33 25.32 62.66 26 63 C25.98259766 63.58555664 25.96519531 64.17111328 25.94726562 64.77441406 C25.85344368 70.47298008 26.29407033 75.90635751 27.06787109 81.54785156 C30.51937148 107.12405443 30.62141559 133.62118888 26.26953125 159.07861328 C25.92945679 161.0942822 25.92945679 161.0942822 26.09375 163.52734375 C25.97144094 166.75324533 24.95614491 169.38178995 23.88671875 172.41308594 C22.92634955 175.21486789 22.09465564 178.03497263 21.28125 180.8828125 C20.98863281 181.90503906 20.69601562 182.92726563 20.39453125 183.98046875 C19.79612074 186.08405153 19.1997801 188.18822419 18.60546875 190.29296875 C17.04858284 195.71806458 15.37915992 200.87900334 13 206 C11.87789472 202.63368415 12.07701873 202.09967285 13.2578125 198.921875 C13.55139648 198.10307861 13.84498047 197.28428223 14.14746094 196.44067383 C14.47004883 195.55275146 14.79263672 194.6648291 15.125 193.75 C36.6859292 131.43116043 28.5976248 63.02513952 0.8828125 4.109375 C0 2 0 2 0 0 Z M24 65 C25 68 25 68 25 68 Z ",
    fill: "#636380",
    transform: "translate(678,138)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.28875 0.639375 0.5775 1.27875 0.875 1.9375 C1.82823451 4.15206079 1.82823451 4.15206079 4 5 C4.37197957 11.3236527 3.24653472 16.73174682 1.73046875 22.8671875 C0.86485887 26.57958924 0.42047584 30.21571741 0 34 C-0.33 34.99 -0.66 35.98 -1 37 C-1.66 37 -2.32 37 -3 37 C-3.10570312 37.66773438 -3.21140625 38.33546875 -3.3203125 39.0234375 C-4.16078966 42.70414783 -5.47565207 46.13004322 -6.875 49.625 C-7.13152344 50.29273438 -7.38804687 50.96046875 -7.65234375 51.6484375 C-9.01500467 55.07220865 -10.26075106 57.54010789 -13 60 C-14.20049407 63.10007201 -14.20049407 63.10007201 -15 66 C-15.33 65.34 -15.66 64.68 -16 64 C-16.66 64 -17.32 64 -18 64 C-16.73616041 59.91633742 -15.1778443 56.10621995 -13.38549805 52.23852539 C-10.36005767 45.69288423 -8.38305285 40.27800422 -8 33 C-7.01 32.505 -7.01 32.505 -6 32 C-5.44183834 30.1327396 -5.44183834 30.1327396 -5.125 27.75 C-4.13705243 21.75060868 -3.0219619 15.78312405 -1.875 9.8125 C-1.51809872 7.94403533 -1.16131837 6.07554755 -0.8046875 4.20703125 C-0.53652232 2.80467526 -0.26831873 1.40232662 0 0 Z ",
    fill: "#72729D",
    transform: "translate(656,288)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 2.31 1.66 4.62 2 7 C3.32 5.35 4.64 3.7 6 2 C7.19536461 6.68632563 7.12759836 11.22029329 7.09765625 16.01953125 C7.0962413 16.87810226 7.09482635 17.73667328 7.09336853 18.6212616 C7.08779057 21.35171049 7.07524214 24.08207607 7.0625 26.8125 C7.05748215 28.6686186 7.05291974 30.5247385 7.04882812 32.38085938 C7.03782836 36.9206048 7.02057893 41.4602883 7 46 C6.67 46 6.34 46 6 46 C5.85900879 46.71655762 5.71801758 47.43311523 5.57275391 48.17138672 C4.93140436 51.40754932 4.27835868 54.64124157 3.625 57.875 C3.40328125 59.00292969 3.1815625 60.13085938 2.953125 61.29296875 C2.62441406 62.90751953 2.62441406 62.90751953 2.2890625 64.5546875 C2.09006348 65.54968262 1.89106445 66.54467773 1.68603516 67.56982422 C1 70 1 70 -1 72 C-0.35849424 67.08178917 0.53718844 62.27532876 1.59765625 57.4296875 C2.35705311 52.84381518 2.11060334 50.08929397 0 46 C0 44.68 0 43.36 0 42 C-0.66 41.67 -1.32 41.34 -2 41 C-1.67 40.34 -1.34 39.68 -1 39 C-0.926404 37.02339534 -0.9164977 35.04426905 -0.9375 33.06640625 C-0.94523438 31.85919922 -0.95296875 30.65199219 -0.9609375 29.40820312 C-0.98662211 26.87955364 -1.01265371 24.35090765 -1.0390625 21.82226562 C-1.08564872 14.48105382 -0.84244084 7.29519916 0 0 Z ",
    fill: "#6F709A",
    transform: "translate(657,246)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.12728659 14.84547152 16.30558093 41.5037965 19 60 C19.10530029 60.7120459 19.21060059 61.4240918 19.3190918 62.15771484 C20.42239835 71.09440125 20.10788013 80.13802231 20.0625 89.125 C20.05747515 90.86197788 20.05291398 92.59895716 20.04882812 94.3359375 C20.03790014 98.55732688 20.02068978 102.77864764 20 107 C18.515 106.505 18.515 106.505 17 106 C16.98018066 104.96069336 16.96036133 103.92138672 16.93994141 102.85058594 C16.86377876 98.98885164 16.775078 95.1274889 16.68261719 91.26611328 C16.64437143 89.59594059 16.60951085 87.92568677 16.578125 86.25537109 C16.53237839 83.85224443 16.47440075 81.44967416 16.4140625 79.046875 C16.40251129 78.30193787 16.39096008 77.55700073 16.37905884 76.78948975 C16.27164764 73.00314972 15.94173868 70.26655316 14 67 C13.91015625 64.58203125 13.91015625 64.58203125 14.0625 61.8125 C14.23976993 43.26563383 7.97427922 22.37548822 0.87133789 5.28417969 C0 3 0 3 0 0 Z ",
    fill: "#868AC5",
    transform: "translate(665,172)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.41170813 1.05638988 6.68242319 2.26575088 9.93359375 3.734375 C22.30812287 9.29993946 34.80318121 12.90952686 48 16 C48 16.66 48 17.32 48 18 C48.66 18.33 49.32 18.66 50 19 C44.47920956 21.47636742 40.56474355 20.80669727 34.875 19.5625 C34.01205322 19.38146729 33.14910645 19.20043457 32.26000977 19.01391602 C25.68212266 17.55328623 19.30397471 15.63651983 12.9375 13.4375 C12.08720215 13.14496338 11.2369043 12.85242676 10.36083984 12.55102539 C6.48814155 11.1489776 3.79739476 10.11591271 1 7 C3.6666419 5.66667905 5.16680303 6.32897967 8 7 C6.7625 6.319375 6.7625 6.319375 5.5 5.625 C4.675 5.08875 3.85 4.5525 3 4 C3 3.34 3 2.68 3 2 C2.01 1.67 1.02 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#BC4688",
    transform: "translate(466,458)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.37403959 5.06105938 3.12443503 10.85748604 3.31640625 16.80859375 C3.37924805 18.66967773 3.37924805 18.66967773 3.44335938 20.56835938 C3.48267578 21.84517578 3.52199219 23.12199219 3.5625 24.4375 C3.60568359 25.74138672 3.64886719 27.04527344 3.69335938 28.38867188 C3.79897524 31.59235316 3.90108101 34.79610611 4 38 C2.02 38.495 2.02 38.495 0 39 C0.2475 39.9075 0.495 40.815 0.75 41.75 C1.85433165 49.28092831 -2.40739383 57.5333089 -6 64 C-6.66 63.34 -7.32 62.68 -8 62 C-9.32 62.99 -10.64 63.98 -12 65 C-10.93065703 62.32664256 -9.8601276 59.65390547 -8.78125 56.984375 C-1.92290802 39.67124343 -1.84150458 23.42692171 -2 5 C-1.67 5 -1.34 5 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z ",
    fill: "#9665A1",
    transform: "translate(586,247)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.35 2.32 -1.3 3.64 -3 5 C-2.34 5.66 -1.68 6.32 -1 7 C-12.67618371 13.2705431 -24.15981627 16.27081163 -37.453125 13.203125 C-42.36774154 11.62947931 -46.62822053 9.75406324 -51 7 C-50.6875 5.0625 -50.6875 5.0625 -50 3 C-47 2 -47 2 -45.23828125 2.70703125 C-44.60277344 3.07183594 -43.96726562 3.43664062 -43.3125 3.8125 C-32.26682556 9.64833165 -21.70031183 8.59256887 -10 5 C-7.22070407 3.74659203 -4.57408805 2.39898959 -1.92578125 0.890625 C-1.29027344 0.59671875 -0.65476562 0.3028125 0 0 Z ",
    fill: "#B95194",
    transform: "translate(554,331)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.556875 0.721875 1.11375 1.44375 1.6875 2.1875 C3.98123652 4.97717956 6.4140111 7.48206344 9 10 C9.66 10.66 10.32 11.32 11 12 C11.87436418 10.26424351 11.87436418 10.26424351 12 8 C10.14835964 5.24743206 10.14835964 5.24743206 8 3 C8.33 2.34 8.66 1.68 9 1 C10.94143176 2.7565335 12.14334696 4.25553154 13.4375 6.5625 C15.15307848 9.23880242 16.16613463 9.7601839 19 11 C19.4021875 11.46019531 19.804375 11.92039062 20.21875 12.39453125 C22.71078697 14.64064352 25.3546958 15.43259905 28.5 16.5625 C32.02340635 17.83616378 34.87625216 18.91750144 38 21 C31.59859065 20.53444296 26.73230171 18.85288164 21 16 C20.67 17.32 20.34 18.64 20 20 C21.98 20.66 23.96 21.32 26 22 C26 22.66 26 23.32 26 24 C33.3048236 25.75585124 40.24740312 26.35396741 47.75 26.3125 C48.80477539 26.30758545 49.85955078 26.3026709 50.94628906 26.29760742 C62.80123209 26.12005643 72.77644316 23.97536912 83.57421875 18.890625 C86 18 86 18 89 19 C78.06855693 23.9967691 67.13386364 28.25295242 55 29 C54.1440625 29.05285156 53.288125 29.10570312 52.40625 29.16015625 C36.87208529 29.64037908 22.23276571 26.30080847 10.125 16.1875 C6.04700523 12.32491843 2.53346542 8.03712537 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#974D83",
    transform: "translate(484,374)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C2.99 1.34 3.98 0.68 5 0 C-0.17762498 14.24490852 -13.54999875 31.2199618 -26 40 C-26.99 40 -27.98 40 -29 40 C-29.66 40.99 -30.32 41.98 -31 43 C-31.66 42.67 -32.32 42.34 -33 42 C-26.47844828 34.45258621 -26.47844828 34.45258621 -23.6875 31.8125 C-21.87740895 30.11397537 -21.87740895 30.11397537 -21.26171875 27.859375 C-19.49877952 23.86410714 -16.88103916 20.79828157 -14.125 17.4375 C-13.59519531 16.77814453 -13.06539062 16.11878906 -12.51953125 15.43945312 C-9.82286679 12.11044427 -7.04840967 9.01453845 -4 6 C-2.63178949 4.02369593 -1.29048808 2.02790984 0 0 Z ",
    fill: "#6B6E97",
    transform: "translate(684,399)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.35373401 3.53060101 2.65778415 6.58595756 3.125 10.6875 C3.21136719 11.38939453 3.29773438 12.09128906 3.38671875 12.81445312 C3.59826875 14.54211145 3.800086 16.2709566 4 18 C4.33 18 4.66 18 5 18 C5 38.79 5 59.58 5 81 C4.67 81 4.34 81 4 81 C3.34 86.61 2.68 92.22 2 98 C1.67 98 1.34 98 1 98 C0.67 65.66 0.34 33.32 0 0 Z M3 42 C3 45.3 3 48.6 3 52 C3.33 52 3.66 52 4 52 C4 48.7 4 45.4 4 42 C3.67 42 3.34 42 3 42 Z ",
    fill: "#666E94",
    transform: "translate(657,618)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.66310435 0.79125074 8.91546187 1.16488126 13.625 1.0625 C14.615 1.3925 15.605 1.7225 16.625 2.0625 C16.625 2.7225 16.625 3.3825 16.625 4.0625 C18.36136719 4.24425781 18.36136719 4.24425781 20.1328125 4.4296875 C24.37244416 4.96406356 28.41285655 5.95476086 32.5 7.1875 C33.22614502 7.40559326 33.95229004 7.62368652 34.70043945 7.84838867 C48.52991386 12.10873752 61.31148335 17.44078953 73.625 25.0625 C72.965 25.3925 72.305 25.7225 71.625 26.0625 C69.61987305 25.27734375 69.61987305 25.27734375 67.13671875 24 C66.21189697 23.5356958 65.2870752 23.0713916 64.33422852 22.59301758 C63.33705811 22.08794678 62.3398877 21.58287598 61.3125 21.0625 C50.36392098 15.64674745 39.30170857 11.59322819 27.625 8.0625 C28.22755615 8.25948486 28.8301123 8.45646973 29.45092773 8.65942383 C30.24958252 8.92263428 31.0482373 9.18584473 31.87109375 9.45703125 C32.6592749 9.71589111 33.44745605 9.97475098 34.25952148 10.24145508 C37.46326452 11.35345713 40.52954987 12.67942654 43.625 14.0625 C42.965 14.3925 42.305 14.7225 41.625 15.0625 C41.295 15.7225 40.965 16.3825 40.625 17.0625 C40.625 16.0725 40.625 15.0825 40.625 14.0625 C40.295 14.7225 39.965 15.3825 39.625 16.0625 C39.109375 15.794375 38.59375 15.52625 38.0625 15.25 C30.13327858 11.38704598 22.5876294 8.60287798 13.625 9.0625 C13.625 8.4025 13.625 7.7425 13.625 7.0625 C12.59375 7.26875 11.5625 7.475 10.5 7.6875 C6.5015784 8.07444403 4.28806243 7.58133076 0.625 6.0625 C0.625 5.4025 0.625 4.7425 0.625 4.0625 C-5.315 3.0725 -5.315 3.0725 -11.375 2.0625 C-11.375 1.4025 -11.375 0.7425 -11.375 0.0625 C-7.26837755 -1.02903719 -4.16051701 -0.75600844 0 0 Z ",
    fill: "#7C5680",
    transform: "translate(476.375,86.9375)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 63.03 1 126.06 1 191 C0.34 190.67 -0.32 190.34 -1 190 C-1.14285714 181.42857143 -1.14285714 181.42857143 0 178 C-0.66 177.67 -1.32 177.34 -2 177 C-1.34 177 -0.68 177 0 177 C-0.23396484 175.93458984 -0.23396484 175.93458984 -0.47265625 174.84765625 C-0.76462891 173.46900391 -0.76462891 173.46900391 -1.0625 172.0625 C-1.25972656 171.14597656 -1.45695313 170.22945312 -1.66015625 169.28515625 C-1.77230469 168.53105469 -1.88445313 167.77695312 -2 167 C-1.67 166.67 -1.34 166.34 -1 166 C-0.91159597 164.27702445 -0.89310145 162.55041258 -0.90234375 160.82519531 C-0.90729858 159.16777313 -0.90729858 159.16777313 -0.91235352 157.47686768 C-0.92065186 156.27278259 -0.9289502 155.06869751 -0.9375 153.828125 C-0.94128662 152.5984198 -0.94507324 151.3687146 -0.94897461 150.10174561 C-0.96332082 145.48263047 -0.98647792 140.86357927 -1.01037598 136.24450684 C-1.03328299 131.73072073 -1.04864375 127.21694654 -1.0625 122.703125 C-1.07079834 121.50713684 -1.07909668 120.31114868 -1.08764648 119.07891846 C-1.09094971 117.96136169 -1.09425293 116.84380493 -1.09765625 115.69238281 C-1.10289307 114.71166809 -1.10812988 113.73095337 -1.11352539 112.72052002 C-1.00187298 110.04488406 -0.60020462 107.60575736 0 105 C-0.66 105 -1.32 105 -2 105 C-1.9278125 104.45214844 -1.855625 103.90429688 -1.78125 103.33984375 C0.15325845 90.39714526 0.15325845 90.39714526 -2 78 C-1.34 78 -0.68 78 0 78 C-0.165 77.175 -0.33 76.35 -0.5 75.5 C-0.88736085 72.78847404 -1.0395601 70.45986694 -1 67.75 C-0.7204915 64.186339 -0.7204915 64.186339 -2 62 C-1.34 62 -0.68 62 0 62 C0 60.35 0 58.7 0 57 C-0.66 57 -1.32 57 -2 57 C-1.34 54.36 -0.68 51.72 0 49 C-0.66 49 -1.32 49 -2 49 C-1.89171875 48.1646875 -1.89171875 48.1646875 -1.78125 47.3125 C-0.33659663 38.45832269 -0.33659663 38.45832269 -2 30 C-1.34 30 -0.68 30 0 30 C-0.12568359 28.51113281 -0.12568359 28.51113281 -0.25390625 26.9921875 C-0.96147012 17.84480178 -0.92924372 9.1494766 0 0 Z ",
    fill: "#83709D",
    transform: "translate(517,574)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 0.99 0.495 0.99 1 2 C-7.30739399 14.25891989 -16.33825673 25.7236133 -28 35 C-28.66 34.67 -29.32 34.34 -30 34 C-29.67 32.68 -29.34 31.36 -29 30 C-30.32 29.67 -31.64 29.34 -33 29 C-32.21496094 28.28714844 -31.42992187 27.57429688 -30.62109375 26.83984375 C-23.98807023 20.79945062 -17.5124621 14.67583243 -11.3125 8.1875 C-9.24155355 6.2284966 -7.61637891 5.06593215 -5 4 C-5 4.99 -5 5.98 -5 7 C-3.35 4.69 -1.7 2.38 0 0 Z ",
    fill: "#726690",
    transform: "translate(617,348)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.66 0.66 -1.32 1.32 -2 2 C-1.01 2.99 -0.02 3.98 1 5 C0.67 5.66 0.34 6.32 0 7 C-0.53367187 6.54109375 -1.06734375 6.0821875 -1.6171875 5.609375 C-11.65753574 -2.65914708 -22.97415981 -6.40439066 -35.9375 -6.3125 C-36.75871338 -6.30831055 -37.57992676 -6.30412109 -38.42602539 -6.29980469 C-50.30108893 -6.08544924 -61.58506066 -3.93666192 -72.6796875 0.328125 C-75 1 -75 1 -78 0 C-53.31451372 -11.67369725 -23.76066911 -16.42442565 0 0 Z ",
    fill: "#D53D85",
    transform: "translate(495,247)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C17.02 0.99 17.02 0.99 15 2 C17.475 2.495 17.475 2.495 20 3 C20 3.33 20 3.66 20 4 C8.44685374 5.57671004 -3.10479488 7.1208314 -14.75 7.8125 C-15.52835205 7.865271 -16.3067041 7.91804199 -17.10864258 7.97241211 C-20.99620474 8.16715889 -23.68265966 8.10463338 -27 6 C-28.65740715 5.62331656 -30.32345271 5.27942455 -32 5 C-31.34 4.67 -30.68 4.34 -30 4 C-29.67 3.01 -29.34 2.02 -29 1 C-19.43 1 -9.86 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#9C62A0",
    transform: "translate(545,455)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.99 2 3.98 2 5 2 C5 2.66 5 3.32 5 4 C5.54817383 4.16290527 6.09634766 4.32581055 6.66113281 4.49365234 C12.41788238 6.2952427 17.51522347 8.64605579 22.75 11.625 C23.52134277 12.05796387 24.29268555 12.49092773 25.08740234 12.93701172 C32.02116182 16.88992947 38.55967983 21.28923577 45 26 C44.01 26.33 43.02 26.66 42 27 C42.90621094 27.6290625 43.81242188 28.258125 44.74609375 28.90625 C51.8769142 33.90115556 58.6637987 38.99904744 65 45 C60.94670595 45 59.26006475 42.93010933 56.375 40.375 C51.48892998 36.16281915 46.48919059 32.40995173 41 29 C40.34 29.66 39.68 30.32 39 31 C38.855625 30.29488281 38.71125 29.58976562 38.5625 28.86328125 C36.15141373 24.44496566 32.272671 22.66445865 28 20.1875 C27.16726563 19.68541016 26.33453125 19.18332031 25.4765625 18.66601562 C21.49518239 16.00634658 21.49518239 16.00634658 17 15 C16.61199219 14.59136719 16.22398437 14.18273438 15.82421875 13.76171875 C13.17356023 11.20187508 10.01189686 9.58709024 6.8125 7.8125 C6.15830078 7.44447266 5.50410156 7.07644531 4.83007812 6.69726562 C3.22253039 5.7937534 1.61159349 4.8962759 0 4 C0 2.66666667 0 1.33333333 0 0 Z ",
    fill: "#7875A0",
    transform: "translate(563,1)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.45778354 -0.41209784 9.30853296 1.74634131 14.16015625 4.00390625 C17.07383275 5.02589732 18.18902918 5.12573651 21 4 C21.33 4.99 21.66 5.98 22 7 C23.81405715 8.16624759 23.81405715 8.16624759 26.09375 9.09375 C26.95129883 9.47877686 27.80884766 9.86380371 28.69238281 10.26049805 C29.61889648 10.66953369 30.54541016 11.07856934 31.5 11.5 C45.06515289 17.71678322 57.52734684 25.42311289 69 35 C65.32724769 35 64.41545305 34.09095964 61.5 31.9375 C56.13717446 28.06171163 50.60839246 24.50791087 45 21 C45 21.66 45 22.32 45 23 C44.236875 22.690625 43.47375 22.38125 42.6875 22.0625 C38.88786528 20.56031883 36.07361224 19.88990237 32 20 C31.91105469 19.38640625 31.82210937 18.7728125 31.73046875 18.140625 C31.18684896 15.90424818 31.18684896 15.90424818 29.36328125 14.734375 C24.94274808 12.61251908 21.9668588 11.88449166 17 12 C15.375 10.6875 15.375 10.6875 14 9 C9.66475536 5.41221133 5.70874251 3 0 3 C0 2.01 0 1.02 0 0 Z M33 17 C33 17.66 33 18.32 33 19 C33.99 18.67 34.98 18.34 36 18 C35.01 17.67 34.02 17.34 33 17 Z ",
    fill: "#84638E",
    transform: "translate(515,68)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.50789063 0.38671875 1.01578125 0.7734375 1.5390625 1.171875 C4.75005416 3.60116457 7.9509454 5.96760546 11.3125 8.1875 C14 10 14 10 15.34375 11.4765625 C17.45000409 13.41391885 19.51751893 14.18192271 22.1875 15.1875 C23.08855469 15.53167969 23.98960937 15.87585938 24.91796875 16.23046875 C25.94857422 16.61138672 25.94857422 16.61138672 27 17 C26.34 18.32 25.68 19.64 25 21 C11.78371355 20.94266253 3.13404139 13.91609246 -6 5 C-5.38125 4.9175 -4.7625 4.835 -4.125 4.75 C-1.81562433 4.18741541 -1.81562433 4.18741541 -0.75 1.9375 C-0.5025 1.298125 -0.255 0.65875 0 0 Z ",
    fill: "#B24583",
    transform: "translate(486,397)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.98 0.99 -1.98 0.99 -4 2 C-1.03 1.34 1.94 0.68 5 0 C1.8745041 2.64465038 -1.08788267 3.84414715 -5 5 C-5 5.66 -5 6.32 -5 7 C-18.71564813 12.35582225 -30.44728366 13.16249931 -45 13 C-45 12.34 -45 11.68 -45 11 C-43.35 10.67 -41.7 10.34 -40 10 C-40 9.67 -40 9.34 -40 9 C-38.9584375 8.84144531 -37.916875 8.68289063 -36.84375 8.51953125 C-20.26839365 5.89137463 -20.26839365 5.89137463 -4.73828125 -0.21484375 C-3 -1 -3 -1 0 0 Z ",
    fill: "#876FA5",
    transform: "translate(589,426)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C-4.55336873 6.87543403 -13.05256613 11.64235179 -21.75 13 C-22.77609375 13.165 -23.8021875 13.33 -24.859375 13.5 C-36.80049937 15.07759584 -48.75600294 15.13802469 -60.7734375 15.09765625 C-62.43494626 15.09578574 -64.09645558 15.09436484 -65.75796509 15.09336853 C-70.08147772 15.08959313 -74.4049555 15.07980681 -78.72845459 15.06866455 C-83.16011077 15.05834197 -87.59177271 15.05384793 -92.0234375 15.04882812 C-100.68230747 15.03817886 -109.34114937 15.0211641 -118 15 C-118.625 12.625 -118.625 12.625 -119 10 C-118.34 9.34 -117.68 8.68 -117 8 C-117 9.65 -117 11.3 -117 13 C-106.0631234 12.96173108 -95.12658349 12.90206518 -84.18997192 12.81609726 C-79.11003446 12.77681671 -74.03026531 12.74453394 -68.95019531 12.72900391 C-64.0351359 12.71370816 -59.12053985 12.67903814 -54.20568848 12.63169098 C-52.3433437 12.61700902 -50.48093273 12.60896669 -48.61853027 12.60811615 C-34.01463703 12.59475611 -20.18367954 11.37068409 -7.0625 4.3125 C-5.91910156 3.71050781 -4.77570313 3.10851562 -3.59765625 2.48828125 C-1.14830768 1.23564911 -1.14830768 1.23564911 0 0 Z ",
    fill: "#565772",
    transform: "translate(636,756)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.38489506 0.61926144 6.54501124 1.49735012 9.8125 2.5625 C21.35791702 5.69714279 32.03589071 4.59532849 43.20703125 0.77734375 C46 0 46 0 49 1 C47.02 1.99 47.02 1.99 45 3 C46.65 2.67 48.3 2.34 50 2 C50 2.66 50 3.32 50 4 C48.29422658 4.65256456 46.58523911 5.29673041 44.875 5.9375 C43.92367187 6.29714844 42.97234375 6.65679687 41.9921875 7.02734375 C28.98195514 11.2565185 12.41116159 10.75590103 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#BC5AA1",
    transform: "translate(512,366)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C4.00900902 2.31865451 6.99541049 2.37990138 10.01953125 2.4609375 C13.66300239 3.11991393 14.55782258 4.30281611 17 7 C18.73418447 8.06228758 20.50856186 9.06103361 22.3125 10 C23.76269531 10.77150391 23.76269531 10.77150391 25.2421875 11.55859375 C26.87006398 12.40942437 28.49959744 13.25711883 30.1328125 14.09765625 C35.48250412 16.95777277 38.55109241 20.48995793 41 26 C38.36 25.67 35.72 25.34 33 25 C33 24.34 33 23.68 33 23 C32.26136719 22.72671875 31.52273438 22.4534375 30.76171875 22.171875 C28.16941236 21.07188643 26.11371218 19.85609931 23.8125 18.25 C19.7009041 15.43317802 15.48159994 12.8822552 11.1640625 10.39453125 C9.12931802 9.08333309 7.68909258 7.71198001 6 6 C4.79638912 5.22937976 3.56625928 4.49851923 2.3125 3.8125 C1.219375 3.214375 0.12625 2.61625 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#7474A1",
    transform: "translate(555,23)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.81082031 0.33773438 1.62164062 0.67546875 2.45703125 1.0234375 C3.56433594 1.46945312 4.67164063 1.91546875 5.8125 2.375 C6.89144531 2.81585938 7.97039062 3.25671875 9.08203125 3.7109375 C18.10627733 6.92524926 27.19853452 7.27607967 36.6875 7.125 C37.78255859 7.11597656 38.87761719 7.10695313 40.00585938 7.09765625 C42.67081354 7.07438154 45.33528134 7.04169135 48 7 C48.495 7.99 48.495 7.99 49 9 C44.545 9.495 44.545 9.495 40 10 C40 10.66 40 11.32 40 12 C36.20848417 12.08829061 32.41723835 12.14081946 28.625 12.1875 C27.03365234 12.22520508 27.03365234 12.22520508 25.41015625 12.26367188 C18.4153909 12.32804088 12.56202529 11.44491029 6 9 C6 8.34 6 7.68 6 7 C4.02 6.34 2.04 5.68 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#AD5B9C",
    transform: "translate(504,389)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-8.32109533 6.75220146 -19.67600649 9.6858927 -29.75 12.8125 C-30.70753174 13.11446289 -31.66506348 13.41642578 -32.65161133 13.72753906 C-38.76767003 15.57242448 -44.62253563 16.62030628 -51 17 C-51 16.34 -51 15.68 -51 15 C-51.66 14.34 -52.32 13.68 -53 13 C-52.31711914 12.86013672 -51.63423828 12.72027344 -50.93066406 12.57617188 C-37.95768151 9.87292392 -25.4860425 7.02781665 -13.40917969 1.453125 C-8.38199723 -0.79274004 -5.38893249 -1.3204669 0 0 Z ",
    fill: "#8B79B6",
    transform: "translate(598,484)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.1840805 0.86884031 9.85726277 2.76678591 14.74609375 4.6484375 C25.86605987 8.43063357 37.22698038 9.56451956 48.875 10.1875 C50.25656893 10.2691987 51.6380803 10.35187694 53.01953125 10.43554688 C56.34592176 10.63326939 59.6725442 10.82127359 63 11 C63 11.33 63 11.66 63 12 C52.44 12 41.88 12 31 12 C30.67 12.66 30.34 13.32 30 14 C32.64 14.66 35.28 15.32 38 16 C38 16.33 38 16.66 38 17 C30.89678316 17.31199012 24.99908464 16.27365319 18.1875 14.3125 C17.22352295 14.04139404 16.2595459 13.77028809 15.26635742 13.4909668 C-3.49819918 8.08835467 -3.49819918 8.08835467 -8 3 C-3.33604798 3.94699533 0.97158468 5.98501186 5.3359375 7.828125 C9.21800311 9.42478102 12.83335025 10.48400622 17 11 C17 10.01 17 9.02 17 8 C15.85660156 7.59007812 14.71320313 7.18015625 13.53515625 6.7578125 C12.04413369 6.21391748 10.55325567 5.66962611 9.0625 5.125 C8.30775391 4.85558594 7.55300781 4.58617187 6.77539062 4.30859375 C1.11328125 2.2265625 1.11328125 2.2265625 0 0 Z ",
    fill: "#805180",
    transform: "translate(485,445)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.66 0.33 -1.32 0.66 -2 1 C-1.505 1.99 -1.505 1.99 -1 3 C-2.63195312 3.74443359 -2.63195312 3.74443359 -4.296875 4.50390625 C-12.14950086 8.12088418 -19.78092363 11.8571008 -27.1953125 16.32421875 C-31.71774385 19.02633999 -36.36018959 21.50655858 -41 24 C-41 24.66 -41 25.32 -41 26 C-41.54269531 26.17015625 -42.08539063 26.3403125 -42.64453125 26.515625 C-47.14473554 28.04001852 -49.18171009 29.10807584 -52 33 C-54.6875 33.25 -54.6875 33.25 -57 33 C-57 32.01 -57 31.02 -57 30 C-55.576875 29.2265625 -55.576875 29.2265625 -54.125 28.4375 C-51.08989351 26.71099455 -48.27476977 24.79857406 -45.4453125 22.75390625 C-40.07066905 18.96957771 -34.48922244 15.69607658 -28.75 12.5 C-27.7487207 11.93974121 -26.74744141 11.37948242 -25.71582031 10.80224609 C-3.94136496 -1.31378832 -3.94136496 -1.31378832 0 0 Z ",
    fill: "#973665",
    transform: "translate(280,22)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C5.20549731 8.62927587 7.39840797 17.23339098 9 26 C9.66 25.67 10.32 25.34 11 25 C10.76228882 26.50832397 10.76228882 26.50832397 10.51977539 28.04711914 C10.02528944 31.80767435 9.79743517 35.45680069 9.68359375 39.24609375 C9.66281265 39.90207047 9.64203156 40.55804718 9.62062073 41.23390198 C9.55594062 43.30167546 9.49662534 45.36956101 9.4375 47.4375 C9.39423693 48.85092242 9.35062035 50.26433407 9.30664062 51.67773438 C9.20034484 55.11837471 9.09885528 58.55913692 9 62 C7.515 62.495 7.515 62.495 6 63 C5.67 52.11 5.34 41.22 5 30 C4.01 29.67 3.02 29.34 2 29 C2.66 29 3.32 29 4 29 C3.87882813 28.26362305 3.75765625 27.52724609 3.6328125 26.76855469 C3.08526441 23.42956429 2.5425802 20.08980111 2 16.75 C1.80921875 15.59113281 1.6184375 14.43226563 1.421875 13.23828125 C1.24140625 12.12324219 1.0609375 11.00820312 0.875 9.859375 C0.70742188 8.83295898 0.53984375 7.80654297 0.3671875 6.74902344 C0 4 0 4 0 0 Z ",
    fill: "#898CCA",
    transform: "translate(653,216)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C-13.16297057 12.66382351 -30.9523929 19.19898343 -49 25 C-46.69 25.66 -44.38 26.32 -42 27 C-44.8736072 28.91573814 -46.26034211 29.41980764 -49.54296875 30.03515625 C-50.44466797 30.20442627 -51.34636719 30.37369629 -52.27539062 30.5480957 C-53.71688477 30.80272583 -53.71688477 30.80272583 -55.1875 31.0625 C-56.17041016 31.2380542 -57.15332031 31.4136084 -58.16601562 31.59448242 C-68.31919529 33.33594761 -78.78943773 35.03899948 -89 33 C-89 32.67 -89 32.34 -89 32 C-78.44 31.01 -67.88 30.02 -57 29 C-57.66 28.01 -58.32 27.02 -59 26 C-62.08365871 25.7497843 -62.08365871 25.7497843 -65 26 C-61.0623171 23.59305174 -56.77496113 23.08698987 -52.3125 22.25 C-33.92687962 18.52488907 -14.94209943 11.64042178 0 0 Z ",
    fill: "#6E618A",
    transform: "translate(617,430)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 8.25 1 16.5 1 25 C1.66 25 2.32 25 3 25 C3.495 26.98 3.495 26.98 4 29 C-0.07154286 31.10144148 -3.40268439 31.11805803 -7.859375 31 C-10.11828944 30.92850447 -10.11828944 30.92850447 -12.75 31.5625 C-15.43804732 32.08517587 -17.33293746 31.53341251 -20 31 C-22.63804589 31.39397335 -22.63804589 31.39397335 -25 32 C-33 32 -41 32 -49 32 C-49 31.34 -49 30.68 -49 30 C-50.47968324 30.14049518 -51.95874516 30.28754826 -53.4375 30.4375 C-54.67306641 30.55931641 -54.67306641 30.55931641 -55.93359375 30.68359375 C-57.98662025 30.78930815 -57.98662025 30.78930815 -59 32 C-60.66608987 32.04384447 -62.33380554 32.0396713 -64 32 C-66.93593133 32 -69.76556416 32.22499427 -72.6875 32.5 C-73.68136719 32.5928125 -74.67523437 32.685625 -75.69921875 32.78125 C-76.83810547 32.88953125 -76.83810547 32.88953125 -78 33 C-78 31.68 -78 30.36 -78 29 C-52.26 29 -26.52 29 0 29 C0 19.43 0 9.86 0 0 Z M1 26 C2 29 2 29 2 29 Z M-39 30 C-35 31 -35 31 -35 31 Z ",
    fill: "#7981B3",
    transform: "translate(802,575)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.89550031 1.30108719 17.84012498 1.50365454 26.8125 1.75 C27.5497934 1.77028259 28.28708679 1.79056519 29.04672241 1.8114624 C33.3017655 1.92604968 37.55697415 2.0297617 41.8125 2.125 C41.8125 2.455 41.8125 2.785 41.8125 3.125 C39.1725 3.455 36.5325 3.785 33.8125 4.125 C36.4525 4.455 39.0925 4.785 41.8125 5.125 C41.8125 5.455 41.8125 5.785 41.8125 6.125 C29.98087836 8.09693694 17.68758962 7.3844792 5.8125 6.125 C5.8125 5.465 5.8125 4.805 5.8125 4.125 C4.8225 4.16625 3.8325 4.2075 2.8125 4.25 C-1.42585866 4.2673348 -5.11943985 3.26691162 -9.1875 2.125 C-9.1875 1.465 -9.1875 0.805 -9.1875 0.125 C-5.57979343 -1.07756886 -3.75243724 -0.60805309 0 0 Z ",
    fill: "#C34E95",
    transform: "translate(494.1875,496.875)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.32076956 1.43567733 1.63094808 2.87371982 1.9375 4.3125 C2.11152344 5.11300781 2.28554688 5.91351563 2.46484375 6.73828125 C8.02532089 40.62878063 2.41023675 76.55912974 -14.0625 106.6875 C-14.47395264 107.44240723 -14.88540527 108.19731445 -15.30932617 108.97509766 C-17.76728412 113.30944532 -20.30024768 116.65637357 -24 120 C-22.66867325 116.34372214 -21.01421265 113.38678498 -18.8125 110.1875 C-15.72751608 105.44336506 -13.31303462 100.61169689 -11.0625 95.4375 C-10.75610596 94.73455811 -10.44971191 94.03161621 -10.1340332 93.30737305 C-8.54207437 89.77846555 -8.54207437 89.77846555 -8 86 C-7.34 86 -6.68 86 -6 86 C-4.62421624 79.83796118 -3.26179357 73.67332288 -1.9375 67.5 C-1.76412109 66.70980469 -1.59074219 65.91960937 -1.41210938 65.10546875 C0.83302534 54.59376523 1.15881433 44.37520754 1.13037109 33.65429688 C1.12504349 31.26946563 1.1303238 28.88482529 1.13671875 26.5 C1.14018092 17.61329497 0.86161805 8.85170249 0 0 Z ",
    fill: "#686388",
    transform: "translate(631,235)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.1886824 3.56604719 0.80719323 3.88648944 -0.75 7.125 C-7.84310089 24.39667685 -6.43073416 43.50599055 -6.3225708 61.81518555 C-6.30914855 64.89368082 -6.31431368 67.97202809 -6.31969929 71.05053902 C-6.32307726 74.06386669 -6.31633879 77.07710853 -6.30657005 80.09041977 C-6.30278642 81.50705387 -6.30154054 82.92369762 -6.3031559 84.34033585 C-6.30683449 103.6133485 -3.9582537 121.06089188 6.64453125 137.609375 C8 140 8 140 8 143 C-3.16056189 128.46232284 -7.97555592 112.07488712 -8.28125 93.890625 C-8.29965942 93.0419989 -8.31806885 92.1933728 -8.33703613 91.31903076 C-8.41521463 87.71427156 -8.4836475 84.10934697 -8.55224609 80.50439453 C-8.60396059 77.86221085 -8.66117557 75.22018644 -8.71875 72.578125 C-8.73232544 71.76249084 -8.74590088 70.94685669 -8.7598877 70.10650635 C-8.83204847 66.83466737 -8.95853473 64.1243958 -10 61 C-9.67 60.34 -9.34 59.68 -9 59 C-8.95224064 57.18812934 -8.963065 55.37462363 -9 53.5625 C-9.10344473 34.8390043 -8.11587129 17.2261774 0 0 Z ",
    fill: "#7B2A4E",
    transform: "translate(117,608)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.4375 1.8125 3.4375 1.8125 4.9375 3.6875 C5.58612081 6.44413844 5.33164695 8.13005916 4.4375 10.8125 C2.68749713 13.3914516 1.54210621 13.78356637 -1.5 14.625 C-4.73051051 14.82278636 -5.99984514 14.73449114 -8.5625 12.8125 C-10.48449114 10.24984514 -10.57278636 8.98051051 -10.375 5.75 C-9.54332873 2.74318849 -9.04021236 1.62313596 -6.5625 -0.1875 C-3.5625 -1.1875 -3.5625 -1.1875 0 0 Z ",
    fill: "#C62B6C",
    transform: "translate(207.5625,59.1875)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C1.99 3 2.98 3 4 3 C2.21322356 10.88283724 -1.3071453 16.42564971 -8 21 C-10.57672781 22.5678252 -13.11531768 24.09069796 -16 25 C-16.99 24.67 -17.98 24.34 -19 24 C-15.37 22.02 -11.74 20.04 -8 18 C-8.99 18 -9.98 18 -11 18 C-11 17.34 -11 16.68 -11 16 C-13.67331214 16.45828208 -15.99618664 16.99837932 -18.5 18.0625 C-21.17773183 19.06664944 -23.16578026 19.16195541 -26 19 C-23.93367817 17.94556117 -21.86997344 16.94408184 -19.73828125 16.02734375 C-12.75036194 12.88784377 -8.13536372 8.6079432 -3 3 C-2.00555234 1.99447832 -1.00786745 0.99207016 0 0 Z ",
    fill: "#B74686",
    transform: "translate(539,293)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.16897961 5.84429648 9.50767598 11.64828052 12.75 19.4375 C13.14832031 20.35337891 13.54664063 21.26925781 13.95703125 22.21289062 C16.05390318 27.16364078 17.68085034 31.61072271 18 37 C17.67 37.33 17.34 37.66 17 38 C17.350625 38.7425 17.70125 39.485 18.0625 40.25 C19.0720098 43.21122875 18.87980884 44.12062561 18 47 C17.78907715 46.49251221 17.5781543 45.98502441 17.36083984 45.4621582 C12.24320599 33.14852358 12.24320599 33.14852358 6.75 21 C0 6.55942623 0 6.55942623 0 0 Z ",
    fill: "#7577A6",
    transform: "translate(668,123)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C2.45375 2.45246094 2.9075 2.90492188 3.375 3.37109375 C4.5675939 4.56655446 5.75425518 5.76794126 6.9375 6.97265625 C9.84908752 9.92284437 12.67640276 12.74525323 15.9375 15.3125 C18 17 18 17 19 20 C17.02 19.34 15.04 18.68 13 18 C12.67 18.99 12.34 19.98 12 21 C11.278125 20.401875 10.55625 19.80375 9.8125 19.1875 C7.1724154 17.00195733 7.1724154 17.00195733 4.625 15.75 C0.71560739 13.14373826 -2.02803982 9.60574996 -5 6 C-4.1875 3.5625 -4.1875 3.5625 -3 1 C-2.01 0.67 -1.02 0.34 0 0 Z ",
    fill: "#D24188",
    transform: "translate(467,402)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.43570313 0.38671875 0.87140625 0.7734375 1.3203125 1.171875 C4.09324485 3.5966903 6.75188975 5.84358267 9.875 7.8125 C14.41457116 10.99019981 18.36569694 14.81651337 22 19 C22 19.66 22 20.32 22 21 C22.99 21.33 23.98 21.66 25 22 C29 26.34285714 29 26.34285714 29 30 C23.53365931 28.63341483 20.45406334 26.17153094 16.5 22.375 C15.92757568 21.83593018 15.35515137 21.29686035 14.76538086 20.74145508 C11.22095627 17.34405998 8.07126526 13.87498033 5.27734375 9.82421875 C3.08186137 6.6887745 0.5185413 3.87833291 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#7A79AB",
    transform: "translate(623,69)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.36231553 1.24986598 6.22996169 2.66216888 9.1875 4.6875 C9.95964844 5.21214844 10.73179687 5.73679687 11.52734375 6.27734375 C13.23530735 7.46725204 14.93538604 8.66852999 16.62890625 9.87890625 C17.49386719 10.49636719 18.35882812 11.11382812 19.25 11.75 C20.03890625 12.32234375 20.8278125 12.8946875 21.640625 13.484375 C23.92787294 15.07305374 23.92787294 15.07305374 26.44921875 15.90625 C29.75412213 17.32336018 31.9180486 19.32254809 34.5625 21.75 C35.49191406 22.59046875 36.42132812 23.4309375 37.37890625 24.296875 C40.07186597 27.07411513 41.96763067 29.72908088 44 33 C40 33 40 33 37.66796875 30.91796875 C36.84941406 30.01691406 36.03085937 29.11585937 35.1875 28.1875 C31.27853828 24.10111835 28.2919168 22.05796764 23 20 C21.04166558 18.4307097 19.2307064 16.74121597 17.390625 15.03515625 C13.9431446 12.1002914 10.19587779 9.64582086 6.39208984 7.19677734 C3.28820283 5.13895682 1.27034848 3.56179984 0 0 Z ",
    fill: "#7E6897",
    transform: "translate(558,88)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.88080957 1.17366316 4.34257199 2.35092741 6.5625 4.625 C8.7909084 7.34893236 8.7909084 7.34893236 12 7 C12.66 7.66 13.32 8.32 14 9 C14.99 9 15.98 9 17 9 C23.26793109 15.28155703 31.3626804 25.08800722 33 34 C29.72713318 31.2180632 28.03572303 27.72045933 26 24 C25.01 24.33 24.02 24.66 23 25 C23.515625 25.78375 24.03125 26.5675 24.5625 27.375 C25.036875 28.24125 25.51125 29.1075 26 30 C25.67 30.66 25.34 31.32 25 32 C24.401875 31.030625 23.80375 30.06125 23.1875 29.0625 C21.28872491 25.76947958 21.28872491 25.76947958 18 25 C17.95359375 24.31808594 17.9071875 23.63617188 17.859375 22.93359375 C16.637839 18.76371403 14.12784055 16.24525461 11.25 13.0625 C10.19236939 11.86618498 9.1350745 10.66957307 8.078125 9.47265625 C7.56443359 8.89660645 7.05074219 8.32055664 6.52148438 7.72705078 C4.29194476 5.19628004 2.14540593 2.60229794 0 0 Z ",
    fill: "#8E5284",
    transform: "translate(543,181)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 0.12304688 5.32495117 C-1.40659148 8.28556727 -2.93901395 11.2432458 -4.5 14.1875 C-5.01820313 15.20392578 -5.53640625 16.22035156 -6.0703125 17.26757812 C-9.38255391 23.58612733 -13.01322684 28.89080044 -18 34 C-18.66 33.01 -19.32 32.02 -20 31 C-22.97 35.455 -22.97 35.455 -26 40 C-26 36.56730194 -25.32103368 35.52384838 -23.55078125 32.6484375 C-23.03193359 31.79636719 -22.51308594 30.94429688 -21.97851562 30.06640625 C-21.42873047 29.17824219 -20.87894531 28.29007812 -20.3125 27.375 C-16.3964882 20.98947408 -12.57769536 14.58231827 -9 8 C-8.01 9.485 -8.01 9.485 -7 11 C-6.01 10.67 -5.02 10.34 -4 10 C-2.88319294 7.15020361 -2.88319294 7.15020361 -2 4 C-1.36184656 2.65278717 -0.70674629 1.31252882 0 0 Z ",
    fill: "#6D6F98",
    transform: "translate(704,369)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 6.24406777 -6.95550352 11.8726694 -11.12109375 16.20703125 C-12.29848833 17.369739 -13.48587542 18.52250706 -14.6875 19.66015625 C-16.12099433 20.98662929 -16.12099433 20.98662929 -17 23 C-13.11185508 23.41542862 -13.11185508 23.41542862 -11.078125 21.46875 C-10.47484375 20.8190625 -9.8715625 20.169375 -9.25 19.5 C-8.63640625 18.8503125 -8.0228125 18.200625 -7.390625 17.53125 C-6.93171875 17.0259375 -6.4728125 16.520625 -6 16 C-6 19 -6 19 -8.625 22 C-16.03325835 29.1052621 -24.40119566 35.41143158 -33 41 C-33.66 40.67 -34.32 40.34 -35 40 C-31.37 37.36 -27.74 34.72 -24 32 C-25.98 32 -27.96 32 -30 32 C-30.99 32 -31.98 32 -33 32 C-32.11699219 31.33355469 -31.23398437 30.66710937 -30.32421875 29.98046875 C-18.77150989 21.15337099 -8.8159283 11.64510872 0 0 Z ",
    fill: "#6E6992",
    transform: "translate(627,365)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.72926874 0.31193464 3.45841044 0.62457362 5.1875 0.9375 C6.15042969 1.11152344 7.11335938 1.28554688 8.10546875 1.46484375 C10.74239972 1.9523735 13.3719905 2.46671105 16 3 C16 2.34 16 1.68 16 1 C19 2 19 2 20.84863281 3.03662109 C23.47461373 4.2125313 25.55039539 4.31834651 28.421875 4.4140625 C29.95908203 4.47207031 29.95908203 4.47207031 31.52734375 4.53125 C32.59082031 4.5621875 33.65429688 4.593125 34.75 4.625 C35.82894531 4.66367187 36.90789063 4.70234375 38.01953125 4.7421875 C40.67951775 4.83634631 43.3394994 4.92197387 46 5 C46 5.33 46 5.66 46 6 C44.02 6 42.04 6 40 6 C40 6.99 40 7.98 40 9 C13.82345757 9.61916858 13.82345757 9.61916858 4 6 C5.32 5.34 6.64 4.68 8 4 C5.36 3.01 2.72 2.02 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#AF60A2",
    transform: "translate(504,431)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.40977051 8.40977051 9.37733697 27.69764825 11.50683594 38.80786133 C11.91432069 41.02863851 11.91432069 41.02863851 13 43 C13.11028863 45.17370543 13.15448279 47.35088401 13.16796875 49.52734375 C13.1721582 50.18374344 13.17634766 50.84014313 13.18066406 51.51643372 C13.19048862 53.65684924 13.19044653 55.79706555 13.1875 57.9375 C13.18722809 58.66352417 13.18695618 59.38954834 13.18667603 60.13757324 C13.15965926 75.75542735 12.51225716 90.92906109 8 106 C6.66749254 101.61206482 7.58171762 97.85834112 8.40625 93.4453125 C10.10116643 83.54852496 10.55455128 73.90057726 10.5 63.875 C10.49890228 63.03403778 10.49780457 62.19307556 10.49667358 61.32662964 C10.42486451 42.03369622 7.16227618 24.16665346 0.91796875 5.9140625 C0 3 0 3 0 0 Z ",
    fill: "#696588",
    transform: "translate(627,203)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.65983887 0.28488281 1.31967773 0.56976563 1.99951172 0.86328125 C3.98556141 1.72776797 5.96176539 2.61222179 7.9375 3.5 C13.54831237 5.99260601 19.11692672 8.21406704 25 10 C24.01 10.33 23.02 10.66 22 11 C22 11.66 22 12.32 22 13 C22.66 13.33 23.32 13.66 24 14 C10.44262479 12.70242944 -0.84078418 6.41438623 -12 -1 C-7.86468742 -4.27378912 -4.25794991 -1.90756156 0 0 Z ",
    fill: "#C74B93",
    transform: "translate(480,443)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C9.44827085 4.14525351 16.8965987 4.28727669 24.3449707 4.42724609 C26.86907282 4.47503709 29.39316198 4.52351818 31.91723633 4.57275391 C47.28028917 4.87189541 62.6339168 5.07543179 78 5 C78 5.66 78 6.32 78 7 C51.93 7 25.86 7 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#7A85B8",
    transform: "translate(725,731)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.06469482 0.56283691 1.12938965 1.12567383 1.19604492 1.70556641 C2.82248235 21.36710967 2.82248235 21.36710967 12 38 C11.6875 40.6875 11.6875 40.6875 11 43 C4.23806896 38.87236964 0.76298497 34.42402047 -2 27 C-2.8125 23.375 -2.8125 23.375 -3 21 C-2.01 21.99 -1.02 22.98 0 24 C0 16.08 0 8.16 0 0 Z ",
    fill: "#C84286",
    transform: "translate(485,344)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.90370334 1.61724853 6.71617345 4.26883837 9.75 7.125 C10.3063916 7.64489502 10.8627832 8.16479004 11.43603516 8.70043945 C32.64864721 28.66713881 32.64864721 28.66713881 40 39 C41.32917292 40.66998649 42.66014102 42.33857487 44 44 C43.505 44.99 43.505 44.99 43 46 C41.35 44.35 39.7 42.7 38 41 C39.77945087 45.04420651 42.39529673 48.46078487 45 52 C44.505 52.99 44.505 52.99 44 54 C43.28714844 53.0821875 42.57429687 52.164375 41.83984375 51.21875 C36.7261521 44.65842778 31.60185311 38.15630273 26 32 C26.33 31.34 26.66 30.68 27 30 C27.99 30 28.98 30 30 30 C27.01669981 26.99168504 24.02990259 23.98689606 21.04003906 20.98510742 C20.02673848 19.96682708 19.01434288 18.94764526 18.00292969 17.92749023 C12.61492773 12.4941437 7.21870716 7.14492897 1.34570312 2.22680664 C0.90162109 1.82196045 0.45753906 1.41711426 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#666588",
    transform: "translate(631,45)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.26306592 16.65471023 -7.29101116 32.21782998 -19 44 C-19 40.89448334 -18.4606285 39.64738916 -17 37 C-17.66 36.34 -18.32 35.68 -19 35 C-23.455 39.455 -23.455 39.455 -28 44 C-28.66 43.67 -29.32 43.34 -30 43 C-29.28972656 42.31292969 -28.57945312 41.62585938 -27.84765625 40.91796875 C-26.92855469 40.01691406 -26.00945313 39.11585938 -25.0625 38.1875 C-24.14597656 37.29417969 -23.22945312 36.40085937 -22.28515625 35.48046875 C-19.82064892 33.14563407 -19.82064892 33.14563407 -19 30 C-17.44140625 28.90234375 -17.44140625 28.90234375 -15.5625 27.9375 C-13.25850235 26.73980602 -11.86847183 25.86847183 -10 24 C-9.34 24.33 -8.68 24.66 -8 25 C-3.24738561 13.88651805 -3.24738561 13.88651805 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#905990",
    transform: "translate(588,284)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.74990387 1.37495194 2.90908756 2.79715297 4.0234375 5.63671875 C4.40322754 6.60061523 4.78301758 7.56451172 5.17431641 8.55761719 C5.76865479 10.10690918 5.76865479 10.10690918 6.375 11.6875 C6.7776709 12.72938477 7.1803418 13.77126953 7.59521484 14.84472656 C15.66449697 36.0065091 15.66449697 36.0065091 14 41 C13.34 41 12.68 41 12 41 C11.34 37.7 10.68 34.4 10 31 C9.34 31 8.68 31 8 31 C6.6693893 27.69449717 5.36396757 24.37957377 4.0625 21.0625 C3.68931641 20.13630859 3.31613281 19.21011719 2.93164062 18.25585938 C0.65976275 12.42265941 -0.7026842 7.26893521 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#6F719C",
    transform: "translate(704,143)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C30.62884513 -1.39222023 59.44377424 7.1370801 86 22 C85.34 23.32 84.68 24.64 84 26 C83.57074219 25.67128906 83.14148438 25.34257812 82.69921875 25.00390625 C58.80613858 7.88439832 28.87534213 1.84927477 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#DD519F",
    transform: "translate(448,146)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0.495 39.6 0.495 80 1 C79.67 1.66 79.34 2.32 79 3 C54.25 3 29.5 3 4 3 C3.67 4.65 3.34 6.3 3 8 C3.33 8 3.66 8 4 8 C4 11.63 4 15.26 4 19 C3.67 19 3.34 19 3 19 C2.67 22.96 2.34 26.92 2 31 C2.66 31 3.32 31 4 31 C3.505 32.485 3.505 32.485 3 34 C2.85426942 35.47965926 2.75336732 36.96403843 2.68359375 38.44921875 C2.64169922 39.29677734 2.59980469 40.14433594 2.55664062 41.01757812 C2.49766602 42.33918945 2.49766602 42.33918945 2.4375 43.6875 C2.39431641 44.58017578 2.35113281 45.47285156 2.30664062 46.39257812 C2.20064647 48.59490108 2.09857949 50.79733473 2 53 C1.67 53 1.34 53 1 53 C0.67 35.51 0.34 18.02 0 0 Z ",
    fill: "#CC3773",
    transform: "translate(402,685)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.5625 0.5625 3.5625 0.5625 6.0625 2.6875 C7.5625 5.5625 7.5625 5.5625 7.5625 8.6875 C6.41084332 11.99851296 5.6776646 13.0049177 2.5625 14.5625 C0.0625 15 0.0625 15 -2.4375 14.5625 C-4.75 12.9375 -4.75 12.9375 -6.4375 10.5625 C-6.92496608 7.21987548 -6.75315201 5.26807508 -5.375 2.1875 C-3.4375 0.5625 -3.4375 0.5625 0 0 Z ",
    fill: "#CA4587",
    transform: "translate(616.4375,94.4375)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.47732951 3.8947778 -3.45879633 4.97645504 -7 7 C-7.57878906 7.61230469 -8.15757812 8.22460938 -8.75390625 8.85546875 C-11.46333173 11.44238107 -14.269782 13.03315865 -17.5625 14.8125 C-18.69816406 15.43769531 -19.83382812 16.06289063 -21.00390625 16.70703125 C-24 18 -24 18 -27 17 C-25.68 16.01 -24.36 15.02 -23 14 C-23.66 13.34 -24.32 12.68 -25 12 C-20.02827217 6.6091101 -7.53911196 -2.51303732 0 0 Z ",
    fill: "#726D9D",
    transform: "translate(619,470)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.9162636 0.31421022 4.52836778 0.48807759 6.5546875 2.6875 C9.74620962 8.2773849 12.43194233 14.01458774 14.9375 19.9375 C15.25638184 20.68322266 15.57526367 21.42894531 15.90380859 22.19726562 C18.12127154 27.63618537 18.12127154 27.63618537 17 31 C16.67 30.34 16.34 29.68 16 29 C16.15597656 29.60328125 16.31195312 30.2065625 16.47265625 30.828125 C16.76462891 32.02695313 16.76462891 32.02695313 17.0625 33.25 C17.25972656 34.03890625 17.45695313 34.8278125 17.66015625 35.640625 C18.01847417 38.12825747 17.67152083 39.61334893 17 42 C16.7733667 41.33468262 16.5467334 40.66936523 16.31323242 39.98388672 C15.27568163 36.94608189 14.23165313 33.91054149 13.1875 30.875 C12.65286133 29.30492187 12.65286133 29.30492187 12.10742188 27.703125 C10.35068171 22.61019022 8.58022462 17.73300239 6 13 C5.690625 12.360625 5.38125 11.72125 5.0625 11.0625 C4.06239437 9.12111849 2.98113092 7.25736314 1.875 5.375 C0 2 0 2 0 0 Z ",
    fill: "#A35E9C",
    transform: "translate(565,204)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.53367187 0.18175781 1.06734375 0.36351562 1.6171875 0.55078125 C7.37591783 2.4936055 13.16993922 4.28384432 19 6 C18.01 7.485 18.01 7.485 17 9 C16.67 9.99 16.34 10.98 16 12 C33.60908221 14.37045337 50.50464324 13.10436084 67.40405273 7.58911133 C72.69582189 5.8986073 72.69582189 5.8986073 76 7 C73.23229617 7.96823963 70.46133261 8.92460317 67.6875 9.875 C66.92115234 10.14441406 66.15480469 10.41382813 65.36523438 10.69140625 C55.25982703 14.12976062 45.46688961 15.38990704 34.8125 15.375 C33.72767334 15.37483887 32.64284668 15.37467773 31.52514648 15.37451172 C10.07210969 15.07210969 10.07210969 15.07210969 4 9 C5.11375 9.061875 6.2275 9.12375 7.375 9.1875 C8.57125 9.125625 9.7675 9.06375 11 9 C11.66 8.01 12.32 7.02 13 6 C12.31292969 5.81824219 11.62585938 5.63648438 10.91796875 5.44921875 C10.01691406 5.19785156 9.11585938 4.94648438 8.1875 4.6875 C7.29417969 4.44386719 6.40085937 4.20023437 5.48046875 3.94921875 C2.94752262 2.9799181 1.7283504 2.04990396 0 0 Z ",
    fill: "#875586",
    transform: "translate(500,408)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.93742341 -0.02703381 3.87495479 -0.04641125 5.8125 -0.0625 C6.89144531 -0.07410156 7.97039063 -0.08570313 9.08203125 -0.09765625 C12 0 12 0 15 1 C15.99 0.67 16.98 0.34 18 0 C20.03992808 -0.09398043 22.08291414 -0.12992069 24.125 -0.125 C25.20007813 -0.12757813 26.27515625 -0.13015625 27.3828125 -0.1328125 C30 0 30 0 31 1 C32.671549 0.69208308 34.33805547 0.35613097 36 0 C36.99 0 37.98 0 39 0 C40.794375 -0.0309375 40.794375 -0.0309375 42.625 -0.0625 C46 0 46 0 47 1 C48.99958364 1.04080783 51.00045254 1.04254356 53 1 C52 3 52 3 51 4 C49.09756238 4.09391296 47.19161541 4.11743658 45.28686523 4.11352539 C44.0656749 4.11344986 42.84448456 4.11337433 41.58628845 4.11329651 C40.24372314 4.10818911 38.90115825 4.10297311 37.55859375 4.09765625 C36.19238842 4.09579199 34.82618243 4.09436813 33.4599762 4.09336853 C29.85798305 4.08954394 26.25603 4.07971417 22.65405273 4.06866455 C18.98096255 4.05844916 15.30786591 4.05387064 11.63476562 4.04882812 C4.42315877 4.03809184 -2.788415 4.02101614 -10 4 C-9.67 3.34 -9.34 2.68 -9 2 C-6.36 2 -3.72 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z M8 2 C12 3 12 3 12 3 Z M15 2 C15 2.33 15 2.66 15 3 C16.65 3 18.3 3 20 3 C20 2.67 20 2.34 20 2 C18.35 2 16.7 2 15 2 Z M21 2 C21 2.33 21 2.66 21 3 C23.64 3 26.28 3 29 3 C29 2.67 29 2.34 29 2 C26.36 2 23.72 2 21 2 Z M32 2 C36 3 36 3 36 3 Z M40 2 C40 2.33 40 2.66 40 3 C41.98 3 43.96 3 46 3 C46 2.67 46 2.34 46 2 C44.02 2 42.04 2 40 2 Z ",
    fill: "#5F658A",
    transform: "translate(715,568)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C8.81893946 3.29280356 14.96313688 3.51843156 22 0 C24.4375 0.3125 24.4375 0.3125 26 1 C25.67 1.66 25.34 2.32 25 3 C26.32 2.67 27.64 2.34 29 2 C23.17744129 8.79298516 15.53318328 10.67106162 7 12 C7.66 10.02 8.32 8.04 9 6 C5.37 6 1.74 6 -2 6 C-1 1 -1 1 0 0 Z ",
    fill: "#DE408B",
    transform: "translate(503,308)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C1.2182054 11.82273123 -1.2134751 22.68210315 -5.9375 33.6875 C-6.27346191 34.49074707 -6.60942383 35.29399414 -6.95556641 36.12158203 C-7.28862793 36.86907715 -7.62168945 37.61657227 -7.96484375 38.38671875 C-8.2599585 39.05920654 -8.55507324 39.73169434 -8.85913086 40.42456055 C-10 42 -10 42 -12.12719727 42.72583008 C-13.05423462 42.86154419 -13.05423462 42.86154419 -14 43 C-13.08178662 39.96283267 -12.20019406 37.31697393 -10.5 34.625 C-8.95047137 31.9133249 -8.27949652 29.4021316 -7.59765625 26.37109375 C-6.87962874 23.52244865 -5.94994067 20.77971569 -5 18 C-3.42379222 13.36547862 -2.1003865 8.76834151 -1 4 C-1.99 4 -2.98 4 -4 4 C-3.67 3.34 -3.34 2.68 -3 2 C-2.01 2.33 -1.02 2.66 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#7F6B94",
    transform: "translate(613,290)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.52254137 15.78381205 6.375919 42.85901668 6 61 C3.30844252 57.92418933 2.62057183 55.98793364 2.55859375 51.921875 C2.53337646 50.93300293 2.50815918 49.94413086 2.48217773 48.92529297 C2.46743408 47.87744629 2.45269043 46.82959961 2.4375 45.75 C2.21036123 37.13684596 1.65768726 28.76386243 0.40234375 20.2421875 C-0.14204177 15.85539157 -0.40583679 12.21751037 1 8 C0.90731495 5.93381251 0.90731495 5.93381251 0.5625 3.8125 C0.376875 2.554375 0.19125 1.29625 0 0 Z ",
    fill: "#8C8BCB",
    transform: "translate(632,223)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C22.28606185 -0.5560288 42.25172831 -0.0890095 63 9 C62.505 7.515 62.505 7.515 62 6 C70.40536948 7.27676498 77.8334113 12.33340498 84 18 C80.15726281 18 78.72554364 16.69551586 75.5625 14.5625 C71.09793858 11.5329144 71.09793858 11.5329144 66 10 C66 10.66 66 11.32 66 12 C68.97 12.495 68.97 12.495 72 13 C72 13.99 72 14.98 72 16 C68.44826714 14.65936381 65.24811022 13.03539583 61.9375 11.1875 C49.66001332 4.95713362 34.86703767 2.12474315 21.19140625 1.68359375 C19.95068359 1.64169922 18.70996094 1.59980469 17.43164062 1.55664062 C16.15482422 1.51732422 14.87800781 1.47800781 13.5625 1.4375 C12.25861328 1.39431641 10.95472656 1.35113281 9.61132812 1.30664062 C6.40764684 1.20102476 3.20389389 1.09891899 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7E406A",
    transform: "translate(437,194)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 1.485 0.495 1.485 1 3 C1.99 3.33 2.98 3.66 4 4 C3.34 4.33 2.68 4.66 2 5 C2 13.91 2 22.82 2 32 C2.66 32.33 3.32 32.66 4 33 C3.34 33 2.68 33 2 33 C2 33.66 2 34.32 2 35 C2.66 35.33 3.32 35.66 4 36 C0.49717623 37.16760792 -2.16231583 37.08060028 -5.8581543 37.02172852 C-6.55109589 37.01212097 -7.24403748 37.00251343 -7.95797729 36.99261475 C-10.24682869 36.95965169 -12.5354876 36.91930925 -14.82421875 36.87890625 C-16.41176171 36.85460249 -17.99931177 36.83075906 -19.58686829 36.80735779 C-23.76429342 36.74454228 -27.94159262 36.67546846 -32.11889648 36.60510254 C-36.38194038 36.53439622 -40.64507353 36.46959301 -44.90820312 36.40429688 C-53.27223618 36.27531715 -61.63613049 36.13918216 -70 36 C-70 41.61 -70 47.22 -70 53 C-70.33 53 -70.66 53 -71 53 C-71 47.06 -71 41.12 -71 35 C-47.24 35 -23.48 35 1 35 C0.67 24.77 0.34 14.54 0 4 C-1.32 3.67 -2.64 3.34 -4 3 C-2.68 3 -1.36 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#6E77A4",
    transform: "translate(796,651)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 0 6 C-0.2544753 9.16166277 -0.23816276 12.32906364 -0.25 15.5 C-0.25394775 16.39968506 -0.25789551 17.29937012 -0.26196289 18.22631836 C-0.21003046 24.16321235 0.41535614 29.37598927 2.44140625 35.00390625 C3 37 3 37 2 40 C-2.23735665 29.40660838 -3.29345489 20.46104393 -3 9 C-7.37738315 22.9305401 -9.01336061 35.68512363 -2.875 49.5390625 C-1.92070727 51.36149652 -0.96094646 53.18106562 0 55 C-0.33 55.66 -0.66 56.32 -1 57 C-8.65877213 46.28415496 -10.27310672 33.84680414 -9 21 C-7.40470166 13.09175635 -4.63973564 6.57295882 0 0 Z ",
    fill: "#954275",
    transform: "translate(481,334)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.33090484 0.56681655 11.73958626 2.60888742 17.625 4.9375 C18.553125 5.29779297 19.48125 5.65808594 20.4375 6.02929688 C24.63479614 7.66191278 28.81948784 9.32491587 33 11 C33.33 10.67 33.66 10.34 34 10 C32.02 9.01 30.04 8.02 28 7 C31.71385679 5.76204774 32.41017976 6.36866316 35.8515625 8.01953125 C36.78484375 8.46490234 37.718125 8.91027344 38.6796875 9.36914062 C40.13761719 10.08360352 40.13761719 10.08360352 41.625 10.8125 C42.6046875 11.27720703 43.584375 11.74191406 44.59375 12.22070312 C51.86529054 15.73058107 51.86529054 15.73058107 53 18 C48.545 17.01 48.545 17.01 44 16 C46.64 17.65 49.28 19.3 52 21 C51.01 21.495 51.01 21.495 50 22 C47.87475586 21.15478516 47.87475586 21.15478516 45.21484375 19.7890625 C44.22025146 19.28987305 43.22565918 18.79068359 42.20092773 18.27636719 C41.12399658 17.73141602 40.04706543 17.18646484 38.9375 16.625 C26.29378898 10.36560885 13.36540454 5.47633613 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#6C678D",
    transform: "translate(512,9)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.96875 5.2265625 C-3.22171875 6.41378906 -3.22171875 6.41378906 -4.5 7.625 C-6.01394319 9.06885323 -7.51774858 10.52363053 -9 12 C-9 12.33 -9 12.66 -9 13 C-8.38125 12.505 -7.7625 12.01 -7.125 11.5 C-5 10 -5 10 -3 10 C-1.30225062 8.70647667 0.36739286 7.37482707 2 6 C0.25473546 9.99919915 -2.26523228 12.31331019 -5.44140625 15.21875 C-7.1416707 17.16190937 -7.59651671 18.47961125 -8 21 C-8.58007812 21.08765625 -9.16015625 21.1753125 -9.7578125 21.265625 C-12.60266045 22.19738705 -13.8372451 23.57312127 -15.875 25.75 C-19.0930079 29.100585 -22.3746219 32.09969752 -26 35 C-26.66 34.67 -27.32 34.34 -28 34 C-27.34 33.34 -26.68 32.68 -26 32 C-26 31.01 -26 30.02 -26 29 C-22 27 -22 27 -20 26.1875 C-17.23340147 24.54483212 -15.73231712 22.69471553 -14 20 C-14.32843384 17.93618425 -14.32843384 17.93618425 -15 16 C-13.79599358 12.91550934 -12.31665388 11.1713862 -9.75 9.125 C-6.27517412 6.26937789 -3.14125583 3.21787182 0 0 Z ",
    fill: "#6C6E97",
    transform: "translate(662,427)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1.25 3 1.25 5 4.25 C4.85736712 7.67318917 4.58460033 9.57879221 2.3125 12.1875 C-0.86221916 13.64615475 -2.69878201 13.25471852 -6 12.25 C-8.31282587 8.78076119 -8.42478586 7.32794425 -8 3.25 C-5.58818512 0.07078948 -3.9593082 -0.98982705 0 0 Z ",
    fill: "#CC397B",
    transform: "translate(347,229.75)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.55683513 1.31859857 6.82857497 2.96031907 10.16015625 4.76757812 C27.78114 14.13857843 44.25620858 15.84289936 64 15 C65.49297607 14.94054199 65.49297607 14.94054199 67.01611328 14.87988281 C72.68159594 14.64596528 78.34058584 14.35058318 84 14 C71.6050295 22.26331367 47.2600737 18.82983043 33.32421875 16.04296875 C22.6842975 13.63731726 6.19654228 9.29481343 0 0 Z ",
    fill: "#845483",
    transform: "translate(480,424)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.96447021 0.57741943 0.92894043 1.15483887 0.89233398 1.74975586 C-0.79330743 30.16364801 1.05753684 56.13147628 15.64453125 81.35546875 C17 84 17 84 17 87 C5.06365844 77.45092675 0.78924095 53.81246452 -1.40234375 39.34375 C-2.85568103 26.12435336 -2.31924741 13.06647424 0 0 Z ",
    fill: "#A03D71",
    transform: "translate(384,354)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.2233881 2.2233881 -2.92305521 2.3605016 -5.9140625 2.8515625 C-6.67460938 2.98046875 -7.43515625 3.109375 -8.21875 3.2421875 C-9.0128125 3.36851562 -9.806875 3.49484375 -10.625 3.625 C-11.82769531 3.82609375 -11.82769531 3.82609375 -13.0546875 4.03125 C-15.03527484 4.36134789 -17.01749675 4.68161083 -19 5 C-18.30049815 8.79499854 -16.88170505 10.37518645 -13.8125 12.765625 C-4.46483311 19.13170849 4.92075803 19.79294774 16 19 C22.87851601 17.53173208 28.77302897 14.95864371 34.4765625 10.85546875 C34.97929688 10.57316406 35.48203125 10.29085938 36 10 C36.66 10.33 37.32 10.66 38 11 C27.67854115 18.2320426 16.01975695 23.82733431 3 22 C-8.19499918 19.51848885 -16.22825886 15.31114407 -23 6 C-23 5.34 -23 4.68 -23 4 C-19.18511977 2.3060793 -15.62423434 1.48207188 -11.5 0.875 C-10.3965625 0.70742188 -9.293125 0.53984375 -8.15625 0.3671875 C-5.39581369 0.04604763 -2.77414373 -0.07245898 0 0 Z ",
    fill: "#8D4D80",
    transform: "translate(520,318)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.6884702 1.01107151 20.07533289 10.32219689 27 18 C26.67 18.99 26.34 19.98 26 21 C22.63670142 20.42012094 21.3276513 19.42075735 19 17 C18.278125 16.5875 17.55625 16.175 16.8125 15.75 C14.2490528 14.15496619 12.0087105 12.48590587 9.6875 10.5625 C8.99011719 9.98628906 8.29273438 9.41007813 7.57421875 8.81640625 C6 7 6 7 6 3 C3.03 2.505 3.03 2.505 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#A94783",
    transform: "translate(503,204)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.0093457 0.648479 1.01869141 1.29695801 1.02832031 1.96508789 C1.24251904 13.82476736 1.54507753 24.93928833 5.2578125 36.26953125 C6 39 6 39 5 42 C2.9375 43.1875 2.9375 43.1875 1 44 C0.32389577 42.10751181 -0.34050439 40.2108398 -1 38.3125 C-1.37125 37.25675781 -1.7425 36.20101562 -2.125 35.11328125 C-2.9391857 32.21637944 -3.17709796 29.98299377 -3 27 C-2.01 26.67 -1.02 26.34 0 26 C-0.165 24.9275 -0.33 23.855 -0.5 22.75 C-1.4338665 15.2523861 -1.64525673 7.40365529 0 0 Z ",
    fill: "#EF3A87",
    transform: "translate(433,357)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.24902963 1.38867325 10.1328538 3.68625369 14.5625 8.3125 C15.26536133 9.0230957 15.26536133 9.0230957 15.98242188 9.74804688 C20.27367262 14.13532561 23.99025876 18.13825473 26 24 C25.01 24.66 24.02 25.32 23 26 C22.51273438 25.36835938 22.02546875 24.73671875 21.5234375 24.0859375 C16.25072243 17.43272975 10.59837601 11.42975828 4.52294922 5.50927734 C3.00010288 4.02158327 1.49789682 2.51281187 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7E6D9F",
    transform: "translate(573,132)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4 0 4 -1 6 C-3.67756488 7.43655176 -6.54434409 8.46458119 -9.375 9.5625 C-10.18759277 9.87968994 -11.00018555 10.19687988 -11.83740234 10.52368164 C-17.86921459 12.78396467 -23.51225446 14.10003132 -30 14 C-27.25002779 12.5268006 -25.10380501 11.77595125 -22 11 C-25.63 11 -29.26 11 -33 11 C-33 10.67 -33 10.34 -33 10 C-32.14019531 9.84144531 -31.28039062 9.68289063 -30.39453125 9.51953125 C-21.09619863 7.6842006 -12.23714059 5.20549908 -3.7578125 0.84765625 C-2 0 -2 0 0 0 Z ",
    fill: "#A169A9",
    transform: "translate(574,386)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.01707031 0.39445312 1.01707031 0.39445312 2.0546875 0.796875 C-0.32036573 3.34212748 -2.90582283 5.24610634 -5.7578125 7.234375 C-11.24243079 11.1571969 -16.31317253 15.45385301 -21.34887695 19.93530273 C-25.73841068 23.796875 -25.73841068 23.796875 -27.9453125 23.796875 C-27.9453125 24.456875 -27.9453125 25.116875 -27.9453125 25.796875 C-28.6053125 25.796875 -29.2653125 25.796875 -29.9453125 25.796875 C-29.00791991 18.31509337 -19.6389168 12.10492704 -14.0546875 7.59765625 C-12.73171308 6.57403747 -11.40364224 5.55696832 -10.0703125 4.546875 C-9.44044434 4.05695068 -8.81057617 3.56702637 -8.16162109 3.06225586 C-5.28117133 0.95158808 -3.63616537 -0.25077003 0 0 Z ",
    fill: "#B6437C",
    transform: "translate(395.9453125,259.203125)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 1.32 3 2.64 3 4 C3.66 4.33 4.32 4.66 5 5 C4.34 5 3.68 5 3 5 C3 14.9 3 24.8 3 35 C-10.86 35 -24.72 35 -39 35 C-39 34.67 -39 34.34 -39 34 C-25.8 33.67 -12.6 33.34 1 33 C1.020625 28.111875 1.04125 23.22375 1.0625 18.1875 C1.071604 16.64860107 1.08070801 15.10970215 1.09008789 13.52416992 C1.09258545 12.31349854 1.09508301 11.10282715 1.09765625 9.85546875 C1.10289307 8.61434326 1.10812988 7.37321777 1.11352539 6.09448242 C1.14388083 2.96291782 1.14388083 2.96291782 0 0 Z ",
    fill: "#A93467",
    transform: "translate(491,736)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.98 0.99 -1.98 0.99 -4 2 C-1.03 2 1.94 2 5 2 C5 2.33 5 2.66 5 3 C4.10796875 3.20496094 3.2159375 3.40992188 2.296875 3.62109375 C1.12640625 3.89050781 -0.0440625 4.15992188 -1.25 4.4375 C-2.41015625 4.70433594 -3.5703125 4.97117188 -4.765625 5.24609375 C-6.59009079 5.67136174 -8.41254293 6.10639265 -10.2265625 6.57421875 C-12 7 -12 7 -15.125 7.375 C-18.31713816 7.88986099 -20.95964072 8.6084665 -24 9.625 C-28.48831719 11.04561416 -31.44620253 11.08895157 -36 10 C-33.80248934 7.80248934 -32.63987504 7.42312991 -29.7109375 6.5625 C-28.85113281 6.30726563 -27.99132812 6.05203125 -27.10546875 5.7890625 C-26.20441406 5.52867187 -25.30335938 5.26828125 -24.375 5 C-23.49714844 4.73960937 -22.61929687 4.47921875 -21.71484375 4.2109375 C-6.32669167 -0.31633458 -6.32669167 -0.31633458 0 0 Z ",
    fill: "#8B406C",
    transform: "translate(432,193)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 0.99 0.495 0.99 1 2 C0.1105957 4.17285156 0.1105957 4.17285156 -1.32421875 6.890625 C-1.85249268 7.89947754 -2.3807666 8.90833008 -2.92504883 9.94775391 C-3.50665771 11.03749512 -4.0882666 12.12723633 -4.6875 13.25 C-5.27748779 14.36938965 -5.86747559 15.4887793 -6.4753418 16.64208984 C-11.31861756 25.80120069 -16.26689672 34.90290062 -21.25390625 43.984375 C-24.89772045 50.62336632 -28.45568603 57.30750127 -32 64 C-35.21684271 60.96803331 -37.02331611 57.95336778 -39 54 C-38.67 53.01 -38.34 52.02 -38 51 C-36.35 53.97 -34.7 56.94 -33 60 C-30.97165435 57.29553913 -29.38762326 55.05401411 -27.84375 52.13671875 C-27.26947266 51.05293945 -27.26947266 51.05293945 -26.68359375 49.94726562 C-26.29300781 49.20154297 -25.90242187 48.45582031 -25.5 47.6875 C-25.10941406 46.95337891 -24.71882812 46.21925781 -24.31640625 45.46289062 C-21.98984691 41.04869471 -19.91521396 36.60702383 -18 32 C-16.61267542 29.22535085 -15.04444302 26.5655178 -13.5 23.875 C-8.95391953 15.94251051 -4.4734933 7.9735876 0 0 Z ",
    fill: "#515873",
    transform: "translate(923,579)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.08667969 0.29197266 1.08667969 0.29197266 2.1953125 0.58984375 C2.74960937 0.74582031 3.30390625 0.90179687 3.875 1.0625 C3.875 1.3925 3.875 1.7225 3.875 2.0625 C-20.545 2.0625 -44.965 2.0625 -70.125 2.0625 C-70.455 1.4025 -70.785 0.7425 -71.125 0.0625 C-70.31511627 0.06472061 -69.50523254 0.06694122 -68.67080688 0.06922913 C-61.04846733 0.08924377 -53.42614046 0.10448014 -45.80378151 0.11431217 C-41.8848013 0.11953678 -37.96584274 0.1266268 -34.046875 0.13793945 C-30.26677614 0.14878329 -26.48669814 0.15478002 -22.70658493 0.15737724 C-21.26245164 0.15922878 -19.81831953 0.16284424 -18.3741951 0.16823006 C-16.35575723 0.1754602 -14.33729847 0.17590823 -12.31884766 0.17602539 C-11.16857086 0.178246 -10.01829407 0.18046661 -8.8331604 0.18275452 C-0.657498 -0.18028171 -0.657498 -0.18028171 0 0 Z ",
    fill: "#9C2F60",
    transform: "translate(486.125,569.9375)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C17.45760962 -0.966798 33.7244488 -0.01518797 50 7 C50.66 7.66 51.32 8.32 52 9 C45.09634708 7.73875572 38.31607943 6.11791684 31.53515625 4.32128906 C28.20030865 3.45820962 25.47594671 3 22 3 C25.63 3.99 29.26 4.98 33 6 C33 6.33 33 6.66 33 7 C25.67849106 6.33020896 18.62089577 4.98329403 11.4375 3.4375 C10.33341797 3.20353516 9.22933594 2.96957031 8.09179688 2.72851562 C5.39368745 2.15618938 2.69648125 1.57993998 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#6B648A",
    transform: "translate(472,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C3.32586558 45.51120163 3.32586558 45.51120163 -3 55 C-5.7676427 50.84853596 -4.67699071 47.70788038 -4 43 C-3.73073387 40.88441197 -3.4701767 38.76784207 -3.20996094 36.65112305 C-2.81388223 33.43316098 -2.40652238 30.2166577 -2 27 C-1.34 27 -0.68 27 0 27 C0 18.09 0 9.18 0 0 Z ",
    fill: "#7E7CB3",
    transform: "translate(636,253)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C1.99 1.67 2.98 1.34 4 1 C1.53882161 10.39722658 -6.1507623 16.76717487 -14 22 C-14 21.34 -14 20.68 -14 20 C-14.66 20 -15.32 20 -16 20 C-14.57731655 16.71911777 -12.8482212 14.6870912 -10.25 12.25 C-6.35263177 8.46642354 -3.1167288 4.43897738 0 0 Z ",
    fill: "#7976A8",
    transform: "translate(626,368)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.99 1.98 1.98 3 3 C1.38805488 8.84330104 -0.89739543 13.97669563 -3.875 19.25 C-4.20242188 19.83990723 -4.52984375 20.42981445 -4.8671875 21.03759766 C-7.1615055 25.0022419 -9.67506289 27.91835097 -13 31 C-13.72265625 28.875 -13.72265625 28.875 -14 26 C-12.55859375 23.125 -12.55859375 23.125 -10.4375 20 C-6.22810026 13.60130336 -3.04209311 7.04060186 0 0 Z ",
    fill: "#8783BF",
    transform: "translate(624,325)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.30429347 3.78754289 8.02867791 7.3981235 10.390625 13.45703125 C10.390625 14.11703125 10.390625 14.77703125 10.390625 15.45703125 C9.400625 15.12703125 8.410625 14.79703125 7.390625 14.45703125 C7.266875 13.67328125 7.143125 12.88953125 7.015625 12.08203125 C6.59944507 9.31645303 6.59944507 9.31645303 4.390625 7.45703125 C3.689375 6.67328125 2.988125 5.88953125 2.265625 5.08203125 C-6.79738903 -3.1928946 -17.45104186 -3.30671637 -29.125 -2.78271484 C-36.47035352 -2.07387668 -43.41644576 0.77913368 -49.90234375 4.1875 C-51.24232422 4.81591797 -51.24232422 4.81591797 -52.609375 5.45703125 C-53.269375 5.12703125 -53.929375 4.79703125 -54.609375 4.45703125 C-53.609375 2.45703125 -53.609375 2.45703125 -51.64746094 1.60327148 C-50.80473633 1.32684814 -49.96201172 1.0504248 -49.09375 0.765625 C-48.17207031 0.46076172 -47.25039063 0.15589844 -46.30078125 -0.15820312 C-45.33011719 -0.47080078 -44.35945313 -0.78339844 -43.359375 -1.10546875 C-42.40417969 -1.42193359 -41.44898438 -1.73839844 -40.46484375 -2.06445312 C-26.55563857 -6.62024981 -13.09618388 -7.74400095 0 0 Z ",
    fill: "#BC407A",
    transform: "translate(478.609375,290.54296875)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.54625 2.721875 0.0925 3.44375 -0.375 4.1875 C-2.28170223 7.48756155 -2.63111435 10.2373664 -3 14 C-0.69 10.37 1.62 6.74 4 3 C4.33 3.66 4.66 4.32 5 5 C1.45680891 12.5756094 -4.01013623 19.33840522 -9 26 C-9 25.01 -9 24.02 -9 23 C-9.99 22.67 -10.98 22.34 -12 22 C-12.99 22.66 -13.98 23.32 -15 24 C-13.15018787 19.89279001 -10.57992991 16.27870606 -8.0625 12.5625 C-5.27101109 8.43012122 -2.51575356 4.30916204 0 0 Z ",
    fill: "#70729C",
    transform: "translate(671,370)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.763125 0.7425 1.52625 1.485 2.3125 2.25 C1.9825 2.91 1.6525 3.57 1.3125 4.25 C-1.125 3.4375 -1.125 3.4375 -3.6875 2.25 C-4.1825 0.765 -4.1825 0.765 -4.6875 -0.75 C-6.41527889 -1.73565461 -6.41527889 -1.73565461 -8.5 -2.375 C-9.18707031 -2.61476563 -9.87414062 -2.85453125 -10.58203125 -3.1015625 C-12.60433429 -3.72438681 -14.62940909 -4.25975812 -16.6875 -4.75 C-16.6875 -4.09 -16.6875 -3.43 -16.6875 -2.75 C-18.6675 -3.08 -20.6475 -3.41 -22.6875 -3.75 C-22.6875 -4.08 -22.6875 -4.41 -22.6875 -4.75 C-24.29157328 -4.77708567 -25.8957785 -4.79643483 -27.5 -4.8125 C-28.39332031 -4.82410156 -29.28664063 -4.83570313 -30.20703125 -4.84765625 C-32.82163791 -4.86009967 -32.82163791 -4.86009967 -35.6875 -3.75 C-36.0175 -4.08 -36.3475 -4.41 -36.6875 -4.75 C-37.6775 -4.255 -37.6775 -4.255 -38.6875 -3.75 C-38.6875 -4.41 -38.6875 -5.07 -38.6875 -5.75 C-41.3275 -5.09 -43.9675 -4.43 -46.6875 -3.75 C-46.6875 -4.41 -46.6875 -5.07 -46.6875 -5.75 C-50.81723628 -5.18260132 -50.81723628 -5.18260132 -54.6875 -3.75 C-54.6875 -4.41 -54.6875 -5.07 -54.6875 -5.75 C-56.6675 -5.75 -58.6475 -5.75 -60.6875 -5.75 C-60.6875 -6.08 -60.6875 -6.41 -60.6875 -6.75 C-10.89078887 -8.89456539 -10.89078887 -8.89456539 0 0 Z ",
    fill: "#62668A",
    transform: "translate(614.6875,610.75)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C2.051875 1.649375 3.10375 1.29875 4.1875 0.9375 C7.88859572 0.02739449 9.43467379 0.10866845 13 1 C13.99 0.67 14.98 0.34 16 0 C18.97626501 0.93008282 19.96286685 1.94878187 21.8125 4.5 C22.4003125 5.7375 22.4003125 5.7375 23 7 C22.67 7.66 22.34 8.32 22 9 C21.68248779 8.1850708 21.36497559 7.3701416 21.0378418 6.53051758 C19.13102863 3.5769617 19.13102863 3.5769617 15.17114258 3.43237305 C13.57871934 3.43316376 11.98615838 3.46136542 10.39453125 3.51171875 C9.13572395 3.52233086 9.13572395 3.52233086 7.85148621 3.53315735 C5.17091741 3.56114833 2.49243733 3.62389199 -0.1875 3.6875 C-2.00452712 3.71257695 -3.82158699 3.73539118 -5.63867188 3.75585938 C-10.09325278 3.81099001 -14.54627229 3.89729217 -19 4 C-18.66154053 4.59538574 -18.32308105 5.19077148 -17.97436523 5.80419922 C-16.4537536 8.48985267 -14.94551172 11.18225312 -13.4375 13.875 C-12.90447266 14.81214844 -12.37144531 15.74929688 -11.82226562 16.71484375 C-11.32275391 17.61074219 -10.82324219 18.50664063 -10.30859375 19.4296875 C-9.60947876 20.67081299 -9.60947876 20.67081299 -8.89624023 21.93701172 C-8.60048096 22.61779785 -8.30472168 23.29858398 -8 24 C-8.33 24.66 -8.66 25.32 -9 26 C-9.33773437 25.4946875 -9.67546875 24.989375 -10.0234375 24.46875 C-10.46945312 23.8190625 -10.91546875 23.169375 -11.375 22.5 C-11.81585937 21.8503125 -12.25671875 21.200625 -12.7109375 20.53125 C-13.13632812 20.0259375 -13.56171875 19.520625 -14 19 C-14.66 19 -15.32 19 -16 19 C-16.061875 18.05125 -16.12375 17.1025 -16.1875 16.125 C-16.89171763 10.92872751 -19.52049381 6.54728625 -22 2 C-17.57576535 0.88523221 -13.27758596 0.9185686 -8.75 1 C-6.16031188 1.0455931 -3.59104894 1.04732509 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#545977",
    transform: "translate(834,569)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.17604565 3.31431047 -2.6919487 6.27355828 -4.4375 9.3125 C-9.67837432 18.61930336 -11.20936926 27.1275382 -11.25 37.75 C-11.25394775 38.63872803 -11.25789551 39.52745605 -11.26196289 40.44311523 C-11.21189245 46.07216889 -10.70226322 50.95399307 -8.55859375 56.22265625 C-8 58 -8 58 -9 61 C-13.59225513 49.47835991 -13.59225513 49.47835991 -13 44 C-13.66 43.67 -14.32 43.34 -15 43 C-13.98627242 29.92745328 -12.35962843 16.71820424 -6 5 C-6.66 4.67 -7.32 4.34 -8 4 C-3.375 0 -3.375 0 0 0 Z ",
    fill: "#9F4176",
    transform: "translate(479,326)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.21003415 0.76594334 4.41795739 1.53797883 6.625 2.3125 C7.85476563 2.74175781 9.08453125 3.17101562 10.3515625 3.61328125 C13.70138291 4.88649993 16.82925245 6.33657706 20 8 C20 8.66 20 9.32 20 10 C20.66 10 21.32 10 22 10 C21.67 11.32 21.34 12.64 21 14 C15.90117545 12.4719611 11.34334341 10.28963144 6.625 7.875 C5.88894531 7.50246094 5.15289062 7.12992187 4.39453125 6.74609375 C2.59449642 5.8343878 0.79698598 4.91770068 -1 4 C-1 1 -1 1 0 0 Z ",
    fill: "#E33783",
    transform: "translate(441,480)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.73363368 2.43074079 4.23470824 5.021879 5.91796875 8.25390625 C6.44970703 9.27291016 6.98144531 10.29191406 7.52929688 11.34179688 C8.07650391 12.40462891 8.62371094 13.46746094 9.1875 14.5625 C9.74630859 15.62919922 10.30511719 16.69589844 10.88085938 17.79492188 C15 25.73646406 15 25.73646406 15 28 C28.53 28 42.06 28 56 28 C54.68 25.69 53.36 23.38 52 21 C52.33 20.34 52.66 19.68 53 19 C54.0055761 20.45449401 55.00430435 21.91372443 56 23.375 C56.556875 24.18710937 57.11375 24.99921875 57.6875 25.8359375 C59 28 59 28 59 30 C53.55566741 30.02479204 48.11136797 30.04290359 42.66699219 30.05493164 C40.81640042 30.05994811 38.9658126 30.06676282 37.11523438 30.07543945 C34.44920883 30.0876229 31.78323588 30.09325528 29.1171875 30.09765625 C28.29507782 30.10281754 27.47296814 30.10797882 26.62594604 30.11329651 C17.42497709 30.11418707 17.42497709 30.11418707 14 29 C12.03369141 26.43969727 12.03369141 26.43969727 10.3515625 23.06640625 C9.89818008 22.17670387 9.89818008 22.17670387 9.43563843 21.26902771 C8.47805072 19.3764491 7.55203012 17.47020002 6.625 15.5625 C5.9797712 14.28224044 5.33265532 13.00293008 4.68359375 11.72460938 C0 2.40297319 0 2.40297319 0 0 Z ",
    fill: "#484D60",
    transform: "translate(913,741)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.13950006 2.87886232 5.08095648 5.63665399 7.015625 9.421875 C7.54414062 10.44667969 8.07265625 11.47148438 8.6171875 12.52734375 C9.15601563 13.59082031 9.69484375 14.65429688 10.25 15.75 C10.80429687 16.82894531 11.35859375 17.90789062 11.9296875 19.01953125 C13.29332327 21.6762699 14.64979184 24.33641908 16 27 C16.33 26.34 16.66 25.68 17 25 C15.89719046 22.60666866 14.75010537 20.31432147 13.5 18 C12.24989463 15.68567853 11.10280954 13.39333134 10 11 C10.33 10.34 10.66 9.68 11 9 C12.65642764 12.05688229 14.29821792 15.12139395 15.9375 18.1875 C16.40607422 19.05181641 16.87464844 19.91613281 17.35742188 20.80664062 C17.80537109 21.64775391 18.25332031 22.48886719 18.71484375 23.35546875 C19.12855225 24.12528076 19.54226074 24.89509277 19.96850586 25.68823242 C21.05434833 28.12180458 21.5759133 30.37634398 22 33 C21.34 33 20.68 33 20 33 C20 34.98 20 36.96 20 39 C17.6992808 36.11981875 16.05885451 33.27145174 14.51171875 29.9296875 C13.82239258 28.46015625 13.82239258 28.46015625 13.11914062 26.9609375 C12.17573646 24.927406 11.23301156 22.89355922 10.29101562 20.859375 C7.53985595 14.99737691 4.58023421 9.43736719 1.11254883 3.96533203 C0 2 0 2 0 0 Z ",
    fill: "#5A5874",
    transform: "translate(684,111)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.15120944 5.65824341 -0.32427513 8.15966714 -4 11 C-6.875 11.875 -6.875 11.875 -9 12 C-9.04125 12.556875 -9.0825 13.11375 -9.125 13.6875 C-10.48977108 17.294395 -12.91080176 18.73038496 -16 21 C-16.66 21 -17.32 21 -18 21 C-17.6021079 14.43478037 -12.85389433 10.68199258 -8.26171875 6.515625 C-2.65836263 1.73607355 -2.65836263 1.73607355 0 0 Z ",
    fill: "#7679AA",
    transform: "translate(646,444)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.19975116 1.46837896 5.84834256 3.27839346 8.625 5.4375 C9.40101563 6.03433594 10.17703125 6.63117188 10.9765625 7.24609375 C13 9 13 9 15 12 C13.68 12 12.36 12 11 12 C15.95 16.95 20.9 21.9 26 27 C25.67 27.66 25.34 28.32 25 29 C24.51233154 28.49662109 24.02466309 27.99324219 23.5222168 27.47460938 C11.52185434 14.93566753 11.52185434 14.93566753 -2.12890625 4.3125 C-4 3 -4 3 -5 1 C-3.02 1.66 -1.04 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#735882",
    transform: "translate(564,122)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.77691131 0.70659057 3.52244294 1.49260327 5.25 2.3125 C12.04113432 5.27950043 18.66640964 6.27315007 26 7 C26 7.33 26 7.66 26 8 C22.04 8 18.08 8 14 8 C14.33 8.99 14.66 9.98 15 11 C8.92218211 10.4714941 3.45399675 8.76879145 -2 6 C-2.33 5.34 -2.66 4.68 -3 4 C-2.67 3.01 -2.34 2.02 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#CA4A91",
    transform: "translate(506,333)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 1.98 4.62 3.96 7 6 C7 5.01 7 4.02 7 3 C7.33 2.34 7.66 1.68 8 1 C13.03409271 7.12012793 17.73796376 13.31635226 22 20 C21.67 20.66 21.34 21.32 21 22 C18.69 18.7 16.38 15.4 14 12 C13.01 12.495 13.01 12.495 12 13 C12.58910156 13.91523438 13.17820312 14.83046875 13.78515625 15.7734375 C14.54469218 16.97369181 15.30378391 18.17422729 16.0625 19.375 C16.45244141 19.97828125 16.84238281 20.5815625 17.24414062 21.203125 C18.22460432 22.76492557 19.11916075 24.37992214 20 26 C19.67 26.66 19.34 27.32 19 28 C18.3709375 27.03320312 17.741875 26.06640625 17.09375 25.0703125 C12.51707917 18.09172005 7.89300255 11.3382002 2.49609375 4.953125 C1 3 1 3 0 0 Z ",
    fill: "#72658F",
    transform: "translate(590,151)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.05614455 3.64020773 5.54314518 7.35878064 7.875 11.5 C8.51179687 12.6034375 9.14859375 13.706875 9.8046875 14.84375 C11 18 11 18 10.22900391 20.40332031 C9.05758801 22.87832617 7.84048444 25.29826806 6.53125 27.703125 C6.04688477 28.59370605 5.56251953 29.48428711 5.06347656 30.40185547 C4.5475293 31.34174316 4.03158203 32.28163086 3.5 33.25 C2.97116211 34.21695801 2.44232422 35.18391602 1.89746094 36.18017578 C-2.89226026 44.89253818 -7.88848579 53.47327054 -13 62 C-13.33 61.34 -13.66 60.68 -14 60 C-13.06298828 57.82373047 -13.06298828 57.82373047 -11.5703125 55.1171875 C-11.02592529 54.12178955 -10.48153809 53.1263916 -9.9206543 52.10083008 C-9.32808838 51.03630615 -8.73552246 49.97178223 -8.125 48.875 C-7.53307861 47.79436279 -6.94115723 46.71372559 -6.33129883 45.6003418 C-3.64677888 40.71341829 -0.92910519 35.84896442 1.87109375 31.02734375 C2.2882666 30.30498535 2.70543945 29.58262695 3.13525391 28.83837891 C3.89937811 27.52342606 4.67327138 26.21408374 5.45849609 24.91162109 C7.4697237 21.46039647 8.44583008 19.01247076 8 15 C7.360625 14.87625 6.72125 14.7525 6.0625 14.625 C5.381875 14.41875 4.70125 14.2125 4 14 C3.67 13.34 3.34 12.68 3 12 C3.66 12 4.32 12 5 12 C4.6390625 11.38511719 4.278125 10.77023437 3.90625 10.13671875 C3.4421875 9.32847656 2.978125 8.52023437 2.5 7.6875 C2.0359375 6.88699219 1.571875 6.08648438 1.09375 5.26171875 C0 3 0 3 0 0 Z ",
    fill: "#535A78",
    transform: "translate(856,649)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C17.02 0.99 17.02 0.99 15 2 C17.475 2.495 17.475 2.495 20 3 C20 3.33 20 3.66 20 4 C16.12577792 4.50615271 12.25051183 5.00382721 8.375 5.5 C7.28058594 5.64308594 6.18617188 5.78617187 5.05859375 5.93359375 C3.46337891 6.13662109 3.46337891 6.13662109 1.8359375 6.34375 C0.86188965 6.46943359 -0.1121582 6.59511719 -1.11572266 6.72460938 C-4.09489105 7.00906019 -7.00915797 7.04655007 -10 7 C-9.67 6.34 -9.34 5.68 -9 5 C-6.35139573 4.40644386 -3.70802678 4.25790731 -1 4 C-3.64 3.67 -6.28 3.34 -9 3 C-9 2.67 -9 2.34 -9 2 C-4.545 1.505 -4.545 1.505 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#966EAC",
    transform: "translate(545,455)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.73355967 1.32423416 5.32006615 2.76584806 7.890625 4.3828125 C8.59960938 4.82753906 9.30859375 5.27226562 10.0390625 5.73046875 C10.76867187 6.19066406 11.49828125 6.65085937 12.25 7.125 C13.36761719 7.82689453 13.36761719 7.82689453 14.5078125 8.54296875 C16.33956503 9.69368508 18.1699207 10.84662444 20 12 C17 13 17 13 14.87890625 12.1875 C13.33669726 11.39689033 11.79502841 10.60522612 10.25390625 9.8125 C7.74092814 8.67011183 7.74092814 8.67011183 4 10 C6.64 11.65 9.28 13.3 12 15 C11.01 15.495 11.01 15.495 10 16 C7.46875 14.671875 7.46875 14.671875 4.5 12.75 C3.5203125 12.12609375 2.540625 11.5021875 1.53125 10.859375 C-1 9 -1 9 -3 6 C-2.34 6 -1.68 6 -1 6 C-1.0309375 4.7934375 -1.0309375 4.7934375 -1.0625 3.5625 C-1 1 -1 1 0 0 Z ",
    fill: "#B54381",
    transform: "translate(465,432)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.5775 0.226875 1.155 0.45375 1.75 0.6875 C0.37416087 5.19024624 -1.44316721 6.98537482 -5.25 9.6875 C-7.64402865 10.88317087 -9.97667282 11.97401249 -12.4375 13 C-13.06591797 13.27650391 -13.69433594 13.55300781 -14.34179688 13.83789062 C-15.95111786 14.52120659 -17.59902743 15.11206596 -19.25 15.6875 C-19.91 15.3575 -20.57 15.0275 -21.25 14.6875 C-19.93 13.6975 -18.61 12.7075 -17.25 11.6875 C-17.91 11.3575 -18.57 11.0275 -19.25 10.6875 C-18.35796875 10.14480469 -17.4659375 9.60210937 -16.546875 9.04296875 C-15.36451896 8.32041783 -14.18223087 7.5977557 -13 6.875 C-12.41347656 6.51857422 -11.82695313 6.16214844 -11.22265625 5.79492188 C-8.71333827 4.25831705 -6.28951735 2.71835602 -3.96875 0.90625 C-2.25 -0.3125 -2.25 -0.3125 0 0 Z ",
    fill: "#7A7AAE",
    transform: "translate(621.25,430.3125)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.7566045 1.35902986 7.45189927 3.87223558 10 8 C11.37339037 10.97220044 12.60056939 13.97271951 13.7890625 17.0234375 C14.85600725 19.64605653 16.06040538 22.03232037 17.4375 24.5 C17.953125 25.655 18.46875 26.81 19 28 C18.09765625 30.21875 18.09765625 30.21875 17 32 C16.73372803 31.45174561 16.46745605 30.90349121 16.19311523 30.33862305 C9.32846931 16.20900693 9.32846931 16.20900693 1.1796875 2.80078125 C0 1 0 1 0 0 Z ",
    fill: "#878CC7",
    transform: "translate(683,108)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-5.85267086 6.6599358 -13.52609866 11.46656558 -22 14 C-21.67 13.01 -21.34 12.02 -21 11 C-22.65 11.33 -24.3 11.66 -26 12 C-22.15175698 8.95044893 -17.98649581 6.7840857 -13.65625 4.5 C-11.00711545 3.09547377 -11.00711545 3.09547377 -8.890625 1.32421875 C-6.02283499 -0.6844193 -3.39494425 -0.19586217 0 0 Z ",
    fill: "#8B7DB9",
    transform: "translate(604,396)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.98 0.99 -1.98 0.99 -4 2 C-2.35 1.67 -0.7 1.34 1 1 C1 1.66 1 2.32 1 3 C-9.5447345 8.77511131 -21.37208612 7.3810989 -33 7 C-33 6.34 -33 5.68 -33 5 C-27.72 5 -22.44 5 -17 5 C-17 4.34 -17 3.68 -17 3 C-14.73194205 2.30190555 -12.46133393 1.61628983 -10.1875 0.9375 C-9.54490234 0.73833984 -8.90230469 0.53917969 -8.24023438 0.33398438 C-3.33984375 -1.11328125 -3.33984375 -1.11328125 0 0 Z ",
    fill: "#A65D9C",
    transform: "translate(561,367)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.02929984 4.31248547 3.04689903 8.62494493 3.0625 12.9375 C3.07087891 14.14986328 3.07925781 15.36222656 3.08789062 16.61132812 C3.10565466 23.16625712 2.88995726 29.50401275 2 36 C1.01 36 0.02 36 -1 36 C-1.15130716 23.96267515 -0.68944522 12.01604528 0 0 Z ",
    fill: "#898FCD",
    transform: "translate(703,244)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.84315795 -0.36855661 10.04994552 0.81146003 15.4375 3 C16.16904297 3.28617187 16.90058594 3.57234375 17.65429688 3.8671875 C19.44035954 4.56760423 21.22079656 5.28233811 23 6 C22.34 7.32 21.68 8.64 21 10 C13.49247403 8.76925804 7.37621897 6.19008675 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#CD4C95",
    transform: "translate(490,408)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C-1.24261858 4.06568704 -4.49486526 5.09824262 -7.75 6.125 C-8.67039062 6.42792969 -9.59078125 6.73085938 -10.5390625 7.04296875 C-11.42851563 7.32011719 -12.31796875 7.59726562 -13.234375 7.8828125 C-14.05131836 8.14465332 -14.86826172 8.40649414 -15.70996094 8.67626953 C-18.47828326 9.06761232 -19.67020396 8.46430956 -22 7 C-21.67 6.01 -21.34 5.02 -21 4 C-18.57405008 3.10559923 -16.3100728 2.42091347 -13.8125 1.8125 C-12.8215332 1.54663086 -12.8215332 1.54663086 -11.81054688 1.27539062 C-7.81552997 0.25395985 -4.11513098 -0.46942976 0 0 Z ",
    fill: "#926BA7",
    transform: "translate(574,411)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.67825581 3.33374617 13.96738243 10.45759716 19 17 C15.05860922 15.33248852 12.2107188 12.77289351 9 10 C8.77706675 12.18829043 8.77706675 12.18829043 10.75 13.9453125 C11.4925 14.66460937 12.235 15.38390625 13 16.125 C14.11375 17.21167969 14.11375 17.21167969 15.25 18.3203125 C15.8275 18.87460938 16.405 19.42890625 17 20 C14 20 14 20 11.0390625 17.33203125 C9.8933646 16.16635025 8.75563773 14.99279412 7.625 13.8125 C7.06039062 13.23435547 6.49578125 12.65621094 5.9140625 12.06054688 C4.80084469 10.92027169 3.6904246 9.77725754 2.58300781 8.63134766 C0.41346043 6.39554945 -1.79091266 4.19667674 -4 2 C-2.02 2.66 -0.04 3.32 2 4 C1.34 2.68 0.68 1.36 0 0 Z ",
    fill: "#6B688F",
    transform: "translate(614,60)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.76660902 1.60159203 17.37072413 3.79450269 26 6 C26 6.66 26 7.32 26 8 C26.66 8.33 27.32 8.66 28 9 C22.29485843 11.64247965 18.06663286 10.63409745 12.1875 9.3125 C11.33607422 9.13783203 10.48464844 8.96316406 9.60742188 8.78320312 C3.92403619 7.57553777 -1.52981272 5.95274989 -7 4 C-2.94448738 2.64816246 0.12382469 3.8341697 4.125 4.875 C10.09379073 6.36230523 15.84827225 7.55260162 22 8 C20.83082031 7.66226562 19.66164063 7.32453125 18.45703125 6.9765625 C16.90881606 6.52617263 15.36064109 6.0756445 13.8125 5.625 C13.04357422 5.40328125 12.27464844 5.1815625 11.48242188 4.953125 C7.56591221 3.8101093 3.75643949 2.61097806 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#874C7B",
    transform: "translate(488,468)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3.37393582 7.35690901 2.24860247 12.79359694 0.65625 18.94921875 C0.05349689 21.75130313 -0.12697417 24.14837175 0 27 C-1.65 26.67 -3.3 26.34 -5 26 C-4.83564453 25.195625 -4.83564453 25.195625 -4.66796875 24.375 C-3.02745157 16.26577686 -1.51370171 8.13362385 0 0 Z ",
    fill: "#8387C2",
    transform: "translate(657,292)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.505 1.45375 1.01 1.9075 0.5 2.375 C-1.22609337 3.87635519 -1.22609337 3.87635519 -1 6 C0.32 6.33 1.64 6.66 3 7 C1.75160501 8.105981 0.50120766 9.20970201 -0.75 10.3125 C-1.44609375 10.92738281 -2.1421875 11.54226563 -2.859375 12.17578125 C-4.85114506 13.87314734 -6.88898915 15.45477809 -9 17 C-9.66 16.67 -10.32 16.34 -11 16 C-11 15.01 -11 14.02 -11 13 C-11.66 12.34 -12.32 11.68 -13 11 C-12.22914063 10.37351562 -11.45828125 9.74703125 -10.6640625 9.1015625 C-9.15972656 7.87566406 -9.15972656 7.87566406 -7.625 6.625 C-6.62726562 5.81289063 -5.62953125 5.00078125 -4.6015625 4.1640625 C-2.03639494 2.09734084 -2.03639494 2.09734084 0 0 Z ",
    fill: "#7879AA",
    transform: "translate(632,418)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.125 1.625 1.125 1.625 2 4 C0.71831423 9.13428239 -1.77100296 13.34409431 -4.5 17.8125 C-5.10521484 18.8324707 -5.10521484 18.8324707 -5.72265625 19.87304688 C-8.74251116 24.87125558 -8.74251116 24.87125558 -11 26 C-11.765625 23.96484375 -11.765625 23.96484375 -12 21 C-10.68290624 18.345415 -9.36315329 16.02145554 -7.75 13.5625 C-6.93026522 12.27342181 -6.11252602 10.98307226 -5.296875 9.69140625 C-4.90435547 9.07410645 -4.51183594 8.45680664 -4.10742188 7.82080078 C-2.57044615 5.2937362 -1.27052689 2.6689315 0 0 Z ",
    fill: "#8487C2",
    transform: "translate(663,348)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-2.11481699 8.00714706 -5.94971465 13.48132364 -11 18 C-11.928125 18.928125 -12.85625 19.85625 -13.8125 20.8125 C-14.534375 21.534375 -15.25625 22.25625 -16 23 C-16.66 22.67 -17.32 22.34 -18 22 C-15.65024537 15.8544879 -12.72695924 10.39766511 -9 5 C-7 8 -7 8 -7 11 C-4.69 7.37 -2.38 3.74 0 0 Z ",
    fill: "#6F6F9A",
    transform: "translate(660,362)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.37048699 4.11146096 -0.16677604 6.68719001 -1.75 10.5 C-2.01554688 11.17675781 -2.28109375 11.85351562 -2.5546875 12.55078125 C-3.95204681 15.98991315 -5.23919427 18.52235383 -8 21 C-9.20049407 24.10007201 -9.20049407 24.10007201 -10 27 C-10.33 26.34 -10.66 25.68 -11 25 C-11.66 25 -12.32 25 -13 25 C-11.44991147 20.10295415 -9.58362009 15.40344688 -7.5625 10.6875 C-7.26279297 9.95982422 -6.96308594 9.23214844 -6.65429688 8.48242188 C-5.85280995 6.61692194 -4.93371136 4.80295712 -4 3 C-3.01 2.67 -2.02 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#8586C1",
    transform: "translate(651,327)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.07647339 2.27453701 -3.86928093 3.53810864 -6.6875 4.75 C-15.08058208 8.83103991 -20.27422428 15.10580646 -25 23 C-25.33 22.34 -25.66 21.68 -26 21 C-21.73735386 13.67032799 -16.4828363 8.41944616 -10 3 C-13.95828576 3.71028473 -17.42242453 4.87020764 -21.1328125 6.37890625 C-23 7 -23 7 -26 7 C-17.10588749 0.70904237 -10.93202971 -0.44385685 0 0 Z ",
    fill: "#AC437A",
    transform: "translate(480,317)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 6.8993135 0 6.8993135 -2.70703125 9.87890625 C-3.40183594 10.43449219 -4.09664062 10.99007813 -4.8125 11.5625 C-5.53050781 12.15289062 -6.24851562 12.74328125 -6.98828125 13.3515625 C-7.65214844 13.89554687 -8.31601562 14.43953125 -9 15 C-10.35010281 16.31635024 -11.69414946 17.63973902 -13 19 C-15 18 -15 18 -16 15 C-13.89888324 12.87190742 -11.79429065 10.74746285 -9.6875 8.625 C-9.09259766 8.02171875 -8.49769531 7.4184375 -7.88476562 6.796875 C-7.30791016 6.21679688 -6.73105469 5.63671875 -6.13671875 5.0390625 C-5.60780029 4.50490723 -5.07888184 3.97075195 -4.53393555 3.42041016 C-3 2 -3 2 0 0 Z ",
    fill: "#8C7EB9",
    transform: "translate(606,359)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.59128562 9.68518048 0.38135792 17.69293749 -2 26 C-2.99 26 -3.98 26 -5 26 C-5.33 26.66 -5.66 27.32 -6 28 C-5.26409139 21.90126313 -3.89274619 16.02615597 -2.4375 10.0625 C-2.08655273 8.6074707 -2.08655273 8.6074707 -1.72851562 7.12304688 C-1.15522471 4.74798449 -0.57898512 2.37367947 0 0 Z ",
    fill: "#868AC6",
    transform: "translate(679,297)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 23.1 1 46.2 1 70 C0.34 69.67 -0.32 69.34 -1 69 C-1.14285714 60.42857143 -1.14285714 60.42857143 0 57 C-0.66 56.67 -1.32 56.34 -2 56 C-1.34 56 -0.68 56 0 56 C-0.15597656 55.28972656 -0.31195312 54.57945312 -0.47265625 53.84765625 C-0.66730469 52.92855469 -0.86195313 52.00945313 -1.0625 51.0625 C-1.25972656 50.14597656 -1.45695313 49.22945312 -1.66015625 48.28515625 C-1.77230469 47.53105469 -1.88445313 46.77695312 -2 46 C-1.505 45.505 -1.505 45.505 -1 45 C-0.92405299 42.7876635 -0.91699894 40.57291977 -0.9375 38.359375 C-0.94128662 37.68134827 -0.94507324 37.00332153 -0.94897461 36.30474854 C-0.96525386 33.40230783 -0.99285383 30.50000781 -1.02050781 27.59765625 C-1.10119317 18.34007329 -0.89523491 9.22811338 0 0 Z ",
    fill: "#7C6B95",
    transform: "translate(517,695)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 8.58 1 17.16 1 26 C1.33 25.01 1.66 24.02 2 23 C2.66 23 3.32 23 4 23 C4.33 25.31 4.66 27.62 5 30 C4.34 30.33 3.68 30.66 3 31 C3.52537724 36.0302076 4.10594786 41.01885239 5 46 C-1.18727142 39.81272858 -1.65979908 24.80780809 -2.05078125 16.640625 C-1.97187305 10.98351416 -1.12932446 5.5346232 0 0 Z ",
    fill: "#994371",
    transform: "translate(428,353)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.66 3.96 1.32 6 2 C5.67 1.34 5.34 0.68 5 0 C8.93673644 1.31224548 11.22719294 2.91910327 14 6 C13.01 6 12.02 6 11 6 C12.35931641 6.94359375 12.35931641 6.94359375 13.74609375 7.90625 C20.8769142 12.90115556 27.6637987 17.99904744 34 24 C29.94670595 24 28.26006475 21.93010933 25.375 19.375 C20.48892998 15.16281915 15.48919059 11.40995173 10 8 C9.34 8.66 8.68 9.32 8 10 C7.79375 9.2575 7.5875 8.515 7.375 7.75 C5.60629775 4.21259551 3.32763028 3.02551409 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#636180",
    transform: "translate(594,22)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -2 6 C-1.34 5.67 -0.68 5.34 0 5 C-1.58876339 8.78995513 -3.97389547 11.37175677 -6.8125 14.3125 C-8.09060547 15.66794922 -8.09060547 15.66794922 -9.39453125 17.05078125 C-12 19 -12 19 -14.82421875 18.79296875 C-15.54222656 18.53128906 -16.26023437 18.26960938 -17 18 C-11.72898586 11.58930713 -5.90871848 5.81409488 0 0 Z ",
    fill: "#8585C1",
    transform: "translate(638,387)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 6.6 1 13.2 1 20 C2.87824891 18.12175109 2.39102397 14.96064724 2.5625 12.4375 C2.64628906 11.23996094 2.73007812 10.04242188 2.81640625 8.80859375 C2.87699219 7.88175781 2.93757813 6.95492188 3 6 C3.33 6 3.66 6 4 6 C4.04898437 6.95519531 4.09796875 7.91039062 4.1484375 8.89453125 C4.60200704 16.73815629 5.35069728 24.29791643 7 32 C5.04783565 30.04783565 4.15173355 28.46800047 3 26 C2.67 27.65 2.34 29.3 2 31 C-1.85889002 27.14110998 -1.12905276 21.80953196 -1.13671875 16.64648438 C-1.13285156 15.75251953 -1.12898438 14.85855469 -1.125 13.9375 C-1.12886719 13.03966797 -1.13273437 12.14183594 -1.13671875 11.21679688 C-1.13542969 10.34990234 -1.13414062 9.48300781 -1.1328125 8.58984375 C-1.13168457 7.80472412 -1.13055664 7.01960449 -1.12939453 6.21069336 C-1.00121514 4.0207606 -0.60390331 2.10406629 0 0 Z ",
    fill: "#F13B8B",
    transform: "translate(468,350)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.67496701 1.43813676 4.87654355 3.00091819 6.61328125 6.5 C7.05607422 7.386875 7.49886719 8.27375 7.95507812 9.1875 C8.40302734 10.115625 8.85097656 11.04375 9.3125 12 C9.77978516 12.928125 10.24707031 13.85625 10.72851562 14.8125 C13.24071863 19.91854334 13.24071863 19.91854334 14 22 C13.67 22.66 13.34 23.32 13 24 C9.40496521 22.80165507 9.22672767 22.12681042 7.51953125 18.88671875 C7.07802734 18.05076172 6.63652344 17.21480469 6.18164062 16.35351562 C5.72982422 15.47373047 5.27800781 14.59394531 4.8125 13.6875 C4.34908203 12.81931641 3.88566406 11.95113281 3.40820312 11.05664062 C0 4.51630385 0 4.51630385 0 0 Z ",
    fill: "#8687C2",
    transform: "translate(631,161)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.15437819 6.23156729 3.1237242 14.19891561 3.0625 21.4375 C3.05798828 22.45521484 3.05347656 23.47292969 3.04882812 24.52148438 C3.03712437 27.01438509 3.02072848 29.50716074 3 32 C2.67 32 2.34 32 2 32 C1.67 26.06 1.34 20.12 1 14 C0.67 18.95 0.34 23.9 0 29 C-0.33 29 -0.66 29 -1 29 C-1.79681084 20.97497656 -2.12867289 13.06350113 -2 5 C-1.67 5 -1.34 5 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z ",
    fill: "#9F6CAB",
    transform: "translate(586,247)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.34391955 3.51587932 3.21805677 6.95024329 4.1875 11 C4.36893555 11.75659912 4.55037109 12.51319824 4.73730469 13.29272461 C6.08678922 19.38547889 6.22333391 24.84343912 5 31 C4.67 31 4.34 31 4 31 C3.1261303 27.15003113 2.27948625 23.29455636 1.4375 19.4375 C1.19064453 18.35146484 0.94378906 17.26542969 0.68945312 16.14648438 C-0.55152981 10.39601417 -1.37970215 5.75839761 0 0 Z ",
    fill: "#878DC8",
    transform: "translate(718,181)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.20532284 0.71019684 8.05398999 1.99272153 12.0625 3.4375 C13.87427734 4.08525391 13.87427734 4.08525391 15.72265625 4.74609375 C18.25947231 5.71667534 20.59330341 6.76211853 23 8 C24.99220557 8.68960962 26.99105606 9.36079057 29 10 C28.01 10.495 28.01 10.495 27 11 C27 11.99 27 12.98 27 14 C24.36 13.67 21.72 13.34 19 13 C19 12.34 19 11.68 19 11 C18.34 11 17.68 11 17 11 C17 10.01 17 9.02 17 8 C15.85660156 7.59007812 14.71320313 7.18015625 13.53515625 6.7578125 C12.04413369 6.21391748 10.55325567 5.66962611 9.0625 5.125 C8.30775391 4.85558594 7.55300781 4.58617187 6.77539062 4.30859375 C1.11328125 2.2265625 1.11328125 2.2265625 0 0 Z ",
    fill: "#A1528E",
    transform: "translate(485,445)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.58742071 4.78921775 7.77473688 11.17585975 10 18 C10.556875 19.051875 11.11375 20.10375 11.6875 21.1875 C13 24 13 24 12 27 C11.60167969 26.16855469 11.20335937 25.33710938 10.79296875 24.48046875 C10.26316406 23.39378906 9.73335937 22.30710938 9.1875 21.1875 C8.66542969 20.10855469 8.14335938 19.02960938 7.60546875 17.91796875 C6.21988301 15.39964139 5.13315617 13.85263152 3 12 C-0.00756286 8.99243714 -0.66976911 4.99069268 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#8280B3",
    transform: "translate(652,145)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-1.07378906 1.12117187 -2.14757812 1.24234375 -3.25390625 1.3671875 C-4.69013975 1.53615615 -6.12633572 1.70544404 -7.5625 1.875 C-8.61920898 1.99294922 -8.61920898 1.99294922 -9.69726562 2.11328125 C-14.30773009 2.66568713 -18.52844134 3.71090201 -23 5 C-25.63542402 5.47029341 -28.27990742 5.80681914 -30.9375 6.125 C-31.96327148 6.25455078 -31.96327148 6.25455078 -33.00976562 6.38671875 C-34.67257046 6.59602285 -36.33620513 6.79871722 -38 7 C-38 6.01 -38 5.02 -38 4 C-25.59708521 1.13544474 -12.73393028 -0.4950556 0 0 Z ",
    fill: "#B54279",
    transform: "translate(420,147)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.49361571 1.20381448 4.68143083 2.45428722 7 4 C7.33 3.34 7.66 2.68 8 2 C8.763125 2.165 9.52625 2.33 10.3125 2.5 C13.03596236 3.09145396 13.03596236 3.09145396 16 3 C18.09040891 3.94026425 20.15065696 4.94872617 22.1875 6 C23.27417969 6.556875 24.36085938 7.11375 25.48046875 7.6875 C26.31191406 8.120625 27.14335937 8.55375 28 9 C24.52128379 10.15957207 23.65780355 9.77456651 20.3125 8.5625 C19.50425781 8.27503906 18.69601562 7.98757813 17.86328125 7.69140625 C17.24839844 7.46324219 16.63351562 7.23507812 16 7 C15.67 7.99 15.34 8.98 15 10 C14.319375 9.566875 13.63875 9.13375 12.9375 8.6875 C9.96129275 6.88438339 9.96129275 6.88438339 6.375 5.5625 C3.06152944 4.02848585 1.80906887 3.08605865 0 0 Z ",
    fill: "#B34684",
    transform: "translate(472,418)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C2.11969736 6.2827463 2.1486682 12.44180917 2.125 18.8125 C2.12886719 19.84181641 2.13273438 20.87113281 2.13671875 21.93164062 C2.12860221 28.34776679 1.77615942 34.63071915 1 41 C0.67 41 0.34 41 0 41 C-0.79972813 27.21897068 -1.49059921 13.76142487 0 0 Z ",
    fill: "#77769F",
    transform: "translate(657,246)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.9948063 1.57567766 6.24195175 4.20135144 9.0625 7.375 C10.34833984 8.80972656 10.34833984 8.80972656 11.66015625 10.2734375 C12.43230469 11.17320312 13.20445312 12.07296875 14 13 C14.61746094 13.71414062 15.23492188 14.42828125 15.87109375 15.1640625 C16.24363281 15.76992187 16.61617187 16.37578125 17 17 C16.67 17.99 16.34 18.98 16 20 C14.68 18.35 13.36 16.7 12 15 C12 15.66 12 16.32 12 17 C11.34 17 10.68 17 10 17 C9.67 17.33 9.34 17.66 9 18 C6 15 3 12 0 9 C0.33 8.34 0.66 7.68 1 7 C1.8971875 7.99 1.8971875 7.99 2.8125 9 C4.87501834 11.3373846 4.87501834 11.3373846 8 11 C6.63629701 8.00779732 5.05091917 5.70973471 2.875 3.25 C2.33617187 2.63640625 1.79734375 2.0228125 1.2421875 1.390625 C0.83226562 0.93171875 0.42234375 0.4728125 0 0 Z ",
    fill: "#99497F",
    transform: "translate(521,213)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.98 0.99 -1.98 0.99 -4 2 C-1.69 2.33 0.62 2.66 3 3 C-0.74235319 5.44989101 -4.44225419 5.23086143 -8.75 5.125 C-9.44738281 5.11597656 -10.14476562 5.10695313 -10.86328125 5.09765625 C-12.57566958 5.07419888 -14.28788004 5.03833104 -16 5 C-16 4.34 -16 3.68 -16 3 C-19.63 2.67 -23.26 2.34 -27 2 C-27 1.67 -27 1.34 -27 1 C-23.62511542 0.83094103 -20.25007637 0.66518231 -16.875 0.5 C-15.44800781 0.42845703 -15.44800781 0.42845703 -13.9921875 0.35546875 C-9.32313191 0.12850077 -4.67636296 -0.06298132 0 0 Z ",
    fill: "#A764A6",
    transform: "translate(552,416)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.59783187 4.29632123 -2.20283715 6.58699523 -3.8125 8.875 C-4.26431641 9.52597656 -4.71613281 10.17695313 -5.18164062 10.84765625 C-5.62314453 11.47285156 -6.06464844 12.09804688 -6.51953125 12.7421875 C-6.92276611 13.3182373 -7.32600098 13.89428711 -7.74145508 14.48779297 C-9 16 -9 16 -12 18 C-11.67 16.02 -11.34 14.04 -11 12 C-11.99 12.495 -11.99 12.495 -13 13 C-12.9375 10.75 -12.9375 10.75 -12 8 C-9.7691525 6.32150176 -7.52594094 5.24000737 -5 4 C-5 4.99 -5 5.98 -5 7 C-3.35 4.69 -1.7 2.38 0 0 Z ",
    fill: "#77709F",
    transform: "translate(617,348)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.60328125 0.27714844 1.2065625 0.55429687 1.828125 0.83984375 C2.62734375 1.20207031 3.4265625 1.56429687 4.25 1.9375 C5.43335938 2.47697266 5.43335938 2.47697266 6.640625 3.02734375 C8.91611007 4.05617628 8.91611007 4.05617628 11.125 4.4140625 C13.60510315 5.18909474 14.31440178 6.30625696 15.75 8.4375 C16.17796875 9.05496094 16.6059375 9.67242187 17.046875 10.30859375 C18 12 18 12 18 14 C13.43769272 12.68875909 10.02620669 10.90819364 6.1875 8.125 C5.23230469 7.44695313 4.27710938 6.76890625 3.29296875 6.0703125 C0.9613095 3.9650665 0.309194 3.06445606 0 0 Z ",
    fill: "#7E7FB4",
    transform: "translate(578,35)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.42799852 4.4793089 -0.03519307 7.52186305 -1.8125 11.6875 C-2.12002197 12.42411865 -2.42754395 13.1607373 -2.74438477 13.91967773 C-6.40321196 22.3787573 -11.1405633 30.18774664 -16 38 C-17.55489094 34.89021812 -17.02645117 33.08431311 -16 29.8125 C-15.67 28.884375 -15.34 27.95625 -15 27 C-14.01 27 -13.02 27 -12 27 C-11.67 25.02 -11.34 23.04 -11 21 C-10.01 20.67 -9.02 20.34 -8 20 C-6.84045785 18.00252131 -6.84045785 18.00252131 -5.95703125 15.52734375 C-5.60576172 14.62822266 -5.25449219 13.72910156 -4.89257812 12.80273438 C-4.53615234 11.85720703 -4.17972656 10.91167969 -3.8125 9.9375 C-3.44447266 8.98810547 -3.07644531 8.03871094 -2.69726562 7.06054688 C-1.7880365 4.71072094 -0.88950026 2.35734961 0 0 Z ",
    fill: "#6B6A90",
    transform: "translate(653,325)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.91763541 0.60628382 8.76837016 2.74386159 13.0625 5.0625 C13.81402344 5.4651709 14.56554687 5.8678418 15.33984375 6.28271484 C25.2033657 11.6457945 34.266835 17.94289697 43 25 C39.34979643 25 38.5108335 24.14759703 35.625 22 C24.33904692 13.889748 12.31690499 7.37233887 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#6F597F",
    transform: "translate(541,78)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.87482078 2.44770455 3.89440249 4.83824337 5.125 8.375 C5.45757812 9.31085938 5.79015625 10.24671875 6.1328125 11.2109375 C6.93750152 13.79899138 7.52496007 16.33395959 8 19 C8.33 19 8.66 19 9 19 C9.22577402 24.4185766 8.46670113 28.77487721 7 34 C6.34 34 5.68 34 5 34 C4.34 35.32 3.68 36.64 3 38 C3.144375 37.34515625 3.28875 36.6903125 3.4375 36.015625 C5.59008774 25.43206863 6.1734801 16.49311337 1.97265625 6.375 C1.10359334 4.2529508 0.49146444 2.23486985 0 0 Z ",
    fill: "#A53F76",
    transform: "translate(498,258)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.99 2 3.98 2 5 2 C5 2.66 5 3.32 5 4 C5.59167969 4.17015625 6.18335938 4.3403125 6.79296875 4.515625 C11.63657645 6.00110338 15.22504826 7.46859353 19 11 C18.67 11.33 18.34 11.66 18 12 C18.99 12.99 19.98 13.98 21 15 C17 15 17 15 15.69921875 13.76171875 C15.13847656 13.18035156 14.57773437 12.59898438 14 12 C11.62056114 10.55128461 9.24606747 9.16231225 6.8125 7.8125 C6.15830078 7.44447266 5.50410156 7.07644531 4.83007812 6.69726562 C3.22253039 5.7937534 1.61159349 4.8962759 0 4 C0 2.66666667 0 1.33333333 0 0 Z ",
    fill: "#6F688C",
    transform: "translate(563,1)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C12.88 4.67 24.76 4.34 37 4 C36.67 4.99 36.34 5.98 36 7 C24.12 7 12.24 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#902B56",
    transform: "translate(299,764)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-1.89385437 3.50744423 -3.79018666 4.00564574 -5.6875 4.5 C-6.74324219 4.7784375 -7.79898438 5.056875 -8.88671875 5.34375 C-11.71142672 5.9391715 -14.12836708 6.12786492 -17 6 C-17 5.34 -17 4.68 -17 4 C-17.66 3.34 -18.32 2.68 -19 2 C-16.77376199 1.46678738 -14.54384996 0.94889881 -12.3125 0.4375 C-11.07113281 0.14746094 -9.82976563 -0.14257812 -8.55078125 -0.44140625 C-5.23888546 -0.96241956 -3.18139847 -0.91852996 0 0 Z ",
    fill: "#936AA6",
    transform: "translate(564,495)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.79557348 1.89778674 4.68611517 7.08616497 6.1875 10.875 C6.56841797 11.79925781 6.94933594 12.72351563 7.34179688 13.67578125 C7.69693359 14.56394531 8.05207031 15.45210937 8.41796875 16.3671875 C8.74563232 17.18300293 9.0732959 17.99881836 9.41088867 18.83935547 C10 21 10 21 9 24 C5.40516163 20.73179214 4.05574964 16.98770128 2.25 12.5625 C1.75693359 11.4168457 1.75693359 11.4168457 1.25390625 10.24804688 C0.94839844 9.50748047 0.64289062 8.76691406 0.328125 8.00390625 C0.0487207 7.33174072 -0.23068359 6.6595752 -0.51855469 5.96704102 C-1.0878409 3.64110845 -0.74864911 2.24688784 0 0 Z ",
    fill: "#868AC5",
    transform: "translate(704,143)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.85351562 0.4597168 1.85351562 0.4597168 3.90625 1.44921875 C4.65003906 1.80306641 5.39382813 2.15691406 6.16015625 2.52148438 C6.93230469 2.90626953 7.70445312 3.29105469 8.5 3.6875 C9.27214844 4.05294922 10.04429687 4.41839844 10.83984375 4.79492188 C14.43588363 6.53685107 17.27096592 8.02745375 20 11 C19.01 12.485 19.01 12.485 18 14 C17.48953125 13.63648438 16.9790625 13.27296875 16.453125 12.8984375 C10.25938562 8.61553261 3.78987019 5.23983654 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#C74D94",
    transform: "translate(514,158)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C3.62642278 2.60388898 3.28877098 3.74294757 1.29296875 5.51953125 C0.59816406 5.94621094 -0.09664062 6.37289063 -0.8125 6.8125 C-1.49957031 7.25207031 -2.18664062 7.69164062 -2.89453125 8.14453125 C-5.44197505 9.17957799 -6.4204096 8.72583617 -9 8 C-11.00812926 8.98357352 -13.00854609 9.98308736 -15 11 C-15.99 10.67 -16.98 10.34 -18 10 C-17.49025635 9.7326001 -16.9805127 9.4652002 -16.45532227 9.18969727 C-14.15670784 7.9825377 -11.85958995 6.77255777 -9.5625 5.5625 C-8.76005859 5.14162109 -7.95761719 4.72074219 -7.13085938 4.28710938 C-6.36708984 3.88427734 -5.60332031 3.48144531 -4.81640625 3.06640625 C-4.10943604 2.69459229 -3.40246582 2.32277832 -2.67407227 1.93969727 C-1.02071254 1.11087599 -1.02071254 1.11087599 0 0 Z ",
    fill: "#8983C0",
    transform: "translate(607,414)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.43152344 1.4125 0.86304688 1.825 0.27734375 2.25 C-5.22029215 6.3617544 -9.656411 10.70495817 -14 16 C-15.14328516 17.33551895 -16.28896782 18.66899074 -17.4375 20 C-18.283125 20.99 -19.12875 21.98 -20 23 C-20.73046875 21.29296875 -20.73046875 21.29296875 -21 19 C-15.87508075 11.00181066 -7.66227885 5.36748468 0 0 Z ",
    fill: "#C03D7B",
    transform: "translate(417,289)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C7.30698726 6.04211073 11.75608257 12.22108626 14 20 C13.34 20.33 12.68 20.66 12 21 C11.46890625 20.19175781 10.9378125 19.38351563 10.390625 18.55078125 C9.68421875 17.48214844 8.9778125 16.41351563 8.25 15.3125 C7.55390625 14.25675781 6.8578125 13.20101562 6.140625 12.11328125 C4.08085507 8.99995718 4.08085507 8.99995718 1.734375 6.35546875 C0 4 0 4 0 0 Z ",
    fill: "#8581BC",
    transform: "translate(613,134)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.1875 0.875 3.1875 0.875 6 2 C5.96447021 3.04978027 5.92894043 4.09956055 5.89233398 5.18115234 C5.76216101 9.0685228 5.63893206 12.95608749 5.51782227 16.84375 C5.46438576 18.5277307 5.40905512 20.21165239 5.35180664 21.89550781 C5.26994148 24.31302158 5.19484528 26.73066432 5.12109375 29.1484375 C5.08054115 30.28132706 5.08054115 30.28132706 5.03916931 31.43710327 C4.83711274 35.34429703 4.83711274 35.34429703 6 39 C2.04 38.505 2.04 38.505 -2 38 C-2 37.01 -2 36.02 -2 35 C-0.02 35 1.96 35 4 35 C4 24.44 4 13.88 4 3 C1.69 2.67 -0.62 2.34 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#B14B82",
    transform: "translate(490,569)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.44057094 3.15320949 5.89674158 6.66792588 8.3125 10.625 C8.68439453 11.21023437 9.05628906 11.79546875 9.43945312 12.3984375 C10.35989729 13.89308798 11.18825721 15.44363527 12 17 C11.67 17.66 11.34 18.32 11 19 C8 19 8 19 6 17.125 C2.64986044 11.89040693 1.47790976 5.98070026 0 0 Z ",
    fill: "#7C79AE",
    transform: "translate(623,144)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.2233881 2.2233881 -2.92305521 2.3605016 -5.9140625 2.8515625 C-6.67460938 2.98046875 -7.43515625 3.109375 -8.21875 3.2421875 C-9.0128125 3.36851562 -9.806875 3.49484375 -10.625 3.625 C-11.82769531 3.82609375 -11.82769531 3.82609375 -13.0546875 4.03125 C-15.03527484 4.36134789 -17.01749675 4.68161083 -19 5 C-18.18958827 9.55374212 -15.532833 11.32079411 -12 14 C-10.576875 15.1446875 -10.576875 15.1446875 -9.125 16.3125 C-8.42375 16.869375 -7.7225 17.42625 -7 18 C-11.60759354 17.51106471 -13.86881553 15.78017022 -17.25 12.6875 C-18.55710937 11.51767578 -18.55710937 11.51767578 -19.890625 10.32421875 C-21.93134521 8.0756474 -22.64787896 6.95917105 -23 4 C-19.18511977 2.3060793 -15.62423434 1.48207188 -11.5 0.875 C-10.3965625 0.70742188 -9.293125 0.53984375 -8.15625 0.3671875 C-5.39581369 0.04604763 -2.77414373 -0.07245898 0 0 Z ",
    fill: "#A8467D",
    transform: "translate(520,318)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.21942867 0.37230253 6.32715026 1.93195932 9.44140625 4.72265625 C11.74068309 6.60702599 14.30500566 7.78083589 17 9 C13.06411188 10.31196271 10.91245633 9.13816911 7 8 C6.01 8.495 6.01 8.495 5 9 C2.18060883 6.79020692 -0.53058944 4.59937954 -3 2 C-1.68 2 -0.36 2 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#D23F89",
    transform: "translate(461,457)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 1.98 10.56 3.96 16 6 C12.29847322 6.92538169 11.36541838 7.08174162 8 6 C8 6.66 8 7.32 8 8 C12.455 8.99 12.455 8.99 17 10 C17 10.33 17 10.66 17 11 C15.54119891 10.85892253 14.08296449 10.71197585 12.625 10.5625 C11.40683594 10.44068359 11.40683594 10.44068359 10.1640625 10.31640625 C8 10 8 10 6 9 C6 8.34 6 7.68 6 7 C4.02 6.34 2.04 5.68 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#C25097",
    transform: "translate(504,389)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.23343613 0.45266443 8.65853828 2.41083918 12.8125 5.4375 C13.39708984 5.84548828 13.98167969 6.25347656 14.58398438 6.67382812 C18.85312781 9.70625562 18.85312781 9.70625562 20 12 C17.9375 12.875 17.9375 12.875 15 13 C12.99253121 11.63871215 11.30512929 10.11797249 9.55078125 8.4453125 C8.04338079 6.90391662 8.04338079 6.90391662 6 6 C6 5.01 6 4.02 6 3 C3.03 2.505 3.03 2.505 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#CE478F",
    transform: "translate(503,204)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C1.66 2 2.32 2 3 2 C3.93853865 6.37984703 3.76166521 9.62042504 3 14 C3.3577614 16.27650745 3.3577614 16.27650745 4 18 C1.34828752 15.62905707 -0.1490052 13.16431913 -1.75 10 C-2.19859375 9.13375 -2.6471875 8.2675 -3.109375 7.375 C-4 5 -4 5 -3 2 C-2.01 2.33 -1.02 2.66 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#CA397C",
    transform: "translate(437,397)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.40536948 1.27676498 15.8334113 6.33340498 22 12 C18.15726281 12 16.72554364 10.69551586 13.5625 8.5625 C9.09793858 5.5329144 9.09793858 5.5329144 4 4 C4 4.66 4 5.32 4 6 C6.97 6.495 6.97 6.495 10 7 C10 7.99 10 8.98 10 10 C6.07260319 8.69086773 3.64361016 7.21009805 1 4 C0.25 1.75 0.25 1.75 0 0 Z ",
    fill: "#964579",
    transform: "translate(499,200)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.98 0.99 -1.98 0.99 -4 2 C-1.03 1.34 1.94 0.68 5 0 C0.5763026 3.8466934 -4.86733829 6.96514424 -10.80859375 7.03125 C-13.23477862 6.78346942 -15.60560885 6.45988306 -18 6 C-15.43461521 3.43461521 -12.93954104 2.62642121 -9.5625 1.3125 C-8.40878906 0.85488281 -7.25507812 0.39726562 -6.06640625 -0.07421875 C-3 -1 -3 -1 0 0 Z ",
    fill: "#8B7DBA",
    transform: "translate(589,426)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.61689922 8.28407525 2.12019449 16.56744731 2.25 24.875 C2.27578125 26.19242187 2.3015625 27.50984375 2.328125 28.8671875 C2.16570313 30.41792969 2.16570313 30.41792969 2 32 C1.01 32.66 0.02 33.32 -1 34 C-1.10492107 22.6184852 -1.17759935 11.33439373 0 0 Z ",
    fill: "#898FCC",
    transform: "translate(726,248)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 4.95 1.66 9.9 2 15 C2.33 15 2.66 15 3 15 C3 22.26 3 29.52 3 37 C2.01 36.67 1.02 36.34 0 36 C0 24.12 0 12.24 0 0 Z ",
    fill: "#8A8FCE",
    transform: "translate(682,242)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.85077588 1.11940982 7.777893 2.1334716 11 6 C10 8 10 8 9 9 C8.01 9 7.02 9 6 9 C5.67 9.66 5.34 10.32 5 11 C2.69 8.69 0.38 6.38 -2 4 C-0.66666667 4 0.66666667 4 2 4 C1.34 2.68 0.68 1.36 0 0 Z ",
    fill: "#B83F7D",
    transform: "translate(492,247)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.49944208 3.02614802 10.97440313 6.09629651 16.4375 9.1875 C17.36006592 9.70473633 17.36006592 9.70473633 18.30126953 10.23242188 C20.81705061 11.66122335 22.94382918 12.94382918 25 15 C16.76869978 13.71385934 8.5576335 10.16010505 2 5 C2 4.01 2 3.02 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#B83A79",
    transform: "translate(430,470)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.10958767 1.45044271 7.43258745 3.51110752 11 6 C8.38058783 7.74627478 6.96175123 8.38722388 4 9 C5.65 9.99 7.3 10.98 9 12 C8.01 12.495 8.01 12.495 7 13 C4.65234375 11.85546875 4.65234375 11.85546875 1.9375 10.1875 C1.03902344 9.64480469 0.14054687 9.10210937 -0.78515625 8.54296875 C-3 7 -3 7 -4 5 C-1.525 5.495 -1.525 5.495 1 6 C1.33 5.34 1.66 4.68 2 4 C1.10836423 1.88316159 1.10836423 1.88316159 0 0 Z ",
    fill: "#AD3F7B",
    transform: "translate(455,451)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.99 0.66 -1.98 1.32 -3 2 C-1.02 1.34 0.96 0.68 3 0 C0.42639878 2.9667903 -2.51704221 4.49144778 -6 6.25 C-7.5778125 7.06210937 -7.5778125 7.06210937 -9.1875 7.890625 C-12 9 -12 9 -15 8 C-14.34 7.67 -13.68 7.34 -13 7 C-13.66 6.34 -14.32 5.68 -15 5 C-14.360625 4.71125 -13.72125 4.4225 -13.0625 4.125 C-10.84793921 3.17176549 -10.84793921 3.17176549 -10 1 C-3.67567568 -1.22522523 -3.67567568 -1.22522523 0 0 Z ",
    fill: "#7672A2",
    transform: "translate(607,442)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.03819846 2.03819846 2.67841059 3.29417798 3.6875 5.9375 C3.95949219 6.62714844 4.23148438 7.31679687 4.51171875 8.02734375 C5 10 5 10 4 13 C3.67 12.34 3.34 11.68 3 11 C3.15597656 11.60328125 3.31195312 12.2065625 3.47265625 12.828125 C3.76462891 14.02695313 3.76462891 14.02695313 4.0625 15.25 C4.25972656 16.03890625 4.45695313 16.8278125 4.66015625 17.640625 C5.01847417 20.12825747 4.67152083 21.61334893 4 24 C2.79764762 20.73443413 1.61572409 17.46184085 0.4375 14.1875 C0.09525391 13.25873047 -0.24699219 12.32996094 -0.59960938 11.37304688 C-0.91865234 10.48037109 -1.23769531 9.58769531 -1.56640625 8.66796875 C-1.86490479 7.84578857 -2.16340332 7.0236084 -2.47094727 6.17651367 C-3 4 -3 4 -2 1 C-1.67 1.33 -1.34 1.66 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#A267A6",
    transform: "translate(578,222)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.44038147 2.21096635 3.81906237 4.30573977 5.2265625 7.2734375 C5.6184375 8.0984375 6.0103125 8.9234375 6.4140625 9.7734375 C6.81367187 10.63195312 7.21328125 11.49046875 7.625 12.375 C8.03234375 13.22578125 8.4396875 14.0765625 8.859375 14.953125 C10.75919775 18.99182105 12.24642188 22.57504387 13 27 C13.99 26.67 14.98 26.34 16 26 C16.33 27.65 16.66 29.3 17 31 C16.01 31.66 15.02 32.32 14 33 C12.35 28.71 10.7 24.42 9 20 C8.34 20 7.68 20 7 20 C6.84724609 18.70835937 6.84724609 18.70835937 6.69140625 17.390625 C5.94549789 13.73272413 4.68508565 11.0386009 2.9375 7.75 C0 2.19294118 0 2.19294118 0 0 Z ",
    fill: "#685E81",
    transform: "translate(610,179)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.96564796 0.50771472 10.63809899 2.38592128 16 5 C16 5.66 16 6.32 16 7 C16.94875 7.28875 17.8975 7.5775 18.875 7.875 C22 9 22 9 24 11 C21.3864045 11.9861483 20.2405193 12.08441302 17.5625 11.14453125 C13.03976246 8.79353506 9.55733355 6.68438117 6 3 C2.86649283 1.73215876 2.86649283 1.73215876 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7A78A8",
    transform: "translate(524,9)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.15227823 0.76116551 2.2966386 1.53432693 3.4375 2.3125 C4.39462891 2.95638672 4.39462891 2.95638672 5.37109375 3.61328125 C7 5 7 5 8 8 C6.02 8.99 6.02 8.99 4 10 C1.03 7.69 -1.94 5.38 -5 3 C-3.68 2.34 -2.36 1.68 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#E13B87",
    transform: "translate(450,448)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C3 2.66 3 3.32 3 4 C3.78375 4.268125 4.5675 4.53625 5.375 4.8125 C8 6 8 6 10 9 C7.0280615 7.87548273 4.66559313 6.77706209 2 5 C3.47505187 12.08744437 5.19826985 18.12142338 9.109375 24.2578125 C9.40328125 24.83273437 9.6971875 25.40765625 10 26 C9.67 26.66 9.34 27.32 9 28 C1.76705563 20.76705563 0.38505149 9.78030779 0 0 Z ",
    fill: "#9D4579",
    transform: "translate(494,330)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.680625 0.61875 1.36125 1.2375 2.0625 1.875 C5.45881234 4.3319068 7.96018821 5.04945605 12 6 C12 6.99 12 7.98 12 9 C12.31088368 10.67099977 12.64080332 12.33871537 13 14 C13.99 14.33 14.98 14.66 16 15 C15.34 16.32 14.68 17.64 14 19 C13.49210938 18.35933594 12.98421875 17.71867187 12.4609375 17.05859375 C9.20940498 12.97286656 5.95827181 8.91330758 2.5 5 C0 2 0 2 0 0 Z ",
    fill: "#6D6B93",
    transform: "translate(642,93)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.49049637 3.39766402 6.67741794 6.9086365 9.75 10.6875 C10.52859375 11.64011719 11.3071875 12.59273438 12.109375 13.57421875 C14 16 14 16 15 18 C14.38125 18.144375 13.7625 18.28875 13.125 18.4375 C10.96741678 18.93152225 10.96741678 18.93152225 9 20 C8.6596875 18.453125 8.6596875 18.453125 8.3125 16.875 C7.43893129 13.74523585 6.70508988 12.64610785 4.5 10 C1.61267615 6.53521137 0.95172061 4.32600276 0 0 Z ",
    fill: "#C33779",
    transform: "translate(402,441)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.92 0.33 15.84 0.66 24 1 C24 1.99 24 2.98 24 4 C20.37407004 3.91939409 16.74985598 3.80653183 13.125 3.6875 C11.57619141 3.65366211 11.57619141 3.65366211 9.99609375 3.61914062 C8.51689453 3.5659668 8.51689453 3.5659668 7.0078125 3.51171875 C6.09660645 3.48553467 5.18540039 3.45935059 4.24658203 3.43237305 C3.50520996 3.28968994 2.76383789 3.14700684 2 3 C1.34 2.01 0.68 1.02 0 0 Z ",
    fill: "#A05B99",
    transform: "translate(520,436)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.63 1 7.26 1 11 C1.33 11 1.66 11 2 11 C2.22577402 16.4185766 1.46670113 20.77487721 0 26 C-1.51171875 24.73828125 -1.51171875 24.73828125 -3 23 C-2.84706962 19.89041563 -2.49882103 17.06056296 -2 14 C-1.64372174 11.47946424 -1.28963986 8.95861726 -0.9375 6.4375 C-0.62638183 4.29146588 -0.31435689 2.14556209 0 0 Z ",
    fill: "#8887C4",
    transform: "translate(634,282)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C0.2984375 2.38091797 0.2984375 2.38091797 -1.4375 2.76953125 C-2.95839966 3.11689722 -4.47922929 3.46456993 -6 3.8125 C-6.74378906 3.97814453 -7.48757813 4.14378906 -8.25390625 4.31445312 C-12.09774338 5.2002069 -15.71197027 6.22578852 -19.375 7.69921875 C-23 9 -23 9 -26 8 C-7.22087676 -0.88059473 -7.22087676 -0.88059473 0 0 Z ",
    fill: "#DD408A",
    transform: "translate(443,239)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.45337748 3.79206924 11.18878565 8.58746425 15 16 C15.69140625 18.33984375 15.69140625 18.33984375 16 20 C13.68849668 18.03522218 12.4720477 16.04171639 11.125 13.375 C10.42375 12.26125 9.7225 11.1475 9 10 C8.175 9.835 7.35 9.67 6.5 9.5 C4 9 4 9 2.79296875 7.47265625 C0 2.64664311 0 2.64664311 0 0 Z ",
    fill: "#95578E",
    transform: "translate(560,195)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.28791874 0.38767655 2.57970419 0.76273417 3.875 1.125 C4.90625 1.41375 5.9375 1.7025 7 2 C3.67499687 4.21666876 1.96276172 4.77137913 -2 5 C-4.84874124 4.14362993 -7.86245582 3.13754418 -10 1 C-11.99958364 0.95919217 -14.00045254 0.95745644 -16 1 C-10.31907698 -2.27745559 -6.03539368 -2.34025469 0 0 Z ",
    fill: "#7B6798",
    transform: "translate(568,455)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 2.485 1.01 2.485 0 4 C0.99 4 1.98 4 3 4 C3.66 4.33 4.32 4.66 5 5 C3.25579087 6.32018588 1.50439909 7.63088602 -0.25 8.9375 C-1.22453125 9.66839844 -2.1990625 10.39929688 -3.203125 11.15234375 C-5.6267881 12.75345079 -7.1757492 13.57636238 -10 14 C-7.66666667 11.66666667 -5.33333333 9.33333333 -3 7 C-5.62113708 7 -7.50935112 7.31292445 -10 8 C-6.97727468 4.74475735 -3.74281699 2.38179263 0 0 Z ",
    fill: "#696890",
    transform: "translate(621,464)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C-0.64 6.3 -3.28 9.6 -6 13 C-7.32 12.67 -8.64 12.34 -10 12 C-10.99 12 -11.98 12 -13 12 C-12.14535156 11.21753906 -11.29070313 10.43507813 -10.41015625 9.62890625 C-9.29425993 8.60678273 -8.17837511 7.58464667 -7.0625 6.5625 C-6.21655273 5.7880957 -6.21655273 5.7880957 -5.35351562 4.99804688 C-2.64001674 2.53775333 -2.64001674 2.53775333 0 0 Z ",
    fill: "#956FAB",
    transform: "translate(588,345)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.22182994 0.87419028 8.25533994 4.5085649 12 8 C12.825 8.7425 13.65 9.485 14.5 10.25 C16 12 16 12 16 15 C11.69422496 13.33830526 8.90988145 10.16919694 5.75 6.9375 C5.19570313 6.38255859 4.64140625 5.82761719 4.0703125 5.25585938 C0 1.14043257 0 1.14043257 0 0 Z ",
    fill: "#9479B6",
    transform: "translate(573,132)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.48331435 3.01887244 4.79157144 5.56909529 6 10 C4.66666667 8.66666667 3.33333333 7.33333333 2 6 C2.67170806 9.8063457 3.72746564 13.35206816 5 17 C2.36115438 14.59888822 0.63586471 11.99444972 -1.1875 8.9375 C-1.98220703 7.62072266 -1.98220703 7.62072266 -2.79296875 6.27734375 C-4 4 -4 4 -4 2 C-2.68 2 -1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#6A6A91",
    transform: "translate(667,119)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.33 0.99 2.66 1.98 3 3 C1.73965413 4.50882261 0.46636351 6.00684044 -0.8125 7.5 C-1.52019531 8.3353125 -2.22789062 9.170625 -2.95703125 10.03125 C-5 12 -5 12 -8 12 C-8.99 13.485 -8.99 13.485 -10 15 C-10.66 14.67 -11.32 14.34 -12 14 C-11.55269531 13.49210937 -11.10539063 12.98421875 -10.64453125 12.4609375 C-10.03996094 11.77257812 -9.43539062 11.08421875 -8.8125 10.375 C-8.17570313 9.65054687 -7.53890625 8.92609375 -6.8828125 8.1796875 C-5.2734359 6.31655028 -3.7239969 4.42292127 -2.1875 2.5 C-1.465625 1.675 -0.74375 0.85 0 0 Z ",
    fill: "#8589C5",
    transform: "translate(663,427)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.6015625 0.99609375 2.6015625 0.99609375 5.625 2.4375 C6.62789062 2.91058594 7.63078125 3.38367188 8.6640625 3.87109375 C9.43492187 4.24363281 10.20578125 4.61617188 11 5 C10.01 5.33 9.02 5.66 8 6 C7.34 5.67 6.68 5.34 6 5 C5.67 6.32 5.34 7.64 5 9 C2.36 7.68 -0.28 6.36 -3 5 C-2.67 3.68 -2.34 2.36 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#D6428D",
    transform: "translate(506,333)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.35647645 1.44950405 7.31757289 3.67747112 10.8125 6.625 C11.78832031 7.44226562 12.76414062 8.25953125 13.76953125 9.1015625 C14.50558594 9.72804688 15.24164062 10.35453125 16 11 C11.75354935 11 9.61475228 9.18249194 6 7 C6.33 7.99 6.66 8.98 7 10 C2.56541027 8.6062718 0.12621626 6.39417765 -3 3 C-1.02 3.66 0.96 4.32 3 5 C2.01 3.35 1.02 1.7 0 0 Z ",
    fill: "#6A688D",
    transform: "translate(593,44)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.71539173 1.29975324 12.72019113 3.29928888 19 6 C19 6.99 19 7.98 19 9 C12.14381674 7.07443364 5.56747868 4.7527517 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#8788C4",
    transform: "translate(515,7)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.6015209 4.4087928 0.14993067 5.87393835 -3 7.75 C-4.051875 8.39195312 -4.051875 8.39195312 -5.125 9.046875 C-7 10 -7 10 -9 10 C-9 9.34 -9 8.68 -9 8 C-9.66 7.67 -10.32 7.34 -11 7 C-9.23754778 5.8000962 -7.46473019 4.61540483 -5.6875 3.4375 C-4.70136719 2.77621094 -3.71523438 2.11492187 -2.69921875 1.43359375 C-1.80847656 0.96050781 -0.91773438 0.48742187 0 0 Z ",
    fill: "#8382BD",
    transform: "translate(616,469)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 1.65 3.3 3.3 5 5 C4.38125 5.144375 3.7625 5.28875 3.125 5.4375 C0.96741678 5.93152225 0.96741678 5.93152225 -1 7 C0.98 9.31 2.96 11.62 5 14 C4.67 14.66 4.34 15.32 4 16 C1.03 12.7 -1.94 9.4 -5 6 C-4.34 4.35 -3.68 2.7 -3 1 C-2.01 0.67 -1.02 0.34 0 0 Z ",
    fill: "#B73E7B",
    transform: "translate(467,402)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.2706682 7.7306703 -9.08420953 11.75108298 -16 16 C-16.66 15.67 -17.32 15.34 -18 15 C-14.37 12.36 -10.74 9.72 -7 7 C-8.32 6.67 -9.64 6.34 -11 6 C-9.73608512 4.99126984 -8.46359117 3.99328178 -7.1875 3 C-6.47980469 2.443125 -5.77210938 1.88625 -5.04296875 1.3125 C-3 0 -3 0 0 0 Z ",
    fill: "#7871A0",
    transform: "translate(610,390)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.58385789 0.60147674 3.926582 0.9046183 6.32421875 4.01953125 C7.12432265 5.27607916 7.91170067 6.54080259 8.6875 7.8125 C9.09033203 8.44220703 9.49316406 9.07191406 9.90820312 9.72070312 C11.8271587 12.78396051 13.25029029 15.47226628 14 19 C12.22038688 17.38216989 11.06598322 16.14516309 10.0625 13.9375 C9.16750415 11.84913 9.16750415 11.84913 7.10546875 11.12890625 C4.56746828 9.76808596 3.71251128 8.45557449 2.25 6 C1.82203125 5.29875 1.3940625 4.5975 0.953125 3.875 C0 2 0 2 0 0 Z ",
    fill: "#877DB9",
    transform: "translate(601,162)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 8.25 1 16.5 1 25 C1.66 25 2.32 25 3 25 C3.33 26.32 3.66 27.64 4 29 C-0.77573323 31.61895048 -4.84434881 30.83119431 -10 30 C-10 29.67 -10 29.34 -10 29 C-6.7 29 -3.4 29 0 29 C0 19.43 0 9.86 0 0 Z M1 26 C2 29 2 29 2 29 Z ",
    fill: "#727AA7",
    transform: "translate(802,575)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.95409701 1.37154504 5.44008376 2.98863724 8 5 C7.67 5.66 7.34 6.32 7 7 C6.34 7 5.68 7 5 7 C5 7.66 5 8.32 5 9 C1.27566618 7.7874262 -2.37802806 6.49140021 -6 5 C-6 4.34 -6 3.68 -6 3 C-4.824375 3.309375 -4.824375 3.309375 -3.625 3.625 C-2.75875 3.74875 -1.8925 3.8725 -1 4 C-0.34 3.34 0.32 2.68 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#B44A89",
    transform: "translate(507,361)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 0 3 0 4.5 1.4375 C6.63604094 5.08656994 7.78443107 8.96534567 9 13 C7.68 13.33 6.36 13.66 5 14 C4.16235732 12.04350603 3.33000941 10.08474444 2.5 8.125 C2.0359375 7.03445312 1.571875 5.94390625 1.09375 4.8203125 C0 2 0 2 0 0 Z ",
    fill: "#8682BC",
    transform: "translate(618,192)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.71328339 3.40050142 5.53048084 7.5469584 7.75 12 C8.17410156 12.81984375 8.59820313 13.6396875 9.03515625 14.484375 C9.43089844 15.27328125 9.82664062 16.0621875 10.234375 16.875 C10.59756836 17.59429687 10.96076172 18.31359375 11.33496094 19.0546875 C12 21 12 21 11 24 C10.01 24 9.02 24 8 24 C7.87625 23.13375 7.7525 22.2675 7.625 21.375 C6.4547734 15.05577638 3.9874038 9.82568355 1.0234375 4.171875 C0 2 0 2 0 0 Z ",
    fill: "#69698E",
    transform: "translate(694,120)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.34313399 0.64669414 2.67391178 1.31903578 4 2 C4.804375 2.391875 5.60875 2.78375 6.4375 3.1875 C9.90686532 5.64144133 11.66247194 8.46031465 14 12 C10 12 10 12 7.421875 9.8828125 C6.54015625 8.97273438 5.6584375 8.06265625 4.75 7.125 C3.85796875 6.22007813 2.9659375 5.31515625 2.046875 4.3828125 C0 2 0 2 0 0 Z ",
    fill: "#8E7BB5",
    transform: "translate(588,109)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.68320312 0.27328125 1.36640625 0.5465625 2.0703125 0.828125 C3.875 1.75 3.875 1.75 5.875 3.75 C5.215 3.75 4.555 3.75 3.875 3.75 C3.875 4.74 3.875 5.73 3.875 6.75 C0.65647169 6.11934243 -1.63301069 4.96979305 -4.375 3.1875 C-5.08140625 2.73246094 -5.7878125 2.27742188 -6.515625 1.80859375 C-7.31226563 1.28458984 -7.31226563 1.28458984 -8.125 0.75 C-4.91860316 -1.23422764 -3.47699386 -1.45425599 0 0 Z ",
    fill: "#D2448D",
    transform: "translate(476.125,441.25)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.27749285 0.53851968 9.25645564 1.77343836 14 4 C11 5 11 5 8 4 C8 4.99 8 5.98 8 7 C4.22454612 5.90931332 1.52956528 5.0916909 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#C94B92",
    transform: "translate(488,425)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.76276177 0.52268466 5.3260876 1.10869587 8 2 C8 3.32 8 4.64 8 6 C9.65 6 11.3 6 13 6 C13 6.66 13 7.32 13 8 C8.28596212 7.52060632 4.33420699 7.03165952 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#C15096",
    transform: "translate(512,366)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.07345597 1.58471263 -7.92993597 0.50954919 -12.0625 -0.3125 C-13.14241211 -0.50875977 -13.14241211 -0.50875977 -14.24414062 -0.70898438 C-17.7214091 -1.37731731 -20.01896397 -2.01264264 -23 -4 C-15.52700922 -6.44443624 -6.94038377 -2.88091402 0 0 Z ",
    fill: "#CC5099",
    transform: "translate(512,476)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1.66 0.02 2.32 -1 3 C-0.34 3.66 0.32 4.32 1 5 C-0.43344 5.53190541 -1.87195367 6.05015258 -3.3125 6.5625 C-4.11300781 6.85253906 -4.91351562 7.14257812 -5.73828125 7.44140625 C-8 8 -8 8 -11 7 C-13.00875442 7.27571139 -15.01178687 7.60235737 -17 8 C-14.41879025 5.41879025 -11.9172628 4.70385292 -8.5 3.4375 C-4.18461645 1.86937955 -4.18461645 1.86937955 0 0 Z ",
    fill: "#8A80BD",
    transform: "translate(595,444)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C-2.11378556 10.70459519 -2.11378556 10.70459519 -5.8125 11.9375 C-6.8953125 11.9684375 -6.8953125 11.9684375 -8 12 C-7.71125 11.443125 -7.4225 10.88625 -7.125 10.3125 C-5.94107481 7.99978964 -5.94107481 7.99978964 -5.125 5.4375 C-3.84573028 2.66574894 -2.54768145 1.61353158 0 0 Z ",
    fill: "#7E83BB",
    transform: "translate(676,411)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C1.66 2.33 2.32 2.66 3 3 C1.68 5.31 0.36 7.62 -1 10 C-1.5775 9.62875 -2.155 9.2575 -2.75 8.875 C-3.4925 8.58625 -4.235 8.2975 -5 8 C-7.12730285 8.89681416 -7.12730285 8.89681416 -9 10 C-8.06409496 8.8944811 -7.12620142 7.79064547 -6.1875 6.6875 C-5.66542969 6.07261719 -5.14335938 5.45773437 -4.60546875 4.82421875 C-3.12827531 3.14575321 -1.59960869 1.56117966 0 0 Z ",
    fill: "#AC5A9C",
    transform: "translate(569,318)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.49519943 11.40849295 -3.03186074 21.31400349 -9 31 C-9.33 30.34 -9.66 29.68 -10 29 C-9.109375 26.96875 -9.109375 26.96875 -7.75 24.5 C-3.96794961 17.19927321 -1.45987793 10.28187169 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#745680",
    transform: "translate(588,284)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.01024316 0.84832067 6.46656026 1.48023821 9.4375 4.375 C11 7 11 7 11 11 C7.84164893 9.60249952 5.67727175 7.94801766 3.25 5.5 C2.63640625 4.8915625 2.0228125 4.283125 1.390625 3.65625 C0 2 0 2 0 0 Z ",
    fill: "#E73885",
    transform: "translate(433,438)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.5534764 2.07553648 1 3.84365964 1 6 C0.01 6 -0.98 6 -2 6 C-2.33 6.99 -2.66 7.98 -3 9 C-2.01 9 -1.02 9 0 9 C0 12 0 12 -2 14.1875 C-2.99 15.0846875 -2.99 15.0846875 -4 16 C-3.67 14.68 -3.34 13.36 -3 12 C-5.16874252 12.50603992 -6.99967627 12.99983813 -9 14 C-7.45158425 10.65291949 -5.50894136 7.75332488 -3.375 4.75 C-2.74335937 3.85796875 -2.11171875 2.9659375 -1.4609375 2.046875 C-0.73777344 1.03367187 -0.73777344 1.03367187 0 0 Z ",
    fill: "#6A6C94",
    transform: "translate(665,380)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 5.7734375 3.58203125 C6.30195312 4.64808594 6.83046875 5.71414062 7.375 6.8125 C7.91898438 7.87082031 8.46296875 8.92914063 9.0234375 10.01953125 C10 13 10 13 8 17 C4.04 8.585 4.04 8.585 0 0 Z ",
    fill: "#898EC8",
    transform: "translate(692,123)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.41793589 1.20896794 2.79103206 1.58206411 4 4 C3.18595703 4.25523438 3.18595703 4.25523438 2.35546875 4.515625 C-2.14473554 6.04001852 -4.18171009 7.10807584 -7 11 C-9.6875 11.25 -9.6875 11.25 -12 11 C-12 10.01 -12 9.02 -12 8 C-10.948125 7.4225 -9.89625 6.845 -8.8125 6.25 C-5.6213518 4.4338994 -2.80510465 2.38008879 0 0 Z ",
    fill: "#8C3760",
    transform: "translate(235,44)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.25 -0.25 2.25 -0.25 5 0 C6.34732307 1.31919524 7.67884247 2.65460105 9 4 C10.57220568 5.02970255 12.17867553 6.00866436 13.8125 6.9375 C18.06746072 9.41483269 22.04191894 12.07446183 26 15 C25.34 15.66 24.68 16.32 24 17 C24 16.34 24 15.68 24 15 C23.26136719 14.72671875 22.52273438 14.4534375 21.76171875 14.171875 C19.16941236 13.07188643 17.11371218 11.85609931 14.8125 10.25 C10.605522 7.367441 6.28183171 4.75704396 1.87109375 2.19921875 C1.25363281 1.80347656 0.63617187 1.40773437 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#686486",
    transform: "translate(564,31)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-6.85902346 4.5726823 -14.82055673 6.62918794 -23 6 C-16.14097654 1.4273177 -8.17944327 -0.62918794 0 0 Z ",
    fill: "#B53A71",
    transform: "translate(346,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C29.01 1.485 29.01 1.485 28 3 C27.01 3 26.02 3 25 3 C24.67 2.67 24.34 2.34 24 2 C23.01 2.495 23.01 2.495 22 3 C22 2.34 22 1.68 22 1 C19.36 1.66 16.72 2.32 14 3 C14 2.34 14 1.68 14 1 C9.87026372 1.56739868 9.87026372 1.56739868 6 3 C6 2.34 6 1.68 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#797DAE",
    transform: "translate(554,604)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C1.66 3 2.32 3 3 3 C2.19534869 6.73654172 0.82425115 10.19422782 -0.5625 13.75 C-1.24505859 15.50570313 -1.24505859 15.50570313 -1.94140625 17.296875 C-2.29074219 18.18890625 -2.64007812 19.0809375 -3 20 C-5.1923475 13.42295749 -2.03157309 6.35026304 0 0 Z ",
    fill: "#8381BA",
    transform: "translate(630,306)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.598125 0.165 1.19625 0.33 1.8125 0.5 C4.11344336 1.1114124 4.11344336 1.1114124 7 1 C9.18052998 2.48551921 11.02195971 4.24174197 13 6 C12.67 6.99 12.34 7.98 12 9 C10.66666667 8.33333333 9.33333333 7.66666667 8 7 C7.34 6.731875 6.68 6.46375 6 6.1875 C3.3245365 4.59894355 1.82994269 2.48349364 0 0 Z ",
    fill: "#E93381",
    transform: "translate(414,464)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.625 3 1.625 3 0 5 C-0.66 5 -1.32 5 -2 5 C-5.63051524 5.53257558 -7.25640749 6.92504638 -9.75 9.5625 C-10.36359375 10.20316406 -10.9771875 10.84382813 -11.609375 11.50390625 C-12.06828125 11.99761719 -12.5271875 12.49132812 -13 13 C-13.66 12.67 -14.32 12.34 -15 12 C-13.07141188 9.99068029 -11.133102 7.99272731 -9.1875 6 C-8.64029297 5.42765625 -8.09308594 4.8553125 -7.52929688 4.265625 C-3.33984375 0 -3.33984375 0 0 0 Z ",
    fill: "#7072A0",
    transform: "translate(649,405)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3.47614677 3.0746395 3.93848921 5.15348085 4.328125 7.24609375 C5.36866396 11.51109355 7.18920619 15.40013177 8.9765625 19.3984375 C10 22 10 22 10 25 C6.74910454 20.58807044 4.79356427 16.22683676 2.9296875 11.07421875 C2.18641677 8.82934187 2.18641677 8.82934187 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#984275",
    transform: "translate(486,334)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3.33 1.99 3.66 2.98 4 4 C4.66 3.67 5.32 3.34 6 3 C5.67 5.31 5.34 7.62 5 10 C4.01 10 3.02 10 2 10 C1.67 10.66 1.34 11.32 1 12 C0.896875 11.360625 0.79375 10.72125 0.6875 10.0625 C0.460625 9.381875 0.23375 8.70125 0 8 C-0.99 7.67 -1.98 7.34 -3 7 C-2.34 7 -1.68 7 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#8183B9",
    transform: "translate(658,238)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.81516061 5.44548182 -1.09824055 11.12133448 -3.5 16.125 C-3.995 16.74375 -4.49 17.3625 -5 18 C-5.99 18 -6.98 18 -8 18 C-6.65150163 13.64029169 -4.95092154 9.68658562 -2.875 5.625 C-2.33617187 4.56539063 -1.79734375 3.50578125 -1.2421875 2.4140625 C-0.83226562 1.61742187 -0.42234375 0.82078125 0 0 Z ",
    fill: "#8870A6",
    transform: "translate(607,315)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.63 1 7.26 1 11 C1.66 11 2.32 11 3 11 C2.25 18.75 2.25 18.75 0 21 C0 19.35 0 17.7 0 16 C-0.99 17.32 -1.98 18.64 -3 20 C-2.86722656 19.2265625 -2.73445312 18.453125 -2.59765625 17.65625 C-1.60135293 11.78024213 -0.68315535 5.92067973 0 0 Z ",
    fill: "#A26AAA",
    transform: "translate(584,277)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.02107902 -0.0543251 6.04116528 -0.09382927 9.0625 -0.125 C9.91005859 -0.14175781 10.75761719 -0.15851563 11.63085938 -0.17578125 C16.83418201 -0.21596135 21.07469821 0.30254185 26 2 C25.67 2.99 25.34 3.98 25 5 C22.03 4.67 19.06 4.34 16 4 C16 3.34 16 2.68 16 2 C10.72 1.67 5.44 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#E43F8D",
    transform: "translate(452,237)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.87826448 1.59155733 8.56809011 4.39877941 12.625 7.4375 C13.29273438 7.92798828 13.96046875 8.41847656 14.6484375 8.92382812 C17.63668368 11.13811854 20.41349744 13.31688368 23 16 C18.86538891 16 16.83067575 13.7958706 13.75 11.3125 C12.58540025 10.39226041 11.42004166 9.47298031 10.25390625 8.5546875 C9.69461426 8.1122168 9.13532227 7.66974609 8.55908203 7.21386719 C6.64533457 5.72386525 4.67980399 4.32024897 2.6875 2.9375 C1.800625 2.298125 0.91375 1.65875 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#8E8FCC",
    transform: "translate(604,27)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.62 0 9.24 0 14 0 C14 0.66 14 1.32 14 2 C7.56971459 3.32388229 1.5705166 4.24794402 -5 4 C-5 3.34 -5 2.68 -5 2 C-3.35 1.67 -1.7 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#8F69A4",
    transform: "translate(549,435)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C0.56656 3.53190541 -0.87195367 4.05015258 -2.3125 4.5625 C-3.11300781 4.85253906 -3.91351562 5.14257812 -4.73828125 5.44140625 C-7 6 -7 6 -10 5 C-8.68 4.67 -7.36 4.34 -6 4 C-6 3.34 -6 2.68 -6 2 C-6.7425 2.350625 -7.485 2.70125 -8.25 3.0625 C-11.21122875 4.0720098 -12.12062561 3.87980884 -15 3 C-5.00312891 -0.73216521 -5.00312891 -0.73216521 0 0 Z ",
    fill: "#9375B2",
    transform: "translate(574,411)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.31223496 3.93670488 0.24296256 6.12488144 -1 10 C-1.66 9.67 -2.32 9.34 -3 9 C-4.66554027 14.30039859 -6.27275406 19.47293087 -7 25 C-7.33 25 -7.66 25 -8 25 C-8.77872362 15.65531651 -5.93172747 7.32333509 0 0 Z ",
    fill: "#AA3F77",
    transform: "translate(481,334)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.61946506 3.4524818 10.0679294 6.67267854 14 12 C9.84848662 10.55797524 6.70021555 8.4989562 3.1875 5.875 C2.21167969 5.15054687 1.23585938 4.42609375 0.23046875 3.6796875 C-0.50558594 3.12539063 -1.24164063 2.57109375 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#B33874",
    transform: "translate(422,470)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-2.48713568 5.5896337 -6.98568224 9.98854579 -12 14 C-12.66 13.67 -13.32 13.34 -14 13 C-13.34 12.34 -12.68 11.68 -12 11 C-12 10.01 -12 9.02 -12 8 C-8 6 -8 6 -6 5.125 C-3.57114027 3.7587664 -1.8932487 2.02848075 0 0 Z ",
    fill: "#66678D",
    transform: "translate(648,448)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.36324519 2.72649039 1.17909006 4.44780564 0.25 7.3125 C-1.20642826 10.44382075 -3.02654172 13.17137647 -5 16 C-6.35281097 12.92542961 -5.92902928 11.80483052 -4.75 8.5625 C-3.29261717 5.59568494 -1.77307354 2.78625842 0 0 Z ",
    fill: "#868AC6",
    transform: "translate(673,369)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.33 2.31 2.66 4.62 3 7 C2.01 7.495 2.01 7.495 1 8 C1.52537724 13.0302076 2.10594786 18.01885239 3 23 C0.33951455 20.33951455 0.13398293 18.08809 -0.6875 14.4375 C-0.95949219 13.26058594 -1.23148437 12.08367187 -1.51171875 10.87109375 C-1.75341797 9.44990234 -1.75341797 9.44990234 -2 8 C-1.67 7.67 -1.34 7.34 -1 7 C-0.63239269 4.67182036 -0.29758419 2.3381615 0 0 Z ",
    fill: "#BF3C7A",
    transform: "translate(430,376)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.59634744 3.49359465 6.83451967 7.11098131 10 11 C9.34 12.32 8.68 13.64 8 15 C7.67 14.01 7.34 13.02 7 12 C6.34 11.67 5.68 11.34 5 11 C3.7109375 9.51171875 3.7109375 9.51171875 2.375 7.6875 C1.70597656 6.79611328 1.70597656 6.79611328 1.0234375 5.88671875 C0 4 0 4 0 0 Z ",
    fill: "#7B678D",
    transform: "translate(631,116)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.59 0 15.18 0 23 0 C23.33 0.99 23.66 1.98 24 3 C16.08 2.67 8.16 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#932D5A",
    transform: "translate(312,570)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.34 1.66 0.68 2.32 0 3 C0 3.99 0 4.98 0 6 C-5.34883721 11 -5.34883721 11 -8 11 C-7.91433603 8.087425 -7.42089045 6.43201976 -5.375 4.33203125 C-3.61608625 2.83908228 -1.83686981 1.39563738 0 0 Z ",
    fill: "#8385C0",
    transform: "translate(636,454)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.61 0.33 11.22 0.66 17 1 C17 1.33 17 1.66 17 2 C13.04 2 9.08 2 5 2 C4.67 2.99 4.34 3.98 4 5 C1.69 4.67 -0.62 4.34 -3 4 C-2.34 3.67 -1.68 3.34 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#AC60A5",
    transform: "translate(516,456)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.4391134 0.28359887 2.87625518 0.57721399 4.3125 0.875 C5.11300781 1.03742188 5.91351563 1.19984375 6.73828125 1.3671875 C9 2 9 2 12 4 C11.01 4 10.02 4 9 4 C9 4.66 9 5.32 9 6 C9.66 6.33 10.32 6.66 11 7 C8.36 6.67 5.72 6.34 3 6 C2.87625 5.195625 2.7525 4.39125 2.625 3.5625 C2.315625 2.2940625 2.315625 2.2940625 2 1 C1.34 0.67 0.68 0.34 0 0 Z ",
    fill: "#C2539B",
    transform: "translate(493,450)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.28731693 3.83520308 -7.25147171 6.32465344 -12 8 C-12.66 7.67 -13.32 7.34 -14 7 C-12.68 6.01 -11.36 5.02 -10 4 C-10.66 3.67 -11.32 3.34 -12 3 C-4.71428571 -1.71428571 -4.71428571 -1.71428571 0 0 Z ",
    fill: "#8784BF",
    transform: "translate(614,438)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C1.99 1.67 2.98 1.34 4 1 C3.07506212 4.78383679 2.60628829 6.56693694 -0.625 8.875 C-1.40875 9.24625 -2.1925 9.6175 -3 10 C-2.67 8.68 -2.34 7.36 -2 6 C-3.32 7.65 -4.64 9.3 -6 11 C-6.66 10.67 -7.32 10.34 -8 10 C-5.36 6.7 -2.72 3.4 0 0 Z ",
    fill: "#8685C0",
    transform: "translate(626,368)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.70884005 1.62339805 3.37446717 3.29319053 5 5 C5 5.66 5 6.32 5 7 C6.65 6.67 8.3 6.34 10 6 C11.98 8.97 11.98 8.97 14 12 C13.67 12.66 13.34 13.32 13 14 C11.29159719 12.36587557 10.06546953 11.13093906 9 9 C8.01 10.485 8.01 10.485 7 12 C6.38125 11.05125 5.7625 10.1025 5.125 9.125 C3.18029031 6.05554891 3.18029031 6.05554891 1 4 C0.375 1.875 0.375 1.875 0 0 Z ",
    fill: "#646386",
    transform: "translate(676,99)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C2.92046168 2.54134931 2.92046168 2.54134931 5.1875 2.875 C9.66681041 3.77658644 12.47049818 5.10399851 16 8 C16 8.66 16 9.32 16 10 C15.34 10 14.68 10 14 10 C14 9.34 14 8.68 14 8 C12.92685547 8.0928125 12.92685547 8.0928125 11.83203125 8.1875 C8.36693731 7.95808688 6.59534501 6.86102081 3.6875 5 C2.80449219 4.443125 1.92148437 3.88625 1.01171875 3.3125 C0.34785156 2.879375 -0.31601562 2.44625 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#898AC7",
    transform: "translate(555,23)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.43880578 1.79423861 -1.12401964 2.58527123 -2.6875 3.375 C-3.55761719 3.81585937 -4.42773438 4.25671875 -5.32421875 4.7109375 C-7.84854099 5.92703435 -10.39237451 6.97809271 -13 8 C-14.34050052 8.65213539 -15.67661368 9.31379969 -17 10 C-17.99 9.01 -18.98 8.02 -20 7 C-18.89140625 6.66226563 -17.7828125 6.32453125 -16.640625 5.9765625 C-15.17702702 5.52622466 -13.71348845 5.07569367 -12.25 4.625 C-11.15558594 4.29242187 -11.15558594 4.29242187 -10.0390625 3.953125 C-7.09842016 3.04419918 -4.35374049 2.1814943 -1.609375 0.7734375 C-0.81273437 0.39058594 -0.81273437 0.39058594 0 0 Z ",
    fill: "#A52C5D",
    transform: "translate(237,764)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 1.33333333 0 2.66666667 0 4 C0.99 3.34 1.98 2.68 3 2 C1.4169423 6.2742558 -1.50568404 8.26531794 -5 11 C-5 10.34 -5 9.68 -5 9 C-5.66 9 -6.32 9 -7 9 C-5.44499019 5.18315774 -2.96404505 2.80804268 0 0 Z ",
    fill: "#8883BE",
    transform: "translate(617,379)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.40917986 2.48454806 1.80187345 3.96254351 1.1875 5.4375 C0.85105469 6.26121094 0.51460937 7.08492188 0.16796875 7.93359375 C-1 10 -1 10 -4 11 C-4 8.03 -4 5.06 -4 2 C-2.68 1.34 -1.36 0.68 0 0 Z ",
    fill: "#7F83BC",
    transform: "translate(667,342)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.86697492 1.28519565 4.97607712 2.57129254 7 5 C7 5.66 7 6.32 7 7 C7.66 7 8.32 7 9 7 C10.625 9.5 10.625 9.5 12 12 C8.40608886 10.66511872 5.24509304 9.03977277 2 7 C2.33 6.01 2.66 5.02 3 4 C1.62831762 1.80961577 1.62831762 1.80961577 0 0 Z ",
    fill: "#7D6C9B",
    transform: "translate(598,116)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 1.32 2.64 2.64 4 4 C4.99 3.67 5.98 3.34 7 3 C7.99 3.66 8.98 4.32 10 5 C10 6.32 10 7.64 10 9 C7.8125 9.4375 7.8125 9.4375 5 9 C2.55567293 6.48300375 0 3.60995554 0 0 Z ",
    fill: "#7373A0",
    transform: "translate(657,112)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.7421875 1.546875 1.7421875 1.546875 3 3 C-2.44693314 3.09688221 -7.63904667 3.12862175 -13 2 C-13 1.34 -13 0.68 -13 0 C-8.35316375 -1.30692269 -4.68300074 -0.90638724 0 0 Z ",
    fill: "#925B87",
    transform: "translate(478,87)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.55780196 0.60990891 6.6828589 1.5783681 10 3 C10 3.66 10 4.32 10 5 C11.65 5.33 13.3 5.66 15 6 C15 6.66 15 7.32 15 8 C13.35 8.33 11.7 8.66 10 9 C10 8.34 10 7.68 10 7 C7.69 6.34 5.38 5.68 3 5 C4.32 4.67 5.64 4.34 7 4 C4.69 3.01 2.38 2.02 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#AC4987",
    transform: "translate(478,464)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 2.485 1.01 2.485 0 4 C0.33 4.66 0.66 5.32 1 6 C1.99 6 2.98 6 4 6 C1.03 8.475 1.03 8.475 -2 11 C-2.66 10.67 -3.32 10.34 -4 10 C-4 9.01 -4 8.02 -4 7 C-4.66 6.34 -5.32 5.68 -6 5 C-4.02 3.35 -2.04 1.7 0 0 Z ",
    fill: "#6C6C94",
    transform: "translate(625,424)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.54069923 -0.49579807 5.78647769 -2 9 C-5.125 10.375 -5.125 10.375 -8 11 C-7.31453245 5.9275401 -5.75032594 4.35025144 -1.8125 1.3125 C-1.214375 0.879375 -0.61625 0.44625 0 0 Z ",
    fill: "#7D7FB4",
    transform: "translate(655,396)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.59306496 1.4859916 7.43569245 3.85014682 11 7 C8.50907189 8.24546405 7.58919267 7.7767578 5 7 C5 7.66 5 8.32 5 9 C3.68 8.34 2.36 7.68 1 7 C1.20625 6.401875 1.4125 5.80375 1.625 5.1875 C2.30671915 2.71549154 2.30671915 2.71549154 0 0 Z ",
    fill: "#954C81",
    transform: "translate(531,166)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4 0 4 -1 6 C-3.5625 6.625 -3.5625 6.625 -6 7 C-6.33 6.34 -6.66 5.68 -7 5 C-8.65 5.33 -10.3 5.66 -12 6 C-8.59780735 3.25207517 -4.51535412 0 0 0 Z ",
    fill: "#9870AF",
    transform: "translate(574,386)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.5 2 0.5 2 1 4 C1.22558594 4.64453125 1.45117188 5.2890625 1.68359375 5.953125 C2.11454983 8.74103843 1.28233766 10.23639513 0.0625 12.75 C-0.50791016 13.94882812 -0.50791016 13.94882812 -1.08984375 15.171875 C-1.39019531 15.77515625 -1.69054687 16.3784375 -2 17 C-3 14 -3 14 -3 13 C-3.33 12.01 -3.66 11.02 -4 10 C-3.22265625 7.51953125 -3.22265625 7.51953125 -2.0625 4.8125 C-1.68222656 3.91144531 -1.30195312 3.01039063 -0.91015625 2.08203125 C-0.60980469 1.39496094 -0.30945313 0.70789063 0 0 Z ",
    fill: "#705F86",
    transform: "translate(609,306)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.49552403 2.27597646 4.06622986 4.60721178 5.6875 7.5625 C6.12449219 8.34753906 6.56148437 9.13257813 7.01171875 9.94140625 C8 12 8 12 8 14 C7.01 13.67 6.02 13.34 5 13 C5.33 12.34 5.66 11.68 6 11 C5.01 11 4.02 11 3 11 C0 4.5 0 4.5 0 0 Z ",
    fill: "#878CC8",
    transform: "translate(668,123)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.57282151 2.67551353 -0.86708482 4.34019309 -2.3125 6 C-3.51326172 7.3921875 -3.51326172 7.3921875 -4.73828125 8.8125 C-7 11 -7 11 -10 11 C-8.55218207 7.55571735 -6.72305391 5.63869038 -3.875 3.25 C-3.15054688 2.63640625 -2.42609375 2.0228125 -1.6796875 1.390625 C-0.84824219 0.70226562 -0.84824219 0.70226562 0 0 Z ",
    fill: "#B12A63",
    transform: "translate(137,584)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.71671875 0.37382812 1.4334375 0.74765625 2.171875 1.1328125 C4.07673349 1.56380003 5.99544082 1.93674014 7.921875 2.2578125 C8.90671875 2.42539062 9.8915625 2.59296875 10.90625 2.765625 C12.02773438 2.94738281 12.02773438 2.94738281 13.171875 3.1328125 C13.171875 3.4628125 13.171875 3.7928125 13.171875 4.1328125 C6.76834178 4.3690084 1.32558339 3.9561335 -4.828125 2.1328125 C-4.828125 1.4728125 -4.828125 0.8128125 -4.828125 0.1328125 C-1.828125 -0.8671875 -1.828125 -0.8671875 0 0 Z ",
    fill: "#C34388",
    transform: "translate(489.828125,496.8671875)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.1196437 3.35893109 1.07992835 4.67714354 0 8 C-2.0625 9.8125 -2.0625 9.8125 -4 11 C-4.66 10.67 -5.32 10.34 -6 10 C-4.6302836 6.00499382 -2.74277578 3.19990508 0 0 Z ",
    fill: "#8586C2",
    transform: "translate(648,374)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.02952761 3.29164717 1.04697292 6.58325938 1.0625 9.875 C1.07087891 10.7928125 1.07925781 11.710625 1.08789062 12.65625 C1.10964173 18.8335647 0.73930108 24.86721835 0 31 C-0.33 31 -0.66 31 -1 31 C-1.19397476 29.02145742 -1.38001321 27.0421352 -1.5625 25.0625 C-1.66691406 23.96035156 -1.77132812 22.85820312 -1.87890625 21.72265625 C-1.91886719 20.82417969 -1.95882812 19.92570312 -2 19 C-1.67 18.67 -1.34 18.34 -1 18 C-0.84417697 16.65984779 -0.74955858 15.31241097 -0.68359375 13.96484375 C-0.62075195 12.75151367 -0.62075195 12.75151367 -0.55664062 11.51367188 C-0.51732422 10.66353516 -0.47800781 9.81339844 -0.4375 8.9375 C-0.39431641 8.08349609 -0.35113281 7.22949219 -0.30664062 6.34960938 C-0.20023298 4.23327963 -0.09958269 2.11666187 0 0 Z ",
    fill: "#5C5C7F",
    transform: "translate(658,256)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.66 1.32 -1.32 2.64 -2 4 C-8.625 3.25 -8.625 3.25 -12 1 C-3.96428571 -1.27678571 -3.96428571 -1.27678571 0 0 Z ",
    fill: "#8D7AB9",
    transform: "translate(577,453)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.144375 0.928125 1.28875 1.85625 1.4375 2.8125 C1.92100111 6.00725111 1.92100111 6.00725111 3 9 C2.91426773 11.06587115 2.76166465 13.12946525 2.5625 15.1875 C2.40974609 16.81751953 2.40974609 16.81751953 2.25390625 18.48046875 C2.12822266 19.72763672 2.12822266 19.72763672 2 21 C1.67 21 1.34 21 1 21 C0.67 18.36 0.34 15.72 0 13 C-0.33 13 -0.66 13 -1 13 C-1.07654536 8.48382401 -1.10228696 4.40914783 0 0 Z ",
    fill: "#7E83BC",
    transform: "translate(703,235)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.33 -0.66 0.66 -1 1 C-0.34 1.66 0.32 2.32 1 3 C-4.28 3 -9.56 3 -15 3 C-12.41464321 1.27642881 -10.96188386 0.55264982 -8.0625 -0.1875 C-7.39347656 -0.36667969 -6.72445313 -0.54585937 -6.03515625 -0.73046875 C-3.75319112 -1.03268678 -2.17973341 -0.68756692 0 0 Z ",
    fill: "#BF4381",
    transform: "translate(423,197)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C0.99 2.33 1.98 2.66 3 3 C3 3.33 3 3.66 3 4 C0.69 4.33 -1.62 4.66 -4 5 C-4 4.34 -4 3.68 -4 3 C-5.32 2.67 -6.64 2.34 -8 2 C-8 1.34 -8 0.68 -8 0 C-4.71023192 -1.09658936 -3.28696233 -0.79953138 0 0 Z ",
    fill: "#D13E87",
    transform: "translate(480,494)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.75128818 0.28382946 3.50100003 0.57739529 5.25 0.875 C6.71179688 1.11863281 6.71179688 1.11863281 8.203125 1.3671875 C10.77264117 1.94855848 12.72071056 2.70840265 15 4 C13.35 4 11.7 4 10 4 C10 4.66 10 5.32 10 6 C10.66 6.33 11.32 6.66 12 7 C9.36 6.67 6.72 6.34 4 6 C5.32 5.34 6.64 4.68 8 4 C5.36 3.01 2.72 2.02 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#C0589E",
    transform: "translate(504,431)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.53125 4.60546875 C-2.1809375 5.12753906 -2.830625 5.64960938 -3.5 6.1875 C-4.1496875 6.71730469 -4.799375 7.24710937 -5.46875 7.79296875 C-5.9740625 8.19128906 -6.479375 8.58960938 -7 9 C-7.99 8.34 -8.98 7.68 -10 7 C-8.8803014 5.99406757 -7.7540588 4.9954151 -6.625 4 C-5.68527344 3.1646875 -5.68527344 3.1646875 -4.7265625 2.3125 C-3 1 -3 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#8689C4",
    transform: "translate(648,408)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.04882866 2.1725131 1.08882991 3.33787015 0.125 4.5 C-0.40867187 5.1496875 -0.94234375 5.799375 -1.4921875 6.46875 C-1.98976563 6.9740625 -2.48734375 7.479375 -3 8 C-3.66 8 -4.32 8 -5 8 C-5 8.66 -5 9.32 -5 10 C-5.66 10 -6.32 10 -7 10 C-6.42424336 6.64749299 -5.40693737 5.06181371 -2.9375 2.75 C-2.38964844 2.22921875 -1.84179688 1.7084375 -1.27734375 1.171875 C-0.64505859 0.59179688 -0.64505859 0.59179688 0 0 Z ",
    fill: "#B55084",
    transform: "translate(373,275)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.99 0.495 -0.99 0.495 -2 1 C-1.67 1.66 -1.34 2.32 -1 3 C-2.28650706 3.69710731 -3.57940665 4.38242876 -4.875 5.0625 C-5.95394531 5.63677734 -5.95394531 5.63677734 -7.0546875 6.22265625 C-7.69664062 6.47917969 -8.33859375 6.73570313 -9 7 C-9.66 6.67 -10.32 6.34 -11 6 C-11 5.01 -11 4.02 -11 3 C-9.73581754 2.30034557 -8.46334598 1.61565237 -7.1875 0.9375 C-6.47980469 0.55464844 -5.77210938 0.17179687 -5.04296875 -0.22265625 C-3 -1 -3 -1 0 0 Z ",
    fill: "#8F3663",
    transform: "translate(280,22)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C2.98 2 4.96 2 7 2 C6.67 2.66 6.34 3.32 6 4 C4.35 4 2.7 4 1 4 C1 4.66 1 5.32 1 6 C-0.32 6 -1.64 6 -3 6 C-3 5.01 -3 4.02 -3 3 C-3.66 2.34 -4.32 1.68 -5 1 C-3.35 0.67 -1.7 0.34 0 0 Z ",
    fill: "#B8559B",
    transform: "translate(519,414)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.56633048 2.48770135 2.04100928 3.65552204 1.6875 6.625 C1 9 1 9 0 11 C-0.99 11 -1.98 11 -3 11 C-3.33 11.66 -3.66 12.32 -4 13 C-3.40895235 8.15340923 -2.02055843 4.39251833 0 0 Z ",
    fill: "#888BC7",
    transform: "translate(670,331)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.74304413 4.75548243 -0.26756947 7.56068738 -2.7109375 11.42578125 C-3.13632812 11.94527344 -3.56171875 12.46476562 -4 13 C-4.66 13 -5.32 13 -6 13 C-4.7605743 7.83572624 -3.21011179 4.24563172 0 0 Z ",
    fill: "#BF3F7B",
    transform: "translate(390,317)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.45512034 -0.56131481 11.15439723 1.36536213 17 4 C17 4.66 17 5.32 17 6 C16.35933594 5.80664062 15.71867187 5.61328125 15.05859375 5.4140625 C10.04889015 3.9059252 5.03460143 2.42282214 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#DD4492",
    transform: "translate(483,197)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.75 -0.25 2.75 -0.25 6 0 C8.375 2 8.375 2 10 4 C9.34 4 8.68 4 8 4 C7.67 4.66 7.34 5.32 7 6 C2.32307692 4.52307692 2.32307692 4.52307692 0.6875 1.875 C0.460625 1.25625 0.23375 0.6375 0 0 Z ",
    fill: "#CD488F",
    transform: "translate(499,360)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.60573896 -0.81707462 4.41336566 -3 7.1875 C-3.556875 7.90292969 -4.11375 8.61835938 -4.6875 9.35546875 C-5.120625 9.89816406 -5.55375 10.44085938 -6 11 C-6 10.01 -6 9.02 -6 8 C-6.66 7.67 -7.32 7.34 -8 7 C-8 6.34 -8 5.68 -8 5 C-6.36935236 3.94228261 -4.69719127 2.94726954 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#716F9B",
    transform: "translate(635,363)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 1.99 2 2.98 2 4 C-0.5 6.1875 -0.5 6.1875 -3 8 C-3.66 7.67 -4.32 7.34 -5 7 C-4.60196439 4.11424181 -4.20990931 3.17810487 -1.9375 1.25 C-1.298125 0.8375 -0.65875 0.425 0 0 Z ",
    fill: "#876296",
    transform: "translate(578,356)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.99 -0.66 1.98 -1 3 C-2.74965358 3.05429959 -4.49979787 3.09292823 -6.25 3.125 C-7.22453125 3.14820313 -8.1990625 3.17140625 -9.203125 3.1953125 C-12.0196498 2.99862781 -13.60949036 2.44568916 -16 1 C-13.70839646 0.83246763 -11.41671509 0.66599948 -9.125 0.5 C-7.84882813 0.4071875 -6.57265625 0.314375 -5.2578125 0.21875 C-3.50763316 0.10123196 -1.75412035 0 0 0 Z ",
    fill: "#9B2D5B",
    transform: "translate(336,768)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.96865509 2.54456151 4.3619751 5.48994665 6 9 C7.32 8.34 8.64 7.68 10 7 C9.01 8.98 8.02 10.96 7 13 C3.70759125 10.20145256 1.96437054 6.79326725 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#575E80",
    transform: "translate(884,630)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.99 0.33 -1.98 0.66 -3 1 C-3 1.66 -3 2.32 -3 3 C-2.01 3.33 -1.02 3.66 0 4 C-2.64 4.33 -5.28 4.66 -8 5 C-8 4.34 -8 3.68 -8 3 C-8.66 2.34 -9.32 1.68 -10 1 C-6.59437148 0.22157062 -3.49234244 -0.09978121 0 0 Z ",
    fill: "#A365A8",
    transform: "translate(555,496)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.455 0.99 4.455 0.99 9 2 C8.01 3.485 8.01 3.485 7 5 C4.69 4.67 2.38 4.34 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#BE4E94",
    transform: "translate(504,413)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2.8515625 3.06640625 C3.10679687 3.89011719 3.36203125 4.71382813 3.625 5.5625 C3.88539063 6.38878906 4.14578125 7.21507812 4.4140625 8.06640625 C4.60742188 8.70449219 4.80078125 9.34257812 5 10 C3.68 8.68 2.36 7.36 1 6 C0.01 6.66 -0.98 7.32 -2 8 C-3.0625 6.1875 -3.0625 6.1875 -4 4 C-3.67 3.01 -3.34 2.02 -3 1 C-2.34 1.66 -1.68 2.32 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#EF3E8C",
    transform: "translate(457,386)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.67 4.29 0.34 8.58 0 13 C-1.65 12.67 -3.3 12.34 -5 12 C-4.67 10.02 -4.34 8.04 -4 6 C-3.34 6.33 -2.68 6.66 -2 7 C-1.34 4.69 -0.68 2.38 0 0 Z ",
    fill: "#8587C3",
    transform: "translate(657,306)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.36720387 1.39332574 4.9859524 2.9789286 7 6 C6.01 7.485 6.01 7.485 5 9 C0 3.375 0 3.375 0 0 Z ",
    fill: "#B65899",
    transform: "translate(544,177)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.51977578 3.03955157 1.02837619 4.89865646 0.125 8.125 C-1 11 -1 11 -3 12 C-3.75 9.375 -3.75 9.375 -4 6 C-2.0625 2.625 -2.0625 2.625 0 0 Z ",
    fill: "#8687C2",
    transform: "translate(637,352)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95696581 1.23924145 7.11658466 2.78577758 10 7 C8.53775201 6.57576756 7.08026588 6.13509755 5.625 5.6875 C4.81289063 5.44386719 4.00078125 5.20023438 3.1640625 4.94921875 C1 4 1 4 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#876A9D",
    transform: "translate(569,127)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C3.97 3.33 6.94 3.66 10 4 C6.38863788 5.80568106 5.455469 6.24851563 1.75 6.125 C-0.10625 6.063125 -0.10625 6.063125 -2 6 C-1.125 1.125 -1.125 1.125 0 0 Z ",
    fill: "#B1437B",
    transform: "translate(503,308)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 3.63 1.66 7.26 2 11 C1.01 11.66 0.02 12.32 -1 13 C-1.1953125 10.94921875 -1.390625 8.8984375 -1.5859375 6.84765625 C-1.72257813 6.23792969 -1.85921875 5.62820313 -2 5 C-2.66 4.67 -3.32 4.34 -4 4 C-3.34 3.34 -2.68 2.68 -2 2 C-1.67 2.66 -1.34 3.32 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#7C7DB2",
    transform: "translate(659,283)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.53625 1.62875 3.0725 1.2575 3.625 0.875 C6 0 6 0 9.125 0.625 C12 2 12 2 13.375 4.125 C13.58125 4.74375 13.7875 5.3625 14 6 C13.236875 5.690625 12.47375 5.38125 11.6875 5.0625 C7.88786528 3.56031883 5.07361224 2.88990237 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#7B628C",
    transform: "translate(546,85)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.95803507 -0.05389087 3.91648909 -0.09274217 5.875 -0.125 C7.51082031 -0.15980469 7.51082031 -0.15980469 9.1796875 -0.1953125 C12 0 12 0 14 2 C11.05613377 3.47193312 8.62609964 2.84936173 5.375 2.5625 C4.18648437 2.46066406 2.99796875 2.35882812 1.7734375 2.25390625 C0.85820313 2.17011719 -0.05703125 2.08632813 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#777FAD",
    transform: "translate(715,568)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.375 1 2.375 1 5 3 C6.04768041 5.66921593 6.48684546 8.15432483 7 11 C4.0444623 8.24829249 1.88436685 5.58029701 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#B33773",
    transform: "translate(391,437)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4.33 0.99 4.66 1.98 5 3 C2.525 4.485 2.525 4.485 0 6 C0 5.01 0 4.02 0 3 C-0.66 2.67 -1.32 2.34 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#8D77B1",
    transform: "translate(584,378)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.4726862 5.27263601 -1.42695432 6.72014048 -4.6875 8.3125 C-5.450625 8.539375 -6.21375 8.76625 -7 9 C-6.34 7.02 -5.68 5.04 -5 3 C-4.01 3 -3.02 3 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z ",
    fill: "#7577A6",
    transform: "translate(679,366)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C4.67 2.98 4.34 4.96 4 7 C2.68 7 1.36 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#7979AC",
    transform: "translate(651,318)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.02350324 3.03525486 2.32124018 4.19426202 2.625 7.6875 C2.69976563 8.49574219 2.77453125 9.30398437 2.8515625 10.13671875 C2.90054688 10.75160156 2.94953125 11.36648437 3 12 C2.01 12 1.02 12 0 12 C-1.31157516 9.37684968 -0.89649988 7.76966564 -0.5625 4.875 C-0.46066406 3.96492187 -0.35882812 3.05484375 -0.25390625 2.1171875 C-0.17011719 1.41851562 -0.08632813 0.71984375 0 0 Z ",
    fill: "#7E7CB3",
    transform: "translate(631,224)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.25524265 3.02272532 5.61820737 6.25718301 8 10 C7.67 10.66 7.34 11.32 7 12 C2.5991297 8.17819158 1.19194469 5.52628901 0 0 Z ",
    fill: "#716B95",
    transform: "translate(623,144)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.99 2 3.98 2 5 2 C5 2.66 5 3.32 5 4 C5.66 4 6.32 4 7 4 C7.33 4.99 7.66 5.98 8 7 C3.68607774 6.5206753 1.83430453 5.2542015 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#7A7398",
    transform: "translate(563,1)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-5.94 1 -11.88 1 -18 1 C-18 0.67 -18 0.34 -18 0 C-11.26853564 -1.79321797 -6.6476565 -2.2158855 0 0 Z ",
    fill: "#87315D",
    transform: "translate(490,571)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-4.455 3.495 -4.455 3.495 -9 4 C-9 3.34 -9 2.68 -9 2 C-9.66 1.67 -10.32 1.34 -11 1 C-7.32589215 -0.17571451 -3.83070817 -0.07366746 0 0 Z ",
    fill: "#8772AB",
    transform: "translate(577,431)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.0625 1.8125 -0.0625 1.8125 -1 4 C-4.4375 5.8125 -4.4375 5.8125 -8 7 C-8.66 6.67 -9.32 6.34 -10 6 C-8.71283353 4.99421411 -7.42011342 3.99553202 -6.125 3 C-5.40570312 2.443125 -4.68640625 1.88625 -3.9453125 1.3125 C-2 0 -2 0 0 0 Z ",
    fill: "#827EB7",
    transform: "translate(611,414)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.763125 0.20625 1.52625 0.4125 2.3125 0.625 C0.14562509 2.90021866 -2.14370509 4.78294162 -4.6875 6.625 C-5.3475 6.295 -6.0075 5.965 -6.6875 5.625 C-6.375 3.75 -6.375 3.75 -5.6875 1.625 C-2.6875 -0.375 -2.6875 -0.375 0 0 Z ",
    fill: "#A23E72",
    transform: "translate(395.6875,259.375)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C4.835 2.886875 4.67 3.77375 4.5 4.6875 C4.07004243 7.53596892 3.91558965 10.13004802 4 13 C1.12420019 8.68630028 0 5.19265239 0 0 Z ",
    fill: "#8E6199",
    transform: "translate(580,232)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.8274799 1.41292095 8.7162359 3.42974154 13 6 C11 7 11 7 8.65234375 6.328125 C7.75644531 5.97234375 6.86054687 5.6165625 5.9375 5.25 C5.03902344 4.90453125 4.14054688 4.5590625 3.21484375 4.203125 C1 3 1 3 0 0 Z ",
    fill: "#9570A6",
    transform: "translate(543,80)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.43090471 1.20842856 6.98112756 2.51668565 10 6 C4.68559972 6 3.78319167 4.52524678 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#8889C6",
    transform: "translate(597,50)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.99 8 1.98 8 3 C5.36 3 2.72 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#9C62A1",
    transform: "translate(536,437)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C0.625 6 0.625 6 -1 8 C-1.66 8 -2.32 8 -3 8 C-3.33 7.01 -3.66 6.02 -4 5 C-2.0625 2.3125 -2.0625 2.3125 0 0 Z ",
    fill: "#8388C2",
    transform: "translate(681,404)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.44216672 2.6598561 3.99504674 5.90288286 5 10 C3.125 9.75 3.125 9.75 1 9 C-0.25 6.9375 -0.25 6.9375 -1 5 C-0.34 4.67 0.32 4.34 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#7577A4",
    transform: "translate(690,113)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.93673644 1.31224548 6.22719294 2.91910327 9 6 C8.01 6.495 8.01 6.495 7 7 C5.82780457 6.21654285 4.66236332 5.42297164 3.5 4.625 C2.8503125 4.18414062 2.200625 3.74328125 1.53125 3.2890625 C1.0259375 2.86367187 0.520625 2.43828125 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9B75B4",
    transform: "translate(557,119)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C4.1875 3.5625 4.1875 3.5625 5 6 C4.34 6.66 3.68 7.32 3 8 C0.9375 5.6875 0.9375 5.6875 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#8588C2",
    transform: "translate(658,109)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.93200474 2.85276137 5.64315404 5.65079784 8 9 C7.67 9.66 7.34 10.32 7 11 C2.34012809 7.9342948 1.14514798 5.41342681 0 0 Z ",
    fill: "#67678A",
    transform: "translate(675,91)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.81618856 1.11903546 3.62785526 2.24541284 5.4375 3.375 C6.44683594 4.00148438 7.45617187 4.62796875 8.49609375 5.2734375 C11 7 11 7 12 9 C6.81298543 8.68563548 3.4052641 5.69966733 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9981BF",
    transform: "translate(570,95)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.91843445 2.626591 4.94517315 5.66976339 7 9 C7 9.66 7 10.32 7 11 C5.35 11 3.7 11 2 11 C2.3403125 10.1646875 2.3403125 10.1646875 2.6875 9.3125 C3.12433685 6.07990734 1.74925345 4.65886525 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4F566F",
    transform: "translate(965,760)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.46555316 0.73579212 2.92224487 1.48925126 4.375 2.25 C5.18710938 2.66765625 5.99921875 3.0853125 6.8359375 3.515625 C9.20801205 5.14267975 9.97094804 6.35386639 11 9 C6.39860359 7.51131293 3.49772906 5.25370145 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9C2959",
    transform: "translate(130,755)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.68841859 2.25245881 -4.64641875 3.88213958 -8 5 C-8.66 4.67 -9.32 4.34 -10 4 C-4.4 -2.2 -4.4 -2.2 0 0 Z ",
    fill: "#7A6492",
    transform: "translate(583,387)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 2.83967231 -0.40267181 5.23735711 -1 8 C-2.98 8.33 -4.96 8.66 -7 9 C-6.02180976 7.68677212 -5.0424189 6.37443848 -4.0625 5.0625 C-3.51722656 4.33160156 -2.97195313 3.60070312 -2.41015625 2.84765625 C-1 1 -1 1 0 0 Z ",
    fill: "#8078AF",
    transform: "translate(606,359)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.39593478 -0.52165948 4.06619881 -2.5 6.6875 C-2.9640625 7.31011719 -3.428125 7.93273437 -3.90625 8.57421875 C-4.2671875 9.04472656 -4.628125 9.51523437 -5 10 C-6 7 -6 7 -5.3125 5 C-3.82522999 2.73368379 -2.24230766 1.49487177 0 0 Z ",
    fill: "#C33A79",
    transform: "translate(402,315)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 1 7 C0.34 7 -0.32 7 -1 7 C-1.33 7.99 -1.66 8.98 -2 10 C-2.66 8.35 -3.32 6.7 -4 5 C-3.34 5 -2.68 5 -2 5 C-1.34 3.35 -0.68 1.7 0 0 Z ",
    fill: "#95639E",
    transform: "translate(584,292)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.95261487 4.76307437 2.08333357 9.1666528 2 14 C1.01 13.67 0.02 13.34 -1 13 C-0.67 8.71 -0.34 4.42 0 0 Z ",
    fill: "#8D91CE",
    transform: "translate(725,214)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C1.99 3.33 2.98 3.66 4 4 C0.37 4 -3.26 4 -7 4 C-7 3.34 -7 2.68 -7 2 C-7.99 1.67 -8.98 1.34 -10 1 C-6.7 1.33 -3.4 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#A65F98",
    transform: "translate(492,89)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.99996286 1.33332095 4.83782337 3.4957827 7 7 C6.67 7.66 6.34 8.32 6 9 C0.42857143 3.85714286 0.42857143 3.85714286 0 0 Z ",
    fill: "#BD3877",
    transform: "translate(395,432)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C-1.70879335 5.35439668 -4.00933268 5.06501451 -7 5 C-4.87219421 2.65941363 -2.88437779 1.29299694 0 0 Z ",
    fill: "#9168A4",
    transform: "translate(567,390)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 2.64 2.34 5.28 2 8 C1.01 8 0.02 8 -1 8 C-0.67 5.36 -0.34 2.72 0 0 Z ",
    fill: "#878DCA",
    transform: "translate(719,314)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.43628586 4.26954202 0.50037734 5.82575883 -2 8 C-2.66 7.67 -3.32 7.34 -4 7 C-3.43628586 3.73045798 -2.50037734 2.17424117 0 0 Z ",
    fill: "#9D4877",
    transform: "translate(378,270)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.99 2.64 1.98 4 3 C3.67 3.99 3.34 4.98 3 6 C1.125 5.75 1.125 5.75 -1 5 C-2.25 2.9375 -2.25 2.9375 -3 1 C-2.01 1.33 -1.02 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#CA4A92",
    transform: "translate(526,219)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.62198774 2.15377564 -4.64404172 3.40072174 -8 4 C-8.33 3.01 -8.66 2.02 -9 1 C-5.64919071 -1.10976881 -3.77897651 -1.0497157 0 0 Z ",
    fill: "#A43F72",
    transform: "translate(390,208)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.59915881 0.69906942 -3.20455045 1.38389468 -4.8125 2.0625 C-5.70582031 2.44535156 -6.59914063 2.82820313 -7.51953125 3.22265625 C-10 4 -10 4 -13 3 C-12.34 3 -11.68 3 -11 3 C-11 2.34 -11 1.68 -11 1 C-3.375 -1.125 -3.375 -1.125 0 0 Z ",
    fill: "#C63A78",
    transform: "translate(303,14)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C1.99 3.33 2.98 3.66 4 4 C3.01 4.495 3.01 4.495 2 5 C1.34444881 7.52733235 1.34444881 7.52733235 1 10 C0.67 10 0.34 10 0 10 C0 8.02 0 6.04 0 4 C-1.32 3.67 -2.64 3.34 -4 3 C-2.68 3 -1.36 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#596181",
    transform: "translate(796,651)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 6.93 1 13.86 1 21 C0.67 21 0.34 21 0 21 C0 14.07 0 7.14 0 0 Z ",
    fill: "#808AC2",
    transform: "translate(725,609)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.25 2.25 2.25 2.25 2 5 C0 7.3125 0 7.3125 -2 9 C-2.33 8.34 -2.66 7.68 -3 7 C-2.06421005 4.64018187 -1.06652192 2.30368736 0 0 Z ",
    fill: "#827FB9",
    transform: "translate(622,332)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.93423645 3.01031744 1.04449911 3.86650268 0 7 C-0.99 7 -1.98 7 -3 7 C-3.33 7.66 -3.66 8.32 -4 9 C-4 6.69 -4 4.38 -4 2 C-3.34 2.66 -2.68 3.32 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#7B7CAC",
    transform: "translate(663,241)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.32643967 2.98232523 5.29152862 5.86370087 7 10 C6.67 10.66 6.34 11.32 6 12 C5.05598958 10.20963542 4.11197917 8.41927083 3.16796875 6.62890625 C2.00980201 4.67732013 2.00980201 4.67732013 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#8D85C2",
    transform: "translate(608,169)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.79872437 2.52788007 4.45773019 4.20411134 5 8 C4.566875 7.505 4.13375 7.01 3.6875 6.5 C2.00259517 4.66781808 2.00259517 4.66781808 -1 5 C-1.33 3.68 -1.66 2.36 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#686084",
    transform: "translate(652,145)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.37503669 1.1858237 5.64722731 2.27573689 8 5 C7.01 6.485 7.01 6.485 6 8 C4.02 5.36 2.04 2.72 0 0 Z ",
    fill: "#8E82BD",
    transform: "translate(603,125)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.51830747 4.12270126 -1.7261549 4.94523098 -5.75 5.75 C-7.35875 5.87375 -7.35875 5.87375 -9 6 C-6.12050853 3.76039553 -3.23257974 1.70135776 0 0 Z ",
    fill: "#BE3772",
    transform: "translate(269,26)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.29 1 8.58 1 13 C-2.18518519 6.62962963 -2.18518519 6.62962963 -1.0625 2.8125 C-0.711875 1.884375 -0.36125 0.95625 0 0 Z ",
    fill: "#912C57",
    transform: "translate(109,663)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.45792884 -0.05399736 2.91642712 -0.09279177 4.375 -0.125 C5.18710937 -0.14820313 5.99921875 -0.17140625 6.8359375 -0.1953125 C9 0 9 0 11 2 C7.37 2.33 3.74 2.66 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#808AC0",
    transform: "translate(724,605)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C1.8141763 3.37503669 0.72426311 5.64722731 -2 8 C-1.125 1.125 -1.125 1.125 0 0 Z ",
    fill: "#8488C6",
    transform: "translate(687,395)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C1.66 4 2.32 4 3 4 C3 5.65 3 7.3 3 9 C2.01 9 1.02 9 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#807FB8",
    transform: "translate(635,243)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C-1.64 3.67 -4.28 3.34 -7 3 C-7.33 2.01 -7.66 1.02 -8 0 C-4.71023192 -1.09658936 -3.28696233 -0.79953138 0 0 Z ",
    fill: "#D13C83",
    transform: "translate(483,240)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.66 0 -1.32 0 -2 0 C-2 0.66 -2 1.32 -2 2 C-3.98 2.66 -5.96 3.32 -8 4 C-8.66 3.34 -9.32 2.68 -10 2 C-3.375 -1.125 -3.375 -1.125 0 0 Z ",
    fill: "#BF4780",
    transform: "translate(402,203)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.125 0.9375 2.125 0.9375 4 2 C3.67 3.32 3.34 4.64 3 6 C0 5 0 5 -1.1875 2.9375 C-1.5896875 1.9784375 -1.5896875 1.9784375 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#7C7EB2",
    transform: "translate(681,101)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.93673644 1.31224548 6.22719294 2.91910327 9 6 C6.75 6.375 6.75 6.375 4 6 C1.6875 3 1.6875 3 0 0 Z ",
    fill: "#6E6D94",
    transform: "translate(599,22)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.79953138 3.28696233 3.09658936 4.71023192 2 8 C1.34 8 0.68 8 0 8 C-0.79953138 4.71303767 -1.09658936 3.28976808 0 0 Z ",
    fill: "#8184BC",
    transform: "translate(716,176)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C3.38232443 1.62626404 4.71937515 3.2925002 6 5 C5.67 5.66 5.34 6.32 5 7 C2.5 5.75 2.5 5.75 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#8D86C4",
    transform: "translate(613,134)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.375 2.9375 1.375 2.9375 0 5 C-3.125 5.75 -3.125 5.75 -6 6 C-4 4 -2 2 0 0 Z ",
    fill: "#72729F",
    transform: "translate(625,424)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C3.6875 2.5 3.6875 2.5 1 5 C0.01 5 -0.98 5 -2 5 C-1.34 4.34 -0.68 3.68 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#6E6B93",
    transform: "translate(618,408)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1 5 1 5 -1 7 C-1.66 5.02 -2.32 3.04 -3 1 C-2.01 0.67 -1.02 0.34 0 0 Z ",
    fill: "#716C98",
    transform: "translate(625,205)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.375 0.25 2.375 0.25 5 1 C6.3125 3.0625 6.3125 3.0625 7 5 C3.34683329 3.75023244 2.21934164 3.32901247 0 0 Z ",
    fill: "#D2286D",
    transform: "translate(220,776)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.455 0.99 4.455 0.99 9 2 C5.00889681 3.9955516 3.30013434 4.19546065 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#7E86BB",
    transform: "translate(556,734)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0625 1.8125 1.0625 1.8125 2 4 C1.67 4.99 1.34 5.98 1 7 C1.66 7 2.32 7 3 7 C3 7.99 3 8.98 3 10 C1.68 9.34 0.36 8.68 -1 8 C-0.67 5.36 -0.34 2.72 0 0 Z ",
    fill: "#828CC4",
    transform: "translate(725,644)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C3.67 0.99 3.34 1.98 3 3 C1.35 3.33 -0.3 3.66 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#8478B1",
    transform: "translate(591,400)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.50168276 3.68754757 0.89932357 5.60490662 -2 8 C-2.66 7.67 -3.32 7.34 -4 7 C-3.525625 6.5875 -3.05125 6.175 -2.5625 5.75 C-0.83733482 3.817815 -0.43415125 2.51807725 0 0 Z ",
    fill: "#746E99",
    transform: "translate(610,388)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 4.29 1.34 8.58 1 13 C0.67 13 0.34 13 0 13 C-0.19397476 11.02145742 -0.38001321 9.0421352 -0.5625 7.0625 C-0.66691406 5.96035156 -0.77132812 4.85820312 -0.87890625 3.72265625 C-0.91886719 2.82417969 -0.95882812 1.92570312 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#6A6A8F",
    transform: "translate(657,274)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C1.66 3 2.32 3 3 3 C2.67 5.97 2.34 8.94 2 12 C1.67 12 1.34 12 1 12 C0.67 8.04 0.34 4.08 0 0 Z ",
    fill: "#898FD0",
    transform: "translate(678,214)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0.66 5.28 1.32 8 2 C8 2.99 8 3.98 8 5 C4.62496331 3.8141763 2.35277269 2.72426311 0 0 Z ",
    fill: "#934378",
    transform: "translate(501,205)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C0.67 10 0.34 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#7F8AC0",
    transform: "translate(725,705)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.5625 1.25 1.5625 1.25 3 3 C2.6875 5.1875 2.6875 5.1875 2 7 C1.34 4.69 0.68 2.38 0 0 Z ",
    fill: "#8782AF",
    transform: "translate(640,189)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.32 1.98 2.64 3 4 C2.01 4 1.02 4 0 4 C-0.66 3.34 -1.32 2.68 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8282AD",
    transform: "translate(682,163)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.99 1.98 1.98 3 3 C2.67 3.66 2.34 4.32 2 5 C1.34 4.67 0.68 4.34 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#7D86BA",
    transform: "translate(850,643)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.32 1.98 2.64 3 4 C2.34 4.99 1.68 5.98 1 7 C0.67 4.69 0.34 2.38 0 0 Z ",
    fill: "#8585B1",
    transform: "translate(684,220)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.625 4.125 1.625 4.125 1 6 C-0.0625 4.125 -0.0625 4.125 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#8381AB",
    transform: "translate(667,188)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-1.65 2.67 -3.3 2.34 -5 2 C-5 1.67 -5 1.34 -5 1 C-3.35 0.67 -1.7 0.34 0 0 Z ",
    fill: "#7479A5",
    transform: "translate(607,770)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C0.67 8 0.34 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#EA3D83",
    transform: "translate(405,618)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.66 1.98 1.32 3 2 C0.69 2 -1.62 2 -4 2 C-2.68 1.34 -1.36 0.68 0 0 Z ",
    fill: "#767FAE",
    transform: "translate(790,568)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.495 2.97 0.495 6 1 C6 1.33 6 1.66 6 2 C3.69 2 1.38 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#7881AE",
    transform: "translate(779,568)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C4.01 2.495 4.01 2.495 3 3 C2.01 2.67 1.02 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#B75F97",
    transform: "translate(483,429)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1.33 2.38 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#A16B9F",
    transform: "translate(529,404)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.34 4.32 0.68 5.64 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#DA5493",
    transform: "translate(436,369)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C0.67 8 0.34 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#8183AC",
    transform: "translate(722,240)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.67 3.99 1.34 4.98 1 6 C0 5 0 5 -0.0625 2.4375 C-0.041875 1.633125 -0.02125 0.82875 0 0 Z ",
    fill: "#8980AE",
    transform: "translate(626,225)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.32 1.98 2.64 3 4 C2.67 4.66 2.34 5.32 2 6 C0 3 0 3 0 0 Z ",
    fill: "#8381AD",
    transform: "translate(672,141)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C4.34 0.66 3.68 1.32 3 2 C2.01 2 1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8478A3",
    transform: "translate(491,6)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 2.32 1.34 3.64 1 5 C0 2 0 2 0 0 Z ",
    fill: "#7179A4",
    transform: "translate(922,763)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#8085B9",
    transform: "translate(584,606)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7881B0",
    transform: "translate(770,569)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.66 2.64 1.32 4 2 C2.02 2 0.04 2 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#797FAF",
    transform: "translate(708,568)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7A80AF",
    transform: "translate(698,569)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#A06C9F",
    transform: "translate(520,496)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C-0.0625 4.125 -0.0625 4.125 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#D95391",
    transform: "translate(403,364)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.34 3.66 -0.32 4.32 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z ",
    fill: "#8A81B0",
    transform: "translate(625,312)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#8385AF",
    transform: "translate(699,252)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.67 3.99 1.34 4.98 1 6 C0.67 4.02 0.34 2.04 0 0 Z ",
    fill: "#7D7CA2",
    transform: "translate(726,200)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 2 2 2 2 5 C1.34 4.67 0.68 4.34 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#8780AC",
    transform: "translate(632,171)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.34 2.32 0.68 3.64 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#7883B2",
    transform: "translate(804,738)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#EC3B83",
    transform: "translate(297,698)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7E87BB",
    transform: "translate(745,606)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#DE397B",
    transform: "translate(297,594)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.99 1.34 2.98 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#7A83B5",
    transform: "translate(816,582)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#8083B6",
    transform: "translate(562,569)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#8481B4",
    transform: "translate(538,569)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#877FB1",
    transform: "translate(530,569)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C4.01 1.495 4.01 1.495 3 2 C2.01 1.34 1.02 0.68 0 0 Z ",
    fill: "#A96A9E",
    transform: "translate(513,422)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.67 1.66 3.34 2.32 3 3 C2.01 2.01 1.02 1.02 0 0 Z ",
    fill: "#8485AF",
    transform: "translate(689,312)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#8484B0",
    transform: "translate(698,227)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.01 2.34 0.02 1.68 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#8382AE",
    transform: "translate(673,216)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.99 2.34 1.98 2 3 C1.34 2.01 0.68 1.02 0 0 Z ",
    fill: "#897DAB",
    transform: "translate(618,205)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.01 3.34 0.02 2.68 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#8581AD",
    transform: "translate(643,196)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C0.01 4.495 0.01 4.495 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z ",
    fill: "#B74076",
    transform: "translate(321,165)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 1.66 2 2.32 2 3 C1.01 2.67 0.02 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#8281AB",
    transform: "translate(675,148)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.99 1.34 2.98 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#7B799E",
    transform: "translate(702,130)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#7982B2",
    transform: "translate(804,747)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 2.66 -0.32 3.32 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#7D86BC",
    transform: "translate(660,718)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#D63C77",
    transform: "translate(106,680)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EB3B82",
    transform: "translate(297,676)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.34 1.66 0.68 2.32 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#7D86B8",
    transform: "translate(915,667)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#E5397F",
    transform: "translate(235,635)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#E73B81",
    transform: "translate(297,626)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.99 1.34 2.98 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#7C85B6",
    transform: "translate(827,602)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#E13B7D",
    transform: "translate(297,602)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C2.01 2 1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#7B84B5",
    transform: "translate(869,597)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#666C92",
    transform: "translate(963,568)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7F83B6",
    transform: "translate(570,569)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.33 1.02 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9A73A6",
    transform: "translate(532,446)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.33 0.99 2.66 1.98 3 3 C2.34 3 1.68 3 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#7B7FAA",
    transform: "translate(690,443)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#A06A9E",
    transform: "translate(523,432)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C1.68 1.67 0.36 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#8383B0",
    transform: "translate(629,430)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C0.68 1.67 -0.64 1.34 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#7A7EA9",
    transform: "translate(707,417)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#DB5392",
    transform: "translate(436,363)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 2.485 1.01 2.485 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#8984B3",
    transform: "translate(632,352)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.33 0.99 2.66 1.98 3 3 C2.34 3 1.68 3 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#85729C",
    transform: "translate(336,321)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C0.34 3.67 -0.32 3.34 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#8B7CAA",
    transform: "translate(613,308)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.32 1.67 -1.64 1.34 -3 1 C-2.01 0.67 -1.02 0.34 0 0 Z ",
    fill: "#B26098",
    transform: "translate(539,284)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#8386B0",
    transform: "translate(708,241)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.34 2.01 0.68 1.02 0 0 Z ",
    fill: "#8684B2",
    transform: "translate(650,229)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.68 1.33 -0.64 1.66 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#AF5386",
    transform: "translate(403,204)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.33 1.02 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#AC5788",
    transform: "translate(442,196)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.01 3.495 1.01 3.495 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#8182AE",
    transform: "translate(688,180)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.01 2.33 0.02 2.66 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#8C7AA8",
    transform: "translate(603,172)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.34 3.67 0.68 3.34 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#7D7EA7",
    transform: "translate(707,164)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#A6598E",
    transform: "translate(495,157)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.33 1.02 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9173A1",
    transform: "translate(577,141)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 2.66 -0.32 3.32 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#8380AB",
    transform: "translate(665,128)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.01 2.33 -0.98 2.66 -2 3 C-2 2.34 -2 1.68 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#9F4372",
    transform: "translate(291,20)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#CD3675",
    transform: "translate(185,784)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#E53A7A",
    transform: "translate(432,736)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#EB3C81",
    transform: "translate(297,715)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#7C87B9",
    transform: "translate(917,671)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#7C87BB",
    transform: "translate(856,654)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#E73C81",
    transform: "translate(405,606)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#8185BA",
    transform: "translate(563,606)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#8182B5",
    transform: "translate(554,569)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#8282B6",
    transform: "translate(546,569)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#777AA3",
    transform: "translate(705,452)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9974A7",
    transform: "translate(538,443)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#7D82AC",
    transform: "translate(689,437)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#C6528D",
    transform: "translate(426,436)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.01 1.67 -0.98 1.34 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#8486B1",
    transform: "translate(652,432)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#CC528E",
    transform: "translate(411,412)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#C15994",
    transform: "translate(481,405)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#8B80AF",
    transform: "translate(596,383)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#D05592",
    transform: "translate(464,372)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#8D7EAD",
    transform: "translate(604,352)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#D95393",
    transform: "translate(467,340)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#8284AE",
    transform: "translate(703,309)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#7C7CA2",
    transform: "translate(727,300)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#8284AD",
    transform: "translate(721,282)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#8385B0",
    transform: "translate(708,268)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#8285AE",
    transform: "translate(722,267)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#C35690",
    transform: "translate(491,254)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9275A7",
    transform: "translate(590,250)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#9374A7",
    transform: "translate(589,244)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.01 2.495 1.01 2.495 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#8783B0",
    transform: "translate(638,234)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#8182AC",
    transform: "translate(691,190)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#CA437E",
    transform: "translate(340,183)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C2.01 2 1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#827FAA",
    transform: "translate(669,172)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#847AA7",
    transform: "translate(648,148)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#A75586",
    transform: "translate(403,145)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7A799C",
    transform: "translate(677,90)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#827EA8",
    transform: "translate(641,62)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#827DA5",
    transform: "translate(567,35)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#8377A1",
    transform: "translate(488,5)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#A04774",
    transform: "translate(341,3)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#C23871",
    transform: "translate(249,813)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#C53770",
    transform: "translate(204,807)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#6B7298",
    transform: "translate(929,773)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#6D759C",
    transform: "translate(845,772)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#7578A3",
    transform: "translate(584,772)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#C33C72",
    transform: "translate(299,772)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#757BA9",
    transform: "translate(598,771)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#CC3977",
    transform: "translate(297,768)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7680AF",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E23B80",
    transform: "translate(0,0)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#7B84B6",
    transform: "translate(869,735)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CF3A76",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#7C85B8",
    transform: "translate(906,732)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C85B7",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E83A81",
    transform: "translate(0,0)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#7E88BB",
    transform: "translate(833,720)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C87BB",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#E83980",
    transform: "translate(233,714)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E9387E",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#7D88BB",
    transform: "translate(889,701)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D23B78",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D43D78",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC3C83",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC3C82",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB3D83",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808AC3",
    transform: "translate(0,0)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E73C81",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB3D83",
    transform: "translate(0,0)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E88BC",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3C84",
    transform: "translate(0,0)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#E63B81",
    transform: "translate(233,629)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E93B81",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#E8387F",
    transform: "translate(225,613)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#7F86BC",
    transform: "translate(608,613)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E33A7F",
    transform: "translate(0,0)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#7C84B6",
    transform: "translate(796,606)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#8185BA",
    transform: "translate(571,606)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#D74683",
    transform: "translate(473,606)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#7A84B6",
    transform: "translate(818,589)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DB3C7D",
    transform: "translate(0,0)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#747CA8",
    transform: "translate(805,571)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#757AA6",
    transform: "translate(807,569)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#797DAE",
    transform: "translate(691,569)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#7E81B4",
    transform: "translate(586,569)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#CC3672",
    transform: "translate(213,568)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#8F78AA",
    transform: "translate(555,502)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#A56298",
    transform: "translate(499,478)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#A65F96",
    transform: "translate(496,477)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8580B0",
    transform: "translate(600,472)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#9E6FA3",
    transform: "translate(517,463)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8584B2",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#8585B0",
    transform: "translate(626,457)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#7F7DAD",
    transform: "translate(645,454)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#8780B0",
    transform: "translate(588,454)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#A3699F",
    transform: "translate(509,451)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#8782AF",
    transform: "translate(599,450)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#8C7FAF",
    transform: "translate(572,448)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#C7528F",
    transform: "translate(434,445)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#BE4E85",
    transform: "translate(393,445)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8180AE",
    transform: "translate(661,438)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#8B80AF",
    transform: "translate(571,438)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#8A80AF",
    transform: "translate(580,435)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8385B2",
    transform: "translate(648,433)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8786B3",
    transform: "translate(619,425)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#9375A5",
    transform: "translate(549,423)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#7D81AD",
    transform: "translate(700,419)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF4F88",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#9B6FA3",
    transform: "translate(539,404)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#8C80AF",
    transform: "translate(592,395)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#D75393",
    transform: "translate(427,390)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#9279AA",
    transform: "translate(577,376)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#8784B2",
    transform: "translate(629,375)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45390",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#907CAC",
    transform: "translate(588,371)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF5494",
    transform: "translate(0,0)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DE5492",
    transform: "translate(388,349)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8787B5",
    transform: "translate(680,347)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#8E77A7",
    transform: "translate(607,326)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#DF5593",
    transform: "translate(460,326)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9176A7",
    transform: "translate(600,322)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9279A8",
    transform: "translate(600,319)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#7E7EA2",
    transform: "translate(724,318)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F77A7",
    transform: "translate(602,317)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8989B5",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9278A7",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384AD",
    transform: "translate(0,0)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B1",
    transform: "translate(0,0)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#8485B3",
    transform: "translate(674,301)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8586B1",
    transform: "translate(675,296)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B1",
    transform: "translate(0,0)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8386B0",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#D7528F",
    transform: "translate(452,275)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8486B1",
    transform: "translate(708,262)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0609A",
    transform: "translate(0,0)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8182AC",
    transform: "translate(0,0)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8386B0",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8183AC",
    transform: "translate(0,0)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3639B",
    transform: "translate(0,0)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#BD548C",
    transform: "translate(434,245)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8982AE",
    transform: "translate(0,0)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#8386B1",
    transform: "translate(699,237)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8883B2",
    transform: "translate(0,0)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#8584AF",
    transform: "translate(675,225)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8583AF",
    transform: "translate(0,0)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8981AD",
    transform: "translate(0,0)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#9E6DA1",
    transform: "translate(570,220)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8688B5",
    transform: "translate(0,0)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#AF5485",
    transform: "translate(397,207)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8583AE",
    transform: "translate(0,0)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#AE588C",
    transform: "translate(474,198)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#AD5989",
    transform: "translate(433,197)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#AA5686",
    transform: "translate(451,196)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8383AE",
    transform: "translate(0,0)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#8A7BA7",
    transform: "translate(610,185)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807FAA",
    transform: "translate(0,0)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#8781AC",
    transform: "translate(635,179)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8681AC",
    transform: "translate(645,177)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#8C7AA9",
    transform: "translate(605,174)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B94077",
    transform: "translate(0,0)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#7B7BA0",
    transform: "translate(718,170)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8882AD",
    transform: "translate(637,162)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#817FA9",
    transform: "translate(705,158)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#A35A8E",
    transform: "translate(500,158)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#A45E92",
    transform: "translate(508,152)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817FA9",
    transform: "translate(0,0)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#A85586",
    transform: "translate(418,150)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8B7CAA",
    transform: "translate(616,146)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#7A799D",
    transform: "translate(709,146)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#887EAB",
    transform: "translate(653,143)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8180A9",
    transform: "translate(0,0)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827FA8",
    transform: "translate(0,0)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8581AD",
    transform: "translate(656,114)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#8381A9",
    transform: "translate(662,106)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#7A799C",
    transform: "translate(685,97)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#8480AA",
    transform: "translate(653,96)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#926A98",
    transform: "translate(501,91)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#913D69",
    transform: "translate(229,54)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#857EA7",
    transform: "translate(584,47)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807EA5",
    transform: "translate(0,0)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#7D7BA1",
    transform: "translate(613,28)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#7C7BA0",
    transform: "translate(613,25)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#827AA2",
    transform: "translate(514,12)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#7E78A0",
    transform: "translate(564,6)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#857BA7",
    transform: "translate(501,0)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BE3970",
    transform: "translate(244,814)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BF3971",
    transform: "translate(227,814)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#C33670",
    transform: "translate(216,812)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD3673",
    transform: "translate(0,0)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7275A1",
    transform: "translate(580,775)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7478A4",
    transform: "translate(0,0)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#CE3876",
    transform: "translate(154,773)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7077A2",
    transform: "translate(810,772)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7D6892",
    transform: "translate(517,772)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#777CAD",
    transform: "translate(625,765)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#CF3776",
    transform: "translate(139,765)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F77A1",
    transform: "translate(0,0)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767FB0",
    transform: "translate(0,0)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757EAE",
    transform: "translate(0,0)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E13B7D",
    transform: "translate(0,0)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#CC3B76",
    transform: "translate(121,749)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7780AE",
    transform: "translate(0,0)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D71A2",
    transform: "translate(0,0)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7882AE",
    transform: "translate(868,743)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7883B4",
    transform: "translate(805,743)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7A84B3",
    transform: "translate(806,741)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E33B7E",
    transform: "translate(0,0)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#E5397D",
    transform: "translate(446,736)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#E6387D",
    transform: "translate(424,736)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E83980",
    transform: "translate(0,0)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7C85B6",
    transform: "translate(826,732)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A83B6",
    transform: "translate(0,0)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D77A9",
    transform: "translate(0,0)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E23B7F",
    transform: "translate(0,0)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF387E",
    transform: "translate(0,0)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E93C81",
    transform: "translate(0,0)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D78AA",
    transform: "translate(0,0)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7B85B3",
    transform: "translate(899,721)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7882B4",
    transform: "translate(0,0)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D85B9",
    transform: "translate(0,0)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E23A7F",
    transform: "translate(0,0)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A84B4",
    transform: "translate(0,0)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E78AB",
    transform: "translate(0,0)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E83A81",
    transform: "translate(0,0)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86B9",
    transform: "translate(0,0)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3C83",
    transform: "translate(0,0)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86BA",
    transform: "translate(0,0)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F87BC",
    transform: "translate(0,0)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC3C85",
    transform: "translate(0,0)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D88BB",
    transform: "translate(0,0)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7985B6",
    transform: "translate(0,0)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C5538C",
    transform: "translate(0,0)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D83C76",
    transform: "translate(0,0)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7B87B5",
    transform: "translate(922,681)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E78AA",
    transform: "translate(0,0)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA3E7A",
    transform: "translate(0,0)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907CAC",
    transform: "translate(0,0)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D85BA",
    transform: "translate(0,0)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A85B6",
    transform: "translate(0,0)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9279AC",
    transform: "translate(0,0)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C84B4",
    transform: "translate(0,0)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D63B76",
    transform: "translate(0,0)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC3E85",
    transform: "translate(0,0)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#917AAB",
    transform: "translate(0,0)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E93C82",
    transform: "translate(0,0)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D53B78",
    transform: "translate(0,0)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D23A76",
    transform: "translate(0,0)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7B83B5",
    transform: "translate(932,639)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC3C83",
    transform: "translate(0,0)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#818CC3",
    transform: "translate(0,0)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE3B75",
    transform: "translate(0,0)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#818BC3",
    transform: "translate(0,0)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7881B3",
    transform: "translate(0,0)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7F88BD",
    transform: "translate(892,632)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7E87BB",
    transform: "translate(841,629)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E13C7E",
    transform: "translate(0,0)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E4397F",
    transform: "translate(0,0)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8287BE",
    transform: "translate(0,0)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E53B81",
    transform: "translate(0,0)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C85B8",
    transform: "translate(0,0)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F88BB",
    transform: "translate(0,0)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D85B9",
    transform: "translate(0,0)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7E86BC",
    transform: "translate(611,614)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E87BB",
    transform: "translate(0,0)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7F87BB",
    transform: "translate(609,611)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8188C0",
    transform: "translate(600,607)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#DD3677",
    transform: "translate(216,607)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#E3397C",
    transform: "translate(199,602)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D84B8",
    transform: "translate(0,0)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#C63B72",
    transform: "translate(121,597)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D85B8",
    transform: "translate(0,0)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737BA6",
    transform: "translate(0,0)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D83B7A",
    transform: "translate(0,0)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757EAA",
    transform: "translate(0,0)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A70A1",
    transform: "translate(0,0)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7B81B4",
    transform: "translate(604,570)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7E81B3",
    transform: "translate(594,569)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8184B7",
    transform: "translate(583,569)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8382B6",
    transform: "translate(551,569)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8B7CAD",
    transform: "translate(522,569)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7278A1",
    transform: "translate(814,568)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B95992",
    transform: "translate(474,501)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A6699B",
    transform: "translate(515,496)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#867EAD",
    transform: "translate(588,491)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#827DAA",
    transform: "translate(598,487)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8880AE",
    transform: "translate(587,481)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B55890",
    transform: "translate(470,469)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8582B0",
    transform: "translate(612,468)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7689E",
    transform: "translate(0,0)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8C7DAE",
    transform: "translate(560,462)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A36A9F",
    transform: "translate(0,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8B7DAB",
    transform: "translate(570,460)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8B7FAE",
    transform: "translate(574,459)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BA568E",
    transform: "translate(451,459)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B36299",
    transform: "translate(0,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8E7DAF",
    transform: "translate(560,448)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8581B0",
    transform: "translate(604,447)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C72A5",
    transform: "translate(0,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9674A7",
    transform: "translate(542,443)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9A72A4",
    transform: "translate(534,443)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484B1",
    transform: "translate(0,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF629B",
    transform: "translate(0,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E81AD",
    transform: "translate(0,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8984B2",
    transform: "translate(589,431)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#C75692",
    transform: "translate(449,430)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8282AF",
    transform: "translate(0,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8883B2",
    transform: "translate(596,428)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8385B1",
    transform: "translate(657,426)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8686B4",
    transform: "translate(621,424)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8682B0",
    transform: "translate(605,423)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9689E",
    transform: "translate(0,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7C81AD",
    transform: "translate(698,420)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B4",
    transform: "translate(0,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#797CA7",
    transform: "translate(710,419)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A80AA",
    transform: "translate(0,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D82AD",
    transform: "translate(0,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B76199",
    transform: "translate(494,415)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8D7FB0",
    transform: "translate(580,414)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BA5E98",
    transform: "translate(491,413)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC528E",
    transform: "translate(0,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8483AF",
    transform: "translate(0,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8981B0",
    transform: "translate(594,406)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D0548F",
    transform: "translate(0,0)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE5087",
    transform: "translate(0,0)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9A70A3",
    transform: "translate(542,403)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A9699E",
    transform: "translate(521,403)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8886B3",
    transform: "translate(0,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#907FAF",
    transform: "translate(579,401)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8B80AB",
    transform: "translate(585,400)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A80AE",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A06FA3",
    transform: "translate(538,393)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A36B9F",
    transform: "translate(530,393)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8B80AE",
    transform: "translate(596,392)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A66A9E",
    transform: "translate(522,392)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45492",
    transform: "translate(0,0)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8889B6",
    transform: "translate(0,0)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D55590",
    transform: "translate(0,0)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181AB",
    transform: "translate(0,0)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8788B3",
    transform: "translate(0,0)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9278A6",
    transform: "translate(569,384)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8B7CAA",
    transform: "translate(589,383)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D85594",
    transform: "translate(0,0)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8686B3",
    transform: "translate(0,0)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8885B3",
    transform: "translate(0,0)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8987B5",
    transform: "translate(0,0)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CF5493",
    transform: "translate(0,0)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9179A9",
    transform: "translate(0,0)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D3548E",
    transform: "translate(0,0)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C75A94",
    transform: "translate(0,0)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9872A2",
    transform: "translate(0,0)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8483AF",
    transform: "translate(0,0)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7FA7",
    transform: "translate(0,0)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BA5D97",
    transform: "translate(498,365)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7EA7",
    transform: "translate(0,0)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8787B2",
    transform: "translate(672,361)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7DAC",
    transform: "translate(0,0)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8586B2",
    transform: "translate(685,359)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA5491",
    transform: "translate(0,0)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9373A3",
    transform: "translate(576,352)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8885B6",
    transform: "translate(0,0)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D05393",
    transform: "translate(0,0)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC5795",
    transform: "translate(0,0)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8887B5",
    transform: "translate(658,349)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E05293",
    transform: "translate(0,0)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8981AF",
    transform: "translate(0,0)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#AF6399",
    transform: "translate(524,348)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8586B3",
    transform: "translate(680,345)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384B1",
    transform: "translate(0,0)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C80AE",
    transform: "translate(0,0)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C65A95",
    transform: "translate(0,0)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7DA5",
    transform: "translate(0,0)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8586B2",
    transform: "translate(684,336)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B55E97",
    transform: "translate(522,336)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8282AD",
    transform: "translate(0,0)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E79A7",
    transform: "translate(0,0)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B2",
    transform: "translate(0,0)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8986B2",
    transform: "translate(643,329)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897FAC",
    transform: "translate(0,0)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484AF",
    transform: "translate(0,0)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7FAC",
    transform: "translate(0,0)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#DA538F",
    transform: "translate(453,327)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B2",
    transform: "translate(0,0)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D75394",
    transform: "translate(0,0)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#D25594",
    transform: "translate(502,323)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8383AD",
    transform: "translate(0,0)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484B0",
    transform: "translate(0,0)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385AF",
    transform: "translate(0,0)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8183AB",
    transform: "translate(0,0)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8986B5",
    transform: "translate(0,0)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A87B4",
    transform: "translate(0,0)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#DB528F",
    transform: "translate(446,311)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7FAE",
    transform: "translate(0,0)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#DA508F",
    transform: "translate(468,308)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A80AC",
    transform: "translate(0,0)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8687B5",
    transform: "translate(0,0)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8886B5",
    transform: "translate(0,0)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#E14E90",
    transform: "translate(483,300)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8684B2",
    transform: "translate(0,0)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8487B4",
    transform: "translate(0,0)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485B2",
    transform: "translate(0,0)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8683B2",
    transform: "translate(0,0)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A6FA1",
    transform: "translate(0,0)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8689C",
    transform: "translate(0,0)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B3",
    transform: "translate(0,0)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9274A4",
    transform: "translate(0,0)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A56391",
    transform: "translate(0,0)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B7588E",
    transform: "translate(374,279)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9973A5",
    transform: "translate(0,0)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#D35390",
    transform: "translate(462,275)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485B1",
    transform: "translate(0,0)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8183AC",
    transform: "translate(0,0)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485AF",
    transform: "translate(0,0)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BA538C",
    transform: "translate(397,262)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD6298",
    transform: "translate(0,0)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8486AE",
    transform: "translate(0,0)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8486B0",
    transform: "translate(708,247)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385B0",
    transform: "translate(0,0)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#AC5283",
    transform: "translate(346,244)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9376A6",
    transform: "translate(0,0)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#BC558B",
    transform: "translate(446,243)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8384B0",
    transform: "translate(698,241)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B05E95",
    transform: "translate(0,0)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA5B90",
    transform: "translate(0,0)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384B0",
    transform: "translate(0,0)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8182AD",
    transform: "translate(0,0)"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8981AE",
    transform: "translate(0,0)"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8686B3",
    transform: "translate(0,0)"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8784B1",
    transform: "translate(0,0)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8884B1",
    transform: "translate(0,0)"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8084AD",
    transform: "translate(0,0)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485B1",
    transform: "translate(0,0)"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8284AE",
    transform: "translate(0,0)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484AF",
    transform: "translate(0,0)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7B9F",
    transform: "translate(0,0)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#AE5084",
    transform: "translate(375,209)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8781AE",
    transform: "translate(0,0)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#966D9E",
    transform: "translate(0,0)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#AA588D",
    transform: "translate(500,207)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EAC",
    transform: "translate(0,0)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5284",
    transform: "translate(0,0)"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8482AD",
    transform: "translate(0,0)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8383AD",
    transform: "translate(0,0)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A26499",
    transform: "translate(0,0)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A95587",
    transform: "translate(477,199)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B1568C",
    transform: "translate(427,198)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8383AB",
    transform: "translate(0,0)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897CAC",
    transform: "translate(0,0)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#AB5688",
    transform: "translate(409,195)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384AC",
    transform: "translate(0,0)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8683AF",
    transform: "translate(0,0)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#AD5688",
    transform: "translate(418,193)"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8180AB",
    transform: "translate(0,0)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A36699",
    transform: "translate(550,191)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8080A8",
    transform: "translate(0,0)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7CA9",
    transform: "translate(0,0)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A56397",
    transform: "translate(546,187)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8182AC",
    transform: "translate(0,0)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8581AB",
    transform: "translate(0,0)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8882AC",
    transform: "translate(0,0)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8B7DAB",
    transform: "translate(608,182)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8681AA",
    transform: "translate(0,0)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827FA9",
    transform: "translate(0,0)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8380AB",
    transform: "translate(0,0)"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7AA7",
    transform: "translate(0,0)"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8281AA",
    transform: "translate(669,169)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7AA8",
    transform: "translate(0,0)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7CA1",
    transform: "translate(0,0)"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8583AD",
    transform: "translate(0,0)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897AA9",
    transform: "translate(0,0)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F79A6",
    transform: "translate(0,0)"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A45D93",
    transform: "translate(0,0)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8A80AD",
    transform: "translate(624,159)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8480AC",
    transform: "translate(0,0)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8B7FAB",
    transform: "translate(623,157)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A45D92",
    transform: "translate(516,156)"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A25B8C",
    transform: "translate(492,156)"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A75D92",
    transform: "translate(505,152)"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#AC5283",
    transform: "translate(405,151)"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9275A5",
    transform: "translate(0,0)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8281AC",
    transform: "translate(0,0)"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A55588",
    transform: "translate(449,149)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A55283",
    transform: "translate(398,146)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181A8",
    transform: "translate(0,0)"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7BAA",
    transform: "translate(0,0)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8280A9",
    transform: "translate(0,0)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8C7CA9",
    transform: "translate(610,139)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#867BA7",
    transform: "translate(0,0)"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7BA6",
    transform: "translate(0,0)"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8C7CA9",
    transform: "translate(622,136)"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8280AB",
    transform: "translate(0,0)"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9570A0",
    transform: "translate(0,0)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8180A9",
    transform: "translate(0,0)"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897FA9",
    transform: "translate(0,0)"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8080A6",
    transform: "translate(690,128)"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91719D",
    transform: "translate(0,0)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847EA9",
    transform: "translate(0,0)"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8480AB",
    transform: "translate(0,0)"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#857FAB",
    transform: "translate(0,0)"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8580AB",
    transform: "translate(650,109)"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#946A9A",
    transform: "translate(529,108)"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#867EA9",
    transform: "translate(648,105)"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#946D9C",
    transform: "translate(540,104)"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8E72A0",
    transform: "translate(573,103)"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8381A9",
    transform: "translate(0,0)"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7A799E",
    transform: "translate(684,100)"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#78789C",
    transform: "translate(686,99)"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#91719D",
    transform: "translate(559,93)"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817FA8",
    transform: "translate(0,0)"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E6C96",
    transform: "translate(0,0)"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8F72A0",
    transform: "translate(565,88)"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#837FA7",
    transform: "translate(645,87)"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8D6E9C",
    transform: "translate(544,84)"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A6D9A",
    transform: "translate(0,0)"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#80769E",
    transform: "translate(443,72)"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C3860",
    transform: "translate(0,0)"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7B9F",
    transform: "translate(0,0)"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A779A",
    transform: "translate(0,0)"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#837DA7",
    transform: "translate(614,57)"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#817FA8",
    transform: "translate(612,56)"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#837FA8",
    transform: "translate(602,48)"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807CA3",
    transform: "translate(0,0)"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837EA6",
    transform: "translate(0,0)"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#953F6B",
    transform: "translate(0,0)"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7E7AA1",
    transform: "translate(628,40)"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7CA5",
    transform: "translate(0,0)"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7BA2",
    transform: "translate(0,0)"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837EA6",
    transform: "translate(0,0)"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#817CA5",
    transform: "translate(540,22)"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#837DA7",
    transform: "translate(538,21)"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C79A2",
    transform: "translate(0,0)"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#827DA5",
    transform: "translate(536,20)"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7E7BA1",
    transform: "translate(596,17)"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#817CA7",
    transform: "translate(550,17)"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9F4575",
    transform: "translate(304,8)"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8477A0",
    transform: "translate(485,4)"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#101416",
    transform: "translate(0,0)"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#26131B",
    transform: "translate(0,0)"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2386F",
    transform: "translate(0,0)"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF356F",
    transform: "translate(0,0)"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB3675",
    transform: "translate(0,0)"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C83873",
    transform: "translate(0,0)"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C83974",
    transform: "translate(0,0)"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD3372",
    transform: "translate(0,0)"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C83A73",
    transform: "translate(0,0)"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D23474",
    transform: "translate(0,0)"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC3978",
    transform: "translate(0,0)"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB3774",
    transform: "translate(0,0)"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D43572",
    transform: "translate(0,0)"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD3C7E",
    transform: "translate(0,0)"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE3C7E",
    transform: "translate(0,0)"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA3D7B",
    transform: "translate(0,0)"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3880",
    transform: "translate(0,0)"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E13B7F",
    transform: "translate(0,0)"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#697397",
    transform: "translate(0,0)"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B749A",
    transform: "translate(0,0)"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F759E",
    transform: "translate(0,0)"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7275A0",
    transform: "translate(0,0)"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#74749F",
    transform: "translate(0,0)"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#82638D",
    transform: "translate(0,0)"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#727BA7",
    transform: "translate(0,0)"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7077A0",
    transform: "translate(0,0)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7278A2",
    transform: "translate(0,0)"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA4D7C",
    transform: "translate(0,0)"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC3C71",
    transform: "translate(0,0)"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C13C74",
    transform: "translate(0,0)"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B7297",
    transform: "translate(0,0)"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B7399",
    transform: "translate(0,0)"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D759B",
    transform: "translate(0,0)"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7078A1",
    transform: "translate(0,0)"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7178A2",
    transform: "translate(0,0)"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F779F",
    transform: "translate(0,0)"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7179A2",
    transform: "translate(0,0)"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7279A4",
    transform: "translate(0,0)"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737BA6",
    transform: "translate(0,0)"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7378A3",
    transform: "translate(0,0)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA4179",
    transform: "translate(0,0)"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C13F79",
    transform: "translate(0,0)"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C43C74",
    transform: "translate(0,0)"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C53B75",
    transform: "translate(0,0)"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B7599",
    transform: "translate(0,0)"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F77A0",
    transform: "translate(0,0)"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E779E",
    transform: "translate(0,0)"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#717AA3",
    transform: "translate(0,0)"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7078A0",
    transform: "translate(0,0)"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7079A2",
    transform: "translate(0,0)"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7279A3",
    transform: "translate(0,0)"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#707AA4",
    transform: "translate(0,0)"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#727AA6",
    transform: "translate(0,0)"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737BA7",
    transform: "translate(0,0)"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#747CA7",
    transform: "translate(0,0)"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737BA6",
    transform: "translate(0,0)"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737AA4",
    transform: "translate(0,0)"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7278A0",
    transform: "translate(0,0)"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7379A3",
    transform: "translate(0,0)"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7776A0",
    transform: "translate(0,0)"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7776A0",
    transform: "translate(0,0)"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#79719B",
    transform: "translate(0,0)"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CA3A75",
    transform: "translate(0,0)"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C63973",
    transform: "translate(0,0)"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C63B73",
    transform: "translate(0,0)"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD3D72",
    transform: "translate(0,0)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C43A70",
    transform: "translate(0,0)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E03B7C",
    transform: "translate(0,0)"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767CAA",
    transform: "translate(0,0)"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F799E",
    transform: "translate(0,0)"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767BA6",
    transform: "translate(0,0)"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F77A2",
    transform: "translate(0,0)"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#747CA5",
    transform: "translate(0,0)"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777EAC",
    transform: "translate(0,0)"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C93B73",
    transform: "translate(0,0)"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7579A6",
    transform: "translate(0,0)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D73B7A",
    transform: "translate(0,0)"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#747BA7",
    transform: "translate(0,0)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#787AAA",
    transform: "translate(0,0)"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D8397A",
    transform: "translate(0,0)"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767EAD",
    transform: "translate(0,0)"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7279A6",
    transform: "translate(0,0)"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#747BAA",
    transform: "translate(0,0)"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#727CAA",
    transform: "translate(0,0)"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA397A",
    transform: "translate(0,0)"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC3B74",
    transform: "translate(0,0)"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7780AF",
    transform: "translate(0,0)"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE3972",
    transform: "translate(0,0)"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F78A3",
    transform: "translate(0,0)"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7780AE",
    transform: "translate(0,0)"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7580AA",
    transform: "translate(0,0)"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D71A0",
    transform: "translate(0,0)"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C43C72",
    transform: "translate(0,0)"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#717BA4",
    transform: "translate(0,0)"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C83B3",
    transform: "translate(0,0)"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E0377C",
    transform: "translate(0,0)"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767EB1",
    transform: "translate(0,0)"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C83B4",
    transform: "translate(0,0)"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D73375",
    transform: "translate(0,0)"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E03B7F",
    transform: "translate(0,0)"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D03977",
    transform: "translate(0,0)"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7981B4",
    transform: "translate(0,0)"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C72A3",
    transform: "translate(0,0)"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C83B7",
    transform: "translate(0,0)"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF3A7E",
    transform: "translate(0,0)"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7680AE",
    transform: "translate(0,0)"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E33B7F",
    transform: "translate(0,0)"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE3575",
    transform: "translate(0,0)"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7980B0",
    transform: "translate(0,0)"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7781AF",
    transform: "translate(0,0)"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#727BA8",
    transform: "translate(0,0)"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7780AC",
    transform: "translate(0,0)"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7982B4",
    transform: "translate(0,0)"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DB3B7C",
    transform: "translate(0,0)"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6548F",
    transform: "translate(0,0)"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C53D74",
    transform: "translate(0,0)"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7881AF",
    transform: "translate(0,0)"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767FAB",
    transform: "translate(0,0)"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E9387F",
    transform: "translate(0,0)"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC3B76",
    transform: "translate(0,0)"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A83B4",
    transform: "translate(0,0)"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7881AF",
    transform: "translate(0,0)"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7982AF",
    transform: "translate(0,0)"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7781AC",
    transform: "translate(0,0)"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7983B3",
    transform: "translate(0,0)"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F85B6",
    transform: "translate(0,0)"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7880B5",
    transform: "translate(0,0)"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D75A6",
    transform: "translate(0,0)"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D86B7",
    transform: "translate(0,0)"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD4887",
    transform: "translate(0,0)"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D73F81",
    transform: "translate(0,0)"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DB3F7E",
    transform: "translate(0,0)"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA3D7E",
    transform: "translate(0,0)"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DC3D7C",
    transform: "translate(0,0)"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE3C7E",
    transform: "translate(0,0)"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE3B7B",
    transform: "translate(0,0)"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E03B7D",
    transform: "translate(0,0)"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E5377A",
    transform: "translate(0,0)"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E63A7E",
    transform: "translate(0,0)"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E8377B",
    transform: "translate(0,0)"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E6377A",
    transform: "translate(0,0)"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E53B7D",
    transform: "translate(0,0)"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7981B5",
    transform: "translate(0,0)"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B82B1",
    transform: "translate(0,0)"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC3A81",
    transform: "translate(0,0)"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD407E",
    transform: "translate(0,0)"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E76A7",
    transform: "translate(0,0)"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E03E80",
    transform: "translate(0,0)"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#747CAD",
    transform: "translate(0,0)"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B85B5",
    transform: "translate(0,0)"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E53980",
    transform: "translate(0,0)"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F8AC0",
    transform: "translate(0,0)"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D84B6",
    transform: "translate(0,0)"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E33C83",
    transform: "translate(0,0)"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B84B5",
    transform: "translate(0,0)"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC397E",
    transform: "translate(0,0)"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B84B4",
    transform: "translate(0,0)"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9375A7",
    transform: "translate(0,0)"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7681AE",
    transform: "translate(0,0)"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D77A9",
    transform: "translate(0,0)"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B86B5",
    transform: "translate(0,0)"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E8BBE",
    transform: "translate(0,0)"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A85B6",
    transform: "translate(0,0)"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#818AB9",
    transform: "translate(0,0)"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D86B6",
    transform: "translate(0,0)"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F8BC0",
    transform: "translate(0,0)"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E93B81",
    transform: "translate(0,0)"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E93880",
    transform: "translate(0,0)"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C84BA",
    transform: "translate(0,0)"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A86B8",
    transform: "translate(0,0)"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E87BC",
    transform: "translate(0,0)"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808CC0",
    transform: "translate(0,0)"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D85B9",
    transform: "translate(0,0)"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8287BD",
    transform: "translate(0,0)"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E78AA",
    transform: "translate(0,0)"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D86B9",
    transform: "translate(0,0)"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E53980",
    transform: "translate(0,0)"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E93B80",
    transform: "translate(0,0)"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D88B8",
    transform: "translate(0,0)"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E88BC",
    transform: "translate(0,0)"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D86B9",
    transform: "translate(0,0)"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868CC4",
    transform: "translate(0,0)"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E78AB",
    transform: "translate(0,0)"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86B7",
    transform: "translate(0,0)"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8088BD",
    transform: "translate(0,0)"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B88B8",
    transform: "translate(0,0)"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F88BE",
    transform: "translate(0,0)"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7AAB",
    transform: "translate(0,0)"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D33A76",
    transform: "translate(0,0)"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D87BE",
    transform: "translate(0,0)"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E8387F",
    transform: "translate(0,0)"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C88BC",
    transform: "translate(0,0)"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E88BE",
    transform: "translate(0,0)"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D88B9",
    transform: "translate(0,0)"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A85BA",
    transform: "translate(0,0)"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E79AB",
    transform: "translate(0,0)"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E63A7E",
    transform: "translate(0,0)"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D88B9",
    transform: "translate(0,0)"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E88BD",
    transform: "translate(0,0)"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D88B9",
    transform: "translate(0,0)"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D86B9",
    transform: "translate(0,0)"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7783B3",
    transform: "translate(0,0)"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7AAB",
    transform: "translate(0,0)"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B86B6",
    transform: "translate(0,0)"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3A81",
    transform: "translate(0,0)"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E8ABE",
    transform: "translate(0,0)"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3D83",
    transform: "translate(0,0)"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8288BC",
    transform: "translate(0,0)"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F7AAC",
    transform: "translate(0,0)"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C87B7",
    transform: "translate(0,0)"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D53E79",
    transform: "translate(0,0)"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3C83",
    transform: "translate(0,0)"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D87B4",
    transform: "translate(0,0)"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7AAB",
    transform: "translate(0,0)"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A82B3",
    transform: "translate(0,0)"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C5538E",
    transform: "translate(0,0)"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EE3C84",
    transform: "translate(0,0)"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C6538E",
    transform: "translate(0,0)"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86B8",
    transform: "translate(0,0)"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E87B7",
    transform: "translate(0,0)"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9478AC",
    transform: "translate(0,0)"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808ABC",
    transform: "translate(0,0)"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ED3C85",
    transform: "translate(0,0)"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EE3C82",
    transform: "translate(0,0)"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A84B6",
    transform: "translate(0,0)"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D83F7A",
    transform: "translate(0,0)"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3A81",
    transform: "translate(0,0)"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C7528C",
    transform: "translate(0,0)"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EF3D84",
    transform: "translate(0,0)"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8089BD",
    transform: "translate(0,0)"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EF3A84",
    transform: "translate(0,0)"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC3A85",
    transform: "translate(0,0)"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E87B8",
    transform: "translate(0,0)"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B84B4",
    transform: "translate(0,0)"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868CC5",
    transform: "translate(0,0)"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#917CAD",
    transform: "translate(0,0)"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#977AAB",
    transform: "translate(0,0)"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9079AC",
    transform: "translate(0,0)"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D83C7A",
    transform: "translate(0,0)"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9877AC",
    transform: "translate(0,0)"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F33D82",
    transform: "translate(0,0)"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B84B4",
    transform: "translate(0,0)"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A84B7",
    transform: "translate(0,0)"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86BC",
    transform: "translate(0,0)"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D73C7A",
    transform: "translate(0,0)"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A84B4",
    transform: "translate(0,0)"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B83B3",
    transform: "translate(0,0)"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B85B4",
    transform: "translate(0,0)"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E88BB",
    transform: "translate(0,0)"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B86BB",
    transform: "translate(0,0)"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D88C0",
    transform: "translate(0,0)"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F8AC0",
    transform: "translate(0,0)"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8089C0",
    transform: "translate(0,0)"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E44487",
    transform: "translate(0,0)"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E64184",
    transform: "translate(0,0)"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E64084",
    transform: "translate(0,0)"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3E84",
    transform: "translate(0,0)"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA4084",
    transform: "translate(0,0)"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ED3E84",
    transform: "translate(0,0)"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC3F84",
    transform: "translate(0,0)"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EF3D84",
    transform: "translate(0,0)"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EE3D85",
    transform: "translate(0,0)"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F03D83",
    transform: "translate(0,0)"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C84B4",
    transform: "translate(0,0)"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A86BA",
    transform: "translate(0,0)"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A85B7",
    transform: "translate(0,0)"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D53C78",
    transform: "translate(0,0)"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D87B7",
    transform: "translate(0,0)"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888BC2",
    transform: "translate(0,0)"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3A7F",
    transform: "translate(0,0)"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F88BE",
    transform: "translate(0,0)"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D88BC",
    transform: "translate(0,0)"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878DC3",
    transform: "translate(0,0)"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3C82",
    transform: "translate(0,0)"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E73B7F",
    transform: "translate(0,0)"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86B8",
    transform: "translate(0,0)"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B83B7",
    transform: "translate(0,0)"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A84B5",
    transform: "translate(0,0)"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E87BA",
    transform: "translate(0,0)"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E86BA",
    transform: "translate(0,0)"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E88BB",
    transform: "translate(0,0)"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F87BB",
    transform: "translate(0,0)"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D87B7",
    transform: "translate(0,0)"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7882B4",
    transform: "translate(0,0)"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E86B9",
    transform: "translate(0,0)"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#927BAC",
    transform: "translate(0,0)"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E73B80",
    transform: "translate(0,0)"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F89C5",
    transform: "translate(0,0)"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8189C3",
    transform: "translate(0,0)"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E03D80",
    transform: "translate(0,0)"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D86BB",
    transform: "translate(0,0)"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B87BB",
    transform: "translate(0,0)"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA3F82",
    transform: "translate(0,0)"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D13C77",
    transform: "translate(0,0)"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B84B2",
    transform: "translate(0,0)"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E85BB",
    transform: "translate(0,0)"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E93F83",
    transform: "translate(0,0)"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A84AF",
    transform: "translate(0,0)"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB3E83",
    transform: "translate(0,0)"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7983AF",
    transform: "translate(0,0)"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C85B7",
    transform: "translate(0,0)"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D86B9",
    transform: "translate(0,0)"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8088BD",
    transform: "translate(0,0)"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#927AAC",
    transform: "translate(0,0)"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86BD",
    transform: "translate(0,0)"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A83B0",
    transform: "translate(0,0)"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F87BA",
    transform: "translate(0,0)"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E63B7F",
    transform: "translate(0,0)"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F87BA",
    transform: "translate(0,0)"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E33B82",
    transform: "translate(0,0)"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A81B2",
    transform: "translate(0,0)"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86B7",
    transform: "translate(0,0)"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86B7",
    transform: "translate(0,0)"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8185BC",
    transform: "translate(0,0)"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E88BA",
    transform: "translate(0,0)"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E87B9",
    transform: "translate(0,0)"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868AC2",
    transform: "translate(0,0)"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#937AAB",
    transform: "translate(0,0)"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8088BC",
    transform: "translate(0,0)"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848AC3",
    transform: "translate(0,0)"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8087BE",
    transform: "translate(0,0)"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E33B7F",
    transform: "translate(0,0)"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C87BA",
    transform: "translate(0,0)"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E03D80",
    transform: "translate(0,0)"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7580A9",
    transform: "translate(0,0)"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868BC5",
    transform: "translate(0,0)"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#937AAB",
    transform: "translate(0,0)"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C85BA",
    transform: "translate(0,0)"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8287BE",
    transform: "translate(0,0)"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C84B6",
    transform: "translate(0,0)"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7880AA",
    transform: "translate(0,0)"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#947AAA",
    transform: "translate(0,0)"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E13D81",
    transform: "translate(0,0)"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D86B8",
    transform: "translate(0,0)"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7885B3",
    transform: "translate(0,0)"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7982B2",
    transform: "translate(0,0)"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8288BC",
    transform: "translate(0,0)"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D86B8",
    transform: "translate(0,0)"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B83B2",
    transform: "translate(0,0)"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7881B2",
    transform: "translate(0,0)"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE4F8A",
    transform: "translate(0,0)"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA4281",
    transform: "translate(0,0)"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE4182",
    transform: "translate(0,0)"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E03F80",
    transform: "translate(0,0)"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E64082",
    transform: "translate(0,0)"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E63F80",
    transform: "translate(0,0)"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E83F83",
    transform: "translate(0,0)"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE3A7C",
    transform: "translate(0,0)"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C84B5",
    transform: "translate(0,0)"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B84B3",
    transform: "translate(0,0)"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E0367D",
    transform: "translate(0,0)"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E0397B",
    transform: "translate(0,0)"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B84B2",
    transform: "translate(0,0)"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E0377D",
    transform: "translate(0,0)"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767EAC",
    transform: "translate(0,0)"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E85BA",
    transform: "translate(0,0)"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7982AF",
    transform: "translate(0,0)"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C86B4",
    transform: "translate(0,0)"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C87B7",
    transform: "translate(0,0)"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7986B3",
    transform: "translate(0,0)"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D85B6",
    transform: "translate(0,0)"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C85B6",
    transform: "translate(0,0)"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F87B7",
    transform: "translate(0,0)"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7982B3",
    transform: "translate(0,0)"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C83B73",
    transform: "translate(0,0)"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737BA5",
    transform: "translate(0,0)"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9677A8",
    transform: "translate(0,0)"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C73972",
    transform: "translate(0,0)"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A86B8",
    transform: "translate(0,0)"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9875A8",
    transform: "translate(0,0)"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D53A7A",
    transform: "translate(0,0)"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7981AE",
    transform: "translate(0,0)"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D73779",
    transform: "translate(0,0)"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C33B72",
    transform: "translate(0,0)"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7880AB",
    transform: "translate(0,0)"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9876A7",
    transform: "translate(0,0)"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C23B74",
    transform: "translate(0,0)"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7075A0",
    transform: "translate(0,0)"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7780B2",
    transform: "translate(0,0)"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E84B2",
    transform: "translate(0,0)"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E77A4",
    transform: "translate(0,0)"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B74A4",
    transform: "translate(0,0)"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7882AF",
    transform: "translate(0,0)"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D13B78",
    transform: "translate(0,0)"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC366F",
    transform: "translate(0,0)"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757DAB",
    transform: "translate(0,0)"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#727AA4",
    transform: "translate(0,0)"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D85B3",
    transform: "translate(0,0)"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7680A8",
    transform: "translate(0,0)"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D82B4",
    transform: "translate(0,0)"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C81B4",
    transform: "translate(0,0)"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC3A74",
    transform: "translate(0,0)"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC3875",
    transform: "translate(0,0)"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C83971",
    transform: "translate(0,0)"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777DA4",
    transform: "translate(0,0)"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C82B3",
    transform: "translate(0,0)"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F84B9",
    transform: "translate(0,0)"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A170A3",
    transform: "translate(0,0)"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C93C76",
    transform: "translate(0,0)"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8183B8",
    transform: "translate(0,0)"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9971A3",
    transform: "translate(0,0)"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CA3972",
    transform: "translate(0,0)"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#70789E",
    transform: "translate(0,0)"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#70779E",
    transform: "translate(0,0)"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7179A0",
    transform: "translate(0,0)"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7278A1",
    transform: "translate(0,0)"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F7AA4",
    transform: "translate(0,0)"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757DAB",
    transform: "translate(0,0)"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777EAA",
    transform: "translate(0,0)"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#787EAA",
    transform: "translate(0,0)"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777EAB",
    transform: "translate(0,0)"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737DA7",
    transform: "translate(0,0)"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#787EAC",
    transform: "translate(0,0)"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7980B1",
    transform: "translate(0,0)"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D82B4",
    transform: "translate(0,0)"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C81B4",
    transform: "translate(0,0)"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384B8",
    transform: "translate(0,0)"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C72A3",
    transform: "translate(0,0)"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CF3674",
    transform: "translate(0,0)"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C83A72",
    transform: "translate(0,0)"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777EAA",
    transform: "translate(0,0)"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F80B4",
    transform: "translate(0,0)"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D6FA0",
    transform: "translate(0,0)"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D63B7A",
    transform: "translate(0,0)"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC3974",
    transform: "translate(0,0)"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7BAA",
    transform: "translate(0,0)"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7BAA",
    transform: "translate(0,0)"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A79A9",
    transform: "translate(0,0)"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7AA8",
    transform: "translate(0,0)"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7DAB",
    transform: "translate(0,0)"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7CAA",
    transform: "translate(0,0)"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE5891",
    transform: "translate(0,0)"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46B9D",
    transform: "translate(0,0)"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877CAD",
    transform: "translate(0,0)"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#857FAD",
    transform: "translate(0,0)"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#867DAC",
    transform: "translate(0,0)"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F79AB",
    transform: "translate(0,0)"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B45B95",
    transform: "translate(0,0)"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#867FAF",
    transform: "translate(0,0)"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7BAD",
    transform: "translate(0,0)"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C78AA",
    transform: "translate(0,0)"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7DAC",
    transform: "translate(0,0)"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907AAB",
    transform: "translate(0,0)"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B75791",
    transform: "translate(0,0)"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE5188",
    transform: "translate(0,0)"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837EA9",
    transform: "translate(0,0)"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE5088",
    transform: "translate(0,0)"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827FAB",
    transform: "translate(0,0)"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EAC",
    transform: "translate(0,0)"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF5088",
    transform: "translate(0,0)"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C05088",
    transform: "translate(0,0)"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#887FAC",
    transform: "translate(0,0)"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C04D88",
    transform: "translate(0,0)"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877EAE",
    transform: "translate(0,0)"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897FB1",
    transform: "translate(0,0)"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C34F8B",
    transform: "translate(0,0)"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B80AE",
    transform: "translate(0,0)"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8281AB",
    transform: "translate(0,0)"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EAE",
    transform: "translate(0,0)"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE4986",
    transform: "translate(0,0)"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EAF",
    transform: "translate(0,0)"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE6296",
    transform: "translate(0,0)"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1538C",
    transform: "translate(0,0)"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB6095",
    transform: "translate(0,0)"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8582AE",
    transform: "translate(0,0)"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8482B2",
    transform: "translate(0,0)"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B06197",
    transform: "translate(0,0)"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8882B4",
    transform: "translate(0,0)"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807EAB",
    transform: "translate(0,0)"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B45A92",
    transform: "translate(0,0)"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B55A93",
    transform: "translate(0,0)"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8180AB",
    transform: "translate(0,0)"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807DAB",
    transform: "translate(0,0)"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA639A",
    transform: "translate(0,0)"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA5992",
    transform: "translate(0,0)"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8684B3",
    transform: "translate(0,0)"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB5F98",
    transform: "translate(0,0)"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7FA8",
    transform: "translate(0,0)"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8382AF",
    transform: "translate(0,0)"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7FAF",
    transform: "translate(0,0)"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC5490",
    transform: "translate(0,0)"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B82AF",
    transform: "translate(0,0)"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A81AE",
    transform: "translate(0,0)"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7CAC",
    transform: "translate(0,0)"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A667A1",
    transform: "translate(0,0)"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA679F",
    transform: "translate(0,0)"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6679F",
    transform: "translate(0,0)"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7669E",
    transform: "translate(0,0)"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B94F86",
    transform: "translate(0,0)"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE5086",
    transform: "translate(0,0)"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD4D87",
    transform: "translate(0,0)"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797DA4",
    transform: "translate(0,0)"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E80AA",
    transform: "translate(0,0)"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC5487",
    transform: "translate(0,0)"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9779AB",
    transform: "translate(0,0)"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D76AA",
    transform: "translate(0,0)"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B36398",
    transform: "translate(0,0)"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797CA5",
    transform: "translate(0,0)"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B3",
    transform: "translate(0,0)"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8883B0",
    transform: "translate(0,0)"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8582AF",
    transform: "translate(0,0)"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F70A4",
    transform: "translate(0,0)"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A170A6",
    transform: "translate(0,0)"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B65F9C",
    transform: "translate(0,0)"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4629A",
    transform: "translate(0,0)"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8082AC",
    transform: "translate(0,0)"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A26DA5",
    transform: "translate(0,0)"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7DA6",
    transform: "translate(0,0)"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8882AF",
    transform: "translate(0,0)"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F7DAF",
    transform: "translate(0,0)"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7EB1",
    transform: "translate(0,0)"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E80B0",
    transform: "translate(0,0)"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B66098",
    transform: "translate(0,0)"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7FAC",
    transform: "translate(0,0)"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8685B1",
    transform: "translate(0,0)"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD679E",
    transform: "translate(0,0)"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B80AE",
    transform: "translate(0,0)"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E82B0",
    transform: "translate(0,0)"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A66DA1",
    transform: "translate(0,0)"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7649C",
    transform: "translate(0,0)"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797CA5",
    transform: "translate(0,0)"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7FAC",
    transform: "translate(0,0)"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B95D94",
    transform: "translate(0,0)"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3518B",
    transform: "translate(0,0)"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777BA5",
    transform: "translate(0,0)"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#787BA8",
    transform: "translate(0,0)"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EAD",
    transform: "translate(0,0)"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9976A8",
    transform: "translate(0,0)"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7FAD",
    transform: "translate(0,0)"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8685B3",
    transform: "translate(0,0)"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485B0",
    transform: "translate(0,0)"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9877AA",
    transform: "translate(0,0)"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF5B96",
    transform: "translate(0,0)"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B2",
    transform: "translate(0,0)"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E72A5",
    transform: "translate(0,0)"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD4D86",
    transform: "translate(0,0)"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B2",
    transform: "translate(0,0)"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A82B3",
    transform: "translate(0,0)"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C4518E",
    transform: "translate(0,0)"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C80AE",
    transform: "translate(0,0)"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B2",
    transform: "translate(0,0)"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A83B4",
    transform: "translate(0,0)"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8984B4",
    transform: "translate(0,0)"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C81B0",
    transform: "translate(0,0)"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B0",
    transform: "translate(0,0)"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8582B1",
    transform: "translate(0,0)"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8383B1",
    transform: "translate(0,0)"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B82B3",
    transform: "translate(0,0)"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD649C",
    transform: "translate(0,0)"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485B3",
    transform: "translate(0,0)"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C6538E",
    transform: "translate(0,0)"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD4E86",
    transform: "translate(0,0)"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8885B3",
    transform: "translate(0,0)"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C14C86",
    transform: "translate(0,0)"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8383AE",
    transform: "translate(0,0)"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF6398",
    transform: "translate(0,0)"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8083B1",
    transform: "translate(0,0)"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484B1",
    transform: "translate(0,0)"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8682B1",
    transform: "translate(0,0)"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B82B1",
    transform: "translate(0,0)"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C15990",
    transform: "translate(0,0)"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384AF",
    transform: "translate(0,0)"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8684B4",
    transform: "translate(0,0)"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A74A7",
    transform: "translate(0,0)"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C45991",
    transform: "translate(0,0)"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8886B6",
    transform: "translate(0,0)"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#937BAF",
    transform: "translate(0,0)"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384B1",
    transform: "translate(0,0)"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C7548D",
    transform: "translate(0,0)"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8882B2",
    transform: "translate(0,0)"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F84AE",
    transform: "translate(0,0)"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB6199",
    transform: "translate(0,0)"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB5D98",
    transform: "translate(0,0)"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385B1",
    transform: "translate(0,0)"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B1",
    transform: "translate(0,0)"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8888B5",
    transform: "translate(0,0)"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7DAC",
    transform: "translate(0,0)"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CA508B",
    transform: "translate(0,0)"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757BA3",
    transform: "translate(0,0)"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8486B0",
    transform: "translate(0,0)"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8386B2",
    transform: "translate(0,0)"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C81B0",
    transform: "translate(0,0)"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757AA1",
    transform: "translate(0,0)"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B1",
    transform: "translate(0,0)"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#917AAB",
    transform: "translate(0,0)"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A36A9D",
    transform: "translate(0,0)"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7689E",
    transform: "translate(0,0)"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8185AF",
    transform: "translate(0,0)"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8386B0",
    transform: "translate(0,0)"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8282B1",
    transform: "translate(0,0)"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8782B2",
    transform: "translate(0,0)"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907BAD",
    transform: "translate(0,0)"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9278AA",
    transform: "translate(0,0)"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C05A93",
    transform: "translate(0,0)"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CA5692",
    transform: "translate(0,0)"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB5290",
    transform: "translate(0,0)"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9679E",
    transform: "translate(0,0)"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C5538D",
    transform: "translate(0,0)"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385AF",
    transform: "translate(0,0)"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A8AB7",
    transform: "translate(0,0)"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8784B0",
    transform: "translate(0,0)"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F7CAA",
    transform: "translate(0,0)"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9077AA",
    transform: "translate(0,0)"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC659D",
    transform: "translate(0,0)"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B84B3",
    transform: "translate(0,0)"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F78AA",
    transform: "translate(0,0)"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E81AD",
    transform: "translate(0,0)"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8887B5",
    transform: "translate(0,0)"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A83B1",
    transform: "translate(0,0)"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797DA6",
    transform: "translate(0,0)"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797EA9",
    transform: "translate(0,0)"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C80AC",
    transform: "translate(0,0)"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8386B2",
    transform: "translate(0,0)"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8587B2",
    transform: "translate(0,0)"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A82B1",
    transform: "translate(0,0)"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7EA8",
    transform: "translate(0,0)"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D82AD",
    transform: "translate(0,0)"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B3",
    transform: "translate(0,0)"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7FA9",
    transform: "translate(0,0)"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8583B4",
    transform: "translate(0,0)"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C85B4",
    transform: "translate(0,0)"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7EB2",
    transform: "translate(0,0)"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CA5790",
    transform: "translate(0,0)"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F80AC",
    transform: "translate(0,0)"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CA558F",
    transform: "translate(0,0)"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8584B1",
    transform: "translate(0,0)"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A89B6",
    transform: "translate(0,0)"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A83B4",
    transform: "translate(0,0)"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C74A7",
    transform: "translate(0,0)"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A96B9F",
    transform: "translate(0,0)"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA5F97",
    transform: "translate(0,0)"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D15692",
    transform: "translate(0,0)"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B5",
    transform: "translate(0,0)"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8883B3",
    transform: "translate(0,0)"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8286AD",
    transform: "translate(0,0)"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8784B0",
    transform: "translate(0,0)"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9578AB",
    transform: "translate(0,0)"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9477A6",
    transform: "translate(0,0)"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A572A3",
    transform: "translate(0,0)"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8184B2",
    transform: "translate(0,0)"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877FB1",
    transform: "translate(0,0)"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C55B95",
    transform: "translate(0,0)"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC4F87",
    transform: "translate(0,0)"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8284AE",
    transform: "translate(0,0)"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B3",
    transform: "translate(0,0)"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8888B3",
    transform: "translate(0,0)"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A85B3",
    transform: "translate(0,0)"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A84B3",
    transform: "translate(0,0)"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9479A9",
    transform: "translate(0,0)"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8382AF",
    transform: "translate(0,0)"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8883B2",
    transform: "translate(0,0)"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#937AAB",
    transform: "translate(0,0)"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD5592",
    transform: "translate(0,0)"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484B3",
    transform: "translate(0,0)"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8687B1",
    transform: "translate(0,0)"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8684B5",
    transform: "translate(0,0)"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8981B2",
    transform: "translate(0,0)"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D15693",
    transform: "translate(0,0)"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181AD",
    transform: "translate(0,0)"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B3",
    transform: "translate(0,0)"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C89B6",
    transform: "translate(0,0)"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8980B1",
    transform: "translate(0,0)"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E71A6",
    transform: "translate(0,0)"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A66AA0",
    transform: "translate(0,0)"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA699E",
    transform: "translate(0,0)"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D0548F",
    transform: "translate(0,0)"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485AF",
    transform: "translate(0,0)"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C6EA3",
    transform: "translate(0,0)"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5699E",
    transform: "translate(0,0)"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8687B3",
    transform: "translate(0,0)"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B5",
    transform: "translate(0,0)"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B86B6",
    transform: "translate(0,0)"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A81B0",
    transform: "translate(0,0)"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7FAD",
    transform: "translate(0,0)"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#917DAF",
    transform: "translate(0,0)"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A75A6",
    transform: "translate(0,0)"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45491",
    transform: "translate(0,0)"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8887B2",
    transform: "translate(0,0)"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7EAD",
    transform: "translate(0,0)"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#917DAF",
    transform: "translate(0,0)"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B2",
    transform: "translate(0,0)"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8987B2",
    transform: "translate(0,0)"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F7EAE",
    transform: "translate(0,0)"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B2",
    transform: "translate(0,0)"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B5",
    transform: "translate(0,0)"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9375A7",
    transform: "translate(0,0)"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B56199",
    transform: "translate(0,0)"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD558E",
    transform: "translate(0,0)"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384B0",
    transform: "translate(0,0)"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8285B1",
    transform: "translate(0,0)"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9477AA",
    transform: "translate(0,0)"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E83AB",
    transform: "translate(0,0)"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8083AC",
    transform: "translate(0,0)"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8985B1",
    transform: "translate(0,0)"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8987B4",
    transform: "translate(0,0)"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8888B3",
    transform: "translate(0,0)"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B89B6",
    transform: "translate(0,0)"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B75E99",
    transform: "translate(0,0)"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC5690",
    transform: "translate(0,0)"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A86B2",
    transform: "translate(0,0)"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C85895",
    transform: "translate(0,0)"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7FAC",
    transform: "translate(0,0)"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8788B3",
    transform: "translate(0,0)"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B80B0",
    transform: "translate(0,0)"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A070A5",
    transform: "translate(0,0)"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8679E",
    transform: "translate(0,0)"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C72A4",
    transform: "translate(0,0)"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C70A5",
    transform: "translate(0,0)"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B86B3",
    transform: "translate(0,0)"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B81AF",
    transform: "translate(0,0)"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B85D95",
    transform: "translate(0,0)"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D05891",
    transform: "translate(0,0)"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8984B2",
    transform: "translate(0,0)"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8883B1",
    transform: "translate(0,0)"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D79AB",
    transform: "translate(0,0)"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B3",
    transform: "translate(0,0)"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8986B3",
    transform: "translate(0,0)"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8880B0",
    transform: "translate(0,0)"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE558A",
    transform: "translate(0,0)"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8486B4",
    transform: "translate(0,0)"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7FAE",
    transform: "translate(0,0)"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2619B",
    transform: "translate(0,0)"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF5D96",
    transform: "translate(0,0)"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D35593",
    transform: "translate(0,0)"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D55290",
    transform: "translate(0,0)"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D81B6",
    transform: "translate(0,0)"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9878A9",
    transform: "translate(0,0)"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D35594",
    transform: "translate(0,0)"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D65293",
    transform: "translate(0,0)"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8486B3",
    transform: "translate(0,0)"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B4",
    transform: "translate(0,0)"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9576AB",
    transform: "translate(0,0)"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8383B1",
    transform: "translate(0,0)"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C84B1",
    transform: "translate(0,0)"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A76A7",
    transform: "translate(0,0)"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC5792",
    transform: "translate(0,0)"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D85492",
    transform: "translate(0,0)"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8788B1",
    transform: "translate(0,0)"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8982AF",
    transform: "translate(0,0)"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B81AF",
    transform: "translate(0,0)"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C55190",
    transform: "translate(0,0)"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B4",
    transform: "translate(0,0)"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8684B0",
    transform: "translate(0,0)"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D05591",
    transform: "translate(0,0)"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D05692",
    transform: "translate(0,0)"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CF5690",
    transform: "translate(0,0)"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D65591",
    transform: "translate(0,0)"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA5192",
    transform: "translate(0,0)"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA6B9E",
    transform: "translate(0,0)"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B76097",
    transform: "translate(0,0)"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D65593",
    transform: "translate(0,0)"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385AF",
    transform: "translate(0,0)"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B82B2",
    transform: "translate(0,0)"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A82B3",
    transform: "translate(0,0)"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7FAF",
    transform: "translate(0,0)"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D25692",
    transform: "translate(0,0)"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45491",
    transform: "translate(0,0)"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A83B2",
    transform: "translate(0,0)"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A84B3",
    transform: "translate(0,0)"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B83B0",
    transform: "translate(0,0)"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A470A1",
    transform: "translate(0,0)"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A36FA2",
    transform: "translate(0,0)"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C65794",
    transform: "translate(0,0)"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8686B0",
    transform: "translate(0,0)"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A86B5",
    transform: "translate(0,0)"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46EA2",
    transform: "translate(0,0)"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C45B93",
    transform: "translate(0,0)"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485B3",
    transform: "translate(0,0)"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907AA9",
    transform: "translate(0,0)"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB6A9D",
    transform: "translate(0,0)"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D55592",
    transform: "translate(0,0)"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B3",
    transform: "translate(0,0)"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8681AD",
    transform: "translate(0,0)"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8983B0",
    transform: "translate(0,0)"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45795",
    transform: "translate(0,0)"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D65693",
    transform: "translate(0,0)"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B80AF",
    transform: "translate(0,0)"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907BAC",
    transform: "translate(0,0)"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2649D",
    transform: "translate(0,0)"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0659C",
    transform: "translate(0,0)"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B26399",
    transform: "translate(0,0)"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B16299",
    transform: "translate(0,0)"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D85492",
    transform: "translate(0,0)"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8584B3",
    transform: "translate(0,0)"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A82B0",
    transform: "translate(0,0)"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897DAC",
    transform: "translate(0,0)"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F80A4",
    transform: "translate(0,0)"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8889B3",
    transform: "translate(0,0)"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A83B0",
    transform: "translate(0,0)"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907BAB",
    transform: "translate(0,0)"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B06197",
    transform: "translate(0,0)"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B36398",
    transform: "translate(0,0)"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E05693",
    transform: "translate(0,0)"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8888B1",
    transform: "translate(0,0)"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B06099",
    transform: "translate(0,0)"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C15894",
    transform: "translate(0,0)"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B1",
    transform: "translate(0,0)"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907CAC",
    transform: "translate(0,0)"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D65390",
    transform: "translate(0,0)"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2558E",
    transform: "translate(0,0)"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8887B1",
    transform: "translate(0,0)"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A86B2",
    transform: "translate(0,0)"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A84B1",
    transform: "translate(0,0)"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#927DAA",
    transform: "translate(0,0)"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B1",
    transform: "translate(0,0)"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7EAB",
    transform: "translate(0,0)"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8887B4",
    transform: "translate(0,0)"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B86B6",
    transform: "translate(0,0)"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9376A6",
    transform: "translate(0,0)"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C95B95",
    transform: "translate(0,0)"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7EA6",
    transform: "translate(0,0)"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385AF",
    transform: "translate(0,0)"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8587B2",
    transform: "translate(0,0)"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B3",
    transform: "translate(0,0)"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D7EAC",
    transform: "translate(0,0)"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B06099",
    transform: "translate(0,0)"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB5991",
    transform: "translate(0,0)"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D81A5",
    transform: "translate(0,0)"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8688B5",
    transform: "translate(0,0)"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8785B3",
    transform: "translate(0,0)"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D7FAD",
    transform: "translate(0,0)"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE5A97",
    transform: "translate(0,0)"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8885B3",
    transform: "translate(0,0)"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D6DA3",
    transform: "translate(0,0)"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D95590",
    transform: "translate(0,0)"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DC528F",
    transform: "translate(0,0)"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7DA4",
    transform: "translate(0,0)"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9177A2",
    transform: "translate(0,0)"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C15B92",
    transform: "translate(0,0)"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D35895",
    transform: "translate(0,0)"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D75894",
    transform: "translate(0,0)"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385B0",
    transform: "translate(0,0)"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8686B3",
    transform: "translate(0,0)"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8687B2",
    transform: "translate(0,0)"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7EAE",
    transform: "translate(0,0)"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9178A7",
    transform: "translate(0,0)"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE5692",
    transform: "translate(0,0)"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA5492",
    transform: "translate(0,0)"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C45C96",
    transform: "translate(0,0)"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF5492",
    transform: "translate(0,0)"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8686AF",
    transform: "translate(0,0)"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9873A4",
    transform: "translate(0,0)"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7EAD",
    transform: "translate(0,0)"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9179A7",
    transform: "translate(0,0)"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A72A2",
    transform: "translate(0,0)"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E15594",
    transform: "translate(0,0)"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786AE",
    transform: "translate(0,0)"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B4",
    transform: "translate(0,0)"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD5493",
    transform: "translate(0,0)"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8882B1",
    transform: "translate(0,0)"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC679D",
    transform: "translate(0,0)"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE639A",
    transform: "translate(0,0)"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E80A6",
    transform: "translate(0,0)"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8584B3",
    transform: "translate(0,0)"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8884B2",
    transform: "translate(0,0)"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8982AF",
    transform: "translate(0,0)"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C80AF",
    transform: "translate(0,0)"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA6799",
    transform: "translate(0,0)"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC659B",
    transform: "translate(0,0)"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE639B",
    transform: "translate(0,0)"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0639A",
    transform: "translate(0,0)"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D75791",
    transform: "translate(0,0)"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9574A5",
    transform: "translate(0,0)"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF5B95",
    transform: "translate(0,0)"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D15392",
    transform: "translate(0,0)"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D65395",
    transform: "translate(0,0)"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7DA4",
    transform: "translate(0,0)"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8685B2",
    transform: "translate(0,0)"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8889B5",
    transform: "translate(0,0)"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8987B5",
    transform: "translate(0,0)"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F82AF",
    transform: "translate(0,0)"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC6598",
    transform: "translate(0,0)"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD659A",
    transform: "translate(0,0)"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC659A",
    transform: "translate(0,0)"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE639B",
    transform: "translate(0,0)"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B06199",
    transform: "translate(0,0)"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF5B94",
    transform: "translate(0,0)"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D05595",
    transform: "translate(0,0)"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8486B0",
    transform: "translate(0,0)"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A87B6",
    transform: "translate(0,0)"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7FA3",
    transform: "translate(0,0)"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8887B3",
    transform: "translate(0,0)"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8886B2",
    transform: "translate(0,0)"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8882B2",
    transform: "translate(0,0)"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C80AF",
    transform: "translate(0,0)"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6699B",
    transform: "translate(0,0)"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D75494",
    transform: "translate(0,0)"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA5492",
    transform: "translate(0,0)"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE5291",
    transform: "translate(0,0)"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8689B5",
    transform: "translate(0,0)"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8483B1",
    transform: "translate(0,0)"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8887B2",
    transform: "translate(0,0)"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A88B5",
    transform: "translate(0,0)"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8781AF",
    transform: "translate(0,0)"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7FA5",
    transform: "translate(0,0)"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8988B3",
    transform: "translate(0,0)"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#857EAC",
    transform: "translate(0,0)"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A56A9D",
    transform: "translate(0,0)"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF5D98",
    transform: "translate(0,0)"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C65D97",
    transform: "translate(0,0)"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8284AF",
    transform: "translate(0,0)"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9473A5",
    transform: "translate(0,0)"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4679B",
    transform: "translate(0,0)"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD5C98",
    transform: "translate(0,0)"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E25493",
    transform: "translate(0,0)"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD5791",
    transform: "translate(0,0)"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8285AE",
    transform: "translate(0,0)"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B2",
    transform: "translate(0,0)"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A06B9D",
    transform: "translate(0,0)"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C35B93",
    transform: "translate(0,0)"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF5494",
    transform: "translate(0,0)"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D7FAD",
    transform: "translate(0,0)"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F80A7",
    transform: "translate(0,0)"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8985B1",
    transform: "translate(0,0)"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA5292",
    transform: "translate(0,0)"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B2",
    transform: "translate(0,0)"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485AF",
    transform: "translate(0,0)"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A88B2",
    transform: "translate(0,0)"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A87B4",
    transform: "translate(0,0)"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD5594",
    transform: "translate(0,0)"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484AA",
    transform: "translate(0,0)"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B88B7",
    transform: "translate(0,0)"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#997BB0",
    transform: "translate(0,0)"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC6496",
    transform: "translate(0,0)"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE6197",
    transform: "translate(0,0)"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B65F96",
    transform: "translate(0,0)"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DC5492",
    transform: "translate(0,0)"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8784B4",
    transform: "translate(0,0)"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B4",
    transform: "translate(0,0)"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E04E90",
    transform: "translate(0,0)"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD5392",
    transform: "translate(0,0)"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8781AF",
    transform: "translate(0,0)"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E6A9D",
    transform: "translate(0,0)"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE5192",
    transform: "translate(0,0)"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#51394C",
    transform: "translate(0,0)"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8982B2",
    transform: "translate(0,0)"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A80AE",
    transform: "translate(0,0)"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E65393",
    transform: "translate(0,0)"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8987B2",
    transform: "translate(0,0)"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC679D",
    transform: "translate(0,0)"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E55190",
    transform: "translate(0,0)"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B2",
    transform: "translate(0,0)"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F7BA9",
    transform: "translate(0,0)"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB699D",
    transform: "translate(0,0)"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C75897",
    transform: "translate(0,0)"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE5595",
    transform: "translate(0,0)"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9277A6",
    transform: "translate(0,0)"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E75095",
    transform: "translate(0,0)"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8584AE",
    transform: "translate(0,0)"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8583B0",
    transform: "translate(0,0)"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8683B4",
    transform: "translate(0,0)"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E79A8",
    transform: "translate(0,0)"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9176A5",
    transform: "translate(0,0)"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9177A6",
    transform: "translate(0,0)"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8784B3",
    transform: "translate(0,0)"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8782AF",
    transform: "translate(0,0)"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9174A2",
    transform: "translate(0,0)"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B73A0",
    transform: "translate(0,0)"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8988B3",
    transform: "translate(0,0)"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#86729D",
    transform: "translate(0,0)"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877099",
    transform: "translate(0,0)"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7FA1",
    transform: "translate(0,0)"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384AD",
    transform: "translate(0,0)"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8783B0",
    transform: "translate(0,0)"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD5394",
    transform: "translate(0,0)"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9575A5",
    transform: "translate(0,0)"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#86719A",
    transform: "translate(0,0)"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8887B1",
    transform: "translate(0,0)"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A80AD",
    transform: "translate(0,0)"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF5494",
    transform: "translate(0,0)"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E05293",
    transform: "translate(0,0)"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7DA0",
    transform: "translate(0,0)"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8485AD",
    transform: "translate(0,0)"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8887B1",
    transform: "translate(0,0)"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8882B0",
    transform: "translate(0,0)"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3679C",
    transform: "translate(0,0)"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E15494",
    transform: "translate(0,0)"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E05594",
    transform: "translate(0,0)"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5669D",
    transform: "translate(0,0)"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF5494",
    transform: "translate(0,0)"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E75094",
    transform: "translate(0,0)"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E05092",
    transform: "translate(0,0)"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8788B3",
    transform: "translate(0,0)"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B86B1",
    transform: "translate(0,0)"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8284AD",
    transform: "translate(0,0)"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A85B2",
    transform: "translate(0,0)"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8082AA",
    transform: "translate(0,0)"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8687B1",
    transform: "translate(0,0)"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B3",
    transform: "translate(0,0)"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8784B2",
    transform: "translate(0,0)"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8986B2",
    transform: "translate(0,0)"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98719F",
    transform: "translate(0,0)"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E85191",
    transform: "translate(0,0)"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E34F90",
    transform: "translate(0,0)"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45995",
    transform: "translate(0,0)"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8082AB",
    transform: "translate(0,0)"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E05293",
    transform: "translate(0,0)"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7DA3",
    transform: "translate(0,0)"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8686B2",
    transform: "translate(0,0)"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B1",
    transform: "translate(0,0)"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A85B3",
    transform: "translate(0,0)"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D7EAC",
    transform: "translate(0,0)"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E45193",
    transform: "translate(0,0)"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE5593",
    transform: "translate(0,0)"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE5C96",
    transform: "translate(0,0)"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8285AE",
    transform: "translate(0,0)"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8383AC",
    transform: "translate(0,0)"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8687B1",
    transform: "translate(0,0)"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9571A0",
    transform: "translate(0,0)"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E45592",
    transform: "translate(0,0)"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC5E96",
    transform: "translate(0,0)"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8284AD",
    transform: "translate(0,0)"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A89B9",
    transform: "translate(0,0)"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F6DA2",
    transform: "translate(0,0)"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8386B1",
    transform: "translate(0,0)"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9570A2",
    transform: "translate(0,0)"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B76099",
    transform: "translate(0,0)"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF5794",
    transform: "translate(0,0)"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE5594",
    transform: "translate(0,0)"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF5493",
    transform: "translate(0,0)"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7EA2",
    transform: "translate(0,0)"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B2",
    transform: "translate(0,0)"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585AF",
    transform: "translate(0,0)"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8687B3",
    transform: "translate(0,0)"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#956FA3",
    transform: "translate(0,0)"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C6EA0",
    transform: "translate(0,0)"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F6FA2",
    transform: "translate(0,0)"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E35193",
    transform: "translate(0,0)"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8083A9",
    transform: "translate(0,0)"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8784B1",
    transform: "translate(0,0)"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E25293",
    transform: "translate(0,0)"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E35395",
    transform: "translate(0,0)"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7EA5",
    transform: "translate(0,0)"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B2",
    transform: "translate(0,0)"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8686B3",
    transform: "translate(0,0)"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B46097",
    transform: "translate(0,0)"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C95C96",
    transform: "translate(0,0)"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B1",
    transform: "translate(0,0)"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C65C99",
    transform: "translate(0,0)"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B2",
    transform: "translate(0,0)"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8984B0",
    transform: "translate(0,0)"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B4",
    transform: "translate(0,0)"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E6F9F",
    transform: "translate(0,0)"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C86B5",
    transform: "translate(0,0)"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B1",
    transform: "translate(0,0)"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8586B4",
    transform: "translate(0,0)"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9375A3",
    transform: "translate(0,0)"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E44F92",
    transform: "translate(0,0)"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B1",
    transform: "translate(0,0)"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#917FAE",
    transform: "translate(0,0)"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E55092",
    transform: "translate(0,0)"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8686B3",
    transform: "translate(0,0)"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#957BAA",
    transform: "translate(0,0)"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#996FA0",
    transform: "translate(0,0)"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E15494",
    transform: "translate(0,0)"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385B2",
    transform: "translate(0,0)"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8888B4",
    transform: "translate(0,0)"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E35494",
    transform: "translate(0,0)"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8487B3",
    transform: "translate(0,0)"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8787B5",
    transform: "translate(0,0)"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#947AAD",
    transform: "translate(0,0)"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E54E96",
    transform: "translate(0,0)"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD5195",
    transform: "translate(0,0)"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE5592",
    transform: "translate(0,0)"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E25694",
    transform: "translate(0,0)"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DB5591",
    transform: "translate(0,0)"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#966FA1",
    transform: "translate(0,0)"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC558F",
    transform: "translate(0,0)"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E65196",
    transform: "translate(0,0)"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45790",
    transform: "translate(0,0)"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9179AB",
    transform: "translate(0,0)"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9072A3",
    transform: "translate(0,0)"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DC5694",
    transform: "translate(0,0)"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9373A5",
    transform: "translate(0,0)"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B6FA2",
    transform: "translate(0,0)"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC5893",
    transform: "translate(0,0)"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF5094",
    transform: "translate(0,0)"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98719E",
    transform: "translate(0,0)"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45691",
    transform: "translate(0,0)"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B3",
    transform: "translate(0,0)"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B9629A",
    transform: "translate(0,0)"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D25896",
    transform: "translate(0,0)"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8788B6",
    transform: "translate(0,0)"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B76097",
    transform: "translate(0,0)"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E75095",
    transform: "translate(0,0)"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA659A",
    transform: "translate(0,0)"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8488B4",
    transform: "translate(0,0)"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8588B4",
    transform: "translate(0,0)"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9173A4",
    transform: "translate(0,0)"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B16494",
    transform: "translate(0,0)"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A70A2",
    transform: "translate(0,0)"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46694",
    transform: "translate(0,0)"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9970A3",
    transform: "translate(0,0)"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7FA0",
    transform: "translate(0,0)"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9971A3",
    transform: "translate(0,0)"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DC5191",
    transform: "translate(0,0)"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8082AC",
    transform: "translate(0,0)"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8185AF",
    transform: "translate(0,0)"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C65D95",
    transform: "translate(0,0)"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385AF",
    transform: "translate(0,0)"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8588B7",
    transform: "translate(0,0)"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B05A8B",
    transform: "translate(0,0)"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8486B2",
    transform: "translate(0,0)"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45793",
    transform: "translate(0,0)"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D45392",
    transform: "translate(0,0)"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D85290",
    transform: "translate(0,0)"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B05B8C",
    transform: "translate(0,0)"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8284AF",
    transform: "translate(0,0)"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C85E95",
    transform: "translate(0,0)"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D75390",
    transform: "translate(0,0)"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B15C8E",
    transform: "translate(0,0)"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB5B8F",
    transform: "translate(0,0)"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0649A",
    transform: "translate(0,0)"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8184AF",
    transform: "translate(0,0)"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC6498",
    transform: "translate(0,0)"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C65B95",
    transform: "translate(0,0)"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE528C",
    transform: "translate(0,0)"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A73A4",
    transform: "translate(0,0)"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF558D",
    transform: "translate(0,0)"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C45C95",
    transform: "translate(0,0)"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B26499",
    transform: "translate(0,0)"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B85E94",
    transform: "translate(0,0)"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8285AE",
    transform: "translate(0,0)"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD6397",
    transform: "translate(0,0)"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6578D",
    transform: "translate(0,0)"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9972A4",
    transform: "translate(0,0)"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B95B92",
    transform: "translate(0,0)"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB578A",
    transform: "translate(0,0)"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE528B",
    transform: "translate(0,0)"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7EA4",
    transform: "translate(0,0)"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8788B2",
    transform: "translate(0,0)"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8883AF",
    transform: "translate(0,0)"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C55992",
    transform: "translate(0,0)"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9872A5",
    transform: "translate(0,0)"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC5A93",
    transform: "translate(0,0)"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9276AA",
    transform: "translate(0,0)"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C65492",
    transform: "translate(0,0)"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C76A6",
    transform: "translate(0,0)"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD6196",
    transform: "translate(0,0)"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B65384",
    transform: "translate(0,0)"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B7548A",
    transform: "translate(0,0)"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E81AA",
    transform: "translate(0,0)"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8686B4",
    transform: "translate(0,0)"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A96B9F",
    transform: "translate(0,0)"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A8AB4",
    transform: "translate(0,0)"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9970A5",
    transform: "translate(0,0)"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C45692",
    transform: "translate(0,0)"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C35891",
    transform: "translate(0,0)"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7EA3",
    transform: "translate(0,0)"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6568A",
    transform: "translate(0,0)"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B16099",
    transform: "translate(0,0)"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9971A4",
    transform: "translate(0,0)"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B8538B",
    transform: "translate(0,0)"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0568E",
    transform: "translate(0,0)"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA5487",
    transform: "translate(0,0)"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7FA1",
    transform: "translate(0,0)"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA588E",
    transform: "translate(0,0)"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE568C",
    transform: "translate(0,0)"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF568D",
    transform: "translate(0,0)"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7BA2",
    transform: "translate(0,0)"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC5791",
    transform: "translate(0,0)"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF568E",
    transform: "translate(0,0)"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC5383",
    transform: "translate(0,0)"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9970A3",
    transform: "translate(0,0)"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD5590",
    transform: "translate(0,0)"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B9558D",
    transform: "translate(0,0)"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC558C",
    transform: "translate(0,0)"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797B9E",
    transform: "translate(0,0)"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8386AF",
    transform: "translate(0,0)"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847FAE",
    transform: "translate(0,0)"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C45691",
    transform: "translate(0,0)"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD558D",
    transform: "translate(0,0)"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9674A5",
    transform: "translate(0,0)"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD588D",
    transform: "translate(0,0)"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8481B1",
    transform: "translate(0,0)"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B9568C",
    transform: "translate(0,0)"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A76699",
    transform: "translate(0,0)"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B15F97",
    transform: "translate(0,0)"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE4D81",
    transform: "translate(0,0)"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8285B1",
    transform: "translate(0,0)"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8683B1",
    transform: "translate(0,0)"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8385B1",
    transform: "translate(0,0)"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A6EA4",
    transform: "translate(0,0)"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8981AF",
    transform: "translate(0,0)"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B7568D",
    transform: "translate(0,0)"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC4C7E",
    transform: "translate(0,0)"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9774A4",
    transform: "translate(0,0)"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B75A8D",
    transform: "translate(0,0)"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F82AB",
    transform: "translate(0,0)"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8982B1",
    transform: "translate(0,0)"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797A9B",
    transform: "translate(0,0)"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8984B4",
    transform: "translate(0,0)"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8583B1",
    transform: "translate(0,0)"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A96499",
    transform: "translate(0,0)"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8685B0",
    transform: "translate(0,0)"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B2",
    transform: "translate(0,0)"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC6093",
    transform: "translate(0,0)"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8885B2",
    transform: "translate(0,0)"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8582AF",
    transform: "translate(0,0)"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B80B0",
    transform: "translate(0,0)"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F82AC",
    transform: "translate(0,0)"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8884B1",
    transform: "translate(0,0)"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5C93",
    transform: "translate(0,0)"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A81AE",
    transform: "translate(0,0)"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A81AD",
    transform: "translate(0,0)"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9471A3",
    transform: "translate(0,0)"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A65B91",
    transform: "translate(0,0)"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE6095",
    transform: "translate(0,0)"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8483B0",
    transform: "translate(0,0)"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D6EA2",
    transform: "translate(0,0)"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF5486",
    transform: "translate(0,0)"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF5585",
    transform: "translate(0,0)"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE5385",
    transform: "translate(0,0)"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8786B1",
    transform: "translate(0,0)"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9971A6",
    transform: "translate(0,0)"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8883B2",
    transform: "translate(0,0)"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8984B0",
    transform: "translate(0,0)"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E6E9F",
    transform: "translate(0,0)"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB4E7E",
    transform: "translate(0,0)"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484B0",
    transform: "translate(0,0)"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8783B1",
    transform: "translate(0,0)"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5084",
    transform: "translate(0,0)"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484B0",
    transform: "translate(0,0)"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585B0",
    transform: "translate(0,0)"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A71A3",
    transform: "translate(0,0)"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B6C9E",
    transform: "translate(0,0)"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8585AE",
    transform: "translate(0,0)"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8685B0",
    transform: "translate(0,0)"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B15E92",
    transform: "translate(0,0)"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B15C91",
    transform: "translate(0,0)"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B05385",
    transform: "translate(0,0)"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8584AE",
    transform: "translate(0,0)"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8683AF",
    transform: "translate(0,0)"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7FA9",
    transform: "translate(0,0)"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E6B9D",
    transform: "translate(0,0)"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5A91",
    transform: "translate(0,0)"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5A90",
    transform: "translate(0,0)"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B05485",
    transform: "translate(0,0)"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8282AC",
    transform: "translate(0,0)"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384AB",
    transform: "translate(0,0)"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7EAA",
    transform: "translate(0,0)"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF4E82",
    transform: "translate(0,0)"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8082A8",
    transform: "translate(0,0)"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8683AC",
    transform: "translate(0,0)"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7EAA",
    transform: "translate(0,0)"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B65589",
    transform: "translate(0,0)"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8880AF",
    transform: "translate(0,0)"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC578C",
    transform: "translate(0,0)"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5B90",
    transform: "translate(0,0)"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE568E",
    transform: "translate(0,0)"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8783AD",
    transform: "translate(0,0)"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8983B0",
    transform: "translate(0,0)"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA5A8D",
    transform: "translate(0,0)"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE598E",
    transform: "translate(0,0)"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8780AD",
    transform: "translate(0,0)"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897DA9",
    transform: "translate(0,0)"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7DAC",
    transform: "translate(0,0)"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4679B",
    transform: "translate(0,0)"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA5E92",
    transform: "translate(0,0)"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5A8C",
    transform: "translate(0,0)"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B15586",
    transform: "translate(0,0)"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B84B0",
    transform: "translate(0,0)"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8883B0",
    transform: "translate(0,0)"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8983AD",
    transform: "translate(0,0)"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#887FAD",
    transform: "translate(0,0)"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8781AD",
    transform: "translate(0,0)"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897CA9",
    transform: "translate(0,0)"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5686",
    transform: "translate(0,0)"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897CA9",
    transform: "translate(0,0)"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A6D9D",
    transform: "translate(0,0)"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8381A9",
    transform: "translate(0,0)"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF5587",
    transform: "translate(0,0)"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8282AD",
    transform: "translate(0,0)"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8684B0",
    transform: "translate(0,0)"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8681AF",
    transform: "translate(0,0)"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8683AE",
    transform: "translate(0,0)"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A26499",
    transform: "translate(0,0)"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE5689",
    transform: "translate(0,0)"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8281AD",
    transform: "translate(0,0)"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181AA",
    transform: "translate(0,0)"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A699B",
    transform: "translate(0,0)"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE598F",
    transform: "translate(0,0)"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF558B",
    transform: "translate(0,0)"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8283AD",
    transform: "translate(0,0)"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB598E",
    transform: "translate(0,0)"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8284AF",
    transform: "translate(0,0)"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8483AD",
    transform: "translate(0,0)"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8584AE",
    transform: "translate(0,0)"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8780AF",
    transform: "translate(0,0)"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7CA2",
    transform: "translate(0,0)"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF5B91",
    transform: "translate(0,0)"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF5687",
    transform: "translate(0,0)"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8280AC",
    transform: "translate(0,0)"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8483AB",
    transform: "translate(0,0)"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5E91",
    transform: "translate(0,0)"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B05B8E",
    transform: "translate(0,0)"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8281AC",
    transform: "translate(0,0)"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7FAB",
    transform: "translate(0,0)"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A36699",
    transform: "translate(0,0)"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384AF",
    transform: "translate(0,0)"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897CA9",
    transform: "translate(0,0)"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A56399",
    transform: "translate(0,0)"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC5B8C",
    transform: "translate(0,0)"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8083AB",
    transform: "translate(0,0)"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8481AC",
    transform: "translate(0,0)"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7DAA",
    transform: "translate(0,0)"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D669B",
    transform: "translate(0,0)"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181AC",
    transform: "translate(0,0)"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8281AE",
    transform: "translate(0,0)"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181AC",
    transform: "translate(0,0)"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384AD",
    transform: "translate(0,0)"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8281A9",
    transform: "translate(0,0)"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F80A8",
    transform: "translate(0,0)"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8683AD",
    transform: "translate(0,0)"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9659A",
    transform: "translate(0,0)"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7DAA",
    transform: "translate(0,0)"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A26595",
    transform: "translate(0,0)"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837FAA",
    transform: "translate(0,0)"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8582AB",
    transform: "translate(0,0)"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8580AA",
    transform: "translate(0,0)"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F6A99",
    transform: "translate(0,0)"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A16496",
    transform: "translate(0,0)"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0497D",
    transform: "translate(0,0)"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1427E",
    transform: "translate(0,0)"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A16A9A",
    transform: "translate(0,0)"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A56596",
    transform: "translate(0,0)"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2467D",
    transform: "translate(0,0)"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8978A9",
    transform: "translate(0,0)"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A36196",
    transform: "translate(0,0)"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8581AB",
    transform: "translate(0,0)"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897FA8",
    transform: "translate(0,0)"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0679B",
    transform: "translate(0,0)"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A56395",
    transform: "translate(0,0)"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8581AE",
    transform: "translate(0,0)"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8680AC",
    transform: "translate(0,0)"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8383AA",
    transform: "translate(0,0)"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46196",
    transform: "translate(0,0)"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A76595",
    transform: "translate(0,0)"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7AA0",
    transform: "translate(0,0)"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A75E95",
    transform: "translate(0,0)"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A76296",
    transform: "translate(0,0)"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8282AA",
    transform: "translate(0,0)"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B79A8",
    transform: "translate(0,0)"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46294",
    transform: "translate(0,0)"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8480AB",
    transform: "translate(0,0)"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8380AC",
    transform: "translate(0,0)"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8681AC",
    transform: "translate(0,0)"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#887EAC",
    transform: "translate(0,0)"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A26195",
    transform: "translate(0,0)"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A85E95",
    transform: "translate(0,0)"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8382AB",
    transform: "translate(0,0)"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8484AF",
    transform: "translate(0,0)"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8382AD",
    transform: "translate(0,0)"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181A8",
    transform: "translate(0,0)"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8483AB",
    transform: "translate(0,0)"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8480A9",
    transform: "translate(0,0)"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7BA0",
    transform: "translate(0,0)"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EAB",
    transform: "translate(0,0)"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8881AB",
    transform: "translate(0,0)"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F7DAF",
    transform: "translate(0,0)"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C5477E",
    transform: "translate(0,0)"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8480AB",
    transform: "translate(0,0)"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877FAD",
    transform: "translate(0,0)"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A45F91",
    transform: "translate(0,0)"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46091",
    transform: "translate(0,0)"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F81AA",
    transform: "translate(0,0)"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7BA6",
    transform: "translate(0,0)"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46297",
    transform: "translate(0,0)"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384AF",
    transform: "translate(0,0)"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A15F94",
    transform: "translate(0,0)"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6598F",
    transform: "translate(0,0)"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181A8",
    transform: "translate(0,0)"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8882AD",
    transform: "translate(0,0)"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F78A6",
    transform: "translate(0,0)"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837FAE",
    transform: "translate(0,0)"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A06094",
    transform: "translate(0,0)"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A86291",
    transform: "translate(0,0)"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7FA7",
    transform: "translate(0,0)"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897FAC",
    transform: "translate(0,0)"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#897BAA",
    transform: "translate(0,0)"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7B9F",
    transform: "translate(0,0)"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#867EA8",
    transform: "translate(0,0)"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A79A8",
    transform: "translate(0,0)"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8482AD",
    transform: "translate(0,0)"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8582AD",
    transform: "translate(0,0)"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E78A7",
    transform: "translate(0,0)"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A65C8F",
    transform: "translate(0,0)"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877FA9",
    transform: "translate(0,0)"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907AA8",
    transform: "translate(0,0)"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8681AB",
    transform: "translate(0,0)"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A35F92",
    transform: "translate(0,0)"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847CA7",
    transform: "translate(0,0)"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8681AE",
    transform: "translate(0,0)"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8880AC",
    transform: "translate(0,0)"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#887FA7",
    transform: "translate(0,0)"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46194",
    transform: "translate(0,0)"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A45C8D",
    transform: "translate(0,0)"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8480AB",
    transform: "translate(0,0)"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9176A4",
    transform: "translate(0,0)"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B83E76",
    transform: "translate(0,0)"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8280A8",
    transform: "translate(0,0)"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B81B0",
    transform: "translate(0,0)"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7EA9",
    transform: "translate(0,0)"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9176A4",
    transform: "translate(0,0)"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8580A7",
    transform: "translate(0,0)"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9477A7",
    transform: "translate(0,0)"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9177A6",
    transform: "translate(0,0)"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA5A8F",
    transform: "translate(0,0)"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A35888",
    transform: "translate(0,0)"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#79789C",
    transform: "translate(0,0)"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7EA8",
    transform: "translate(0,0)"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6588B",
    transform: "translate(0,0)"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A65A89",
    transform: "translate(0,0)"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD5487",
    transform: "translate(0,0)"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A799E",
    transform: "translate(0,0)"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7EA5",
    transform: "translate(0,0)"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8681A9",
    transform: "translate(0,0)"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B78A4",
    transform: "translate(0,0)"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8578B",
    transform: "translate(0,0)"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7598B",
    transform: "translate(0,0)"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5598C",
    transform: "translate(0,0)"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B54075",
    transform: "translate(0,0)"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9073A3",
    transform: "translate(0,0)"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A95082",
    transform: "translate(0,0)"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8384AA",
    transform: "translate(0,0)"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EAA",
    transform: "translate(0,0)"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B79A6",
    transform: "translate(0,0)"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A25F8F",
    transform: "translate(0,0)"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8982AE",
    transform: "translate(0,0)"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7FAD",
    transform: "translate(0,0)"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807FA5",
    transform: "translate(0,0)"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F5E91",
    transform: "translate(0,0)"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46091",
    transform: "translate(0,0)"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7BA9",
    transform: "translate(0,0)"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7BA9",
    transform: "translate(0,0)"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9076A4",
    transform: "translate(0,0)"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877EA8",
    transform: "translate(0,0)"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F5E8A",
    transform: "translate(0,0)"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7CAB",
    transform: "translate(0,0)"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9078A7",
    transform: "translate(0,0)"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877EA8",
    transform: "translate(0,0)"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7DA6",
    transform: "translate(0,0)"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7DA8",
    transform: "translate(0,0)"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94729E",
    transform: "translate(0,0)"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7EAA",
    transform: "translate(0,0)"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F76A2",
    transform: "translate(0,0)"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD4379",
    transform: "translate(0,0)"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#867CA5",
    transform: "translate(0,0)"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F75A3",
    transform: "translate(0,0)"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC4379",
    transform: "translate(0,0)"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9770A1",
    transform: "translate(0,0)"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93719F",
    transform: "translate(0,0)"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8679A9",
    transform: "translate(0,0)"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9176A2",
    transform: "translate(0,0)"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7EA5",
    transform: "translate(0,0)"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EA9",
    transform: "translate(0,0)"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D7AA6",
    transform: "translate(0,0)"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817FA7",
    transform: "translate(0,0)"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7CA8",
    transform: "translate(0,0)"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F7AA5",
    transform: "translate(0,0)"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F76A2",
    transform: "translate(0,0)"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827FA9",
    transform: "translate(0,0)"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9075A2",
    transform: "translate(0,0)"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D799F",
    transform: "translate(0,0)"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181A9",
    transform: "translate(0,0)"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8582AE",
    transform: "translate(0,0)"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7AA6",
    transform: "translate(0,0)"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#917CA7",
    transform: "translate(0,0)"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907AA8",
    transform: "translate(0,0)"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#907AA6",
    transform: "translate(0,0)"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D78A6",
    transform: "translate(0,0)"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C79A5",
    transform: "translate(0,0)"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8380AC",
    transform: "translate(0,0)"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F79A5",
    transform: "translate(0,0)"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#927BA7",
    transform: "translate(0,0)"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E7BA5",
    transform: "translate(0,0)"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#916C9D",
    transform: "translate(0,0)"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8682AA",
    transform: "translate(0,0)"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B7AA7",
    transform: "translate(0,0)"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F77A3",
    transform: "translate(0,0)"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91749F",
    transform: "translate(0,0)"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7CA7",
    transform: "translate(0,0)"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EA8",
    transform: "translate(0,0)"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C7CA6",
    transform: "translate(0,0)"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9078A7",
    transform: "translate(0,0)"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E79A7",
    transform: "translate(0,0)"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#926FA5",
    transform: "translate(0,0)"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#946D9E",
    transform: "translate(0,0)"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#787999",
    transform: "translate(0,0)"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#937BA8",
    transform: "translate(0,0)"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807FA7",
    transform: "translate(0,0)"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#956F9D",
    transform: "translate(0,0)"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F80AA",
    transform: "translate(0,0)"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8782AD",
    transform: "translate(0,0)"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837EAA",
    transform: "translate(0,0)"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B6EA3",
    transform: "translate(0,0)"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7EA6",
    transform: "translate(0,0)"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D77A3",
    transform: "translate(0,0)"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9373A2",
    transform: "translate(0,0)"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9379A2",
    transform: "translate(0,0)"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F79A7",
    transform: "translate(0,0)"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7FA5",
    transform: "translate(0,0)"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F78A8",
    transform: "translate(0,0)"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7B9E",
    transform: "translate(0,0)"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F80A6",
    transform: "translate(0,0)"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F7AA6",
    transform: "translate(0,0)"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A36E9E",
    transform: "translate(0,0)"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#89719D",
    transform: "translate(0,0)"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#976C9A",
    transform: "translate(0,0)"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#966E9D",
    transform: "translate(0,0)"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8680A9",
    transform: "translate(0,0)"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A06DA0",
    transform: "translate(0,0)"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F77A3",
    transform: "translate(0,0)"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#946B9A",
    transform: "translate(0,0)"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#956B9A",
    transform: "translate(0,0)"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#956D9C",
    transform: "translate(0,0)"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8482AA",
    transform: "translate(0,0)"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#976C9A",
    transform: "translate(0,0)"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8782AD",
    transform: "translate(0,0)"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8782AA",
    transform: "translate(0,0)"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8880AA",
    transform: "translate(0,0)"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB6BA2",
    transform: "translate(0,0)"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9076A6",
    transform: "translate(0,0)"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9076A3",
    transform: "translate(0,0)"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#926EA1",
    transform: "translate(0,0)"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8582AB",
    transform: "translate(0,0)"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8381A9",
    transform: "translate(0,0)"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EAA",
    transform: "translate(0,0)"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827FA9",
    transform: "translate(0,0)"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9075A2",
    transform: "translate(0,0)"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9075A1",
    transform: "translate(0,0)"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7A9F",
    transform: "translate(0,0)"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8382AA",
    transform: "translate(0,0)"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#887EAB",
    transform: "translate(0,0)"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9274A1",
    transform: "translate(0,0)"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#867EA8",
    transform: "translate(0,0)"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#966998",
    transform: "translate(0,0)"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8380AA",
    transform: "translate(0,0)"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#887FA7",
    transform: "translate(0,0)"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A76CA0",
    transform: "translate(0,0)"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F75A4",
    transform: "translate(0,0)"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90739F",
    transform: "translate(0,0)"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#946B9C",
    transform: "translate(0,0)"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#966A96",
    transform: "translate(0,0)"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7DA7",
    transform: "translate(0,0)"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8380AB",
    transform: "translate(0,0)"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A799D",
    transform: "translate(0,0)"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A56B9F",
    transform: "translate(0,0)"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#956D9C",
    transform: "translate(0,0)"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#946D9A",
    transform: "translate(0,0)"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7B9E",
    transform: "translate(0,0)"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A76EA0",
    transform: "translate(0,0)"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E76A3",
    transform: "translate(0,0)"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9073A0",
    transform: "translate(0,0)"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#946A98",
    transform: "translate(0,0)"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#87759E",
    transform: "translate(0,0)"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#80749B",
    transform: "translate(0,0)"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EA8",
    transform: "translate(0,0)"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7DA6",
    transform: "translate(0,0)"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B83B2",
    transform: "translate(0,0)"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#87729C",
    transform: "translate(0,0)"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#89729C",
    transform: "translate(0,0)"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F6D9A",
    transform: "translate(0,0)"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7A9E",
    transform: "translate(0,0)"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#876F98",
    transform: "translate(0,0)"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E6893",
    transform: "translate(0,0)"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7978A9",
    transform: "translate(0,0)"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877DAA",
    transform: "translate(0,0)"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E719E",
    transform: "translate(0,0)"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8776A0",
    transform: "translate(0,0)"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7A9B",
    transform: "translate(0,0)"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847FA8",
    transform: "translate(0,0)"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7BA4",
    transform: "translate(0,0)"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807DA4",
    transform: "translate(0,0)"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A739D",
    transform: "translate(0,0)"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D709E",
    transform: "translate(0,0)"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EA6",
    transform: "translate(0,0)"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#867CA4",
    transform: "translate(0,0)"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C709E",
    transform: "translate(0,0)"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8481A6",
    transform: "translate(0,0)"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8980B0",
    transform: "translate(0,0)"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7CA1",
    transform: "translate(0,0)"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B719C",
    transform: "translate(0,0)"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877FA9",
    transform: "translate(0,0)"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F6D9A",
    transform: "translate(0,0)"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817FA9",
    transform: "translate(0,0)"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#887EA6",
    transform: "translate(0,0)"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8581AB",
    transform: "translate(0,0)"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877FAB",
    transform: "translate(0,0)"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D6E98",
    transform: "translate(0,0)"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827FA4",
    transform: "translate(0,0)"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#887DA7",
    transform: "translate(0,0)"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#857CA4",
    transform: "translate(0,0)"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C6F9D",
    transform: "translate(0,0)"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D6E9D",
    transform: "translate(0,0)"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#89709A",
    transform: "translate(0,0)"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#857FAA",
    transform: "translate(0,0)"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#886E9A",
    transform: "translate(0,0)"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8779A6",
    transform: "translate(0,0)"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#867EA7",
    transform: "translate(0,0)"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B6E95",
    transform: "translate(0,0)"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7B9E",
    transform: "translate(0,0)"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847EA5",
    transform: "translate(0,0)"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877EA7",
    transform: "translate(0,0)"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A6F98",
    transform: "translate(0,0)"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B6F97",
    transform: "translate(0,0)"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7D9C",
    transform: "translate(0,0)"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EA3",
    transform: "translate(0,0)"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B6E96",
    transform: "translate(0,0)"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7197",
    transform: "translate(0,0)"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EA6",
    transform: "translate(0,0)"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8481A6",
    transform: "translate(0,0)"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A7097",
    transform: "translate(0,0)"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7AA1",
    transform: "translate(0,0)"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8480A6",
    transform: "translate(0,0)"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E3761",
    transform: "translate(0,0)"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EA7",
    transform: "translate(0,0)"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837CA6",
    transform: "translate(0,0)"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#857DA6",
    transform: "translate(0,0)"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7A9F",
    transform: "translate(0,0)"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847CA6",
    transform: "translate(0,0)"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7A9D",
    transform: "translate(0,0)"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C799D",
    transform: "translate(0,0)"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827CA7",
    transform: "translate(0,0)"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8380AA",
    transform: "translate(0,0)"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827DA9",
    transform: "translate(0,0)"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837FA8",
    transform: "translate(0,0)"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8581AA",
    transform: "translate(0,0)"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8280A8",
    transform: "translate(0,0)"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847FAB",
    transform: "translate(0,0)"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EA7",
    transform: "translate(0,0)"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E3B62",
    transform: "translate(0,0)"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817FA6",
    transform: "translate(0,0)"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7BA0",
    transform: "translate(0,0)"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847EA9",
    transform: "translate(0,0)"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847DA6",
    transform: "translate(0,0)"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7EA1",
    transform: "translate(0,0)"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#943A68",
    transform: "translate(0,0)"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#953C69",
    transform: "translate(0,0)"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#943F68",
    transform: "translate(0,0)"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7CA5",
    transform: "translate(0,0)"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827DA8",
    transform: "translate(0,0)"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7EA6",
    transform: "translate(0,0)"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EA5",
    transform: "translate(0,0)"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8181A8",
    transform: "translate(0,0)"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817FA7",
    transform: "translate(0,0)"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#963E6B",
    transform: "translate(0,0)"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807DA4",
    transform: "translate(0,0)"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EA7",
    transform: "translate(0,0)"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93416C",
    transform: "translate(0,0)"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817DA6",
    transform: "translate(0,0)"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EA7",
    transform: "translate(0,0)"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7E9E",
    transform: "translate(0,0)"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97426D",
    transform: "translate(0,0)"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7DA5",
    transform: "translate(0,0)"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96416C",
    transform: "translate(0,0)"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7FA9",
    transform: "translate(0,0)"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7BA3",
    transform: "translate(0,0)"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817DA6",
    transform: "translate(0,0)"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7EA5",
    transform: "translate(0,0)"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7FA6",
    transform: "translate(0,0)"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817BAB",
    transform: "translate(0,0)"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847EA6",
    transform: "translate(0,0)"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7AA0",
    transform: "translate(0,0)"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837DA5",
    transform: "translate(0,0)"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847EA7",
    transform: "translate(0,0)"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98426F",
    transform: "translate(0,0)"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D3F70",
    transform: "translate(0,0)"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7BA1",
    transform: "translate(0,0)"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#887FA7",
    transform: "translate(0,0)"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7CA2",
    transform: "translate(0,0)"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C4170",
    transform: "translate(0,0)"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807BA3",
    transform: "translate(0,0)"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C3E6D",
    transform: "translate(0,0)"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A769E",
    transform: "translate(0,0)"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EA5",
    transform: "translate(0,0)"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C4372",
    transform: "translate(0,0)"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B446E",
    transform: "translate(0,0)"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D406F",
    transform: "translate(0,0)"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7C9F",
    transform: "translate(0,0)"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807BA2",
    transform: "translate(0,0)"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817EA5",
    transform: "translate(0,0)"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7AA2",
    transform: "translate(0,0)"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807CA4",
    transform: "translate(0,0)"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837CA5",
    transform: "translate(0,0)"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D4270",
    transform: "translate(0,0)"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8480A6",
    transform: "translate(0,0)"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B4170",
    transform: "translate(0,0)"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7AA1",
    transform: "translate(0,0)"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827EA5",
    transform: "translate(0,0)"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837DA4",
    transform: "translate(0,0)"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827AA4",
    transform: "translate(0,0)"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A24174",
    transform: "translate(0,0)"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8076A7",
    transform: "translate(0,0)"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F4575",
    transform: "translate(0,0)"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A04373",
    transform: "translate(0,0)"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817DA2",
    transform: "translate(0,0)"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827AA2",
    transform: "translate(0,0)"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F4575",
    transform: "translate(0,0)"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837CA6",
    transform: "translate(0,0)"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7CA1",
    transform: "translate(0,0)"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837EA5",
    transform: "translate(0,0)"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#877DA6",
    transform: "translate(0,0)"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A34675",
    transform: "translate(0,0)"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7B9F",
    transform: "translate(0,0)"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7EA2",
    transform: "translate(0,0)"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827DA5",
    transform: "translate(0,0)"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A14274",
    transform: "translate(0,0)"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7DA1",
    transform: "translate(0,0)"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F80A2",
    transform: "translate(0,0)"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#857EA8",
    transform: "translate(0,0)"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827AA4",
    transform: "translate(0,0)"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8176A2",
    transform: "translate(0,0)"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8478A2",
    transform: "translate(0,0)"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#84739E",
    transform: "translate(0,0)"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C4974",
    transform: "translate(0,0)"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A33D71",
    transform: "translate(0,0)"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A04477",
    transform: "translate(0,0)"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807A9F",
    transform: "translate(0,0)"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E4875",
    transform: "translate(0,0)"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807BA1",
    transform: "translate(0,0)"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#827AA4",
    transform: "translate(0,0)"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#84739A",
    transform: "translate(0,0)"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#857DA6",
    transform: "translate(0,0)"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847CA4",
    transform: "translate(0,0)"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A64275",
    transform: "translate(0,0)"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807AA5",
    transform: "translate(0,0)"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847CA4",
    transform: "translate(0,0)"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#826F93",
    transform: "translate(0,0)"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A44776",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5731015fb00a088b0e8bc4c5a4796fc2.svg";
export { ForwardRef as ReactComponent };